import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
import gql from 'graphql-tag'
export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** An account number for a corepro account */
  AccountNumber: any
  Amount: any
  BankCardPin: any
  BigDecimal: any
  CardNumberMasked: any
  /** A ISO8601 format date string */
  Date: any
  /** A ISO8601 format date time string */
  DateTime: any
  /** A field representing a standard email address. https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
  Email: any
  /**  A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/.  */
  EmailAddress: any
  /** Represents untyped JSON */
  JSON: any
  /** Standard format for monetary value - string representation of BigInt */
  Micros: any
  /**  A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234.  */
  PhoneNumber: any
  PositiveFloat: any
  ReferralCode: any
  /** A routing number for a bank */
  RoutingNumber: any
  /** A key scalar which maps to a string in the Unified String Repo */
  StringKey: any
  /** A valid security symbol */
  TickerSymbol: any
  Time: any
  /** A legal URL */
  URL: any
  /** Formatted full-name of a US state. */
  USStateName: any
  /** A universally unique identifier compliant UUID Scalar */
  UUID: any
  /** The Upload scalar type represents a file upload. */
  Upload: any
  /**  Allows for a cleaner 'null' return type to support legacy GQL queries from the gateway  */
  Void: any
}

/** Describes the employer switch based on the switch type. */
export type AbstractSwitch = AcornsPdfSwitch | OnlineSwitch | SubmittableSwitch

/** Bundle of acceptance date, signature, and document type */
export type AcceptDocumentInput = {
  /** The date the document was signed by the user */
  acceptedDate: Scalars['Date']
  /** Type of document the given signature is accepting */
  documentType: AcceptanceDocumentType
  /** The version of the document the user is accepting */
  documentVersion: Scalars['String']
  /** Name to apply to the accepted document */
  signature: Scalars['String']
}

/** What happens when a user accepts a document */
export type AcceptDocumentResponse =
  | AcceptedDocument
  | DocumentNotFound
  | UserNotFound

/** Acceptance documents */
export type AcceptanceDocument = {
  __typename?: 'AcceptanceDocument'
  id: Scalars['ID']
  /** Indicates whether the app should force the user to scroll to the bottom before accepting */
  mustScrollToBottom: Maybe<Scalars['Boolean']>
  /** The name of the document */
  name: Scalars['String']
  /** A string indicating a specific app feature that the acceptance of the document is required for using */
  requiredFor: Maybe<Scalars['String']>
  /** The name of the summary */
  summaryName: Maybe<Scalars['String']>
  /** The URL to the summary text */
  summaryUrl: Maybe<Scalars['URL']>
  /** The type of document (arbitrary right now) */
  type: Scalars['String']
  /** The URL to the document text */
  url: Scalars['URL']
  /** The version of the document */
  version: Scalars['String']
}

export enum AcceptanceDocumentType {
  /**
   * Required agreement when user is signed up through a referral program or code
   * @deprecated Referral disclosure is no longer required for referred users
   */
  ReferralDisclosure = 'referralDisclosure',
}

/** A document that a user has accepted */
export type AcceptedDocument = {
  __typename?: 'AcceptedDocument'
  acceptedDate: Scalars['Date']
  documentType: AcceptanceDocumentType
  documentUrl: Scalars['String']
  documentVersion: Scalars['String']
  signature: Scalars['String']
}

/** Individual accounts opened by a user at Acorns */
export type Account = TimestampsInterface & {
  __typename?: 'Account'
  /** Type of account */
  accountType: AccountType
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for account creator */
  creatorId: Scalars['ID']
  /** Internal ID for account */
  id: Scalars['ID']
  /** Status of account */
  status: AccountStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type AccountAchievement = {
  __typename?: 'AccountAchievement'
  achievement: AchievementItem
  completed: Scalars['Boolean']
  dateCompleted: Scalars['DateTime']
}

/** The account provided is already closed */
export type AccountAlreadyClosedException = {
  __typename?: 'AccountAlreadyClosedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment account is already closed */
export type AccountClosedException = {
  __typename?: 'AccountClosedException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** The account has been frozen due to too many incorrect attempts */
export type AccountFrozen = {
  __typename?: 'AccountFrozen'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type AccountMoneyAssignmentInput = {
  amount?: InputMaybe<Scalars['Int']>
  targetAccountId: Scalars['String']
}

/** When investment account id doesn't match with user */
export type AccountNotFoundException = {
  __typename?: 'AccountNotFoundException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

export type AccountPoints = {
  __typename?: 'AccountPoints'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  earned: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>
}

export type AccountPointsRule = {
  __typename?: 'AccountPointsRule'
  /**
   * detailed explanation about how points are earned
   * @deprecated Use detailsKey field instead
   */
  details: Scalars['String']
  /** key that maps to a detailed explanation about how points are earned */
  detailsKey: Scalars['StringKey']
  milestoneID: Scalars['ID']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /**
   * summarized explanation about how points are earned
   * @deprecated Use summaryKey field instead
   */
  summary: Maybe<Scalars['String']>
  /** key that maps to a summarized explanation about how points are earned */
  summaryKey: Maybe<Scalars['StringKey']>
}

export type AccountRequirement = {
  __typename?: 'AccountRequirement'
  actionable: Scalars['Boolean']
  description: Maybe<Scalars['String']>
  status: AccountRequirementStatus
  type: AccountRequirementType
}

export enum AccountRequirementStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum AccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  Liquidated = 'LIQUIDATED',
  NoPendingInvestments = 'NO_PENDING_INVESTMENTS',
  NoTransferringDividends = 'NO_TRANSFERRING_DIVIDENDS',
  NoTransferringInvestments = 'NO_TRANSFERRING_INVESTMENTS',
  RecurringDepositsDisabled = 'RECURRING_DEPOSITS_DISABLED',
  SelfDirectedPortfolioClosed = 'SELF_DIRECTED_PORTFOLIO_CLOSED',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
}

export type AccountRequirements = {
  __typename?: 'AccountRequirements'
  close: AccountRequirement[]
}

/** reflects the user's account setup progress */
export type AccountSetupMilestones = {
  __typename?: 'AccountSetupMilestones'
  /** optional copy to provide more info */
  descriptionKey: Maybe<Scalars['StringKey']>
  /** account setup completion progress */
  groupProgress: DiscreteMilestoneProgress
  /** list of milestones to show in account set up widget */
  milestones: Milestone[]
}

export enum AccountStatus {
  /** Account has been closed */
  Closed = 'closed',
  /** Account closure is in progress */
  Inactive = 'inactive',
  /** Open account ready for use */
  Open = 'open',
  /** Account is in process of being opened or verified */
  Pending = 'pending',
}

export type AccountStrengthResult = {
  __typename?: 'AccountStrengthResult'
  achievements: Maybe<Array<Maybe<AccountAchievement>>>
  percentage: Scalars['Float']
}

export enum AccountType {
  /** Core basic investment account */
  Basic = 'basic',
  /** Spend LSB checking account */
  Checking = 'checking',
  /** Later ROTH IRA account */
  RothIra = 'rothIra',
  /** Later SEP IRA account */
  SepIra = 'sepIra',
  /** Later traditional IRA account */
  TraditionalIra = 'traditionalIra',
  /** Uniform Gift to Minors Act */
  Ugma = 'ugma',
  /** Uniform Transfers to Minors Act */
  Utma = 'utma',
}

/** Account values over the reporting period */
export type AccountValue = {
  __typename?: 'AccountValue'
  /** The dollar amount of the account's balance */
  amount: Maybe<Scalars['Float']>
  /** The time of the associated account value */
  timestamp: Maybe<Scalars['DateTime']>
}

export enum AchievementItem {
  AccountValueGte10 = 'accountValueGte10',
  AccountValueGte100 = 'accountValueGte100',
  AutomaticInvestmentOn = 'automaticInvestmentOn',
  AutomaticRoundupsOn = 'automaticRoundupsOn',
  FundingSourceLinked = 'fundingSourceLinked',
  MultipleRoundupAccountsLinked = 'multipleRoundupAccountsLinked',
  RegistrationComplete = 'registrationComplete',
  RoundupAccountLinked = 'roundupAccountLinked',
}

export type AcornsEarlyUserDetails = {
  __typename?: 'AcornsEarlyUserDetails'
  address1: Maybe<Scalars['String']>
  address2: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  credentialsExist: Scalars['Boolean']
  dateOfBirth: Maybe<Scalars['DateTime']>
  email: Scalars['String']
  externalId: Scalars['String']
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export enum AcornsPartnerStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
}

/** Acorns PDF Switches are performed by emailing and printing a PDF. */
export type AcornsPdfSwitch = SwitchInterface & {
  __typename?: 'AcornsPdfSwitch'
  source: SwitchSource
  type: SwitchType
}

export type ActionCard = {
  __typename?: 'ActionCard'
  /** The body text for the card */
  body: Maybe<Scalars['String']>
  /** call-to-action */
  ctaDetails: Maybe<ActionCardButton>
  /** A smaller card title */
  eyebrow: Maybe<Scalars['String']>
  /** Headline for the card */
  headline: Maybe<Scalars['String']>
  /** An image used in the hero of a card */
  heroImageUrl: Maybe<Scalars['URL']>
  /** A type of icon to render on the card */
  icon: Maybe<Scalars['String']>
  /** An image to render on the card */
  image: Maybe<Scalars['JSON']>
  /** An image to render on the card */
  imageUrl: Maybe<Scalars['URL']>
  /** Owner name for found money offers */
  ownerName: Maybe<Scalars['String']>
  /** A specific card style */
  style: ActionCardStyle
  /** The title for the card */
  title: Maybe<Scalars['String']>
  /** A specific type of card */
  type: Scalars['String']
  /** Unique digest for the card */
  userCardDigest: Maybe<Scalars['ID']>
  /** A widget to be rendered with the card */
  widget: Maybe<Scalars['JSON']>
}

export type ActionCardButton = {
  __typename?: 'ActionCardButton'
  id: Maybe<Scalars['String']>
  image: Maybe<Scalars['URL']>
  title: Scalars['String']
  type: Scalars['String']
  video: Maybe<Scalars['URL']>
  videoUrl: Maybe<Scalars['URL']>
}

export enum ActionCardStyle {
  /** alert */
  Alert = 'alert',
  /** announcingLater */
  AnnouncingLater = 'announcingLater',
  /** basic */
  Basic = 'basic',
  /** basicVideo */
  BasicVideo = 'basicVideo',
  /** foundMoney */
  FoundMoney = 'foundMoney',
  /** grow */
  Grow = 'grow',
  /** snackable */
  Snackable = 'snackable',
  /** widget */
  Widget = 'widget',
}

export type ActionCardsInput = {
  feedContext?: InputMaybe<ActionFeedContext>
}

export enum ActionFeedContext {
  /** feed context */
  A3Core = 'a3Core',
  /** feed context */
  A3Later = 'a3Later',
  /** feed context */
  A3Present = 'a3Present',
  /** feed context */
  A3Spend = 'a3Spend',
  /** feed context */
  A4BankingHub = 'a4BankingHub',
  /** feed context */
  A4CheckingEngagementWizard = 'a4CheckingEngagementWizard',
  /** feed context */
  A4CheckingHub = 'a4CheckingHub',
  /** feed context */
  A4Early = 'a4Early',
  /** feed context */
  A4EarlyDetails = 'a4EarlyDetails',
  /** feed context */
  A4Home = 'a4Home',
  /** feed context */
  A4HomeBottomNav = 'a4HomeBottomNav',
  /** feed context */
  A4Invest = 'a4Invest',
  /** feed context */
  A4InvestHub = 'a4InvestHub',
  /** feed context */
  A4Kids = 'a4Kids',
  /** feed context */
  A4Later = 'a4Later',
  /** feed context */
  A4LearnHub = 'a4LearnHub',
  /** feed context */
  A4Savings = 'a4Savings',
  /** feed context */
  A4Spend = 'a4Spend',
  /** feed context */
  Later = 'later',
  /** feed context */
  Present = 'present',
}

export type ActionFeedCta = {
  __typename?: 'ActionFeedCta'
  hideCardIfUnknown: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  image: Maybe<Scalars['String']>
  title: Scalars['String']
  type: Maybe<ActionFeedCtaType>
  video: Maybe<Scalars['String']>
  videoUrl: Maybe<Scalars['String']>
}

export enum ActionFeedCtaType {
  /** triggers an email download */
  Email = 'email',
  /** grow article link */
  GrowArticle = 'grow_article',
  /** link */
  Link = 'link',
  /** insights sequence offer */
  Offer = 'offer',
  /** insights sequence spell */
  Spell = 'spell',
  /** customer feedback survey */
  Survey = 'survey',
  /** link to view a video */
  Video = 'video',
  /** insights sequence wizard */
  Wizard = 'wizard',
}

/** input for an action feed event */
export type ActionFeedEvent = {
  /** investment account id */
  accountId?: InputMaybe<Scalars['ID']>
  /** event action type */
  action: ActionFeedEventAction
  /** body of event */
  body?: InputMaybe<Scalars['String']>
  /** cta id */
  ctaId?: InputMaybe<Scalars['ID']>
  /** card, widget, or tip type */
  eventKey: Scalars['ID']
  /** CARD | TIP */
  eventType: ActionFeedEventType
  /** card digest id */
  userCardDigest?: InputMaybe<Scalars['String']>
}

export enum ActionFeedEventAction {
  /** Completed */
  Completed = 'completed',
  /** Dismissed */
  Dismissed = 'dismissed',
  /** Card Impression */
  Impression = 'impression',
  /** CTA Tapped */
  Tapped = 'tapped',
}

/** Response to recording a feed event */
export type ActionFeedEventResponse = {
  __typename?: 'ActionFeedEventResponse'
  success: Scalars['Boolean']
}

export enum ActionFeedEventType {
  /** Card Event - impression, tapped, dismissed */
  Card = 'CARD',
  /** Tip Event - completed, dismissed */
  Tip = 'TIP',
}

/** Extendable Frontend Component Type */
export type ActionScreenComponent = ActionWidget

export enum ActionScreenContext {
  /** screen context */
  A4BankingHub = 'a4BankingHub',
  /** screen context */
  A4CheckingHub = 'a4CheckingHub',
  /** screen context */
  A4EarlyDetails = 'a4EarlyDetails',
  /** screen context */
  A4HomeBottomNav = 'a4HomeBottomNav',
  /** screen context */
  A4Invest = 'a4Invest',
  /** screen context */
  A4InvestHub = 'a4InvestHub',
  /** screen context */
  A4Kids = 'a4Kids',
  /** screen context */
  A4Later = 'a4Later',
  /** screen context */
  A4LearnHub = 'a4LearnHub',
  /** screen context */
  A4Savings = 'a4Savings',
  /** screen context */
  A4Spend = 'a4Spend',
}

export enum ActionType {
  Choose = 'CHOOSE',
  Continue = 'CONTINUE',
  Direct = 'DIRECT',
  Link = 'LINK',
  Manual = 'MANUAL',
  MoreInfo = 'MORE_INFO',
  Skip = 'SKIP',
  Switch = 'SWITCH',
  /** Represents when a user switches funnels mid-way through a funnel */
  Update = 'UPDATE',
}

/** Action Screen widget type */
export type ActionWidget = {
  __typename?: 'ActionWidget'
  /**
   * unique identifying hash of the card
   * @deprecated not in use by clients
   */
  digest: Maybe<Scalars['String']>
  /** The identifying string for the widget */
  identifier: Scalars['String']
  /** The unique name of the widget */
  type: Scalars['String']
}

export type ActivateBankCardInput = {
  cardNumberMasked: Scalars['CardNumberMasked']
}

export type ActivateBankCardPayload = {
  __typename?: 'ActivateBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type ActivateOauthAppClientResult =
  | OauthAppClient
  | OauthAppClientNotFoundException

export type ActivateOauthAppResult = OauthApp | OauthAppNotFoundException

export type ActiveReferralCampaignOutput = {
  __typename?: 'ActiveReferralCampaignOutput'
  campaigns: Array<Maybe<ReferralCampaignV2>>
}

export type Activity = {
  __typename?: 'Activity'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  meta: Scalars['JSON']
  pending: Maybe<Scalars['Boolean']>
  type: ActivityType
}

export enum ActivitySummaryProduct {
  /** Early investment product */
  Early = 'EARLY',
  /** Core investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
}

export type ActivitySummaryResponse = {
  __typename?: 'ActivitySummaryResponse'
  activitySummaryItems: Maybe<SummaryItem[]>
  numberOfDays: Maybe<Scalars['Int']>
  /** @deprecated Use `totalV2` for standardized money format */
  total: Maybe<CurrencyAmount>
  totalV2: Maybe<MicrosMoney>
}

export enum ActivityType {
  AchFee = 'achFee',
  BonusRoundup = 'bonusRoundup',
  Credit = 'credit',
  DirectFee = 'directFee',
  Dividend = 'dividend',
  EmployeeContribution = 'employeeContribution',
  Fee = 'fee',
  FoundMoney = 'foundMoney',
  GiftCard = 'giftCard',
  OneTimeInvestment = 'oneTimeInvestment',
  PartnerReward = 'partnerReward',
  Rebalance = 'rebalance',
  RecurringInvestment = 'recurringInvestment',
  ReferralReward = 'referralReward',
  RoundUp = 'roundUp',
  Seeding = 'seeding',
  Withdrawal = 'withdrawal',
}

/** Input for adding cohorts */
export type AddCohortEligibilityInput = {
  /** List of cohort slugs to add */
  add: Array<Scalars['String']>
}

/** Added Cohorts Result */
export type AddCohortEligibilityResult = UserCohorts

export type AddPolicyInput = {
  name: Scalars['String']
}

export type AddPolicyResult =
  | AddPolicySuccess
  | PoliciesRecordDoesNotExistException
  | PolicyNotAddedException

export type AddPolicySuccess = {
  __typename?: 'AddPolicySuccess'
  policies: Maybe<Array<Maybe<Policy>>>
}

export type AddSearchTermToLearnSearchHistoryInput = {
  term: Scalars['String']
}

export type AddSearchTermToLearnSearchHistoryResult = LearnSearchTermSavedResult

/** Input to add a security to a portfolio */
export type AddSecurityToPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** The market exchange symbol of the ETF to add to the portfolio */
  symbol: Scalars['String']
}

/** Result from adding a security to a portfolio */
export type AddSecurityToPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

/** Input for creating a Self Directed Portfolio */
export type AddSelfDirectedPortfolioInput = {
  /** ID of the existing investment account for this portfolio to be associated with */
  investmentAccountId: Scalars['ID']
}

/** Result from opening a Self Directed Portfolio */
export type AddSelfDirectedPortfolioResult =
  | CustomerAgreementRequiredException
  | InvalidInvestmentAccountException
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | PortfolioNotFoundException

/** Miscellaneous attributes and information about a user's address */
export type Address = TimestampsInterface & {
  __typename?: 'Address'
  /** Type of address */
  addressType: AddressType
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for address */
  id: Scalars['ID']
  /** State */
  state: Scalars['String']
  /** First street address */
  street1: Scalars['String']
  /** Second street address */
  street2: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Address has been verified */
  verified: Scalars['Boolean']
  /** Zip code */
  zipCode: Scalars['String']
}

export type AddressDeliverabilityAdditionalInfo = {
  __typename?: 'AddressDeliverabilityAdditionalInfo'
  isBusiness: Maybe<Scalars['Boolean']>
  isPoBox: Maybe<Scalars['Boolean']>
  isPrivateMailbox: Maybe<Scalars['Boolean']>
  isVacant: Maybe<Scalars['Boolean']>
}

/**
 * The Address is verified as deliverable but requires corrections to one or more input fields.
 * Note: Clients can determine what fields are different by diffing their input with the corrected field.
 */
export type AddressDeliverabilityCorrectedAddress = {
  __typename?: 'AddressDeliverabilityCorrectedAddress'
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  street1: Maybe<Scalars['String']>
  street2: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

/** Changeable attributes for addresses */
export type AddressDeliverabilityInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  /** 5 digit zip code */
  zipCode?: InputMaybe<Scalars['String']>
}

export type AddressDeliverabilityResult =
  | AddressDeliverabilityCorrectedAddress
  | AddressDeliverabilityUnavailableError
  | AddressDeliverabilityVerificationError
  | AddressDeliverabilityVerified

/** The Verification was unavailable. Clients should determine how to handle this case according to product requirements */
export type AddressDeliverabilityUnavailableError = {
  __typename?: 'AddressDeliverabilityUnavailableError'
  requestId: Maybe<Scalars['String']>
}

/** The Verification rejected the address as undeliverable. */
export type AddressDeliverabilityVerificationError = {
  __typename?: 'AddressDeliverabilityVerificationError'
  failureReason: Maybe<AddressDeliverabilityVerificationErrorFailureReason>
  requestId: Maybe<Scalars['String']>
}

export enum AddressDeliverabilityVerificationErrorFailureReason {
  /** The input address matched to a physical address that does not receive delivery from the USPS */
  AddressNotDeliverable = 'addressNotDeliverable',
  /** The input address is missing or was not found */
  AddressNotFound = 'addressNotFound',
  /** The input matched multiple addresses, needs more info */
  AmbiguousAddress = 'ambiguousAddress',
  /** The input address has an invalid house number */
  InvalidAddressPrimaryNumber = 'invalidAddressPrimaryNumber',
  /** The input address contains an invalid ste, apt, or box number */
  InvalidAddressSecondaryNumber = 'invalidAddressSecondaryNumber',
  /** The input city is missing or invalid */
  InvalidCity = 'invalidCity',
  /** The input address' PO, RR, or HC box number invalid */
  InvalidPoBoxNumber = 'invalidPoBoxNumber',
  /** The input state code is missing or invalid */
  InvalidState = 'invalidState',
  /** The input postal code is missing or invalid */
  InvalidZipCode = 'invalidZipCode',
  /** The input address is missing a house number */
  MissingAddressPrimaryNumber = 'missingAddressPrimaryNumber',
  /** The input address is missing ste, apt, or box number */
  MissingAddressSecondaryNumber = 'missingAddressSecondaryNumber',
  /** The input address matched to CMRA but PMB designator not present (PMB 123 or # 123) */
  MissingPmbNumber = 'missingPmbNumber',
  /** The input address is missing PO, RR, or HC box number */
  MissingPoBoxNumber = 'missingPoBoxNumber',
  /** An unknown or unmapped error occurred */
  Unknown = 'unknown',
}

/** The Address is verified as deliverable with no corrections issued on any input fields. */
export type AddressDeliverabilityVerified = {
  __typename?: 'AddressDeliverabilityVerified'
  additionalInfo: Maybe<AddressDeliverabilityAdditionalInfo>
  requestId: Maybe<Scalars['String']>
}

/** Address Document Requested Alert. */
export type AddressDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'AddressDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Changeable attributes for addresses */
export type AddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']>
  /** Country */
  country?: InputMaybe<Scalars['String']>
  /** State */
  state?: InputMaybe<Scalars['String']>
  /** Street 1 */
  street1?: InputMaybe<Scalars['String']>
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>
  /** Zip code */
  zipCode?: InputMaybe<Scalars['String']>
}

export enum AddressType {
  /** A billing address */
  Billing = 'billing',
  /** A mailing address */
  Mailing = 'mailing',
  /** A residential address */
  Residential = 'residential',
}

export type AddressVerification = {
  verificationStatus: VerificationStatus
}

/** An existing Acorns user that has referred friends to Acorns */
export type Advocate = {
  __typename?: 'Advocate'
  /** User's current eligible campaign */
  campaign: Maybe<ReferralCampaignV2>
  /** The content that supports and drives the user experience */
  experienceContent: Maybe<ExperienceContent>
  /**
   * A list of people that have used the advocate's share link
   * @deprecated Field no longer supported
   */
  friends: Maybe<Friend[]>
  /** The referral code associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>
  /**
   * An object with referral metrics for the advocate
   * @deprecated Field no longer supported
   */
  referralHistory: Maybe<ReferralHistory>
  /** UUID of the existing Acorns user */
  userId: Maybe<Scalars['ID']>
}

/** List of referral codes and friends that were referred by an existing Acorns user */
export type AdvocateFriendsStatuses = {
  __typename?: 'AdvocateFriendsStatuses'
  /** A list of people that have used the advocate's share link */
  friends: Maybe<Friend[]>
  /** The referral codes associated with the advocate */
  referralCodes: Maybe<Array<Scalars['String']>>
  /** User ID of the advocate */
  userId: Scalars['ID']
}

export type AdvocateV2 = {
  __typename?: 'AdvocateV2'
  userId: Maybe<Scalars['ID']>
}

export type Alert = {
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Response from beneficiary alert hub alerts query */
export type AlertHubBeneficiaryAlert =
  | MissingSsnBeneficiaryAlertItem
  | UnverifiedBeneficiarySsnAlertItem

export type AlertMessage = Message & {
  __typename?: 'AlertMessage'
  body: MessageTextAsset
  createdAt: Scalars['DateTime']
  deepLink: Maybe<Scalars['URL']>
  externalId: Scalars['ID']
  icon: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  messageCategory: MessageCategory
  messageType: MessageType
  platforms: Platform[]
  readAt: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type AllAccountHistorySummary = PastSummary & {
  __typename?: 'AllAccountHistorySummary'
  dividends: CurrencyAmount
  earnRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  referralRewards: CurrencyAmount
}

/** Optional filter to retrieve all accounts for a customer. */
export type AllAccountsFilterInput = {
  /** Retrieve accounts internal to Acorns. */
  internalType?: InputMaybe<Scalars['Boolean']>
}

export type AllBankAccountsInput = {
  /** Deprecated. Use types instead. types takes precedence over type if both are non-null */
  type?: InputMaybe<BankAccountType>
  types?: InputMaybe<BankAccountType[]>
}

export type AllBankCardsFilter = {
  showNonActive?: InputMaybe<Scalars['Boolean']>
}

export type AllBankDocumentsInput = {
  accountType?: InputMaybe<BankAccountType>
  isActive?: InputMaybe<Scalars['Boolean']>
}

export type AllChatHistoryMessages = {
  __typename?: 'AllChatHistoryMessages'
  edges: ChatHistoryMessageEdge[]
  pageInfo: PageInfo
}

/** The result of the allCheckPayments query */
export type AllCheckPaymentsResult = AuthorizationError | CheckPaymentConnection

export type AllPastCoreItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastEarlyItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastItemsFilter = {
  /** Requested Account */
  pastItemsAccountFilter?: InputMaybe<PastItemsAccountFilter>
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastLaterItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllPastSpendItemsSchemaFilter = {
  /** Only return pending items */
  pending?: InputMaybe<Scalars['Boolean']>
}

export type AllSupportArticlesFilterInput = {
  after?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  promoted?: InputMaybe<Scalars['Boolean']>
}

export type AllTransferableToInput = {
  /** ID of TransferableAccounts that money can be taken from */
  from: Scalars['ID']
}

/** Returned when the allocation amounts add up to over 100 */
export type AllocationAmountsSumExceedingMaxError = {
  __typename?: 'AllocationAmountsSumExceedingMaxError'
  message: Scalars['String']
}

export type AnswerChallengeResult =
  | AnswerChallengeSuccess
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException

export type AnswerChallengeSuccess = {
  __typename?: 'AnswerChallengeSuccess'
  authenticatorId: Scalars['ID']
  deliveryType: ChallengeDeliveryType
  userId: Scalars['ID']
}

export type AnswerLearnQuizQuestionInput = {
  questionId: Scalars['ID']
  quizId: Scalars['ID']
  /** A list of one or more answers (if multiple choice question) */
  selectedAnswers: LearnAnswerInput[]
}

export type AnswerLearnQuizQuestionResult =
  | LearnQuizAnswerResult
  | RecordDoesNotExistError
  | UnauthorizedModifyLockedContentError

export type ApplyPromoCodeResult = InvalidPromoCodeError | PromoCodeCustomer

export type ApplyPromotionInput = {
  promotionId: Scalars['ID']
  subscriptionId: Scalars['ID']
}

export type ApplyPromotionResult =
  | PromotionConsumedError
  | PromotionExpiredError
  | PromotionNotFoundError
  | SubscriberIneligibleError
  | TierSubscription

export type ApplyPromotionalWaiverInput = {
  monthsToWaive: Scalars['Int']
  promotion: WaiverPromotion_V2
}

export type ApplyPromotionalWaiverResult =
  | InvalidDateException
  | InvalidUserIdException
  | PromotionalWaiver_V2
  | WaiverCreationException

export type ApplyProvisionalWaiverResult =
  | InvalidDateException
  | InvalidUserIdException
  | ProvisionalWaiver_V2
  | WaiverCreationException

export type ArchiveInvalidSmartDepositRecordsResult = {
  __typename?: 'ArchiveInvalidSmartDepositRecordsResult'
  userId: Scalars['String']
}

/** Options to assign a subaccount to a given role */
export type AssignLinkedSubaccountInput = {
  /** Role to give the linked subaccount */
  role: LinkedSubaccountRoleEnum
}

/** Response returned if the link session is asynchronous. */
export type AsyncLinkSessionResult = {
  __typename?: 'AsyncLinkSessionResult'
  /** The asynchronous process was kicked off successfully? */
  success: Scalars['Boolean']
}

export type AuthAlert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

export type AuthChallenge = {
  alternateAuthenticators: AuthenticatorInfo[]
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type AuthChallengeAnswerAttemptsExhaustedException = {
  __typename?: 'AuthChallengeAnswerAttemptsExhaustedException'
  message: Maybe<Scalars['String']>
}

export type AuthChallengeAnswerIncorrectException = {
  __typename?: 'AuthChallengeAnswerIncorrectException'
  message: Maybe<Scalars['String']>
}

export type AuthChallengeExpiredException = {
  __typename?: 'AuthChallengeExpiredException'
  message: Maybe<Scalars['String']>
}

export type AuthProfile = {
  __typename?: 'AuthProfile'
  /** the Authenticator that will be used for challenges by default. */
  defaultAuthenticator: Maybe<Authenticator>
  email: Maybe<Scalars['EmailAddress']>
  emailVerifiedAt: Maybe<Scalars['DateTime']>
  loginAccess: Maybe<LoginAccess>
  phoneNumber: Maybe<Scalars['String']>
  phoneNumberVerifiedAt: Maybe<Scalars['DateTime']>
  privateRelayUnverified: Maybe<Scalars['Boolean']>
  requireLoginChallenge: Maybe<Scalars['Boolean']>
  userId: Scalars['ID']
}

export type AuthProfileAlreadyExistsException = {
  __typename?: 'AuthProfileAlreadyExistsException'
  message: Maybe<Scalars['String']>
}

export type AuthProfileNotFoundException = {
  __typename?: 'AuthProfileNotFoundException'
  userId: Scalars['ID']
}

export type AuthSession = {
  __typename?: 'AuthSession'
  id: Scalars['ID']
  identityId: Scalars['ID']
  /** @deprecated No longer used */
  redirectUrl: Maybe<Scalars['URL']>
  refreshToken: Maybe<Scalars['ID']>
  token: Scalars['ID']
}

export type AuthTokenNotFoundException = {
  __typename?: 'AuthTokenNotFoundException'
  userId: Scalars['ID']
}

export enum AuthType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Push = 'PUSH',
}

export type AuthenticateForFeeNegotiationChallengeInput = {
  linkedAccountId: Scalars['ID']
  tfaInput: Scalars['String']
}

export type AuthenticateForFeeNegotiationChallengeMethodInput = {
  linkedAccountId: Scalars['ID']
  restart: Scalars['Boolean']
  tfaOption: Scalars['String']
  tfaType: TfaType
}

export type AuthenticateForFeeNegotiationInput = {
  bankName: BankName
  linkedAccountId: Scalars['ID']
  password: Scalars['String']
  reconnect: Scalars['Boolean']
  userName: Scalars['String']
}

export type AuthenticateForFeeNegotiationResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound
  | NegotiationServiceConnectionFailure

export type AuthenticateForFeeNegotiationStatus = {
  __typename?: 'AuthenticateForFeeNegotiationStatus'
  credentialStatus: CredentialStatus
  operationError: Maybe<AutomationError>
  operationStage: OperationStage
  tfaMethod: Maybe<Scalars['String']>
  tfaOptions: Maybe<TfaOptions>
  tfaStatus: TfaStatus
  tfaType: TfaType
}

export type AuthenticateInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
  rememberMe?: InputMaybe<Scalars['Boolean']>
  udid: Scalars['String']
}

export type AuthenticateNegotiationStatusResult =
  | AuthenticateForFeeNegotiationStatus
  | LinkedAccountNotFound

export type AuthenticateResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthSession
  | AuthenticatorTypeAlreadyRegisteredException
  | AuthenticatorUnavailableException
  | ChallengeRateExceededException
  | DeviceBlockedException
  | EmailAuthChallenge
  | InvalidCredentialsException
  | LoginRateLimitedException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge
  | UserLockedException
  | UserSuspendedException

export type AuthenticationAlreadyUpgradedException = {
  __typename?: 'AuthenticationAlreadyUpgradedException'
  userId: Scalars['ID']
}

export type Authenticator = {
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type AuthenticatorAlreadyDefaultException = {
  __typename?: 'AuthenticatorAlreadyDefaultException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorInfo = {
  __typename?: 'AuthenticatorInfo'
  id: Scalars['ID']
  type: AuthType
}

export type AuthenticatorNotFoundException = {
  __typename?: 'AuthenticatorNotFoundException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorTypeAlreadyRegisteredException = {
  __typename?: 'AuthenticatorTypeAlreadyRegisteredException'
  message: Maybe<Scalars['String']>
}

export type AuthenticatorUnavailableException = {
  __typename?: 'AuthenticatorUnavailableException'
  message: Maybe<Scalars['String']>
}

export type AuthorizationError = {
  __typename?: 'AuthorizationError'
  requestId: Scalars['ID']
}

export type AutomationError = {
  __typename?: 'AutomationError'
  error: Maybe<Scalars['String']>
  errorCode: Maybe<AutomationErrorCode>
}

export enum AutomationErrorCode {
  CttEx = 'CTT_EX',
  LogBlk = 'LOG_BLK',
  LogEx = 'LOG_EX',
  LogInv = 'LOG_INV',
  SttEx = 'STT_EX',
  SttRes = 'STT_RES',
  TfaInv = 'TFA_INV',
  TfaSelInv = 'TFA_SEL_INV',
  WfTfa = 'WF_TFA',
}

export type BackendJobBatch = {
  __typename?: 'BackendJobBatch'
  createdAt: Scalars['DateTime']
  failedJobs: Maybe<Scalars['Int']>
  id: Scalars['ID']
  name: Scalars['String']
  pendingJobs: Maybe<Scalars['Int']>
  pendingPercentage: Maybe<Scalars['Float']>
  processedJobs: Maybe<Scalars['Int']>
  status: BackendJobBatchStatus
  successPercentage: Maybe<Scalars['Float']>
  totalJobs: Maybe<Scalars['Int']>
  type: BackendJobBatchType
}

export type BackendJobBatchAutomatedOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchMoneyMovementFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchOrdersFilterInput = {
  jobBatchType?: InputMaybe<BackendJobBatchType>
  timeframe: BackendJobBatchTimeframe
}

export type BackendJobBatchProfitStarsFilterInput = {
  timeframe: BackendJobBatchTimeframe
}

export enum BackendJobBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Restarted = 'RESTARTED',
  Started = 'STARTED',
}

export type BackendJobBatchSummary = {
  __typename?: 'BackendJobBatchSummary'
  createdAt: Scalars['DateTime']
  customerCount: Maybe<Scalars['Int']>
  id: Scalars['ID']
  name: Scalars['String']
  totalHoldingsAmount: Maybe<Scalars['Float']>
  totalInvestmentAmount: Maybe<Scalars['Float']>
  totalInvestmentCount: Maybe<Scalars['Int']>
}

export type BackendJobBatchSummaryFilterInput = {
  jobBatchType: BackendJobBatchType
  timeframe: BackendJobBatchTimeframe
}

export enum BackendJobBatchTimeframe {
  LastSeven = 'LAST_SEVEN',
  LastThirty = 'LAST_THIRTY',
  Month = 'MONTH',
  Today = 'TODAY',
  Year = 'YEAR',
  Yesterday = 'YESTERDAY',
}

export enum BackendJobBatchType {
  AutomatedBuyOrderConfirm = 'AUTOMATED_BUY_ORDER_CONFIRM',
  AutomatedBuyOrderLock = 'AUTOMATED_BUY_ORDER_LOCK',
  AutomatedSellFeeOrderConfirm = 'AUTOMATED_SELL_FEE_ORDER_CONFIRM',
  AutomatedSellFeeOrderLock = 'AUTOMATED_SELL_FEE_ORDER_LOCK',
  BuyOrderConfirm = 'BUY_ORDER_CONFIRM',
  BuyOrderLock = 'BUY_ORDER_LOCK',
  ChargebackOrderLock = 'CHARGEBACK_ORDER_LOCK',
  ProfitStarsDeposits = 'PROFIT_STARS_DEPOSITS',
  RebalanceBuyOrderConfirm = 'REBALANCE_BUY_ORDER_CONFIRM',
  RebalanceBuyOrderLock = 'REBALANCE_BUY_ORDER_LOCK',
  RebalanceSellOrderConfirm = 'REBALANCE_SELL_ORDER_CONFIRM',
  RebalanceSellOrderLock = 'REBALANCE_SELL_ORDER_LOCK',
  SellFeeOrderConfirm = 'SELL_FEE_ORDER_CONFIRM',
  SellFeeOrderLock = 'SELL_FEE_ORDER_LOCK',
  TransferApproval = 'TRANSFER_APPROVAL',
}

/** Request either has missing or incorrect data */
export type BadRequestError = {
  __typename?: 'BadRequestError'
  message: Scalars['String']
}

export enum BadgeCategory {
  NewCustomer = 'NEW_CUSTOMER',
  Travel = 'TRAVEL',
}

export type BankAccount = {
  __typename?: 'BankAccount'
  accountHolderReferenceId: Scalars['ID']
  /** The name of the account */
  accountName: Scalars['String']
  /**
   * Balance available for immediate withdrawal.
   * Settling a transaction for a DDA account will typically credit the
   * availableBalance immediately. However, savings or FBO accounts may have
   * a "deposit hold time" or a "new customer hold time", meaning there could be
   * a length of time between when the transaction is settled and the corresponding
   * funds are made available for withdrawal.
   */
  availableBalance: CurrencyAmount
  availableBalanceAndIncomingBalance: CurrencyAmount
  balance: CurrencyAmount
  /** The bank that this account is associated with */
  bankType: BankType
  closedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  /**
   * The interest rates that are currently being offered
   * @deprecated Use bankInterestRates Query to get apy
   */
  currentAPY: Maybe<Scalars['String']>
  /** @deprecated Use balance */
  currentBalance: CurrencyAmount
  /** Information related to the goals of the bank account */
  goals: BankAccountGoals
  id: Scalars['ID']
  isEligible: Scalars['Boolean']
  isLocked: Scalars['Boolean']
  /**
   * True if an account closure has been initiated but
   * was unsuccessful in automatically closing.
   */
  isPendingClosure: Maybe<Scalars['Boolean']>
  lockReason: Maybe<BankAccountLockReason>
  number: Scalars['String']
  /**
   * Balance of pending deposit transactions. When a pending deposit transaction
   * settles, it will debit this balance. Deposit transactions which settle
   * immediately will never affect this balance.
   */
  pendingBalance: CurrencyAmount
  referenceId: Scalars['ID']
  /**
   * The current status of the account and requirements
   * needed to be met to close the account
   */
  requirements: BankAccountRequirements
  routingNumber: Scalars['String']
  status: BankAccountStatus
  /**
   * Total balance of account, including funds that have holds placed on them. Represents all settled
   * transactions on the account to date. Balance of pending deposit transactions. When a pending deposit transaction settles, it will
   * debit this balance. Deposit transactions which settle immediately will never affect this
   * balance.
   */
  totalBalance: CurrencyAmount
  type: BankAccountType
  updatedAt: Scalars['DateTime']
}

export enum BankAccountClosureReason {
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Missing features I expect with a checking account */
  MissingFeaturesExpectedWithCheckingAccount = 'MISSING_FEATURES_EXPECTED_WITH_CHECKING_ACCOUNT',
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Other */
  Other = 'OTHER',
}

export type BankAccountDisclosure = {
  __typename?: 'BankAccountDisclosure'
  id: Scalars['ID']
  mustScrollToBottom: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  requiredFor: Maybe<Scalars['String']>
  summaryName: Maybe<Scalars['String']>
  summaryUrl: Maybe<Scalars['String']>
  type: Scalars['String']
  url: Scalars['String']
  version: Scalars['String']
}

export type BankAccountDisclosureFilter = {
  bankType: BankType
  paymentProcessor: BankCardPaymentProcessor
}

export type BankAccountGoal = {
  __typename?: 'BankAccountGoal'
  amount: CurrencyAmount
  name: Scalars['String']
  type: BankAccountGoalType
}

export type BankAccountGoalInput = {
  amount: PositiveCurrencyAmountInput
  type: BankAccountGoalType
}

export enum BankAccountGoalType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export type BankAccountGoals = {
  __typename?: 'BankAccountGoals'
  currentGoal: Maybe<BankAccountGoal>
}

export enum BankAccountLockReason {
  Administrative = 'Administrative',
  CreditsOnly = 'CreditsOnly',
  Fraud = 'Fraud',
  Frozen = 'Frozen',
  Temporary = 'Temporary',
  Unknown = 'Unknown',
}

export type BankAccountNotFoundError = {
  __typename?: 'BankAccountNotFoundError'
  message: Scalars['String']
}

/**
 * Defines a list of requirements that must be met before a bank account
 * can be closed
 */
export type BankAccountRequirement = {
  __typename?: 'BankAccountRequirement'
  actionable: Scalars['Boolean']
  description: Maybe<Scalars['String']>
  status: BankAccountRequirementStatus
  type: BankAccountRequirementType
}

export enum BankAccountRequirementStatus {
  ActionsRequired = 'ACTIONS_REQUIRED',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum BankAccountRequirementType {
  FundingSource = 'FUNDING_SOURCE',
  NoPendingTransfers = 'NO_PENDING_TRANSFERS',
  UnlockedCheckingAccount = 'UNLOCKED_CHECKING_ACCOUNT',
  VerifiedFundingSource = 'VERIFIED_FUNDING_SOURCE',
}

export type BankAccountRequirements = {
  __typename?: 'BankAccountRequirements'
  close: BankAccountRequirement[]
}

export type BankAccountState = {
  __typename?: 'BankAccountState'
  accountType: BankAccountType
  status: BankAccountStateStatus
}

export type BankAccountStateResult = {
  __typename?: 'BankAccountStateResult'
  accounts: BankAccountState[]
}

export enum BankAccountStateStatus {
  Closed = 'CLOSED',
  HardFailure = 'HARD_FAILURE',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING',
}

export enum BankAccountStatus {
  Closed = 'closed',
  Locked = 'locked',
  Open = 'open',
}

export enum BankAccountType {
  Save = 'save',
  Spend = 'spend',
}

export type BankAccountTypeConfig = {
  accountType: BankAccountType
  bankType?: InputMaybe<BankType>
  isReopen?: InputMaybe<Scalars['Boolean']>
}

export type BankCard = {
  __typename?: 'BankCard'
  activatedAt: Maybe<Scalars['DateTime']>
  bankType: BankType
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>
  createdAt: Scalars['DateTime']
  digitalWalletTokens: DigitalWalletToken[]
  expireMonth: Scalars['Int']
  expireYear: Scalars['Int']
  id: Scalars['ID']
  isDigitalOnly: Maybe<Scalars['Boolean']>
  isDigitallyProvisioned: Scalars['Boolean']
  lockReason: Maybe<BankCardLockReason>
  lockTypeCode: BankCardLockTypeCode
  paymentProcessor: BankCardPaymentProcessor
  referenceId: Scalars['ID']
  status: BankCardStatus
  tier: BankCardTier
  type: BankCardType
  userActivatedAt: Maybe<Scalars['DateTime']>
}

export enum BankCardLockReason {
  Admin = 'admin',
  Damage = 'damage',
  Fraud = 'fraud',
  Lost = 'lost',
  PinRetriesExceeded = 'pinRetriesExceeded',
  Stolen = 'stolen',
  Temporary = 'temporary',
  Unknown = 'unknown',
}

export enum BankCardLockTypeCode {
  Customer = 'customer',
  System = 'system',
  Unlocked = 'unlocked',
}

export type BankCardOrder = {
  __typename?: 'BankCardOrder'
  addressVerification: Maybe<BankCardOrderAddressVerification>
  bankCardTier: Maybe<BankCardTier>
  bankType: Maybe<BankType>
  cardOrderStatus: BankCardOrderStatus
  createdAt: Maybe<Scalars['String']>
  failureReason: Maybe<BankCardOrderFailureReason>
  fundingInitiated: Maybe<Scalars['Boolean']>
  fundingSourceVerification: Maybe<BankCardOrderFundingSourceVerification>
  identityVerification: Maybe<BankCardOrderIdentityVerification>
  /**
   * Verification results for this customer contained reasons that we consider high risk,
   * irrespective of the decision returned by our KYC vendor.
   * The purpose of this field is to surface that risk to related backend services.
   * Front end clients should confirm with banking team before using.
   */
  isKycHighRisk: Maybe<Scalars['Boolean']>
  kycStatus: Maybe<KycStatus>
  prefundVerification: Maybe<BankCardOrderPrefundVerification>
  requestVersion: Maybe<RequestVersions>
}

export type BankCardOrderAddressVerification = AddressVerification & {
  __typename?: 'BankCardOrderAddressVerification'
  actionRequired: Maybe<BankCardOrderAddressVerificationActions>
  status: BankCardOrderVerificationStatus
  verificationStatus: VerificationStatus
}

export enum BankCardOrderAddressVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFailureReason {
  AddressFailure = 'ADDRESS_FAILURE',
  Expired = 'EXPIRED',
  FundingSourceFailure = 'FUNDING_SOURCE_FAILURE',
  IdentityFailure = 'IDENTITY_FAILURE',
  PrefundFailure = 'PREFUND_FAILURE',
}

export type BankCardOrderFundingSourceVerification = {
  __typename?: 'BankCardOrderFundingSourceVerification'
  actionRequired: Maybe<BankCardOrderFundingSourceVerificationActions>
  pendingReason: Maybe<BankCardOrderFundingSourceVerificationPendingReason>
  status: BankCardOrderVerificationStatus
}

export enum BankCardOrderFundingSourceVerificationActions {
  HandleFrozenFundingSource = 'handleFrozenFundingSource',
  LinkFundingSource = 'linkFundingSource',
  SubmitRdVs = 'submitRDVs',
  UploadDocuments = 'uploadDocuments',
}

export enum BankCardOrderFundingSourceVerificationPendingReason {
  DocumentsUnderReview = 'documentsUnderReview',
  RdvsInitiated = 'rdvsInitiated',
  RdvsPending = 'rdvsPending',
}

export type BankCardOrderIdentityVerification = IdentityVerification & {
  __typename?: 'BankCardOrderIdentityVerification'
  actionRequired: Maybe<BankCardOrderIdentityVerificationActions>
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual approval due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>
  documentUploadUrl: Maybe<Scalars['String']>
  status: BankCardOrderVerificationStatus
  verificationStatus: VerificationStatus
}

export enum BankCardOrderIdentityVerificationActions {
  UploadDocuments = 'uploadDocuments',
}

export type BankCardOrderPrefundVerification = {
  __typename?: 'BankCardOrderPrefundVerification'
  actionRequired: Maybe<BankCardOrderPrefundVerificationActions>
  status: BankCardOrderVerificationStatus
}

export enum BankCardOrderPrefundVerificationActions {
  CreateBankTransfer = 'createBankTransfer',
}

export enum BankCardOrderStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  NotOrdered = 'notOrdered',
  Pending = 'pending',
  Success = 'success',
}

export enum BankCardOrderVerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success',
}

export type BankCardPanDisplayPayload = {
  __typename?: 'BankCardPanDisplayPayload'
  bankCard: BankCard
  token: Scalars['String']
}

export type BankCardPanDisplayResult = BankCardPanDisplayPayload

export enum BankCardPaymentProcessor {
  Dps = 'DPS',
  Shazam = 'SHAZAM',
}

export enum BankCardPermanentLockReason {
  Fraud = 'fraud',
  Lost = 'lost',
  Stolen = 'stolen',
}

export type BankCardPrefundTransfer = {
  /** Amount (either $0 or between $25, $500) to transfer after bank account is created. */
  amount: PositiveCurrencyAmountInput
}

export type BankCardProvisioningDetailsInput = {
  nonce: Scalars['String']
}

export type BankCardProvisioningDetailsPayload = {
  __typename?: 'BankCardProvisioningDetailsPayload'
  cardNumberMasked: Maybe<Scalars['CardNumberMasked']>
  token: Scalars['String']
}

export type BankCardProvisioningDetailsResult =
  BankCardProvisioningDetailsPayload

export type BankCardReissue = {
  __typename?: 'BankCardReissue'
  bankCardRequest: Maybe<BankCardRequest>
  bankType: BankType
  reissueBankCardEligibility: ReissueBankCardEligibility
}

export type BankCardRequest = {
  __typename?: 'BankCardRequest'
  /** tag for new bank card */
  id: Scalars['ID']
  /** True when new bank card has been activated */
  isActivated: Scalars['Boolean']
  isReissue: Scalars['Boolean']
  /** Issued date for new bank card */
  issuedDate: Maybe<Scalars['Date']>
  /** The mailing address used to ship the reissued card */
  mailingAddress: Maybe<BankCardRequestMailingAddress>
  previousBankCardId: Maybe<Scalars['ID']>
  /** The tier level of the card. */
  previousBankCardTier: Maybe<BankCardTier>
  /** Reason for requesting a new bank card */
  reason: BankCardRequestReason
  /** Additional information pertaining to the request */
  reasonComment: Maybe<Scalars['String']>
  /** Date associated with reason (Date lost, date stolen, etc) */
  reasonDate: Maybe<Scalars['Date']>
  requestedDate: Scalars['Date']
  status: BankCardRequestStatus
  userId: Scalars['ID']
}

export type BankCardRequestMailingAddress = {
  __typename?: 'BankCardRequestMailingAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type BankCardRequestMailingAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

export enum BankCardRequestReason {
  Damaged = 'DAMAGED',
  DeliveryIssue = 'DELIVERY_ISSUE',
  Lost = 'LOST',
  NewAccount = 'NEW_ACCOUNT',
  Other = 'OTHER',
  Stolen = 'STOLEN',
}

export enum BankCardRequestStatus {
  Approved = 'APPROVED',
  Issued = 'ISSUED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}

export enum BankCardStatus {
  Archived = 'archived',
  Denied = 'denied',
  DigitalActivePhysicalInitiated = 'digitalActivePhysicalInitiated',
  DigitalActivePhysicalPending = 'digitalActivePhysicalPending',
  Expired = 'expired',
  Hotlisted = 'hotlisted',
  Initiated = 'initiated',
  Pending = 'pending',
  PendingVerification = 'pendingVerification',
  Reissued = 'reissued',
  Verified = 'verified',
}

export enum BankCardTemporaryLockReason {
  Damage = 'damage',
  Fraud = 'fraud',
  Temporary = 'temporary',
  Unknown = 'unknown',
}

export enum BankCardTier {
  MightyOak = 'mightyOak',
  Oak = 'oak',
  PremiumOak = 'premiumOak',
  VipReissue = 'vipReissue',
}

export enum BankCardType {
  Credit = 'credit',
  Debit = 'debit',
}

export type BankConnection = {
  __typename?: 'BankConnection'
  accountStatus: Maybe<BankConnectionStatus>
  bank: Scalars['String']
  eligible: Maybe<Scalars['Boolean']>
  lastSubmissionDate: Maybe<Scalars['DateTime']>
  linkedAccountId: Scalars['ID']
  logoUrl: Maybe<Scalars['URL']>
  negotiationType: Maybe<NegotiationType>
  nextSubmissionDate: Maybe<Scalars['DateTime']>
  totalNegotiableFees: Maybe<MonetaryAmount>
}

export enum BankConnectionStatus {
  Eligible = 'ELIGIBLE',
  IneligibleCooldown = 'INELIGIBLE_COOLDOWN',
  IneligibleNotsupported = 'INELIGIBLE_NOTSUPPORTED',
  IneligibleThreshold = 'INELIGIBLE_THRESHOLD',
  Lowertier = 'LOWERTIER',
  Pending = 'PENDING',
}

export type BankDocument = {
  __typename?: 'BankDocument'
  name: Scalars['String']
  type: Scalars['String']
  url: Scalars['String']
}

/** Bank Document Requested Alert. */
export type BankDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'BankDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type BankFee = {
  __typename?: 'BankFee'
  accountName: Maybe<Scalars['String']>
  amount: MonetaryAmount
  category: Maybe<TransactionCategory>
  /** @deprecated replaced by last4 */
  digit: Maybe<Scalars['String']>
  last4: Maybe<Scalars['String']>
  linkedAccountId: Maybe<Scalars['ID']>
  linkedSubAccountId: Maybe<Scalars['ID']>
  name: Maybe<Scalars['String']>
  status: Maybe<FeeStatus>
  submissionKey: Maybe<Scalars['String']>
  subtitle: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  transactionDate: Maybe<Scalars['DateTime']>
  type: Maybe<BankFeeType>
}

export type BankFeeConnection = {
  __typename?: 'BankFeeConnection'
  bank: BankName
  eligible: Scalars['Boolean']
  feeSynopsis: Maybe<Scalars['String']>
  institutionName: Scalars['String']
  latestSubmission: Maybe<Submission>
  linkedAccountId: Scalars['ID']
  logoUrl: Scalars['URL']
  mailInEligibility: Scalars['Boolean']
  status: ConnectionStatus
  submissions: Maybe<Submission[]>
  totalNegotiableFees: MonetaryAmount
}

export type BankFeeFilter = {
  connectionStatus?: InputMaybe<BankConnectionStatus[]>
  status?: InputMaybe<FeeStatus[]>
  submissionKey?: InputMaybe<Scalars['String']>
}

export enum BankFeeNegotiationExternalStatus {
  ActionrequiredConnectionError = 'ACTIONREQUIRED_CONNECTION_ERROR',
  ActionrequiredReportRefund = 'ACTIONREQUIRED_REPORT_REFUND',
  ActionrequiredScheduleCall = 'ACTIONREQUIRED_SCHEDULE_CALL',
  CallScheduled = 'CALL_SCHEDULED',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED',
  SubmittedSent = 'SUBMITTED_SENT',
}

export enum BankFeeNegotiationInternalStatus {
  AutofetchCompleted = 'AUTOFETCH_COMPLETED',
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
}

export enum BankFeeNegotiationStatus {
  AutoConnectionError = 'AUTO_CONNECTION_ERROR',
  AutoError = 'AUTO_ERROR',
  AutoInProgress = 'AUTO_IN_PROGRESS',
  CallScheduled = 'CALL_SCHEDULED',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInScheduleCall = 'MAIL_IN_SCHEDULE_CALL',
  MailInSent = 'MAIL_IN_SENT',
  ResolvedNoRefund = 'RESOLVED_NO_REFUND',
  ResolvedRefund = 'RESOLVED_REFUND',
  Submitted = 'SUBMITTED',
}

export type BankFeeSummary = {
  __typename?: 'BankFeeSummary'
  coffeeCount: Scalars['Int']
  eligible: Scalars['Boolean']
  feesFound: FeeStatusSummary
  linkedAccounts: BankFeeConnection[]
  totalNegotiableFees: MonetaryAmount
  totalNegotiatedFees: MonetaryAmount
  totalReimbursedFees: MonetaryAmount
}

export enum BankFeeType {
  AccountMaintenanceFee = 'ACCOUNT_MAINTENANCE_FEE',
  AtmFee = 'ATM_FEE',
  BalanceInquiryFee = 'BALANCE_INQUIRY_FEE',
  CardSetupFee = 'CARD_SETUP_FEE',
  CashAdvance = 'CASH_ADVANCE',
  CheckFee = 'CHECK_FEE',
  ClosedAccountProcessingFee = 'CLOSED_ACCOUNT_PROCESSING_FEE',
  CreditCardInterestCharge = 'CREDIT_CARD_INTEREST_CHARGE',
  DormantFee = 'DORMANT_FEE',
  EarlyClosureFee = 'EARLY_CLOSURE_FEE',
  ExcessFee = 'EXCESS_FEE',
  ExternalTransferFee = 'EXTERNAL_TRANSFER_FEE',
  ForeignTransactionFee = 'FOREIGN_TRANSACTION_FEE',
  LateFee = 'LATE_FEE',
  MinimumBalanceFee = 'MINIMUM_BALANCE_FEE',
  MonthlyServiceFee = 'MONTHLY_SERVICE_FEE',
  NsfFee = 'NSF_FEE',
  OverdraftFee = 'OVERDRAFT_FEE',
  PaperStatementFee = 'PAPER_STATEMENT_FEE',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  WireTransferFee = 'WIRE_TRANSFER_FEE',
}

export type BankInterestRate = {
  __typename?: 'BankInterestRate'
  /** Pre-formatted to two places (i.e. "5.00"). Not present if the product has no associated interest rate. */
  currentApy: Maybe<Scalars['String']>
  liveDate: Maybe<Scalars['String']>
  productName: BankingProduct
}

export type BankInterestRates = {
  __typename?: 'BankInterestRates'
  bankInterestRates: Maybe<BankInterestRate[]>
}

export type BankInterestRatesResult = BankInterestRates | BankServiceFailure

export type BankMetadata = {
  __typename?: 'BankMetadata'
  /** Deprecated */
  totals: Maybe<BankMetadataTotals>
}

export type BankMetadataTotals = {
  __typename?: 'BankMetadataTotals'
  oak: Scalars['Int']
  royalOak: Scalars['Int']
}

export enum BankName {
  Chase = 'CHASE',
  NotApplicable = 'NOT_APPLICABLE',
  TestBank = 'TEST_BANK',
  WellsFargo = 'WELLS_FARGO',
}

export type BankServiceFailure = {
  __typename?: 'BankServiceFailure'
  reason: Maybe<Scalars['String']>
  retryable: Maybe<Scalars['Boolean']>
}

export type BankStatement = {
  __typename?: 'BankStatement'
  createdAt: Scalars['DateTime']
  month: Scalars['String']
  type: BankStatementType
  url: Scalars['String']
  year: Scalars['String']
}

export enum BankStatementType {
  Monthly = 'monthly',
  Tax = 'tax',
}

export type BankTransaction = {
  __typename?: 'BankTransaction'
  /** The amount of funds the transaction represents. */
  amount: CurrencyAmount
  /** The exact date and time the funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>
  /**
   * The card that created the transaction. Will be null if this transaction is
   * not tied to a card
   */
  bankCard: Maybe<BankCard>
  /** The exact date and time the transaction was created */
  createdAt: Scalars['DateTime']
  /**
   * Represents a client-specified description of the transaction.
   * If transaction was received from a NACHA file (typeCode is UNKWTH, UNKDEP, UNKRSV),
   * this property contains the description verbatim from the NACHA file. By law, this
   * description must be displayed to the end user. If transaction was received
   * from an ISO-8583 interface (i.e. debit card transaction), this property contains
   * description verbatim from DataElement 43 (Card Acceptor Name/Location) of
   * ISO-8583 interface plus details of any fees or surchages that may have been
   * incurred. By law, this description must be displayed to the end user
   * Otherwise, the transaction was received from a call to CorePro API or it was
   * line item in the Bulk Transfer File. This property contains the description
   * verbatim passed by the client code
   */
  description: Scalars['String']
  id: Scalars['ID']
  nachaCode: Scalars['String']
  nachaInfo: Maybe<BankTransactionNachaInfo>
  /** The exact date and time the transaction was settled. */
  settledAt: Maybe<Scalars['DateTime']>
  /** The status of the transaction */
  status: BankTransactionStatus
  /**
   * Shorter version of description. Depending on type, may contain full description.
   * Ex. Purchase transactions contain merchant name without address.
   */
  summary: Scalars['String']
  /** The program-wide unique identifier generated for each transfer */
  tag: Maybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt: Scalars['DateTime']
  /** The exact date and time the transaction was voided. */
  voidedAt: Maybe<Scalars['DateTime']>
}

export type BankTransactionConnection = {
  __typename?: 'BankTransactionConnection'
  edges: Array<Maybe<BankTransactionEdge>>
  pageInfo: PageInfo
}

export type BankTransactionEdge = {
  __typename?: 'BankTransactionEdge'
  cursor: Scalars['ID']
  node: Maybe<BankTransaction>
}

export type BankTransactionNachaInfo = {
  __typename?: 'BankTransactionNachaInfo'
  companyDiscretionaryData: Maybe<Scalars['String']>
  companyEntryDescription: Maybe<Scalars['String']>
  companyIdentification: Maybe<Scalars['String']>
  companyName: Maybe<Scalars['String']>
  isEarlyDeposit: Maybe<Scalars['Boolean']>
  nachaSettledDate: Maybe<Scalars['DateTime']>
  standardEntryClassCode: Maybe<Scalars['String']>
}

export enum BankTransactionStatus {
  /** Transaction has been created but not yet put into a NACHA file */
  Initiated = 'initiated',
  /** Transaction has been created and put into a NACHA file */
  Pending = 'pending',
  /** Transaction has been posted to the account */
  Settled = 'settled',
  /** Transaction has been voided */
  Voided = 'voided',
}

export enum BankTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

export enum BankType {
  Lsb = 'LSB',
  Nbkc = 'NBKC',
}

export type BankingKyc = {
  __typename?: 'BankingKyc'
  addressVerification: Maybe<AddressVerification>
  identityVerification: Maybe<IdentityVerification>
  kycStatus: Maybe<KycStatus>
  /**
   * Details of Banking KYC results surfaced for clients that have been cleared to reuse Banking KYC user info for specific scenarios, with specific criteria.
   * Usage of this field is only appliable for approved clients.
   * Please confirm with the banking team before using.
   */
  verificationDetails: Maybe<VerificationDetails>
}

export type BankingKycAddressVerification = AddressVerification & {
  __typename?: 'BankingKycAddressVerification'
  verificationStatus: VerificationStatus
}

export type BankingKycIdentityVerification = IdentityVerification & {
  __typename?: 'BankingKycIdentityVerification'
  /**
   * If the user can re-attempt identity verification
   * They may have reached the max configured allowed attempts, or need manual review due to suspected fraud or risk
   */
  canRetry: Maybe<Scalars['Boolean']>
  verificationStatus: VerificationStatus
}

export enum BankingProduct {
  EmergencySavings = 'emergencySavings',
  MightyOakChecking = 'mightyOakChecking',
  MightyOakEmergencyFund = 'mightyOakEmergencyFund',
  OakChecking = 'oakChecking',
  OakEmergencyFund = 'oakEmergencyFund',
}

export type BannersErrors = {
  __typename?: 'BannersErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export type BannersResponse =
  | BannersErrors
  | HelpcenterBannerContent
  | SiteWideBannerContent

/** Acorns base Portfolio interface */
export type BasePortfolio = {
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<PortfolioSecurity[]>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<PortfolioSecurityAllocation[]>
  yearToDateReturn: Maybe<MarketReturn>
}

/** Returned result for a batchAddTierSubscriptions mutation */
export type BatchAddTierSubscriptions = {
  __typename?: 'BatchAddTierSubscriptions'
  addedIds: Array<Scalars['ID']>
  unaddedIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsInput = {
  allowInactiveTier?: InputMaybe<Scalars['Boolean']>
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  migrationId?: InputMaybe<Scalars['ID']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userIds: Array<Scalars['ID']>
}

export type BatchAddTierSubscriptionsResult =
  | BatchAddTierSubscriptions
  | InvalidTier
  | InvalidTierPrice

/** A person who doesn't have an Acorns account, but may someday inherit one or funds from one. */
export type Beneficiary = TimestampsInterface & {
  __typename?: 'Beneficiary'
  /** List of addresses associated with beneficiary */
  addresses: Maybe<Array<Maybe<Address>>>
  /** Age of beneficiary */
  age: Scalars['Int']
  /** URL for the Beneficiary's avatar image */
  avatarUrl: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for user who this beneficiary belongs to */
  custodianId: Scalars['ID']
  /** Beneficiary's nickname for their custodian */
  custodianNickname: Maybe<Scalars['String']>
  /**
   * Beneficiary's date of birth:
   * @deprecated Use beneficiary.age or beneficiary.eligible for contribution tooltip instead
   */
  dateOfBirth: Scalars['String']
  /** Timestamp when the Beneficiary was deactivated */
  deactivatedAt: Maybe<Scalars['DateTime']>
  /** Beneficiary's birthday is within the next month */
  eligibleForContributionTooltip: Scalars['Boolean']
  /** Beneficiary's email ID */
  email: Maybe<Scalars['Email']>
  /** First name of beneficiary */
  firstName: Scalars['String']
  /** Internal ID for beneficiary */
  id: Scalars['ID']
  /** Beneficiary's investment account */
  investmentAccount: Maybe<InvestmentAccount>
  /** Last name of beneficiary */
  lastName: Scalars['String']
  /** List of phone numbers associated with the beneficiary */
  phoneNumbers: Maybe<Array<Maybe<Phone>>>
  /** True if the beneficiary has an ssn false if not */
  ssnPresent: Scalars['Boolean']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Cannot open early account because the beneficiary account already exsists */
export type BeneficiaryAccountExistsException = {
  __typename?: 'BeneficiaryAccountExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** A person with the supplied date of birth is too old to open a UTMA/UGMA account */
export type BeneficiaryExceedsAgeLimitException = {
  __typename?: 'BeneficiaryExceedsAgeLimitException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInfoInput = {
  /** Beneficiaries nickname for their custodian. */
  custodianNickname?: InputMaybe<Scalars['String']>
  /** Beneficiary Email */
  email?: InputMaybe<Scalars['Email']>
  /** Mailing Address */
  mailingAddress?: InputMaybe<AddressInput>
  /** Beneficiary Phone number */
  phoneNumber?: InputMaybe<Scalars['String']>
}

/** Changeable attributes for beneficiaries */
export type BeneficiaryInput = {
  /** Date of Birth */
  dateOfBirth: Scalars['String']
  /** Beneficiary First Name */
  firstName: Scalars['String']
  /** Beneficiary Last Name */
  lastName: Scalars['String']
}

/** Beneficiary does not exist */
export type BeneficiaryNotFoundException = {
  __typename?: 'BeneficiaryNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum BeneficiaryType {
  Entity = 'entity',
  Individual = 'individual',
}

export type BenefitPartnerInput = {
  product: BenefitsProduct
}

export type BenefitPartnerResponse =
  | ProductNotSupportedException
  | TaxFilingPartner

export enum BenefitProductStatus {
  ComingSoon = 'COMING_SOON',
  Disabled = 'DISABLED',
  DisablingSoon = 'DISABLING_SOON',
  Enabled = 'ENABLED',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE',
  UnderMaintenance = 'UNDER_MAINTENANCE',
}

export type BenefitProductTile = {
  __typename?: 'BenefitProductTile'
  product: BenefitsTrackerProducts
  status: BenefitProductStatus
}

export enum BenefitPromotedThrough {
  MainFeedCard = 'MAIN_FEED_CARD',
  TourTip = 'TOUR_TIP',
  Wtdn = 'WTDN',
}

export type BenefitStatus = {
  __typename?: 'BenefitStatus'
  benefitProductKey: Scalars['String']
  claimStatus: ClaimStatus
  claimedOn: Maybe<Scalars['String']>
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>
  expiresOn: Maybe<Scalars['String']>
  /** @deprecated Use claim_status instead */
  status: Scalars['String']
  updatedBy: Maybe<Scalars['String']>
  updatedOn: Maybe<Scalars['String']>
}

export enum BenefitStatusDetail {
  IneligibleAge = 'INELIGIBLE_AGE',
  IneligibleLocation = 'INELIGIBLE_LOCATION',
}

export type BenefitTileGroup = {
  __typename?: 'BenefitTileGroup'
  group: Scalars['String']
  groupName: Scalars['String']
  products: Maybe<Array<Maybe<BenefitProductTile>>>
}

export type BenefitsMessage = {
  __typename?: 'BenefitsMessage'
  message: Scalars['String']
}

export enum BenefitsPartner {
  April = 'APRIL',
  Avibra = 'AVIBRA',
  GoHenry = 'GO_HENRY',
  TrustAndWill = 'TRUST_AND_WILL',
}

export enum BenefitsProduct {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceBasic = 'BENEFITS_INSURANCE_BASIC',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
}

export type BenefitsStatusResponse = {
  __typename?: 'BenefitsStatusResponse'
  benefitsStatus: BenefitStatus[]
  userId: Scalars['String']
}

export enum BenefitsTrackerProducts {
  BenefitsFeeNegotiation = 'BENEFITS_FEE_NEGOTIATION',
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
}

export type BigCurrencyAmount = {
  __typename?: 'BigCurrencyAmount'
  currency: Currency
  value: Scalars['BigDecimal']
}

/** Attributes related to the billing cycle */
export type BillingCycle = TimestampsInterface & {
  __typename?: 'BillingCycle'
  active: Scalars['Boolean']
  adhoc: Scalars['Boolean']
  amount: Maybe<Scalars['Float']>
  amountCollected: Maybe<Scalars['Float']>
  amountOwed: Maybe<Scalars['Float']>
  callbackUrl: Maybe<Scalars['String']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  credits: Array<Maybe<Credit>>
  endDate: Scalars['String']
  executionAudits: Array<Maybe<ExecutionAudit>>
  extension: Scalars['String']
  fees: Array<Maybe<Fee>>
  id: Scalars['ID']
  invoiceDate: Scalars['String']
  liquidations: Array<Maybe<Liquidation>>
  nonce: Maybe<Scalars['String']>
  startDate: Scalars['String']
  state: BillingCycleState
  tierSubscription: Maybe<TierSubscription>
  tierSubscriptionId: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Attributes related to the billing cycle */
export type BillingCycleCreditsArgs = {
  discount_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
}

/** Attributes related to the billing cycle */
export type BillingCycleFeesArgs = {
  execution_methods?: InputMaybe<Array<InputMaybe<FeeExecutionMethod>>>
}

export enum BillingCycleState {
  /** Assessed billing cycle */
  Assessed = 'ASSESSED',
  /** Billing cycle execution started */
  Executed = 'EXECUTED',
  /** Billing cycle execution failed */
  ExecutionFailed = 'EXECUTION_FAILED',
  /** Failed billing cycle */
  Failed = 'FAILED',
  /** Paid billing cycle */
  Paid = 'PAID',
  /** Partially collected billing cycle */
  Partial = 'PARTIAL',
  /** Initiate refund billing cycle */
  PendingRefund = 'PENDING_REFUND',
  /** Refunded billing cycle */
  Refunded = 'REFUNDED',
  /** Refund failed billing cycle */
  RefundFailed = 'REFUND_FAILED',
  /** Billing cycle pending retry */
  RetryPending = 'RETRY_PENDING',
  /** Unpaid billing cycle */
  Unpaid = 'UNPAID',
}

export enum BillingFrequency {
  Monthly = 'MONTHLY',
  Never = 'NEVER',
}

/** Internal representation of a billing cycle */
export type BillingInvoice = {
  __typename?: 'BillingInvoice'
  amount: Maybe<Scalars['Float']>
  amountCollected: Maybe<Scalars['Float']>
  amountOwed: Maybe<Scalars['Float']>
  createdAt: Maybe<Scalars['DateTime']>
  endDate: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['ID']>
  invoiceDate: Maybe<Scalars['DateTime']>
  invoiceItems: Maybe<Array<Maybe<InvoiceItem>>>
  startDate: Maybe<Scalars['DateTime']>
  state: BillingCycleState
  updatedAt: Maybe<Scalars['DateTime']>
  userId: Scalars['ID']
}

/** the billing profile for a user */
export type BillingProfile = {
  __typename?: 'BillingProfile'
  mightyOakCardWaiver: Maybe<MightyOakCardWaiver>
  provisionalWaiver: Maybe<ProvisionalWaiver>
  userId: Scalars['ID']
  userVerifiedAt: Maybe<Scalars['String']>
  waivers: Maybe<Waiver[]>
}

/** Billing Profile not found */
export type BillingProfileNotFoundException = {
  __typename?: 'BillingProfileNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type BillingVendorError = {
  __typename?: 'BillingVendorError'
  message: Scalars['String']
}

export type BlockDeviceInput = {
  deviceId: Scalars['ID']
}

export type BlockDeviceResult = Device | DeviceNotFoundException

export type BlockedEmailDomainException = {
  __typename?: 'BlockedEmailDomainException'
  message: Maybe<Scalars['String']>
}

export enum BrazeEvent {
  AdvocateReferralLinkClick = 'AdvocateReferralLinkClick',
  FriendInvestCore = 'FriendInvestCore',
  FriendRegistrationStart = 'FriendRegistrationStart',
  FriendUserVerified = 'FriendUserVerified',
}

/** Grouping of Products */
export type Bundle = {
  __typename?: 'Bundle'
  /** Image asset path in CDN */
  iconPath: Scalars['String']
  /** Name of bundle */
  name: Scalars['String']
  /** Associated products to display for grouping */
  products: PresentableProduct[]
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export enum CampaignBackgroundType {
  SquirrelsWithAcorns = 'SQUIRRELS_WITH_ACORNS',
  SquirrelsWithAcornsCloud = 'SQUIRRELS_WITH_ACORNS_CLOUD',
  SquirrelsWithAcornsTransparent = 'SQUIRRELS_WITH_ACORNS_TRANSPARENT',
  SquirrelsWithAcornsUber = 'SQUIRRELS_WITH_ACORNS_UBER',
}

export enum CampaignFilterType {
  Advertised = 'ADVERTISED',
  Participated = 'PARTICIPATED',
}

export type CampaignHistoryConnection = {
  __typename?: 'CampaignHistoryConnection'
  edges: Maybe<CampaignHistoryEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export type CampaignHistoryEdge = {
  __typename?: 'CampaignHistoryEdge'
  cursor: Scalars['String']
  eligibilityMet: Maybe<Scalars['Boolean']>
  hurdleMet: Maybe<Scalars['Boolean']>
  node: ReferralCampaignV2
  numCompletedReferrals: Maybe<Scalars['Int']>
  numPendingReferrals: Maybe<Scalars['Int']>
}

export type CampaignHistoryFilter = {
  /** filters specific Campaign */
  campaignId?: InputMaybe<Scalars['ID']>
  /** Whether campaigns where created after the date. */
  createdAfter?: InputMaybe<Scalars['DateTime']>
  /** Whether or not hurdle has been met */
  hurdleMet?: InputMaybe<Scalars['Boolean']>
  /** Whether campaigns where published after the date. Defaults to 6 month back */
  publishedAfter?: InputMaybe<Scalars['DateTime']>
  /** Published Campaign status (eg. COMPLETE, LIVE, PENDING, SCHEDULED) */
  publishedStatus?: InputMaybe<PublishedCampaignStatus>
  /** Campaign reward filter type */
  rewardType?: InputMaybe<CampaignRewardFilterType>
  /** Campaign filter type */
  type: CampaignFilterType
}

export enum CampaignIconType {
  SquirrelAvatar_1 = 'SQUIRREL_AVATAR_1',
  SquirrelAvatar_2 = 'SQUIRREL_AVATAR_2',
  SquirrelAvatar_3 = 'SQUIRREL_AVATAR_3',
  SquirrelAvatarUber = 'SQUIRREL_AVATAR_UBER',
}

export enum CampaignQualificationActionType {
  InitialInvestment = 'INITIAL_INVESTMENT',
}

export enum CampaignRewardFilterType {
  Burst = 'BURST',
  Evergreen = 'EVERGREEN',
}

export enum CampaignStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type CampaignV2 = {
  __typename?: 'CampaignV2'
  campaignId: Maybe<Scalars['ID']>
}

/** The result of the cancelCheckPayment mutation */
export type CancelCheckPaymentResult =
  | AuthorizationError
  | CheckPayment
  | ResourceNotFoundError
  | UnableToCancelCheckError

export type CancelIntentResult = Intent | ValidationError

/** Input to cancel existing account closure request */
export type CancelInvestmentAccountClosureRequestInput = {
  /** The ID of the investment account */
  investmentAccountId: Scalars['ID']
}

/** Cancel investment account request mutation response */
export type CancelInvestmentAccountClosureRequestResult =
  | AccountClosedException
  | AccountNotFoundException
  | ClosureRequestDoesNotExistException
  | InvestmentAccount

/** Input to cancel a pending investment */
export type CancelInvestmentInput = {
  /** DEPRECATED: The ID of the investment account */
  investmentAccountId?: InputMaybe<Scalars['ID']>
  /** The ID of the pending investment associated with the investment account id */
  investmentId: Scalars['ID']
}

/** ID of canceled investment */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload'
  id: Scalars['ID']
}

/** Cancel investment mutation response */
export type CancelInvestmentResult =
  | CancelInvestmentPayload
  | InvestmentNotFoundException
  | InvestmentUncancellableException

export type CancelMoneyAssignmentInput = {
  transactionId: Scalars['ID']
}

export type CancelMoneyAssignmentResult =
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError
  | MoneyRulesCancelMoneyAssignmentSuccess

export type CancelRecurringTransferResult =
  | RecurringTransfer
  | VersionMismatchException

export type CancelTransferPayload = {
  __typename?: 'CancelTransferPayload'
  transactionId: Scalars['ID']
}

/** Card delivery status */
export type CardDeliveryStatus = {
  __typename?: 'CardDeliveryStatus'
  /** When the card tracking record was created */
  createdAt: Scalars['String']
  /** Current Tracking Status Description */
  description: Maybe<Scalars['String']>
  /** USPS Tracking Number */
  picNumber: Maybe<Scalars['String']>
  /** Reference ID */
  referenceId: Scalars['String']
  /** Status enum */
  status: PackageStatus
  /** When the card tracking record was updated */
  updatedAt: Scalars['String']
}

export enum CarouselType {
  Banner = 'BANNER',
  Standard = 'STANDARD',
}

export type ChallengeAnswerInput = {
  challengeAnswer: Scalars['String']
  challengeId: Scalars['ID']
}

export enum ChallengeDeliveryType {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS',
}

export type ChallengePointsEarned = {
  __typename?: 'ChallengePointsEarned'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** how many points earned out of how many possible */
  earningProgress: DiscreteMilestoneProgress
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>
}

export enum ChallengePushState {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type ChallengeRateExceededException = {
  __typename?: 'ChallengeRateExceededException'
  errorCode: Scalars['String']
}

export enum ChallengeTriggers {
  Authenticate = 'AUTHENTICATE',
  InitEmail = 'INIT_EMAIL',
  InitEmailForAuthenticate = 'INIT_EMAIL_FOR_AUTHENTICATE',
  InitPushForVerification = 'INIT_PUSH_FOR_VERIFICATION',
  InitSms = 'INIT_SMS',
  ReinitChallenge = 'REINIT_CHALLENGE',
  SuspendedChallenge = 'SUSPENDED_CHALLENGE',
  SuspendedInitEmailForAuthenticate = 'SUSPENDED_INIT_EMAIL_FOR_AUTHENTICATE',
}

/** Input to change the amount of an outside contribution */
export type ChangeOutsideContributionAmountInput = {
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
  /** Stripe payment intent id */
  paymentIntentId: Scalars['ID']
}

/** Change outside contribution amount response */
export type ChangeOutsideContributionAmountResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

export type ChangePasswordInput = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
  securityAnswer?: InputMaybe<SecurityAnswer>
}

export type ChangePasswordResult =
  | ChangePasswordSuccess
  | IncorrectOldPasswordException
  | IncorrectSecurityAnswerException
  | InvalidPasswordException

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess'
  userId: Scalars['ID']
}

/** Specifies whether a message was written by a user or is bot generated */
export enum ChatAuthor {
  Bot = 'BOT',
  User = 'USER',
}

export type ChatDeeplink = {
  __typename?: 'ChatDeeplink'
  title: Scalars['String']
  url: Scalars['String']
}

export type ChatHistoryCitation = {
  __typename?: 'ChatHistoryCitation'
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  type: CitationType
}

export type ChatHistoryMessage = {
  __typename?: 'ChatHistoryMessage'
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor
  /** Contains the contents of the message */
  body: Scalars['String']
  canRate: Scalars['Boolean']
  /** The citations for a chat response. Only chats authored by a BOT will contain these */
  citations: ChatHistoryCitation[]
  createdAt: Scalars['DateTime']
  /** Custom feedback text provided by the user */
  customFeedback: Maybe<Scalars['String']>
  /** Deeplinks associated with a particular BOT response */
  deeplinks: ChatDeeplink[]
  /** Reason for the feedback provided */
  feedbackReason: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>
  ragSessionId: Maybe<Scalars['ID']>
  rating: Maybe<Scalars['Int']>
  /** Specifies which session a message is from */
  sessionId: Scalars['ID']
}

export type ChatHistoryMessageBody = {
  __typename?: 'ChatHistoryMessageBody'
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID']
  /** When the partial message was sent */
  sentAt: Scalars['DateTime']
  /** Text chunk of the full message */
  text: Scalars['String']
}

export type ChatHistoryMessageCustomFeedbackOutOfBounds =
  ChatHistoryMessageError & {
    __typename?: 'ChatHistoryMessageCustomFeedbackOutOfBounds'
    id: Scalars['ID']
    message: Scalars['String']
  }

export type ChatHistoryMessageEdge = {
  __typename?: 'ChatHistoryMessageEdge'
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  cursor: Scalars['ID']
  /** The ChatSessionRecord in the edge */
  node: ChatHistoryMessage
}

export type ChatHistoryMessageError = {
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageFooter = {
  __typename?: 'ChatHistoryMessageFooter'
  /** Used to display thumbs up/down */
  canRate: Scalars['Boolean']
  /** Citations for the chat history message */
  citations: ChatHistoryCitation[]
  deeplinks: ChatDeeplink[]
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID']
  /** When the footer message was sent */
  sentAt: Scalars['DateTime']
}

export type ChatHistoryMessageHeader = {
  __typename?: 'ChatHistoryMessageHeader'
  /** Specifies whether a message was written by a user or is bot generated */
  author: ChatAuthor
  createdAt: Scalars['DateTime']
  /** Id of the chat history message, subsequent body messages and footer will have the same ID */
  id: Scalars['ID']
  /** ID of the message that prompted the current message. Only present for 'BOT' authored messages */
  originatingMessageId: Maybe<Scalars['ID']>
  /** Specifies which session a message is from */
  sessionId: Scalars['ID']
}

export type ChatHistoryMessageNotFound = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageNotRatable = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageNotRatable'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageRatingFailed = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingFailed'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatHistoryMessageRatingOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatHistoryMessageRatingOutOfBounds'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatMessageSizeOutOfBounds = ChatHistoryMessageError & {
  __typename?: 'ChatMessageSizeOutOfBounds'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatMessageStreamResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageBody
  | ChatHistoryMessageFooter
  | ChatHistoryMessageHeader

export type ChatSession = {
  __typename?: 'ChatSession'
  createdAt: Scalars['DateTime']
  endedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  type: Maybe<SessionType>
  /** Specifies the id of the user who had the chat session */
  userId: Scalars['ID']
}

export type ChatSessionNotFound = {
  __typename?: 'ChatSessionNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export type ChatUnavailableError = {
  __typename?: 'ChatUnavailableError'
  message: Scalars['String']
}

/** Represents the check to be uploaded. */
export type CheckImage = {
  /** Image based-64 encoded. */
  image: Scalars['String']
  type: ImageType
}

export type CheckPayment = {
  __typename?: 'CheckPayment'
  amount: CurrencyAmount
  canceledAt: Maybe<Scalars['DateTime']>
  checkNumber: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  estimatedArrivalAt: Scalars['DateTime']
  failedAt: Maybe<Scalars['DateTime']>
  failureReason: Maybe<CheckPaymentFailureReason>
  fromAccountId: Scalars['String']
  id: Scalars['ID']
  memo: Maybe<Scalars['String']>
  recipientAddress: CheckPaymentAddress
  recipientName: Scalars['String']
  status: CheckPaymentStatus
  trackingNumber: Maybe<Scalars['String']>
}

export type CheckPaymentAddress = {
  __typename?: 'CheckPaymentAddress'
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentAddressInput = {
  city: Scalars['String']
  country: Scalars['String']
  state: Scalars['String']
  street1: Scalars['String']
  street2?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type CheckPaymentConnection = {
  __typename?: 'CheckPaymentConnection'
  edges: CheckPaymentEdge[]
  pageInfo: PageInfo
}

export type CheckPaymentEdge = {
  __typename?: 'CheckPaymentEdge'
  cursor: Scalars['ID']
  node: CheckPayment
}

export enum CheckPaymentFailureReason {
  InsufficientFunds = 'insufficientFunds',
}

export type CheckPaymentRecipient = {
  __typename?: 'CheckPaymentRecipient'
  businessName: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
}

export type CheckPaymentRecipientAddressType = {
  __typename?: 'CheckPaymentRecipientAddressType'
  recipient: CheckPaymentRecipient
  recipientAddress: CheckPaymentAddress
}

export type CheckPaymentRecipientInput = {
  businessName?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

export enum CheckPaymentStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  Pending = 'pending',
  Shipped = 'shipped',
}

export type CheckingHistorySummary = PastSummary & {
  __typename?: 'CheckingHistorySummary'
  interestEarned: Maybe<CurrencyAmount>
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum CheckoutCartStatus {
  /** Terminal state, canceled payment intent */
  Canceled = 'CANCELED',
  /** State a payment intent is in after actions are handled */
  Processing = 'PROCESSING',
  /** Payment intent needs further action by frontend */
  RequiresAction = 'REQUIRES_ACTION',
  /** Payment intent needs capturing */
  RequiresCapture = 'REQUIRES_CAPTURE',
  /** Payment intent needs confirming */
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  /** Initial state, before a payment method is attached */
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  /** Terminal state, succeeded payment intent */
  Succeeded = 'SUCCEEDED',
}

export enum CitationType {
  LearnHubContent = 'LEARN_HUB_CONTENT',
  Other = 'OTHER',
  SupportFaq = 'SUPPORT_FAQ',
}

export enum ClaimStatus {
  Claimed = 'CLAIMED',
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Ineligible = 'INELIGIBLE',
  InProgress = 'IN_PROGRESS',
  Unclaimed = 'UNCLAIMED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
}

export type ClaimStatusDetails = {
  __typename?: 'ClaimStatusDetails'
  message: Maybe<Scalars['String']>
  statusCode: Maybe<BenefitStatusDetail>
}

export type ClearSupportSiteCache = {
  __typename?: 'ClearSupportSiteCache'
  message: Maybe<Scalars['String']>
}

/** Represents the client info passed into startCheckDeposit */
export type ClientInfo = {
  /** App version */
  appVersion: Scalars['String']
  /** Make of the device, e.g. Samsung, Apple, LG, etc */
  manufacturer: Scalars['String']
  /** Device model, e.g. iPhone 7, AsusPad 2 etc. */
  model: Scalars['String']
  /** Operating System, e.g. iOS, Android, Windows, Mac OS */
  os: Scalars['String']
  /** Operating System version, e.g. 8.0.10211, KITKAT, LOLLIPOP etc. */
  osVersion: Scalars['String']
  /** iphone, android, or web */
  platform: Scalars['String']
}

export type CloseAccountReason = {
  __typename?: 'CloseAccountReason'
  key: Scalars['String']
  label: Scalars['String']
}

export type CloseBankAccountInput = {
  accountId: Scalars['ID']
  bankAccountClosureReason?: InputMaybe<BankAccountClosureReason>
  feedback?: InputMaybe<Scalars['String']>
}

export type CloseBankAccountResult = BankAccount | BankAccountNotFoundError

/** Investment account closure request */
export type CloseInvestmentAccountInput = {
  /** List of closure reason keys */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: InputMaybe<Scalars['String']>
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
}

/** Investment Account Closure Response */
export type CloseInvestmentAccountResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | NonBasicAccountOpenException

/** Close User Account Response */
export type CloseUserAccountResult =
  | OpenAccountsException
  | UserNotFoundException
  | User_V2

/** No account closure request exists for the given investment account */
export type ClosureRequestDoesNotExistException = {
  __typename?: 'ClosureRequestDoesNotExistException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** An account closure request already exists for this account */
export type ClosureRequestExistsException = {
  __typename?: 'ClosureRequestExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type CohortEligibility = {
  __typename?: 'CohortEligibility'
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
  /** key referencing the cohort eligibility scope */
  type: CohortEligibilityScope
}

export enum CohortEligibilityScope {
  /** Earn Incentive New User Cohort */
  EarnIncentive = 'EARN_INCENTIVE',
  /** Mobile Remote Deposit Checks Feature Cohort */
  Mrdc = 'MRDC',
  /** Passions Cohort */
  PassionsExperience = 'PASSIONS_EXPERIENCE',
  /** Personalized Found Money on Present Cohort */
  PersonalizedFoundMoneyOnPresent = 'PERSONALIZED_FOUND_MONEY_ON_PRESENT',
  /** Send Check Cohort */
  SendCheck = 'SEND_CHECK',
}

export type CohortEligibility_V2 = {
  __typename?: 'CohortEligibility_v2'
  /** key referencing the cohort name */
  cohort: Scalars['String']
  /** key referencing if the user is eligible or not */
  eligible: Scalars['Boolean']
}

export type CohortEligibility_V2FilterInput = {
  /** key referencing the cohort name */
  cohorts?: InputMaybe<Array<Scalars['String']>>
}

export enum CollectionMethod {
  Automatic = 'automatic',
  Manual = 'manual',
}

/** Performance values aggregated across all investment accounts within a user's Acorns account */
export type CombinedPerformance = {
  __typename?: 'CombinedPerformance'
  /** Combined investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>
  /** Value of bond holdings across all investment accounts */
  bondValue: Maybe<MonetaryAmount>
  /** Value of crypto holdings across all investment accounts */
  cryptoValue: Maybe<MonetaryAmount>
  /** Value of all investment accounts based on most current available prices */
  currentBalance: Maybe<MonetaryAmount>
  /** The dollar change in combined account value from market movement over the reporting period */
  marketChange: Maybe<MonetaryAmount>
  /** The percentage change in combined account value from market movement over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>
  /** The percentage change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>
  /** The dollar change in combined account value from market movement over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<MonetaryAmount>
  /** The total dollar amount of contributions minus withdrawals */
  netInvestments: Maybe<MonetaryAmount>
  /** Value of stock holdings across all investment accounts */
  stockValue: Maybe<MonetaryAmount>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<MonetaryAmount>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<MonetaryAmount>
}

export type CompleteCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to complete. */
  sessionToken: Scalars['String']
}

/** Response from completing a deposit. */
export type CompleteCheckDepositPayload = {
  __typename?: 'CompleteCheckDepositPayload'
  /** The session that was completed. */
  sessionToken: Scalars['String']
}

export type CompleteFunnelOnboardingResult =
  | RegistrationFunnel
  | UnmetRequirementsException

export type CompletedQuiz = {
  __typename?: 'CompletedQuiz'
  communityAvgPercents: Scalars['Int']
  correctQuestions: Scalars['Int']
  totalQuestions: Scalars['Int']
  userScorePercents: Scalars['Int']
}

export type ConfigureSettingsInput = {
  employerHidden?: InputMaybe<Scalars['Boolean']>
  employerName: Scalars['String']
  splitPercent: Scalars['String']
  splitType: DistributionType
}

export type ConfigureSplitDepositDirectDepositIntentPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositIntentPayload'
  intent: SplitDepositDirectDepositIntentSetting
}

export type ConfigureSplitDepositDirectDepositIntentSettingInput = {
  allocations: SplitDepositAllocationInput[]
  estimatedPaycheckAmount: CurrencyAmountInput
  id?: InputMaybe<Scalars['ID']>
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingInput = {
  allocations: SplitDepositAllocationInput[]
  directDepositIntentSettingId?: InputMaybe<Scalars['ID']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
}

export type ConfigureSplitDepositDirectDepositSettingPayload = {
  __typename?: 'ConfigureSplitDepositDirectDepositSettingPayload'
  setting: SplitDepositDirectDepositSetting
}

export type ConnectAchAccountInput = {
  account: Scalars['AccountNumber']
  routing: Scalars['RoutingNumber']
}

export type ConnectAchAccountResult =
  | ConnectAchAccountSucceeded
  | InstitutionNotSupportedError

export type ConnectAchAccountSucceeded = {
  __typename?: 'ConnectACHAccountSucceeded'
  message: Scalars['String']
}

export enum ConnectionStatus {
  Authorized = 'AUTHORIZED',
  TfaRequired = 'TFA_REQUIRED',
  Unauthorized = 'UNAUTHORIZED',
}

export type ConnectionSummary = {
  __typename?: 'ConnectionSummary'
  connections: Maybe<BankConnection[]>
  totalEligibleFeeCount: Maybe<Scalars['Int']>
  totalEligibleFees: Maybe<MonetaryAmount>
  /** @deprecated replaced by totalEligibleFees */
  totalEligibleFeesForUser: Maybe<MonetaryAmount>
  userEligibility: Maybe<Scalars['Boolean']>
}

export type ConsumeUserTokenResult = InvalidUserTokenException | UserToken

export type ContactCategory = {
  __typename?: 'ContactCategory'
  id: Scalars['ID']
  label: Scalars['String']
  subcategories: Maybe<ContactSubcategory[]>
  value: Scalars['String']
}

export type ContactFaq = {
  __typename?: 'ContactFaq'
  answer: Scalars['String']
  href: Scalars['String']
  id: Scalars['ID']
  question: Scalars['String']
}

export type ContactFormAlert = {
  __typename?: 'ContactFormAlert'
  message: Maybe<Scalars['String']>
}

export type ContactInfoInput = {
  address1?: InputMaybe<Scalars['String']>
  address2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type ContactSubcategory = {
  __typename?: 'ContactSubcategory'
  chatEnabled: Scalars['Boolean']
  emailEnabled: Scalars['Boolean']
  faqs: ContactFaq[]
  id: Scalars['ID']
  label: Scalars['String']
  message: Maybe<SubcategoryMessage>
  phoneEnabled: Scalars['Boolean']
  value: Scalars['String']
}

export type ContentPreviewConnection = LearnConnection & {
  __typename?: 'ContentPreviewConnection'
  edges: ContentPreviewEdge[]
  pageInfo: LearnPageInfo
}

export type ContentPreviewEdge = LearnEdge & {
  __typename?: 'ContentPreviewEdge'
  cursor: Scalars['ID']
  node: LearnContentPreview
}

export type ContextEntryInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ContributionAbility = {
  __typename?: 'ContributionAbility'
  /** flag indicating if the user can contribute to this tax year */
  canContribute: Maybe<Scalars['Boolean']>
  /** maximum legally allowed amount for contributions */
  planLimit: Maybe<Scalars['Int']>
  /** available contribution amount */
  remaining: Maybe<Scalars['Float']>
  /** tax year of aggregated contributions */
  taxYear: Scalars['Int']
  /** total current contributions in tax year */
  yearToDate: Maybe<Scalars['Float']>
}

export type ContributionAbilityByYear = {
  __typename?: 'ContributionAbilityByYear'
  contributionAbilities: Maybe<ContributionAbility[]>
}

/** Contribution cannot be created because an additional action needs to be taken first */
export type ContributionActionRequiredError = {
  __typename?: 'ContributionActionRequiredError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
  /** The url that the frontend needs to redirect the user to for 3DS. Only available for REDIRECT_TO_URL action */
  redirectUrl: Maybe<Scalars['String']>
  /** The action that needs to be taken in order to create transaction */
  requiredAction: ContributionRequiredAction
}

/** Contribution amount must be below the maximum threshold */
export type ContributionAmountAboveThresholdError = {
  __typename?: 'ContributionAmountAboveThresholdError'
  maximumThresholdAmount: Scalars['String']
}

/** Contribution amount must be above the minimum threshold */
export type ContributionAmountBelowThresholdError = {
  __typename?: 'ContributionAmountBelowThresholdError'
  minimumThresholdAmount: Scalars['String']
}

/** Contribution cannot be created because the card was declined */
export type ContributionCardDeclinedError = {
  __typename?: 'ContributionCardDeclinedError'
  /** The payment_intent_id that the contribution was attempted to be made for */
  paymentIntentId: Scalars['ID']
}

export type ContributionHistoryItem = {
  __typename?: 'ContributionHistoryItem'
  year: Scalars['Int']
}

/** Invalid owner email. */
export type ContributionInvalidOwnerEmailError = {
  __typename?: 'ContributionInvalidOwnerEmailError'
  /** The invalid email provided. */
  providedEmail: Scalars['String']
}

export enum ContributionRequiredAction {
  /** Stripe is expecting the app to redirect the user (not part of our flow and should not happen) */
  RedirectToUrl = 'REDIRECT_TO_URL',
  /** The frontend is responsible for sending this payment intent to Stripe for 3DS verification */
  UseStripeSdk = 'USE_STRIPE_SDK',
}

export enum ContributionState {
  /** Terminal state, failed contribution */
  Failed = 'FAILED',
  /** Initial state, pending contribution */
  Pending = 'PENDING',
  /** Terminal state, successful contribution */
  Success = 'SUCCESS',
}

/** Pulls from funding source */
export type CoreAchSubscriptionFeeItem = PastItem & {
  __typename?: 'CoreACHSubscriptionFeeItem'
  /** The amount paid for the subscription. Note that this is intentionally positive because it does not represent removing balance from the account. */
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** A Core account already exists for this user */
export type CoreAccountAlreadyExistsException = {
  __typename?: 'CoreAccountAlreadyExistsException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Deprecated - This exception is no longer returned */
export type CoreAccountClosedException = {
  __typename?: 'CoreAccountClosedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Legacy type we need to account for Credit (Found Money Credits + Employee Contribution) */
export type CoreAdjustmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreAdjustmentItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreCashForwardItem = PastItem & {
  __typename?: 'CoreCashForwardItem'
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Format: 2017-02 */
  relatedMonth: Scalars['String']
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** You owe us money */
export type CoreCollectionItem = PastItem & {
  __typename?: 'CoreCollectionItem'
  /** The amount owed. */
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** Sell shares to pay down cash owed by the customer. */
export type CoreDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreDividendsItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreDividendsItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreEmployeeCreditItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreEmployeeCreditItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    employerName: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type CoreFeeInvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreFeeInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreFoundMoneyRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreFoundMoneyRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreGiftCardCreditRedemptionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreGiftCardCreditRedemptionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Holding transfer transfered in from Age of Transfer beneficiary investment account */
export type CoreHoldingsTransferInItem = PastItem & {
  __typename?: 'CoreHoldingsTransferInItem'
  amount: CurrencyAmount
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** An investment in to the Core account */
export type CoreInvestmentItem = PastCoreCombinedItem &
  PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    isCombinedInvestment: Scalars['Boolean']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreLocalFoundMoneyItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreLocalFoundMoneyItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CorePartnerRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CorePartnerRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    partnerLogoUrl: Maybe<Scalars['URL']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreRebalanceItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreRebalanceItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreReferralRewardItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreReferralRewardItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash refunded to the customer */
export type CoreRefundedItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreRefundedItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type CoreReinvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'CoreReinvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Instant and regular round ups */
export type CoreRoundUpsItem = PastCoreCombinedItem &
  PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreRoundUpsItem'
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** The investment amount prior to being multiplied */
    initialAmount: CurrencyAmount
    isCombinedInvestment: Scalars['Boolean']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    merchantName: Maybe<Scalars['String']>
    multiplier: Scalars['Int']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** The amount of the transaction that caused this round up. TransactionAmount will be null if this is a combined round up investment. */
    transactionAmount: Maybe<CurrencyAmount>
    type: RoundUpType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type CoreWithdrawalItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'CoreWithdrawalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type Course = {
  __typename?: 'Course'
  authors: LearnAuthor[]
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  learnProductKey: Maybe<LearnProductKey>
  lessons: Lesson[]
  metadata: LearnMetadata
  summary: Maybe<Scalars['String']>
  tags: LearnTag[]
  theme: CourseTheme
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: LearnTopic[]
}

export type CourseLocked = {
  __typename?: 'CourseLocked'
  authors: LearnAuthor[]
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  id: Scalars['ID']
  lessons: Lesson[]
  numLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  summary: Maybe<Scalars['String']>
  theme: CourseTheme
  title: Scalars['String']
  topics: LearnTopic[]
}

export type CoursePreview = {
  __typename?: 'CoursePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  courseTheme: CourseTheme
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  relatedQuizProgress: Maybe<LearnProgress>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
}

export type CoursePreviewLocked = {
  __typename?: 'CoursePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  courseTheme: CourseTheme
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  numberOfLessons: Scalars['Int']
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type CourseTheme = LearnThemeLiteral

export type CreateAuthProfileInput = {
  email?: InputMaybe<Scalars['EmailAddress']>
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>
}

export type CreateAuthProfileResult =
  | AuthProfile
  | AuthProfileAlreadyExistsException

export type CreateBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
  tag?: InputMaybe<Scalars['String']>
  type: BankAccountType
}

export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload'
  bankAccount: Maybe<BankAccount>
}

/** Response to a beneficiary creation attempt */
export type CreateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryExceedsAgeLimitException
  | InternalErrorException
  | InvalidDateOfBirthException
  | InvalidFirstNameException
  | InvalidLastNameException

export type CreateCustomSupportTicketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  category?: InputMaybe<Scalars['String']>
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  dateOfBirth?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  email: Scalars['String']
  phoneNumber: Scalars['String']
  subject: Scalars['String']
  ticketFormId?: InputMaybe<Scalars['String']>
  uuid?: InputMaybe<Scalars['ID']>
}

export type CreateDelegateResult = DelegateDefinition

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoFailure = {
  __typename?: 'CreateDirectDepositLinkInfoFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for retrieving a Pinwheel link token */
export type CreateDirectDepositLinkInfoInput = {
  /** Account ID */
  accountId: Scalars['ID']
  /** Required Job */
  requiredJobs: PinwheelLinkTokenRequiredJobs[]
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
  /** Vendor */
  vendor?: InputMaybe<DirectDepositVendor>
}

/** Pinwheel Token Return Results */
export type CreateDirectDepositLinkInfoPayload = {
  __typename?: 'CreateDirectDepositLinkInfoPayload'
  results: CreatePinwheelLinkToken
  vendor: Scalars['String']
}

/** Describes the create direct deposit info return type. */
export type CreateDirectDepositLinkInfoSwitch =
  | CreateDirectDepositLinkInfoFailure
  | CreateDirectDepositLinkInfoPayload

export type CreateDocumentUpload = {
  __typename?: 'CreateDocumentUpload'
  createdAt: Scalars['DateTime']
  expiresAt: Scalars['DateTime']
  requestedDocumentId: Scalars['ID']
  uploadUrl: Scalars['URL']
}

export type CreateDocumentUploadInput = {
  contentType: Scalars['String']
  documentType: DocumentType
}

export type CreateImplicitTokenForUserInput = {
  oauthAppClientId?: InputMaybe<Scalars['String']>
  oauthAppId: Scalars['String']
}

export type CreateImplicitTokenForUserResult =
  | ImplicitToken
  | InvalidOauthAppClientIdException
  | OauthAppNotFoundException

/** Input of CreateIntent. */
export type CreateIntentInput = {
  /** The amount to transfer. */
  amount: CurrencyAmountInput
  /** The ID of the `CustomerAccount` to transfer money from. */
  fromId: Scalars['ID']
  /** Idempotent identifier for this transaction intent, provided by caller. */
  nonce: Scalars['UUID']
  /** The ID of the `CustomerAccount` to transfer money to. */
  toId: Scalars['ID']
  /** Additional input to be passed for this transfer. */
  transferContext?: InputMaybe<ContextEntryInput[]>
}

export type CreateIntentResult = Intent | ValidationError

/** Input for creating investing strategy recommendations */
export type CreateInvestingStrategyRecommendationInput = {
  /** Type of account to get recommendation for */
  accountType: SuitabilityAccountType
  /** Factors affecting outcome of recommendation */
  factors: InvestingStrategyFactors[]
}

export type CreateInvestingStrategyRecommendationResult =
  | BadRequestError
  | RecommendedInvestingStrategy

export type CreateInvestmentAccountResponse = {
  __typename?: 'CreateInvestmentAccountResponse'
  id: Scalars['ID']
  iraType: InvestmentAccountTypes
  userUuid: Scalars['ID']
}

export type CreateJobAlertResult = JobAlert

export type CreateOauthAppInput = {
  accessTokenAudience: Array<InputMaybe<Scalars['String']>>
  accessTokenExpiry?: InputMaybe<Scalars['Int']>
  active: Scalars['Boolean']
  contactEmail?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<Scalars['String']>
  externalApp: Scalars['Boolean']
  imageUri?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  pageType: Scalars['String']
  redirectUri?: InputMaybe<Scalars['String']>
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>
  scopeIdentifiers: Array<Scalars['String']>
  type: OauthAppType
}

export type CreateOauthAppResult = OauthApp

export type CreateOfferInput = {
  availableTo: OfferAvailability
  expiresAt?: InputMaybe<Scalars['DateTime']>
  offerType: OfferType
  price: OfferPriceInput
}

export type CreateOfferResult = Offer

/** Input to create a new outside contribution checkout cart */
export type CreateOutsideContributionCheckoutCartInput = {
  /** Outside contribution code */
  code: Scalars['String']
  /** investment amount for the outside contribution */
  investmentAmount: Scalars['String']
}

/** Create Outside Contribution checkout cart response */
export type CreateOutsideContributionCheckoutCartResult =
  | ContributionAmountAboveThresholdError
  | ContributionAmountBelowThresholdError
  | OutsideContributionCheckoutCart

/** Input to create a new outside contribution */
export type CreateOutsideContributionInput = {
  /** The last 4 digits of the debit card number */
  cardNumberLast4: Scalars['String']
  /** The provider of the debit card ie visa, mastercard etc */
  cardProvider: Scalars['String']
  /** The outside contributor email address */
  contributorEmail: Scalars['String']
  /** The first name of the outside contributor */
  contributorFirstName: Scalars['String']
  /** The last name of the outside contributor */
  contributorLastName: Scalars['String']
  /** The note from the outside contributor */
  note?: InputMaybe<Scalars['String']>
  /** The name from the note of the contributor */
  noteAuthor?: InputMaybe<Scalars['String']>
  /** Stripe payment_intent_id */
  paymentIntentId: Scalars['ID']
  /** Stripe payment_method_id */
  paymentMethodId: Scalars['ID']
}

/** Create Outside Contribution mutation response */
export type CreateOutsideContributionResult =
  | ContributionActionRequiredError
  | ContributionCardDeclinedError
  | ContributionInvalidOwnerEmailError
  | OutsideContribution

export type CreatePinwheelLinkToken = {
  __typename?: 'CreatePinwheelLinkToken'
  /** Pinwheel Token expiration date/time */
  expires: Scalars['DateTime']
  /** UUID of the link token */
  id: Scalars['String']
  /** Pinwheel token Environment */
  mode: Scalars['String']
  /** Short lived token that is used to initialize Pinwheel Link */
  token: Scalars['String']
}

/** Attributes for a linked account created through Plaid Link */
export type CreatePlaidLinkedAccountInput = {
  /** Should the related round up account be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>
  /** Plaid's Financial Institution ID */
  externalInstitutionId?: InputMaybe<Scalars['String']>
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type CreatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  description: Scalars['String']
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  qualificationAmount: Scalars['Int']
  rewards: Array<Scalars['ID']>
  status: PromoCodeStatus
  termsUrl?: InputMaybe<Scalars['URL']>
  title: Scalars['String']
}

export type CreatePromoCodeResult =
  | DuplicatePromoCodeError
  | PromoCode
  | PromoCodeFieldLengthError

export type CreatePromoCodeRewardInput = {
  amount: Scalars['Float']
  type: PromoCodeRewardType
}

export type CreatePromoCodeRewardResult =
  | DuplicatePromoCodeRewardError
  | PromoCodeReward

/** Input for creating a prospect user */
export type CreateProspectUserInput = {
  /** Email address of the prospect user */
  email: Scalars['String']
  /** Prospect Type */
  type: ProspectType
}

/** Create Prospect User Response */
export type CreateProspectUserResult =
  | GrowProspect
  | InternalErrorException
  | LaterWaitlistProspect
  | OutsideContributionProspect
  | User_V2

export type CreateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>
  background?: InputMaybe<CampaignBackgroundType>
  condensedTitle?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>
  hidden: Scalars['Boolean']
  icon?: InputMaybe<CampaignIconType>
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: CampaignQualificationActionType
  qualificationAmount: Scalars['Int']
  rewards: Array<Scalars['ID']>
  status: CampaignStatus
  title: Scalars['String']
}

export type CreateReferralCampaignResult = ReferralCampaignV2

export type CreateReferralCampaignRewardInput = {
  amount: Scalars['Float']
  hurdle: Scalars['Int']
  repeated: Scalars['Boolean']
  targets: ReferralCampaignRewardTarget[]
  type: ReferralCampaignRewardType
}

export type CreateReferralCampaignRewardResult = ReferralCampaignReward

export type CreateReferralPayoutInput = {
  advocateId: Scalars['ID']
  campaignId: Scalars['ID']
  friendId?: InputMaybe<Scalars['ID']>
  rewardId: Scalars['ID']
}

export type CreateReferralPayoutResult =
  | ReferralPayout
  | ReferralPayoutExistsError

export type CreateReferralRelationshipResult =
  | InvalidReferralRelationship
  | ReferralRelationship

export type CreateSavingsAccountInput = {
  bankType?: InputMaybe<BankType>
  currentGoal?: InputMaybe<BankAccountGoalInput>
  isReopen?: InputMaybe<Scalars['Boolean']>
  type: SavingsAccountType
}

export type CreateSavingsAccountPayload = {
  __typename?: 'CreateSavingsAccountPayload'
  bankAccountId: Scalars['ID']
}

export type CreateSavingsAccountResult =
  | CreateSavingsAccountPayload
  | CreateSavingsAccountVerificationError

export type CreateSavingsAccountVerificationError = {
  __typename?: 'CreateSavingsAccountVerificationError'
  notEligibleReasons: SavingsAccountEligibilityRequirement[]
}

export type CreateScopeException = {
  __typename?: 'CreateScopeException'
  message: Scalars['String']
}

export type CreateScopeInput = {
  description?: InputMaybe<Scalars['String']>
  identifier: Scalars['String']
  required?: InputMaybe<Scalars['Boolean']>
  title: Scalars['String']
}

export type CreateScopeResult = CreateScopeException | Scope

export type CreateSubscriptionMigrationInput = {
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTierId: Scalars['ID']
  toTierId: Scalars['ID']
}

export type CreateSubscriptionMigrationResult = SubscriptionMigration

export type CreateSupportTicketInput = {
  category?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  message: Scalars['String']
  phone: Scalars['String']
  recaptchaToken?: InputMaybe<Scalars['String']>
  subcategory?: InputMaybe<Scalars['String']>
  tags?: InputMaybe<Array<Scalars['String']>>
  uuid?: InputMaybe<Scalars['ID']>
}

export type CreateSuspendedUserSupportTicketInput = {
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  message: Array<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  subject: Scalars['String']
  tags?: InputMaybe<Array<Scalars['String']>>
  uuid?: InputMaybe<Scalars['ID']>
}

/** Input for creating an upload url for direct to s3 upload */
export type CreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the user_id of the user uploading a document */
  userId: Scalars['String']
}

/** CreateUploadUrlResult */
export type CreateUploadUrlResult = UploadUrl

export type CreateUserInput = {
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>
  authorizationAccessToken?: InputMaybe<Scalars['String']>
  authorizationExpiresAt?: InputMaybe<Scalars['DateTime']>
  authorizationProvider?: InputMaybe<Scalars['String']>
  authorizationRefreshToken?: InputMaybe<Scalars['String']>
  authorizationUid?: InputMaybe<Scalars['String']>
  captchaToken?: InputMaybe<Scalars['String']>
  clientCredentialsToken?: InputMaybe<Scalars['String']>
  codeGroup?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  invitationCode?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  sourceAttributes?: InputMaybe<Scalars['JSON']>
  sourceId?: InputMaybe<Scalars['String']>
  udid: Scalars['String']
  usResident?: InputMaybe<Scalars['Boolean']>
  withBasicAccount?: InputMaybe<Scalars['Boolean']>
}

/** Input for creating a new user and user profile */
export type CreateUserProfileInput = {
  /** required acceptance document version UUIDs for login */
  acceptanceDocumentVersionUuids: Array<InputMaybe<Scalars['String']>>
  dateOfBirth?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  usResident: Scalars['Boolean']
}

/** CreateUserProfileResult */
export type CreateUserProfileResult =
  | MissingAgreementsException
  | User
  | UserExistsException
  | UserNotUsResidentException

export type CreateVendorInvoiceInput = {
  chargeCustomerNotes?: InputMaybe<Scalars['String']>
  collectionMethod?: InputMaybe<CollectionMethod>
  creditCustomerNotes?: InputMaybe<Scalars['String']>
  currency: Currency
  netTerms?: InputMaybe<Scalars['Int']>
  netTermsType?: InputMaybe<NetTermsType>
  poNumber?: InputMaybe<Scalars['String']>
  termsAndConditions?: InputMaybe<Scalars['String']>
  vatReverseChargeNotes?: InputMaybe<Scalars['String']>
}

export type CreateVendorInvoiceResult = BillingVendorError | InvoiceCollection

export type CreateVendorLineItemInput = {
  accountingCode?: InputMaybe<Scalars['String']>
  avalaraServiceType?: InputMaybe<Scalars['Int']>
  avalaraTransactionType?: InputMaybe<Scalars['Int']>
  creditReasonCode?: InputMaybe<CreditReasonCode>
  currency: Currency
  customFields?: InputMaybe<CustomFieldInput[]>
  description?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['DateTime']>
  itemCode?: InputMaybe<Scalars['String']>
  itemId?: InputMaybe<Scalars['String']>
  origin?: InputMaybe<Origin>
  productCode?: InputMaybe<Scalars['String']>
  quantity?: InputMaybe<Scalars['Int']>
  revenueScheduleType?: InputMaybe<RevenueScheduleType>
  startDate?: InputMaybe<Scalars['DateTime']>
  taxCode?: InputMaybe<Scalars['String']>
  taxExempt?: InputMaybe<Scalars['Boolean']>
  taxInclusive?: InputMaybe<Scalars['Boolean']>
  type: Type
  unitAmount: Scalars['Float']
}

export type CreateVendorLineItemResult = BillingVendorError | InvoiceLineItem

export enum CredentialStatus {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Valid = 'VALID',
}

export type Credentials = {
  __typename?: 'Credentials'
  email: Scalars['EmailAddress']
  userId: Scalars['ID']
}

/** Possible credentials types */
export enum CredentialsType {
  /** Apple OIDC credentials */
  Apple = 'APPLE',
  /** Native email and password credentials */
  User = 'USER',
}

/** Credit information */
export type Credit = TimestampsInterface & {
  __typename?: 'Credit'
  amount: Scalars['Float']
  assessedAt: Maybe<Scalars['String']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discountId: Scalars['ID']
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum CreditReasonCode {
  General = 'general',
  Promotional = 'promotional',
  Service = 'service',
}

export type Cta = {
  __typename?: 'Cta'
  id: Scalars['ID']
  image: Maybe<Image>
  title: Maybe<Scalars['String']>
  type: CtaType
}

export enum CtaType {
  Action = 'action',
  Disclaimer = 'disclaimer',
  GrowArticle = 'grow_article',
  Link = 'link',
  ProtectLink = 'protect_link',
  Video = 'video',
}

/** System of money that is used in a particular country */
export enum Currency {
  Usd = 'USD',
}

/** Standard format for all currency amounts */
export type CurrencyAmount = {
  __typename?: 'CurrencyAmount'
  /** Currency code of owning country. */
  currency: Currency
  /** Quantity of currency */
  value: Scalars['Float']
}

/** Input the amount to be transferred. */
export type CurrencyAmountInput = {
  /** Currency code of the country. */
  currency: Currency
  /** Quantity of currency */
  value: Scalars['Float']
}

export type CurrencyMilestoneProgress = {
  __typename?: 'CurrencyMilestoneProgress'
  /** the type of currency */
  currency: Currency
  /** the current value */
  currentAmount: Scalars['Float']
  /** the value needed for completion */
  targetAmount: Scalars['Float']
}

/** A bank statement showing ownership of the current funding source has not been provided */
export type CurrentBankStatementNotProvided = {
  __typename?: 'CurrentBankStatementNotProvided'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type CustomFieldInput = {
  name?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption'
  default: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['ID']>
  label: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  raw_name: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccount = {
  __typename?: 'CustomerAccount'
  /** The available balance of the account. */
  balance: Maybe<CurrencyAmount>
  /** Beneficiary as populated by user service. */
  beneficiary: Maybe<Beneficiary>
  /** Datetime the account was created. */
  createdAt: Scalars['DateTime']
  /** Get customer accounts by transfer action. */
  customerAccountsByTransferAction: Array<Maybe<CustomerAccount>>
  /** Account has either a customer action required or will have customer communication to show. */
  customerNotice: Scalars['Boolean']
  /** ID. */
  id: Scalars['ID']
  /** The FinancialInstitution associated with this account. Populated if the account was connected through Plaid or DBI, null for all other accounts. */
  institution: Maybe<FinancialInstitution>
  /**
   * Indicator if the account has deposit capability at this time.
   * @deprecated Deprecated
   */
  isDepositAllowed: Scalars['Boolean']
  /**
   * Indicator if the account has withdrawal capability at this time.
   * @deprecated Deprecated
   */
  isWithdrawalAllowed: Scalars['Boolean']
  /** The last 2-4 alphanumeric characters of an account's official account number. */
  mask: Maybe<Scalars['String']>
  /** Account name. */
  name: Scalars['String']
  /** User ID. */
  ownerId: Scalars['ID']
  /** ID used to reference the account in the owning domain. */
  referenceId: Scalars['ID']
  /** Account status. */
  status: CustomerAccountStatus
  /** Type of the account. */
  type: Scalars['String']
  /** Datetime the account was last updated. */
  updatedAt: Scalars['DateTime']
}

/** Account details of a customer account. This owns the customerAccount type and can be defined by id. */
export type CustomerAccountCustomerAccountsByTransferActionArgs = {
  transferAction: TransferAction
}

/** Customer Account Closure Record */
export type CustomerAccountClosure = {
  __typename?: 'CustomerAccountClosure'
  closedAt: Maybe<Scalars['DateTime']>
  closureState: CustomerAccountClosureState
  requestedAt: Scalars['DateTime']
  requestedBy: Scalars['String']
  /** User UUID */
  userId: Scalars['ID']
  workflowId: Scalars['String']
}

export enum CustomerAccountClosureState {
  Fulfilled = 'FULFILLED',
  Initiated = 'INITIATED',
}

export enum CustomerAccountStatus {
  /** Account is closed. */
  Closed = 'CLOSED',
  /** Account is open but locked for transfer. */
  Locked = 'LOCKED',
  /** Account is open. */
  Open = 'OPEN',
  /** Account has started the closure process. */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has started the opening process. */
  PendingOpen = 'PENDING_OPEN',
  /** Account has started the re-opening process. */
  PendingReopen = 'PENDING_REOPEN',
}

/** Required acceptance documents for portfolio missing */
export type CustomerAgreementRequiredException = {
  __typename?: 'CustomerAgreementRequiredException'
  /** message */
  message: Maybe<Scalars['String']>
  /** message */
  requiredAcceptanceDocumentTypes: Array<Scalars['String']>
}

export type CustomerEarnOnboardingMilestone = {
  __typename?: 'CustomerEarnOnboardingMilestone'
  badgeText: Scalars['String']
  completedAt: Maybe<Scalars['DateTime']>
  completionDescription: Scalars['String']
  completionTitle: Scalars['String']
  description: Scalars['String']
  header: Scalars['String']
  key: Scalars['String']
  logoUrl: Scalars['URL']
  primaryCta: EarnOnboardingMilestoneCta
  reward: MonetaryAmount
  secondaryCta: Maybe<EarnOnboardingMilestoneCta>
  steps: Array<Scalars['String']>
  title: Scalars['String']
}

export type CustomerEarnOnboardingProgram =
  | CustomerEarnOnboardingProgramControl
  | CustomerEarnOnboardingProgramFeature

export type CustomerEarnOnboardingProgramControl = {
  __typename?: 'CustomerEarnOnboardingProgramControl'
  experimentName: Scalars['String']
  variantName: Scalars['String']
}

export type CustomerEarnOnboardingProgramFeature = {
  __typename?: 'CustomerEarnOnboardingProgramFeature'
  activePeriodDays: Scalars['Int']
  closeAt: Scalars['DateTime']
  closurePeriodDays: Scalars['Int']
  completionDescription: Scalars['String']
  completionLogoUrl: Scalars['URL']
  completionTitle: Scalars['String']
  description: Scalars['String']
  endAt: Scalars['DateTime']
  experiment: Maybe<Scalars['String']>
  header: Scalars['String']
  milestones: CustomerEarnOnboardingMilestone[]
  primaryCta: Scalars['String']
  startAt: Scalars['DateTime']
  status: CustomerEarnOnboardingStatus
  subTitle: Scalars['String']
  termsLabel: Scalars['String']
  title: Scalars['String']
  variant: Maybe<Scalars['String']>
}

export enum CustomerEarnOnboardingStatus {
  BeforeOpen = 'BEFORE_OPEN',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
}

export type CustomerMoneyRulesResult =
  | CustomerMoneyRulesResultSuccess
  | MoneyRulesRulesetNotFoundException

export type CustomerMoneyRulesResultSuccess = {
  __typename?: 'CustomerMoneyRulesResultSuccess'
  resultingRuleset: MoneyRulesRuleset
}

export enum DayOfWeek {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED',
}

/** Response to a beneficiary ssn update */
export type DeactivateBeneficiaryResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException

export type DeactivateOauthAppClientResult =
  | OauthAppClient
  | OauthAppClientNotFoundException

export type DeactivateOauthAppResult = OauthApp | OauthAppNotFoundException

export type DeactivateTierSubscriptionInput = {
  feedback?: InputMaybe<Scalars['String']>
  subscriptionDeactivationReason: TierSubscriptionDeactivationReason
  userId?: InputMaybe<Scalars['ID']>
}

export type DeactivateTierSubscriptionResult =
  | TierSubscription
  | TierSubscriptionAlreadyDeactivated

export enum DealType {
  PartnerLink = 'PARTNER_LINK',
  SimplySpend = 'SIMPLY_SPEND',
  TapAndGet = 'TAP_AND_GET',
  UniquePricePoint = 'UNIQUE_PRICE_POINT',
  VerifiedReferral = 'VERIFIED_REFERRAL',
}

export type DelegateDefinition = {
  __typename?: 'DelegateDefinition'
  departmentId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
  ownerId: Scalars['ID']
  qualifiedHostName: Scalars['String']
}

export type DelegateDefinitionInput = {
  departmentId?: InputMaybe<Scalars['ID']>
  id?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  ownerId?: InputMaybe<Scalars['ID']>
  qualifiedHostName?: InputMaybe<Scalars['String']>
}

export type DelegateFilterInput = {
  departmentId?: InputMaybe<Scalars['ID']>
  ownerId?: InputMaybe<Scalars['ID']>
}

export type DeleteDelegateResult = DeleteDelegateResultTemporaryImpl

export type DeleteDelegateResultTemporaryImpl = {
  __typename?: 'DeleteDelegateResultTemporaryImpl'
  someField: Scalars['String']
}

export type DeleteExpiredBankCardOrderCardTierNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderCardTierNotFoundError'
  failureMessage: Scalars['String']
}

export type DeleteExpiredBankCardOrderNotExpiredError = {
  __typename?: 'DeleteExpiredBankCardOrderNotExpiredError'
  expiresAt: Scalars['DateTime']
}

export type DeleteExpiredBankCardOrderNotFoundError = {
  __typename?: 'DeleteExpiredBankCardOrderNotFoundError'
  userId: Scalars['ID']
}

export type DeleteExpiredBankCardOrderResult =
  | BankCardOrder
  | DeleteExpiredBankCardOrderCardTierNotFoundError
  | DeleteExpiredBankCardOrderNotExpiredError
  | DeleteExpiredBankCardOrderNotFoundError

export type DeleteOauthAppResult =
  | DeleteOauthAppSuccess
  | OauthAppNotFoundException

export type DeleteOauthAppSuccess = {
  __typename?: 'DeleteOauthAppSuccess'
  oauthAppId: Scalars['ID']
}

export type DeleteScopeSuccess = {
  __typename?: 'DeleteScopeSuccess'
  message: Scalars['String']
}

/** Response for deleting a trusted contact for a user */
export type DeleteTrustedContactResult =
  | InternalErrorException
  | TrustedContact
  | TrustedContactNotFoundException

export enum DepositField {
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  AuxOnUs = 'auxOnUs',
  BackEndorsement = 'backEndorsement',
  BackImage = 'backImage',
  CheckDate = 'checkDate',
  CheckNumber = 'checkNumber',
  Codeline = 'codeline',
  CourtesyAmount = 'courtesyAmount',
  CustomerSuppliedAmount = 'customerSuppliedAmount',
  EncodedAmount = 'encodedAmount',
  Epc = 'epc',
  FractionCode = 'fractionCode',
  FrontImage = 'frontImage',
  FrontSignature = 'frontSignature',
  InstitutionName = 'institutionName',
  InstrumentType = 'instrumentType',
  LegalAmount = 'legalAmount',
  OnUs = 'onUs',
  PayeeName = 'payeeName',
  Routing = 'routing',
}

/** Represents a risk that could prevent the deposit from completing */
export type DepositRiskFactor = {
  __typename?: 'DepositRiskFactor'
  /** Description of risk */
  description: Scalars['String']
  fields: DepositField[]
  /**
   * Risk Statuses:
   *     fixable: fixable = true
   *     confirmable: confirmable = true
   *     hard_reject: fixable = false, confirmable = false, severity level reject
   */
  status: RiskStatus
}

export type DeregisterAuthenticatorInput = {
  id: Scalars['ID']
}

export type DeregisterAuthenticatorResult =
  | AuthenticatorNotFoundException
  | EmailAuthenticator
  | PhoneAuthenticator

export type DesignLibraryIcon = {
  __typename?: 'DesignLibraryIcon'
  /** icon type corresponding to a Design Library icon */
  icon: IconType
}

export type Destination = {
  __typename?: 'Destination'
  /** deep link to milestone action destination */
  deepLink: Scalars['URL']
  /** key that maps to client-defined destination label */
  labelKey: Scalars['StringKey']
}

export type Device = {
  __typename?: 'Device'
  appVersion: Maybe<Scalars['String']>
  blockTrigger: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deviceAdid: Maybe<Scalars['String']>
  firstLoginAt: Maybe<Scalars['DateTime']>
  hasActiveSession: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  isBlocked: Scalars['Boolean']
  lastLoginAt: Maybe<Scalars['DateTime']>
  platform: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  userAgent: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type DeviceBlockedException = {
  __typename?: 'DeviceBlockedException'
  message: Maybe<Scalars['String']>
}

export type DeviceNotFoundException = {
  __typename?: 'DeviceNotFoundException'
  message: Maybe<Scalars['String']>
}

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
}

export type DigitalWalletDevice = {
  __typename?: 'DigitalWalletDevice'
  deviceId: Scalars['String']
  deviceName: Scalars['String']
  deviceNumber: Scalars['String']
  deviceType: DigitalWalletDeviceType
}

export enum DigitalWalletDeviceType {
  Card = 'Card',
  FashionAccessory = 'FashionAccessory',
  HomeAppliance = 'HomeAppliance',
  KeyFob = 'KeyFob',
  MediaOrGamingDevice = 'MediaOrGamingDevice',
  MobileDevice = 'MobileDevice',
  MobileDeviceAccessory = 'MobileDeviceAccessory',
  MobilePhone = 'MobilePhone',
  PcOrLaptop = 'PCOrLaptop',
  Tablet = 'Tablet',
  UnknownOther = 'UnknownOther',
  Vehicle = 'Vehicle',
  Watch = 'Watch',
}

export type DigitalWalletToken = {
  __typename?: 'DigitalWalletToken'
  device: DigitalWalletDevice
  isDeviceProvisioned: Scalars['Boolean']
  tokenStatus: Scalars['String']
}

export enum DirectDepositDistribution {
  /** Amount of Paycheck */
  FixedAmount = 'FIXED_AMOUNT',
  /** Entire Paycheck */
  FullAmount = 'FULL_AMOUNT',
  /** Percentage of Paycheck */
  PercentageAmount = 'PERCENTAGE_AMOUNT',
}

/** Describes a user direct deposit info */
export type DirectDepositInfo = {
  __typename?: 'DirectDepositInfo'
  /** Direct Deposit Status */
  status: DirectDepositStatus
}

/** Direct Deposit Info */
export type DirectDepositInfoPayload = {
  __typename?: 'DirectDepositInfoPayload'
  /** Direct Deposit Info */
  info: Maybe<DirectDepositInfo>
}

/** Describes a user state for all its direct deposit switches. */
export type DirectDepositState = {
  __typename?: 'DirectDepositState'
  /** Creation Date */
  createdAt: Maybe<Scalars['DateTime']>
  /** Switch Method */
  switchMethod: SwitchMethod
  /** Switch State */
  switchState: SwitchState
  /** Last Updated Date */
  updatedAt: Maybe<Scalars['DateTime']>
}

/** Direct Deposit User State */
export type DirectDepositStatePayload = {
  __typename?: 'DirectDepositStatePayload'
  /** Direct Deposit State */
  state: Maybe<DirectDepositState>
}

export enum DirectDepositStatus {
  /** Downloaded pdf to personal device or got a success status back from Pinwheel */
  Attempted = 'Attempted',
  /** SplitDepositSettings Query returns a paycheck has landed */
  Completed = 'Completed',
  /** Has not set up DD */
  NoInteraction = 'NoInteraction',
  /** Has viewed the pdf or entered the pinwheel flow */
  Viewed = 'Viewed',
}

export enum DirectDepositVendor {
  Pinwheel = 'Pinwheel',
}

export type DiscreteMilestoneProgress = {
  __typename?: 'DiscreteMilestoneProgress'
  /** the current value */
  currentInt: Scalars['Int']
  /** the value needed for completion */
  targetInt: Scalars['Int']
}

export type DismissMessageInput = {
  messageId: Scalars['ID']
}

export type DismissMessagesInput = {
  messageIds: Array<Scalars['ID']>
}

export type DismissMessagesResult =
  | DismissMessagesSuccess
  | UpdateMessagesFailure

export type DismissMessagesSuccess = {
  __typename?: 'DismissMessagesSuccess'
  dismissedCount: Scalars['Int']
}

export type DistributionAmounts = {
  __typename?: 'DistributionAmounts'
  investment: Scalars['String']
  retirement: Scalars['String']
  savings: Scalars['String']
}

export enum DistributionType {
  Balanced = 'BALANCED',
  LongTerm = 'LONG_TERM',
  LongWeighted = 'LONG_WEIGHTED',
  MediumTerm = 'MEDIUM_TERM',
  MediumWeighted = 'MEDIUM_WEIGHTED',
}

/** Discrete categorization information for diversification scores */
export type DiversificationBucket = {
  __typename?: 'DiversificationBucket'
  bucketName: DiversificationBucketType
  minDiversificationScoreThreshold: Scalars['Float']
}

export enum DiversificationBucketType {
  /** Excellent Diversification Bucket */
  Excellent = 'EXCELLENT',
  /** Fair Diversification Bucket */
  Fair = 'FAIR',
  /** Poor Diversification Bucket */
  Poor = 'POOR',
}

/** Diversification information for a given portfolio */
export type DiversificationInfo = {
  __typename?: 'DiversificationInfo'
  diversificationBuckets: DiversificationBucket[]
  securityDiversificationInfo: SecurityDiversificationInfo[]
}

/** Input to fetch portfolio diversification information for a provided customer's account */
export type DiversificationInfoByInvestmentAccountIdInput = {
  /** Investment account id of the desired customer's investment account, currently limited to managed account id */
  investmentAccountId: Scalars['ID']
  /** List of ticker symbols the caller wishes to know the diversification factors for */
  symbols: Array<Scalars['TickerSymbol']>
}

export type Document = {
  __typename?: 'Document'
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

export type DocumentInput = {
  uploadedAt: Scalars['DateTime']
  url: Scalars['URL']
}

/** No document for the given document_type and version */
export type DocumentNotFound = {
  __typename?: 'DocumentNotFound'
  /** The type of document to sign */
  documentType: AcceptanceDocumentType
  /** The version of the document to sign */
  documentVersion: Scalars['String']
}

export enum DocumentQueryType {
  Address = 'address',
  All = 'all',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9',
}

export type DocumentRequest = {
  __typename?: 'DocumentRequest'
  acceptedAt: Maybe<Scalars['DateTime']>
  canceledAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  documentType: DocumentType
  documents: Maybe<Document[]>
  externalId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  parentRequest: Maybe<DocumentRequest>
  parentRequestId: Maybe<Scalars['ID']>
  rejectedAt: Maybe<Scalars['DateTime']>
  rejectedNote: Maybe<Scalars['String']>
  rejectedReason: Maybe<RejectedReason>
  /** Idempotency key for ensuring that duplicate requests are not made or to store additional data */
  requestKey: Maybe<Scalars['String']>
  requestedFileCount: Maybe<Scalars['Int']>
  requesterId: Maybe<Scalars['ID']>
  reviewerId: Maybe<Scalars['String']>
  status: DocumentStatus
  userId: Scalars['ID']
}

export type DocumentRequestEdge = {
  __typename?: 'DocumentRequestEdge'
  node: Maybe<DocumentRequest>
}

export type DocumentRequestInput = {
  documentRequestId: Scalars['ID']
}

export type DocumentRequestsConnection = {
  __typename?: 'DocumentRequestsConnection'
  edges: Maybe<DocumentRequestEdge[]>
  pageInfo: DocumentRequestsPageInfo
}

export type DocumentRequestsInput = {
  pageInput?: InputMaybe<DocumentRequestsPageInput>
  status?: InputMaybe<DocumentStatus>
  type: DocumentQueryType
  /** Deprecated: use `status` field */
  uploaded?: InputMaybe<Scalars['Boolean']>
}

export type DocumentRequestsPageInfo = {
  __typename?: 'DocumentRequestsPageInfo'
  cursor: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

export type DocumentRequestsPageInput = {
  ascending?: InputMaybe<Scalars['Boolean']>
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export enum DocumentStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Requested = 'requested',
  Uploaded = 'uploaded',
}

export enum DocumentType {
  Address = 'address',
  BeneficiarySsn = 'beneficiarySsn',
  BulkSuspendCsv = 'bulkSuspendCsv',
  CurrentBankStatement = 'currentBankStatement',
  EarlyQuarantinePromotion = 'earlyQuarantinePromotion',
  FutureBankStatement = 'futureBankStatement',
  Id = 'id',
  MilitaryId = 'militaryId',
  Miscellaneous = 'miscellaneous',
  PaypalFundingSource = 'paypalFundingSource',
  SpendAddress = 'spendAddress',
  SpendFundingSource = 'spendFundingSource',
  SpendId = 'spendId',
  Ssn = 'ssn',
  TraditionalFundingSource = 'traditionalFundingSource',
  W9 = 'w9',
}

export type DocumentUploadSession = {
  __typename?: 'DocumentUploadSession'
  token: Maybe<Scalars['String']>
}

/** Uploads from backend */
export type DocumentUploads = {
  __typename?: 'DocumentUploads'
  uploadDocuments: LegacyUploadDocument[]
}

export type DocumentVerification = {
  __typename?: 'DocumentVerification'
  /** Result of verifying uploaded documents */
  decision: DocumentVerificationDecision
  /** Error descriptors based on reason codes triggered */
  outstandingIssues: Maybe<Array<Scalars['String']>>
  /** Flag indicating if the customer’s identity was marked as verified during document review */
  verificationCriteriaMet: Scalars['Boolean']
}

export enum DocumentVerificationDecision {
  /** Documents were verified and accepted */
  Accepted = 'ACCEPTED',
  /** Documents were declined due to various reason codes */
  Rejected = 'REJECTED',
  /** The information submitted was incomplete or missing */
  ResubmissionRequired = 'RESUBMISSION_REQUIRED',
  /** Manual review is necessary */
  ReviewRequired = 'REVIEW_REQUIRED',
}

export type DuplicateActionError = {
  __typename?: 'DuplicateActionError'
  requestId: Scalars['ID']
}

export type DuplicateBillingInfoError = {
  __typename?: 'DuplicateBillingInfoError'
  message: Scalars['String']
}

export type DuplicatePromoCodeError = {
  __typename?: 'DuplicatePromoCodeError'
  name: Scalars['String']
}

export type DuplicatePromoCodeRewardError = {
  __typename?: 'DuplicatePromoCodeRewardError'
  amount: Scalars['Float']
  type: PromoCodeRewardType
}

/** DEPRECATED - Use Security type instead */
export type Etf = {
  __typename?: 'ETF'
  /** Indicates the amount of every dollar that will go towards buying a share of the ETF */
  amount: Maybe<Scalars['Int']>
  /** ETF high price over trailing 12 month period */
  annualHigh: Maybe<Scalars['Float']>
  /** ETF low price over trailing 12 month period */
  annualLow: Maybe<Scalars['Float']>
  /** Indicates the current per/share price */
  currentPrice: Maybe<Scalars['Float']>
  /** The Acorns-designated display name of the ETF */
  displayName: Scalars['String']
  /** Indicates the individual stocks that make up the ETF */
  holdings: Maybe<Holding[]>
  /** Indicates the investment category for the ETF */
  investmentCategories: InvestmentCategory
  /** Indicates the last market day's close per/share price */
  lastClosePrice: Maybe<Scalars['Float']>
  /** The Acorns-designated name of the ETF */
  name: Scalars['String']
  /** Indicates the total worth of the ETF as a whole */
  netAssets: Maybe<Scalars['String']>
  /** Indicates the day's open per/share price */
  openPrice: Maybe<Scalars['Float']>
  /**
   * Indicates the number of shares the user owns
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  ownedShares: Maybe<Scalars['Float']>
  /** Indicates the percent of every dollar that will go towards buying a share of the ETF */
  percent: Maybe<Scalars['Float']>
  /** Get price values of the ETF over a time range */
  performance: EtfPerformance
  /** Indicates the position of the ETF */
  position: Maybe<Scalars['Int']>
  /** Indicates the per/share price range over the current week */
  priceRangeOverWeek: Maybe<Scalars['String']>
  /** Indicates whether or not the ETF can be removed from a managed Portfolio by direction of an account holder. */
  removable: Maybe<Scalars['Boolean']>
  /** The market exchange symbol of the ETF */
  symbol: Scalars['String']
  /** Indicates the total number of shares in the market */
  volume: Maybe<Scalars['Int']>
  /** Indicates the year-to-date return of the ETF */
  ytdReturn: Maybe<Scalars['Float']>
  /** Indicates the year-to-date return percentage of the ETF */
  ytdReturnPercentage: Maybe<Scalars['Float']>
}

/** DEPRECATED - Use Security type instead */
export type EtfPerformanceArgs = {
  points?: InputMaybe<Scalars['Int']>
  timescale: EtfTimescale
  timespan: Scalars['Int']
}

/** Amount and Percentage of ETF Gain */
export type EtfGain = {
  __typename?: 'ETFGain'
  amount: Scalars['Float']
  percentage: Scalars['Float']
}

/** Gain and Prices of ETF */
export type EtfPerformance = {
  __typename?: 'ETFPerformance'
  gain: Maybe<EtfGain>
  prices: Maybe<EtfPrice[]>
}

/** Price of ETF */
export type EtfPrice = {
  __typename?: 'ETFPrice'
  amount: Scalars['Float']
  timestamp: Scalars['DateTime']
}

export enum EtfTimescale {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

/** State Laws Regarding UGMA/UTMA account types and termination ages */
export type EarlyAccountStateRegulation = {
  __typename?: 'EarlyAccountStateRegulation'
  /** Whether UGMA/UTMA account is offered in the given state */
  accountType: EarlyInvestmentAccountType
  /** Default age of termination for the given state */
  defaultAge: Scalars['Int']
  /** Maximum age of termination for the given state */
  maxAge: Maybe<Scalars['Int']>
  /** Minimum age of termination for the given state */
  minAge: Maybe<Scalars['Int']>
  /** Full State/Territory name */
  state: Scalars['String']
  /** State/Territory abbreviation */
  stateCode: Scalars['String']
}

/** Result for Early Account state regulations */
export type EarlyAccountStateRegulationResult =
  | EarlyAccountStateRegulation
  | InternalErrorException
  | InvalidStateException
  | UserNotFoundException

/** DEPRECATED - Use InvestmentAccountTransferability instead */
export type EarlyAccountTransferInfo = {
  __typename?: 'EarlyAccountTransferInfo'
  /** The beneficiary investment account's state of residence */
  stateCode: Scalars['String']
  /** The beneficiary investment account's age of transfer */
  terminationAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  terminationDate: Scalars['Date']
}

/** Sell shares to pay down cash owed by the customer. */
export type EarlyDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'EarlyDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyDividendsItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyDividendsItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. */
export type EarlyFeeInvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyFeeInvestmentItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A gift investment line item for the Early account */
export type EarlyGiftItem = PastAnnotatedItem &
  PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyGiftItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** Annotation on the item */
    note: Maybe<Scalars['String']>
    /** Author of the note */
    noteAuthor: Maybe<Scalars['String']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyHistorySummary = PastSummary & {
  __typename?: 'EarlyHistorySummary'
  dividends: CurrencyAmount
  earlyInvestMatches: CurrencyAmount
  giftsReceived: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum EarlyInvestmentAccountType {
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
}

/** A generic money movement line item for the Early account */
export type EarlyInvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'EarlyInvestmentItem'
    amount: Maybe<CurrencyAmount>
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A matching investment made into a customers account by the firm. */
export type EarlyMatchItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyMatchItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A removal of matching investments made into a customers account by the firm. */
export type EarlyMatchRemovalItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyMatchRemovalItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type EarlyRefundedItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyRefundedItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type EarlyReinvestmentItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem & {
    __typename?: 'EarlyReinvestmentItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarlyWithdrawalItem = PastCoreTradedItem &
  PastEarlyItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'EarlyWithdrawalItem'
    amount: CurrencyAmount
    beneficiaryAccountId: Scalars['String']
    beneficiaryId: Scalars['String']
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type EarnCtaRecord = {
  __typename?: 'EarnCTARecord'
  ctaDates: Maybe<Array<Maybe<Scalars['Date']>>>
  devicePlatform: Maybe<Scalars['String']>
  partnerName: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type EarnMissingCreditRequest = {
  __typename?: 'EarnMissingCreditRequest'
  createdAt: Scalars['DateTime']
  extensionMerchantName: Maybe<Scalars['String']>
  merchantId: Scalars['ID']
  method: EarnPurchaseMethod
  orderNumber: Scalars['String']
  proofOfPurchaseUrl: Scalars['URL']
  purchaseDate: Scalars['Date']
  subTotal: Scalars['Float']
  total: Scalars['Float']
  userId: Scalars['ID']
}

export type EarnMissingCreditRequestPurchaseDateError = {
  __typename?: 'EarnMissingCreditRequestPurchaseDateError'
  maxDays: Scalars['Int']
  minDays: Scalars['Int']
}

export type EarnOffer = {
  __typename?: 'EarnOffer'
  /** The list of applicable categories for affiliates */
  affiliateCategoryList: Maybe<Array<Scalars['String']>>
  /** Whether affiliateCategoryList is inclusionary or exclusionary */
  affiliateCategoryType: Maybe<Scalars['String']>
  /** For use with colorBackgroundLogoImageUrl */
  backgroundColorHex: Scalars['String']
  /** Non-logo background image */
  backgroundImageUrl: Scalars['URL']
  /** Offer's Badge Category */
  badgeCategory: Maybe<BadgeCategory>
  /** Long description of what is needed to qualify for offer */
  campaignDescription: Scalars['String']
  /** ID associated with the Campaign */
  campaignId: Scalars['ID']
  campaignOfferId: Scalars['ID']
  /** Transparent logo used with backgroundColorHex overlaid on background */
  colorBackgroundLogoImageUrl: Scalars['URL']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  ctaDetails: EarnOfferCtaDetails
  /** Offer's Deal Type */
  dealType: Maybe<DealType>
  /** Desktop Background/featured image url */
  desktopBackgroundImageUrl: Maybe<Scalars['URL']>
  /** Offer Details Information */
  details: Array<Scalars['String']>
  /** List of device platforms the campaign offer is eligible for */
  devicePlatforms: Array<Scalars['String']>
  /** The main campaign text used image overlay text */
  displayBody: Maybe<Scalars['String']>
  /** The ending date of a campaign */
  displayEndDate: Maybe<Scalars['String']>
  /** The main campaign name used on tiles and on details */
  displayName: Scalars['String']
  /** The starting date of a campaign */
  displayStartDate: Maybe<Scalars['String']>
  /** Summary of qualification, e.g. "For new customers only" */
  displaySubtitle: Maybe<Scalars['String']>
  /** Display Title for the amount invested, e.g. "Earn 2%" or "Earn $10" */
  displayTitle: Scalars['String']
  /** Offer Exclusion Information */
  exclusions: Array<Scalars['String']>
  /** Denotes the favorite order rank by most recently added */
  favoriteRank: Scalars['Int']
  /** Used for the banner on the categories page */
  featuredCategoryOffer: Scalars['Boolean']
  /** Used for the banner on the categories page */
  featuredCategoryOfferRank: Scalars['Int']
  /** The amount for the reward */
  incentiveAmount: Maybe<Scalars['Float']>
  /** The reward amount rate */
  incentiveRate: Maybe<EarnOfferIncentiveRate>
  /** Amount invested, e.g. "2%" or "$10" */
  incentiveSummary: Scalars['String']
  /** The reward amount structure */
  incentiveType: Maybe<EarnOfferIncentiveType>
  /** Denotes a favorite offer for the current user */
  isFavorite: Scalars['Boolean']
  /** Offer's Keyphrase Categories Names */
  keyphraseCategoryNames: Maybe<Array<Scalars['String']>>
  /** External merchantId associated with owner */
  merchantId: Maybe<Scalars['String']>
  /** Description of the brand */
  ownerDescription: Scalars['String']
  /** ID associated with the Owner */
  ownerId: Scalars['ID']
  /** The name of the Owner */
  ownerName: Scalars['String']
  /** Used for the banner on web */
  promoted: Scalars['Boolean']
  /** Used for the banner on web */
  promotionRank: Scalars['Int']
  /** Identifying slug on the owner level */
  slug: Scalars['String']
  termsAndConditionsUrl: Scalars['String']
  /** The ending time for a campaign */
  visibilityEndTime: Maybe<Scalars['String']>
  /** The starting time for a campaign */
  visibilityStartTime: Maybe<Scalars['String']>
  /** Manages how we launch offers on mobile */
  webviewEnabled: Scalars['Boolean']
}

export type EarnOfferCtaDetails = {
  __typename?: 'EarnOfferCtaDetails'
  android: Maybe<Scalars['String']>
  buttonUrl: Maybe<Scalars['String']>
  chromeExt: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  internallyRouted: Scalars['Boolean']
  ios: Maybe<Scalars['String']>
  notificationTitle: Scalars['String']
  notificationUrl: Scalars['URL']
  repeatTitle: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  userMetadata: Maybe<Scalars['String']>
  web: Maybe<Scalars['String']>
}

export enum EarnOfferIncentiveRate {
  Dynamic = 'DYNAMIC',
  Flat = 'FLAT',
}

export enum EarnOfferIncentiveTemplate {
  V1 = 'V1',
}

export enum EarnOfferIncentiveType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE',
}

export type EarnOfferQueryPage = {
  __typename?: 'EarnOfferQueryPage'
  earnOffers: EarnOffer[]
  pageInfo: EarnPageInfo
}

export type EarnOnboardingMilestoneCta = {
  __typename?: 'EarnOnboardingMilestoneCta'
  destination: EarnOnboardingMilestoneCtaType
  title: Scalars['String']
}

export enum EarnOnboardingMilestoneCtaType {
  DownloadExtension = 'DOWNLOAD_EXTENSION',
  LinkCard = 'LINK_CARD',
  SimplySpendOffers = 'SIMPLY_SPEND_OFFERS',
  TapAndGetOffers = 'TAP_AND_GET_OFFERS',
}

export type EarnPageInfo = {
  __typename?: 'EarnPageInfo'
  /** This value is passed back as the 'cursor' parameter to continue pagination. An empty string indicates there are no more pages to fetch. */
  endCursor: Scalars['String']
}

export enum EarnPurchaseMethod {
  Android = 'ANDROID',
  ChromeExtension = 'CHROME_EXTENSION',
  EarnRewardEmail = 'EARN_REWARD_EMAIL',
  InStore = 'IN_STORE',
  Iphone = 'IPHONE',
  SafariExtension = 'SAFARI_EXTENSION',
  WebApp = 'WEB_APP',
}

export type EarnReward = {
  __typename?: 'EarnReward'
  amount: MonetaryAmount
  colorBackgroundLogoImageUrl: Scalars['URL']
  displayName: Scalars['String']
  expectedFulfilledAt: Maybe<Scalars['Date']>
  fulfilledAt: Maybe<Scalars['Date']>
  fulfillmentType: EarnRewardFulfillmentType
  id: Scalars['ID']
  incentiveAmount: Maybe<Scalars['Float']>
  investmentId: Maybe<Scalars['ID']>
  linked: Maybe<EarnReward[]>
  /** The purchase or event date associated with the reward */
  originationDate: Scalars['Date']
  status: Maybe<EarnRewardStatus>
  type: EarnRewardType
}

export enum EarnRewardFulfillmentType {
  Standard = 'STANDARD',
  Travel = 'TRAVEL',
}

export enum EarnRewardInvestType {
  EarnReward = 'EARN_REWARD',
  EarnRewardMatch = 'EARN_REWARD_MATCH',
  EarnRoundUpMatch = 'EARN_ROUND_UP_MATCH',
  EmployeeContribution = 'EMPLOYEE_CONTRIBUTION',
  Referral = 'REFERRAL',
}

export enum EarnRewardStatus {
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
}

export enum EarnRewardType {
  EmployeeBenefit = 'EMPLOYEE_BENEFIT',
  Referral = 'REFERRAL',
  Reward = 'REWARD',
  RewardMatch = 'REWARD_MATCH',
  RoundupMatch = 'ROUNDUP_MATCH',
}

export type Ecbsv = {
  __typename?: 'Ecbsv'
  /** Flag indicating whether eCBSV can be used or not for verification */
  consent: Scalars['Boolean']
  /** UTC timestamp when customer provided eCBSV response */
  providedAt: Maybe<Scalars['DateTime']>
}

export type EducationTip = {
  __typename?: 'EducationTip'
  /** key that maps to client-defined education tip details */
  detailsKey: Scalars['StringKey']
  /** key that maps to client-defined education tip summary */
  summaryKey: Scalars['StringKey']
}

export type Eligibility = {
  __typename?: 'Eligibility'
  eligible: Scalars['Boolean']
}

export enum EligibilityScope {
  FundSpendInActivation = 'fundSpendInActivation',
  Mrdc = 'mrdc',
  RoundUps = 'roundUps',
  SendCheck = 'sendCheck',
  Spend = 'spend',
  SpendRecurringTransfers = 'spendRecurringTransfers',
}

export type EmailAddressValidation = {
  __typename?: 'EmailAddressValidation'
  /** Wether or not credentials are associated with the address or not. */
  credentialsExist: Scalars['Boolean']
  /** Soft check indicating wether or not a DNS MX record exists for the address domain (does not validate that an email can actually be delivered to the email server). */
  deliverable: Scalars['Boolean']
  /** The email that is being validated */
  email: Scalars['EmailAddress']
  /** Indicates if the email credential is enabled for use. */
  nativeCredentialsEnabled: Maybe<Scalars['Boolean']>
  /** Indicates if the email is associated with an OIDC provider. */
  oidcAssociated: Maybe<Scalars['Boolean']>
  /** Indicates wether the address may have common spelling mistakes. */
  possibleTypo: Scalars['Boolean']
  /** Suggestion for corrected address if there was a typo detected. */
  suggestion: Maybe<Scalars['EmailAddress']>
}

export type EmailAuthChallenge = AuthChallenge & {
  __typename?: 'EmailAuthChallenge'
  alternateAuthenticators: AuthenticatorInfo[]
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  maskedEmail: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type EmailAuthenticator = Authenticator & {
  __typename?: 'EmailAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  email: Scalars['EmailAddress']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type EmailTakenException = {
  __typename?: 'EmailTakenException'
  message: Maybe<Scalars['String']>
}

export type EmergencyFundHistorySummary = PastSummary & {
  __typename?: 'EmergencyFundHistorySummary'
  interestEarned: Maybe<CurrencyAmount>
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export enum Employees {
  /** User has full or part time employees under their company */
  FullOrPart = 'fullOrPart',
  /** User has no employees under their company */
  None = 'none',
}

/** Employer */
export type Employer = {
  __typename?: 'Employer'
  /**
   * Clickswitch Target ID
   * @deprecated Use SwitchInterface.vendorTargetId instead
   */
  clickSwitchTargetId: Maybe<Scalars['ID']>
  /** DUNS Name */
  dunsName: Maybe<Scalars['String']>
  /** Duns Number */
  dunsNumber: Maybe<Scalars['ID']>
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer ID */
  id: Scalars['ID']
  /** Employer Logo URL */
  logoUrl: Maybe<Scalars['String']>
  /** Switch Type specific information. */
  switch: AbstractSwitch
  /** Switch Type */
  switchType: SwitchType
  /**
   * Employer URL
   * @deprecated Use OnlineSwitch.url instead
   */
  url: Maybe<Scalars['String']>
}

export type EmploymentInput = {
  employer?: InputMaybe<Scalars['String']>
  occupation?: InputMaybe<Scalars['String']>
  suitability?: InputMaybe<Array<InputMaybe<SuitabilityInput>>>
}

export enum EmploymentStatus {
  /** User is a full time employee or contractor */
  FullTime = 'fullTime',
  /** User is a part time employee or contractor */
  PartTime = 'partTime',
  /** User is retired and does not work */
  Retired = 'retired',
  /** User owns their own business or is self employed */
  SelfEmployed = 'selfEmployed',
  /** User is enrolled full time in school */
  Student = 'student',
  /** User currently is not employed */
  Unemployed = 'unemployed',
}

/** Configuration for investment account quarterly recaps. */
export type EnableQuarterlyRecapsInput = {
  /** Wether or not to enable quarterly recaps. */
  enabled: Scalars['Boolean']
  /** The unique identifier of the investment account for which to configure quarterly recaps. */
  investmentAccountId: Scalars['ID']
}

/** Result of configuring investment account recaps. */
export type EnableQuarterlyRecapsResult =
  | InvalidSubscriptionTierException
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException

export type EstimatedCheckPaymentDates = {
  __typename?: 'EstimatedCheckPaymentDates'
  estimatedArrivalAt: Scalars['DateTime']
  estimatedShippingAt: Scalars['DateTime']
  estimatedTransferAtText: Scalars['String']
}

/** Input to get estimated dates for a transfer */
export type EstimatedTransferDatesInput = {
  /** Amount of the transfer which will be created. */
  amount?: InputMaybe<CurrencyAmountInput>
  /** Type of account to move money from */
  fromAccountType: TransferableAccountTypeEnum
  /** Type of account to move money into */
  toAccountType: TransferableAccountTypeEnum
  /** UTC datetime when the transfer was/will be created. If omitted, the current datetime will be used */
  transferCreatedAt?: InputMaybe<Scalars['DateTime']>
}

/** Estimated dates for a transfer */
export type EstimatedTransferDatesPayload = {
  __typename?: 'EstimatedTransferDatesPayload'
  /** Estimated UTC datetime when the transfer will be completed by */
  estimatedTransferCompletedAt: Scalars['DateTime']
}

/** Evaluates check deposit session to determine if it is submittable. */
export type EvaluateCheckDepositInput = {
  amount: CurrencyAmountInput
  /** The session to evaluate. */
  sessionToken: Scalars['String']
}

/** Evaluates if a check can be submitted. */
export type EvaluateCheckDepositPayload = {
  __typename?: 'EvaluateCheckDepositPayload'
  /** Recognized amount from check image. */
  ocrAmount: CurrencyAmount
  riskFactors: DepositRiskFactor[]
}

export type ExchangeAcornsEarlyTokenResult =
  | AcornsEarlyUserDetails
  | InvalidAcornsEarlyTokenException

export type ExecuteMoneyInError = {
  __typename?: 'ExecuteMoneyInError'
  message: Scalars['String']
}

export type ExecuteMoneyInInput = {
  moneyInEvent: MoneyInEventInput
}

export type ExecuteMoneyInResult = ExecuteMoneyInError | ExecuteMoneyInSuccess

export type ExecuteMoneyInSuccess = {
  __typename?: 'ExecuteMoneyInSuccess'
  workflowId: Scalars['ID']
}

/** Execution Audit */
export type ExecutionAudit = TimestampsInterface & {
  __typename?: 'ExecutionAudit'
  billingCycleId: Scalars['ID']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  decisionName: Scalars['String']
  id: Scalars['ID']
  result: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type ExistingEmailVerifiedException = {
  __typename?: 'ExistingEmailVerifiedException'
  message: Maybe<Scalars['String']>
}

/** A reopen request for this investment account already exists and is pending review */
export type ExistingRequestPendingReview = {
  __typename?: 'ExistingRequestPendingReview'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** A reopen request for this investment account already exists and is pending user action */
export type ExistingRequestPendingUserAction = {
  __typename?: 'ExistingRequestPendingUserAction'
  /** Reopen request for investment account */
  reopenRequest: InvestmentAccountReopenRequest
}

/** The content that supports and drives the user experience */
export type ExperienceContent = {
  __typename?: 'ExperienceContent'
  /** Campaign ID for the referrer's active campaign */
  campaignId: Maybe<Scalars['ID']>
  pillAmount: Maybe<Scalars['String']>
  /** JSON Content for rendering the referrer experience */
  rawContent: Maybe<Scalars['String']>
  /** Referrer's link to refer new friends */
  shareableLink: Maybe<Scalars['String']>
}

export type ExpirePromotionalWaiverInput = {
  promotion: WaiverPromotion_V2
}

export type ExpirePromotionalWaiverResult =
  | InvalidUserIdException
  | PromotionalWaiver_V2
  | WaiverDeletionException

/** Individual accounts opened by a user at Acorns */
export type ExternalMetadata = {
  __typename?: 'ExternalMetadata'
  /** Flag indicating if user is active customer in external source */
  isSubscriptionActive: Scalars['Boolean']
  /** External subscription type */
  membership: Maybe<ExternalSubscriptionType>
}

export enum ExternalSource {
  DirectBank = 'direct_bank',
  Manual = 'manual',
  Paypal = 'paypal',
  Plaid = 'plaid',
  Spend = 'spend',
}

export enum ExternalSubscriptionType {
  /** Highest tier */
  Premium = 'PREMIUM',
}

export enum ExternalUserSource {
  UserExternalSourceGoHenry = 'USER_EXTERNAL_SOURCE_GO_HENRY',
  UserExternalSourceInvalid = 'USER_EXTERNAL_SOURCE_INVALID',
}

export type ExtoleCampaignHistoryConnection = {
  __typename?: 'ExtoleCampaignHistoryConnection'
  edges: Maybe<ExtoleCampaignHistoryEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export type ExtoleCampaignHistoryEdge = {
  __typename?: 'ExtoleCampaignHistoryEdge'
  cursor: Scalars['String']
  hurdleMet: Maybe<Scalars['Boolean']>
  node: ExtoleReferralCampaign
}

export type ExtoleReferralCampaign = {
  __typename?: 'ExtoleReferralCampaign'
  advocateRewardAmount: Scalars['Float']
  eligibilityEnd: Scalars['DateTime']
  friendRewardAmount: Scalars['Float']
  hurdle: Scalars['Int']
  id: Scalars['ID']
  publishEnd: Scalars['DateTime']
  publishStart: Scalars['DateTime']
  status: PublishedCampaignStatus
  title: Scalars['String']
}

export type ExtoleReferralHistory = {
  __typename?: 'ExtoleReferralHistory'
  extoleFriendHistory: Maybe<FriendHistoryConnection>
  userId: Maybe<Scalars['ID']>
}

export type ExtoleReferralHistoryExtoleFriendHistoryArgs = {
  extoleCampaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

export type FaceLivenessSession = {
  __typename?: 'FaceLivenessSession'
  expiresAt: Scalars['DateTime']
  idMatches: Maybe<Scalars['Boolean']>
  isLive: Maybe<Scalars['Boolean']>
  livenessConfidence: Maybe<Scalars['Int']>
  referenceImageConsumedAt: Maybe<Scalars['DateTime']>
  sessionId: Scalars['ID']
  updatedAt: Maybe<Scalars['DateTime']>
  userId: Scalars['ID']
}

export type FaceLivenessSessionExpiredException = {
  __typename?: 'FaceLivenessSessionExpiredException'
  sessionId: Scalars['ID']
  userId: Scalars['ID']
}

export type FaceLivenessSessionFailedException = {
  __typename?: 'FaceLivenessSessionFailedException'
  sessionId: Scalars['ID']
  userId: Scalars['ID']
}

export type FaceLivenessSessionIncompleteException = {
  __typename?: 'FaceLivenessSessionIncompleteException'
  sessionId: Scalars['ID']
  userId: Scalars['ID']
}

export type FaceLivenessSessionNotFoundException = {
  __typename?: 'FaceLivenessSessionNotFoundException'
  sessionId: Scalars['ID']
  userId: Scalars['ID']
}

export type FailVendorInvoiceResult = BillingVendorError | Invoice

export type FavoritePartnerOfferGroup = {
  __typename?: 'FavoritePartnerOfferGroup'
  /** list of offers in the favorite group */
  offers: PartnerOfferGroupItem[]
}

/** Used to customize favorite offer group contents */
export type FavoritePartnerOfferInput = {
  ids: Array<Scalars['String']>
}

export type FeaturedLearnContentPreview =
  | LearnArticlePreview
  | LearnMediaPreview

export type FeaturedMilestones = {
  __typename?: 'FeaturedMilestones'
  /** list of featured milestones to show on widget */
  milestones: Milestone[]
}

export type FeaturedMilestonesV2 = AccountSetupMilestones | FeaturedMilestones

/** Fee information */
export type Fee = TimestampsInterface & {
  __typename?: 'Fee'
  accountId: Maybe<Scalars['ID']>
  amount: Scalars['Float']
  amountCollected: Scalars['Float']
  assessedAt: Maybe<Scalars['String']>
  balance: Maybe<Scalars['Float']>
  billingCycle: BillingCycle
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  discount: Maybe<Scalars['Float']>
  discountedAmount: Maybe<Scalars['Float']>
  feeCategoryId: Scalars['String']
  feeExecutions: Array<Maybe<FeeExecution>>
  feeType: FeeType
  id: Scalars['ID']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Maybe<Scalars['ID']>
}

/** Fee execution information */
export type FeeExecution = TimestampsInterface & {
  __typename?: 'FeeExecution'
  accountType: Maybe<Scalars['String']>
  amountCollected: Scalars['Float']
  amountRequested: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  executionMethod: Scalars['String']
  externalId: Maybe<Scalars['ID']>
  fundingAccountId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  reason: Maybe<Scalars['String']>
  sourceId: Maybe<Scalars['ID']>
  state: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum FeeExecutionMethod {
  /** Executed fee by direct ACH */
  Direct = 'DIRECT',
  /** Executed fee by selling shares */
  LiquidateSecurities = 'LIQUIDATE_SECURITIES',
  /** Pre-emptively failed execution due to a known failure reason */
  PreemptiveFailure = 'PREEMPTIVE_FAILURE',
  /** Skipped fee execution */
  Skip = 'SKIP',
  /** Executed by direct ACH from Spend funding source */
  SpendDirect = 'SPEND_DIRECT',
  /** Waived fee execution */
  Waive = 'WAIVE',
}

export type FeeNegotiation = {
  __typename?: 'FeeNegotiation'
  connection: Maybe<BankConnection>
  created: Maybe<Scalars['DateTime']>
  displayStatus: Maybe<Scalars['String']>
  feeSynopsis: Maybe<Scalars['String']>
  id: Scalars['ID']
  internalStatus: Maybe<BankFeeNegotiationInternalStatus>
  negotiatedAmount: Maybe<MonetaryAmount>
  refundAmount: Maybe<MonetaryAmount>
  status: Maybe<BankFeeNegotiationExternalStatus>
  updated: Maybe<Scalars['DateTime']>
}

export type FeeNegotiationSummary = {
  __typename?: 'FeeNegotiationSummary'
  negotiations: Maybe<FeeNegotiation[]>
  totalRefundedFees: Maybe<MonetaryAmount>
}

export enum FeeStatus {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE',
}

export enum FeeStatusFilter {
  Negotiable = 'NEGOTIABLE',
  Negotiated = 'NEGOTIATED',
  Processing = 'PROCESSING',
  Unnegotiable = 'UNNEGOTIABLE',
}

export type FeeStatusSummary = {
  __typename?: 'FeeStatusSummary'
  negotiable: Scalars['Int']
  negotiated: Scalars['Int']
  processing: Scalars['Int']
  total: Scalars['Int']
  unnegotiable: Scalars['Int']
}

export enum FeeType {
  /** ADVISORY fee */
  Advisory = 'ADVISORY',
  /** SUBSCRIPTION fee */
  Subscription = 'SUBSCRIPTION',
}

export enum FeedContext {
  /** a4 banking hub */
  A4BankingHub = 'a4_banking_hub',
  /** a4 checking engagement wizard */
  A4CheckingEngagementWizard = 'a4_checking_engagement_wizard',
  /** a4 checking hub */
  A4CheckingHub = 'a4_checking_hub',
  /** a4 early */
  A4Early = 'a4_early',
  /** a4 early details */
  A4EarlyDetails = 'a4_early_details',
  /** a4 home/present */
  A4Home = 'a4_home',
  /** a4 home bottom nav */
  A4HomeBottomNav = 'a4_home_bottom_nav',
  /** a4 invest */
  A4Invest = 'a4_invest',
  /** invest hub */
  A4InvestHub = 'a4_invest_hub',
  /** a4 kids */
  A4Kids = 'a4_kids',
  /** a4 later */
  A4Later = 'a4_later',
  /** a4 learn hub */
  A4LearnHub = 'a4_learn_hub',
  /** a4 savings */
  A4Savings = 'a4_savings',
  /** a4 spend */
  A4Spend = 'a4_spend',
}

export type File = {
  __typename?: 'File'
  documentRequestId: Scalars['ID']
  encoding: Scalars['String']
  filename: Scalars['String']
  mimetype: Scalars['String']
  url: Scalars['URL']
}

/** The file does not exist */
export type FileDoesNotExistError = {
  __typename?: 'FileDoesNotExistError'
  /** message */
  message: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The file does not exist in s3 */
export type FileDoesNotExistInS3 = {
  __typename?: 'FileDoesNotExistInS3'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type FileOrException = File | FileSizeError | UploadFailedError

export type FileSizeError = {
  __typename?: 'FileSizeError'
  message: Scalars['String']
}

/** The file uploaded exceeds the max allowed byte size */
export type FileTooLarge = {
  __typename?: 'FileTooLarge'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export enum FilingType {
  /** User files taxes with their spouse */
  Joint = 'joint',
  /** User files taxes living with spouse part of the year */
  SeparatePartYear = 'separatePartYear',
  /** User files taxes living apart from spouse all year */
  SeparateWholeYear = 'separateWholeYear',
}

export type FinancialAdvisorQuestionResponse = {
  __typename?: 'FinancialAdvisorQuestionResponse'
  interactionId: Scalars['String']
  message: Scalars['String']
}

export type FinancialAdvisorQuestionsResponse = {
  __typename?: 'FinancialAdvisorQuestionsResponse'
  message: Scalars['String']
}

export enum FinancialEducation {
  /** User has little to no experience with financial education */
  Beginner = 'BEGINNER',
  /** User has a lot of experience with financial education */
  Expert = 'EXPERT',
  /** User has some experience with financial education */
  Moderate = 'MODERATE',
}

export type FinancialGoalsInput = {
  age: Scalars['Int']
  annualIncome: Scalars['Int']
  contributionFrequency: Scalars['String']
  employmentStatus: Scalars['String']
  spendPercent: Scalars['Float']
  state: Scalars['String']
  strategy: Scalars['String']
}

export type FinancialGoalsResult = {
  __typename?: 'FinancialGoalsResult'
  age: Array<Scalars['Int']>
  balance: Array<Scalars['Float']>
  cumulativeContributions: Array<Scalars['Float']>
  totalContributions: Array<Scalars['Float']>
}

/** Miscellaneous attributes about a Financial Institution */
export type FinancialInstitution = TimestampsInterface & {
  __typename?: 'FinancialInstitution'
  /** Is this Financial Institution blacklisted within Acorns */
  blacklisted: Scalars['Boolean']
  /** Inorganic ordering for Financial Institutions */
  boost: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Is this Financial Institution removed from Plaid's list */
  deleted: Scalars['Boolean']
  /** Is this Financial Institution a Direct Bank type */
  directBank: Scalars['Boolean']
  /** Plaid Financial Institution ID */
  externalId: Scalars['String']
  /** Does this Financial Institution have multi-factor authentication? */
  hasMfa: Scalars['Boolean']
  /** Internal Acorns UUID representing Financial Institution */
  id: Scalars['ID']
  /** The link provider type of the financial institution */
  linkProviderType: Maybe<LinkProviderType>
  /** Location of logo for a Financial Institution */
  logoUrl: Scalars['String']
  /** Name of Financial Institution */
  name: Scalars['String']
  /** URL for signing in with Direct Bank Integration */
  oauthUrl: Maybe<Scalars['String']>
  /** Plaid products this Financial Institution supports */
  products: Array<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** URL of the Financial Institution */
  url: Maybe<Scalars['String']>
}

/** An individual edge within the paginated list of FinancialInstitutionType */
export type FinancialInstitutionTypeEdge = {
  __typename?: 'FinancialInstitutionTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The FinancialInstitutionType record in the edge */
  node: FinancialInstitution
}

/** Relay style pagination information for FinancialInstitutionType */
export type FinancialInstitutionTypePagination = {
  __typename?: 'FinancialInstitutionTypePagination'
  edges: FinancialInstitutionTypeEdge[]
  pageInfo: PageInfo
}

export type FinishSetup = {
  __typename?: 'FinishSetup'
  eyebrow: Scalars['String']
  tips: SetUpTip[]
}

export type FooterContent = {
  __typename?: 'FooterContent'
  acornsLogoAsset: Scalars['String']
  disclosures: Scalars['String']
  linkColumn1Header: Scalars['String']
  linkColumn2Header: Scalars['String']
  linkColumn3Header: Scalars['String']
  mainCTAText: Scalars['String']
  mainCTAUrl: Scalars['String']
  mainHeadline: Scalars['String']
}

export enum FormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other',
}

export type FormattedMonetaryAmount = {
  __typename?: 'FormattedMonetaryAmount'
  currency: Currency
  value: Scalars['String']
}

export type FoundMoneyCampaignOfferV2 = {
  __typename?: 'FoundMoneyCampaignOfferV2'
  id: Scalars['ID']
  incentiveSummary: Scalars['String']
}

export type FoundMoneyCampaignV2 = {
  __typename?: 'FoundMoneyCampaignV2'
  backgroundColorHex: Scalars['String']
  backgroundImageUrl: Scalars['URL']
  cohortSlug: Scalars['String']
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  colorImageUrl: Scalars['URL']
  displayName: Scalars['String']
  id: Scalars['ID']
  /** @deprecated Use colorBackgroundLogoImageUrl instead */
  imageUrl: Scalars['URL']
  offers: FoundMoneyCampaignOfferV2[]
  ownerId: Scalars['ID']
}

export type FoundMoneyReward = {
  __typename?: 'FoundMoneyReward'
  /** @deprecated Field is deprecated, use colorBackgroundLogoImageUrl instead */
  campaignOwnerImageUrl: Maybe<Scalars['URL']>
  campaignOwnerName: Maybe<Scalars['String']>
  categoryIcon: Maybe<Scalars['String']>
  colorBackgroundLogoImageUrl: Maybe<Scalars['URL']>
  daysFulfilledWithin: Maybe<Scalars['Int']>
  dollarValue: Maybe<MonetaryAmount>
  fulfillmentDate: Maybe<Scalars['String']>
  id: Scalars['ID']
  isFoundMoneyPlus: Maybe<Scalars['Boolean']>
  originationDate: Maybe<Scalars['String']>
  originationType: Maybe<Scalars['String']>
  status: Maybe<Scalars['String']>
}

export type FoundMoneySummary = {
  __typename?: 'FoundMoneySummary'
  totalFulfilledRewardsDollarValue: Maybe<MonetaryAmount>
  totalMatchedDollarValue: Maybe<MonetaryAmount>
  totalPendingRewardsDollarValue: Maybe<MonetaryAmount>
  totalRewardsDollarValue: Maybe<MonetaryAmount>
}

/** A user who was referred by an existing Acorns User */
export type Friend = {
  __typename?: 'Friend'
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>
  /**
   * If the Friend object resolved via the Advocate query, advocateUserId
   * corresponds to the argument passed in at the root level.
   * If Friend object resolved via the Friend query, advocateUserId is the
   * first advocate that is returned by Extole.
   */
  advocateUserId: Maybe<Scalars['ID']>
  /** A list of all campaigns that the friend is participating in */
  campaigns: Maybe<ReferralCampaign[]>
  email: Scalars['String']
  friendExperienceContent: Maybe<FriendExperienceContent>
  name: Maybe<Scalars['String']>
  /** Status based on activity of friend */
  status: Maybe<FriendStatus>
  userId: Maybe<Scalars['ID']>
}

/** The content that supports user experience */
export type FriendExperienceContent = {
  __typename?: 'FriendExperienceContent'
  /** The first name of the referred user's advocate */
  advocateFirstName: Maybe<Scalars['String']>
  /** The last name of the referred user's advocate */
  advocateLastName: Maybe<Scalars['String']>
  /** The baseline advocate incentive they will earn if friend converts */
  advocateMinimumIncentive: Maybe<Scalars['String']>
}

/** A summary of information around a referred user */
export type FriendHistory = {
  __typename?: 'FriendHistory'
  /** User ID of the Advocate user */
  advocateUserId: Maybe<Scalars['ID']>
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  /** When the friend account was created */
  createdAt: Maybe<Scalars['DateTime']>
  /** The first name of the advocate's friend */
  friendFirstName: Maybe<Scalars['String']>
  /** The last name of the advocate's friend */
  friendLastName: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatusV2>
  /** User ID of the referred user */
  userId: Scalars['ID']
}

export type FriendHistoryConnection = {
  __typename?: 'FriendHistoryConnection'
  edges: Maybe<FriendHistoryEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export type FriendHistoryEdge = {
  __typename?: 'FriendHistoryEdge'
  cursor: Scalars['String']
  node: FriendHistory
}

/** Status of friend */
export enum FriendStatus {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend did not complete required steps in allotted time frame */
  Expired = 'EXPIRED',
  /** Reward has been given to Friend/Advocate */
  Fulfilled = 'FULFILLED',
  /** Friend has registered */
  Pending = 'PENDING',
  /** Advocate sent invite but user has not completed any steps */
  Sent = 'SENT',
}

/** Status of friend */
export enum FriendStatusV2 {
  /** Friend has finished required steps to qualify for reward */
  Complete = 'COMPLETE',
  /** Friend has invested */
  ConfirmingEligibility = 'CONFIRMING_ELIGIBILITY',
  /** Friend is ineligible for reward */
  Ineligible = 'INELIGIBLE',
  /** Friend has signed up or created first investment */
  InProgress = 'IN_PROGRESS',
}

export type FriendSummary = {
  __typename?: 'FriendSummary'
  /** Campaign identifier that the referred user signed up under */
  campaignId: Scalars['ID']
  /** First name of the referred user */
  name: Maybe<Scalars['String']>
  /** High level status indicating referred user reward status */
  status: Maybe<FriendStatus>
  userId: Scalars['ID']
}

export type FriendV2Output = {
  __typename?: 'FriendV2Output'
  advocate: Maybe<AdvocateV2>
  campaign: Maybe<CampaignV2>
  userId: Maybe<Scalars['ID']>
}

export type Fund = Security & {
  __typename?: 'Fund'
  currentPrice: BigCurrencyAmount
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: SecurityHeadline[]
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  numberOfHoldings: Scalars['Int']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use `Security.headlines` instead. */
  securityHeadlines: SecurityHeadline[]
  /** @deprecated Use `Security.profile` instead. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  topHoldings: TopHolding[]
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** Boolean indicating if the user can fund spend in activation */
export type FundSpendInActivationPayload = {
  __typename?: 'FundSpendInActivationPayload'
  /** Boolean indicating if the user can fund spend in activation */
  eligible: Scalars['Boolean']
}

/** A Funding Source for the acorns user */
export type FundingSource = {
  __typename?: 'FundingSource'
  alert: Maybe<Scalars['JSON']>
  /** The type of the funding source. */
  fundingType: Scalars['String']
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['URL']>
  last4: Maybe<Scalars['String']>
  name: Scalars['String']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  verificationStatus: Scalars['Int']
  verified: Maybe<Scalars['Boolean']>
}

/** A Funding Source for the acorns user */
export type FundingSourceAccount = TimestampsInterface & {
  __typename?: 'FundingSourceAccount'
  accountName: Scalars['String']
  alert: Maybe<Scalars['JSON']>
  balance: Maybe<Scalars['Float']>
  bankRoutingNumber: Maybe<Scalars['String']>
  canCancel: Scalars['Boolean']
  canRetriggerRdv: Scalars['Boolean']
  canTriggerRdv: Scalars['Boolean']
  /** Indicates whether the user is allowed to verify RDV */
  canVerifyRdv: Maybe<Scalars['Boolean']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  deleted: Scalars['Boolean']
  frozen: Scalars['Boolean']
  /** The type of the funding source. */
  fundType: FundingSourceType
  /** The bank icon of the funding source */
  icon: Maybe<Scalars['String']>
  id: Scalars['Int']
  institutionId: Maybe<Scalars['String']>
  institutionName: Scalars['String']
  insufficientFunds: Maybe<Scalars['Boolean']>
  last4: Maybe<Scalars['String']>
  linked: Scalars['Boolean']
  linkedSubaccountId: Maybe<Scalars['ID']>
  /** The logo url from Linked Accounts Service */
  logoUrl: Maybe<Scalars['String']>
  name: Scalars['String']
  /** Identifies whether the user has indicated that they prefer to withdraw funds to this account. */
  preferredWithdrawalAccount: Scalars['Boolean']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  /** The role of the funding source. */
  role: Maybe<FundingSourceRoleEnum>
  /** The status of the funding source. */
  status: FundingSourceStatus
  transfersApproved: Scalars['Boolean']
  /** Deprecated - use fundType instead. */
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  uuid: Maybe<Scalars['ID']>
  verificationStatus: Scalars['Int']
  verified: Maybe<Scalars['Boolean']>
}

/** Funding Source with account and routing already exists for user */
export type FundingSourceAlreadyExists = {
  __typename?: 'FundingSourceAlreadyExists'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Account credentials linked by too many users */
export type FundingSourceCredentialsExceedLinkLimit = {
  __typename?: 'FundingSourceCredentialsExceedLinkLimit'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type FundingSourceInfo = {
  __typename?: 'FundingSourceInfo'
  accountNumberLastFour: Maybe<Scalars['String']>
  alert: Maybe<Scalars['JSON']>
  balance: Maybe<Scalars['Float']>
  /** @deprecated Will move in the future */
  canChange: Scalars['Boolean']
  /** @deprecated Will move in the future */
  changeRequiresApproval: Scalars['Boolean']
  icon: Maybe<Scalars['URL']>
  linkedSubaccountId: Maybe<Scalars['ID']>
  name: Scalars['String']
  rdvSettledAt: Maybe<Scalars['DateTime']>
  rdvTriggeredAt: Maybe<Scalars['DateTime']>
  type: Maybe<FundingSourceType>
  verificationStatus: Maybe<Scalars['Int']>
  verified: Maybe<Scalars['Boolean']>
}

/** The user needs to verify their RDVs to close their early account */
export type FundingSourceRequiresRdvException = {
  __typename?: 'FundingSourceRequiresRdvException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum FundingSourceRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

export enum FundingSourceStatus {
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
}

export enum FundingSourceStatusEnum {
  /** Documents have been requested to verify the funding source. */
  DocsRequired = 'docsRequired',
  /** RDV verification attempts exhausted. */
  Frozen = 'frozen',
  /** Funding Source is waiting on RDV triggers. */
  Pending = 'pending',
  /** RDVs have been sent and are awaiting settlement. */
  RdvsInitiated = 'rdvsInitiated',
  /** RDVs have settled in the user's funding source. User must verify amounts. */
  RdvsSettled = 'rdvsSettled',
  /** Funding Source is verified. No user action is required. */
  Success = 'success',
  /** Awaiting admin approval. No user action is required. */
  Unapproved = 'unapproved',
}

export enum FundingSourceType {
  Ach = 'ach',
  Paypal = 'paypal',
  Spend = 'spend',
}

export enum FundsAvailability {
  /** User wants easy access to cash in an emergency */
  Emergency = 'emergency',
  /** User is planning to save and not withdraw until retirement */
  Retirement = 'retirement',
}

export enum Funnel {
  /** Core funnel */
  Core = 'core',
  /** Direct to mobile funnel */
  DirectToMobile = 'direct_to_mobile',
  /** Early funnel */
  Early = 'early',
  /** Later funnel */
  Later = 'later',
  /** Simple registration funnel */
  SimpleReg = 'simple_reg',
  /** Spend funnel */
  Spend = 'spend',
  /** Tiered registration funnel */
  TieredReg = 'tiered_reg',
}

export type FunnelMetadata = {
  __typename?: 'FunnelMetadata'
  name: FunnelName
  version: Scalars['String']
}

export enum FunnelName {
  Default = 'DEFAULT',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  Referrals = 'REFERRALS',
}

/** Attributes for generating a layer linked account session. */
export type GenerateLayerLinkSessionInput = {
  /** Android package name for the Acorns app. */
  androidPackageName?: InputMaybe<Scalars['String']>
  /** ISO 639-1 code representing the language. Default is 'EN'. */
  language?: InputMaybe<LinkSessionLanguage>
  /** The configuration of the Plaid session to generate for the customer. Defaulted to Acorns' standard configuration. */
  linkCustomization?: InputMaybe<LinkCustomization>
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>
}

/** Returns a Link Token to use with Account Linking. */
export type GenerateLayerLinkSessionResult =
  | PlaidLayerLinkSession
  | UnrecoverableError

/** Attributes for generating a linked account session. */
export type GenerateLinkSessionInput = {
  /** Android package name for the Acorns app */
  androidPackageName?: InputMaybe<Scalars['String']>
  /** The URL to redirect the client to after customer has finished linking account. */
  authRequired?: InputMaybe<Scalars['Boolean']>
  /** Acorns Financial Institution ID */
  institutionId: Scalars['ID']
  /** Flag indicating a web view client default is true */
  isWebview?: InputMaybe<Scalars['Boolean']>
  /** ISO 639-1 code representing the language. default is 'EN' */
  language?: InputMaybe<LinkSessionLanguage>
  /** Linked Account ID for Linked Account to relink */
  linkedAccountId?: InputMaybe<Scalars['ID']>
  /** The URL to redirect the client to after customer has finished linking account. */
  redirectUrl?: InputMaybe<Scalars['URL']>
}

export type GenerateReferralCodeResult = Invitation

/** Returns Base 64 encoded string of PDF for Front-end */
export type GenerateUpdatedPdfPayload = {
  __typename?: 'GenerateUpdatedPdfPayload'
  /** Base 64 Encoded String of PDF */
  pdf: Scalars['String']
}

export type GetUsersBankFromAccountTypePayload = {
  __typename?: 'GetUsersBankFromAccountTypePayload'
  bankType: BankType
}

/** Object representing a grow prospect */
export type GrowProspect = Prospect & {
  __typename?: 'GrowProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type HelpFormContent = {
  __typename?: 'HelpFormContent'
  body: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
}

export enum HelpFormType {
  Contact = 'CONTACT',
  EarnMissingCredit = 'EARN_MISSING_CREDIT',
  SpendDispute = 'SPEND_DISPUTE',
}

export type HelpcenterBannerContent = {
  __typename?: 'HelpcenterBannerContent'
  bannerText: Scalars['String']
  bannerType: HelpcenterBannerType
  currentVersion: Scalars['String']
  publishedVersion: Maybe<Scalars['String']>
  visible: Scalars['Boolean']
}

export type HelpcenterBannerErrors = {
  __typename?: 'HelpcenterBannerErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export enum HelpcenterBannerType {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}

export type HelpcenterContentInput = {
  bannerText?: InputMaybe<Scalars['String']>
  bannerType?: InputMaybe<HelpcenterBannerType>
  publish?: InputMaybe<Scalars['Boolean']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type HideMessageByExternalIdInput = {
  externalMessageId: Scalars['ID']
}

export type HideMessageInput = {
  messageId: Scalars['ID']
}

/** The Individual Security on the ETF */
export type Holding = {
  __typename?: 'Holding'
  /** Indicates the amount of every dollar that will go towards buying a share of the stock */
  amount: Scalars['Float']
  /** The name of the stock */
  name: Scalars['String']
  /** Indicates the percent of every dollar that will go towards buying a share of the stock */
  percent: Scalars['Float']
  /** The Symbol of the stock */
  symbol: Scalars['String']
}

/** Holding transfer information; ex: beneficiaryTransfer, external transfer, and external transfer reversed */
export type HoldingsTransfer = {
  __typename?: 'HoldingsTransfer'
  /** Holdings transfer type */
  transferType: HoldingsTransferType
}

/** Defines the different types of holdings transfers. */
export enum HoldingsTransferType {
  BeneficiaryTransfer = 'BENEFICIARY_TRANSFER',
  ExternalTransfer = 'EXTERNAL_TRANSFER',
  ExternalTransferReversed = 'EXTERNAL_TRANSFER_REVERSED',
}

/** An IRA Distribution or a withdraw investment for Later account */
export type IraDistribution = {
  __typename?: 'IRADistribution'
  /** created at date and time of IRA Distribution */
  createdAt: Scalars['DateTime']
  /** Stubbed Field: Federal withholdings for Later account */
  federalWithholdings: Maybe<MonetaryAmount>
  /** ID of the IRA Distribution */
  id: Scalars['ID']
  /** Investment ID of the IRA Distribution from the investment table */
  investmentId: Scalars['ID']
  /** Stubbed Field: State withholdings for Later account */
  stateWithholdings: Maybe<MonetaryAmount>
  /** update at date and time of IRA Distribution */
  updatedAt: Scalars['DateTime']
}

export enum IconType {
  IconAddGoal = 'ICON_ADD_GOAL',
  IconAlert = 'ICON_ALERT',
  IconAlertGrey = 'ICON_ALERT_GREY',
  IconAlertPause = 'ICON_ALERT_PAUSE',
  IconAlertPending = 'ICON_ALERT_PENDING',
  IconAlertRed = 'ICON_ALERT_RED',
  IconAlertYellow = 'ICON_ALERT_YELLOW',
  IconArrow = 'ICON_ARROW',
  IconArticle = 'ICON_ARTICLE',
  IconArticle12 = 'ICON_ARTICLE12',
  IconAudio = 'ICON_AUDIO',
  IconBabyKids = 'ICON_BABY_KIDS',
  IconCard = 'ICON_CARD',
  IconCategoryBaby = 'ICON_CATEGORY_BABY',
  IconCategoryBeauty = 'ICON_CATEGORY_BEAUTY',
  IconCategoryCar = 'ICON_CATEGORY_CAR',
  IconCategoryClothing = 'ICON_CATEGORY_CLOTHING',
  IconCategoryCollege = 'ICON_CATEGORY_COLLEGE',
  IconCategoryEntertainment = 'ICON_CATEGORY_ENTERTAINMENT',
  IconCategoryFlowers = 'ICON_CATEGORY_FLOWERS',
  IconCategoryFood = 'ICON_CATEGORY_FOOD',
  IconCategoryFootball = 'ICON_CATEGORY_FOOTBALL',
  IconCategoryHealth = 'ICON_CATEGORY_HEALTH',
  IconCategoryHome = 'ICON_CATEGORY_HOME',
  IconCategoryPet = 'ICON_CATEGORY_PET',
  IconCategoryPhone = 'ICON_CATEGORY_PHONE',
  IconCategoryShoe = 'ICON_CATEGORY_SHOE',
  IconCheckHub = 'ICON_CHECK_HUB',
  IconCheckIn = 'ICON_CHECK_IN',
  IconCircleCheck = 'ICON_CIRCLE_CHECK',
  IconCircleClock = 'ICON_CIRCLE_CLOCK',
  IconCircleInfo = 'ICON_CIRCLE_INFO',
  IconCirclePause = 'ICON_CIRCLE_PAUSE',
  IconCircleX = 'ICON_CIRCLE_X',
  IconClose = 'ICON_CLOSE',
  IconClothing = 'ICON_CLOTHING',
  IconDepositCheck = 'ICON_DEPOSIT_CHECK',
  IconDirectDeposit = 'ICON_DIRECT_DEPOSIT',
  IconDisclosureRight = 'ICON_DISCLOSURE_RIGHT',
  IconDropPin = 'ICON_DROP_PIN',
  IconEarnJobs = 'ICON_EARN_JOBS',
  IconElectronics = 'ICON_ELECTRONICS',
  IconEntertainment = 'ICON_ENTERTAINMENT',
  IconExpand = 'ICON_EXPAND',
  IconFastQuote = 'ICON_FAST_QUOTE',
  IconFavorites = 'ICON_FAVORITES',
  IconFinancialWellness = 'ICON_FINANCIAL_WELLNESS',
  IconFlowersGifts = 'ICON_FLOWERS_GIFTS',
  IconFoodGourmet = 'ICON_FOOD_GOURMET',
  IconGradCap = 'ICON_GRAD_CAP',
  IconHealthBeauty = 'ICON_HEALTH_BEAUTY',
  IconHealthWellness = 'ICON_HEALTH_WELLNESS',
  IconHistory = 'ICON_HISTORY',
  IconHomeDecor = 'ICON_HOME_DECOR',
  IconInstant = 'ICON_INSTANT',
  IconInterstitialAchievements = 'ICON_INTERSTITIAL_ACHIEVEMENTS',
  IconInterstitialAdd = 'ICON_INTERSTITIAL_ADD',
  IconInterstitialApy = 'ICON_INTERSTITIAL_APY',
  IconInterstitialAutoRefill = 'ICON_INTERSTITIAL_AUTO_REFILL',
  IconInterstitialBank = 'ICON_INTERSTITIAL_BANK',
  IconInterstitialCalculator = 'ICON_INTERSTITIAL_CALCULATOR',
  IconInterstitialCalendar = 'ICON_INTERSTITIAL_CALENDAR',
  IconInterstitialCheck = 'ICON_INTERSTITIAL_CHECK',
  IconInterstitialCheckActive = 'ICON_INTERSTITIAL_CHECK_ACTIVE',
  IconInterstitialConfident = 'ICON_INTERSTITIAL_CONFIDENT',
  IconInterstitialCreditCard = 'ICON_INTERSTITIAL_CREDIT_CARD',
  IconInterstitialDeposit = 'ICON_INTERSTITIAL_DEPOSIT',
  IconInterstitialDocuments = 'ICON_INTERSTITIAL_DOCUMENTS',
  IconInterstitialDollar = 'ICON_INTERSTITIAL_DOLLAR',
  IconInterstitialDollarSign = 'ICON_INTERSTITIAL_DOLLAR_SIGN',
  IconInterstitialEarnJobs = 'ICON_INTERSTITIAL_EARN_JOBS',
  IconInterstitialEntries = 'ICON_INTERSTITIAL_ENTRIES',
  IconInterstitialFastQuote = 'ICON_INTERSTITIAL_FAST_QUOTE',
  IconInterstitialFeelingGood = 'ICON_INTERSTITIAL_FEELING_GOOD',
  IconInterstitialGettingStarted1 = 'ICON_INTERSTITIAL_GETTING_STARTED1',
  IconInterstitialGettingStarted2 = 'ICON_INTERSTITIAL_GETTING_STARTED2',
  IconInterstitialHealthAdd = 'ICON_INTERSTITIAL_HEALTH_ADD',
  IconInterstitialLearn = 'ICON_INTERSTITIAL_LEARN',
  IconInterstitialMatch = 'ICON_INTERSTITIAL_MATCH',
  IconInterstitialNextDay = 'ICON_INTERSTITIAL_NEXT_DAY',
  IconInterstitialNumber = 'ICON_INTERSTITIAL_NUMBER',
  IconInterstitialOffers = 'ICON_INTERSTITIAL_OFFERS',
  IconInterstitialPie = 'ICON_INTERSTITIAL_PIE',
  IconInterstitialPin = 'ICON_INTERSTITIAL_PIN',
  IconInterstitialProfile = 'ICON_INTERSTITIAL_PROFILE',
  IconInterstitialRecurring = 'ICON_INTERSTITIAL_RECURRING',
  IconInterstitialRenters = 'ICON_INTERSTITIAL_RENTERS',
  IconInterstitialRoundUp = 'ICON_INTERSTITIAL_ROUND_UP',
  IconInterstitialRoundUps = 'ICON_INTERSTITIAL_ROUND_UPS',
  IconInterstitialRoundUpBill = 'ICON_INTERSTITIAL_ROUND_UP_BILL',
  IconInterstitialSave = 'ICON_INTERSTITIAL_SAVE',
  IconInterstitialSendCheck = 'ICON_INTERSTITIAL_SEND_CHECK',
  IconInterstitialShipping = 'ICON_INTERSTITIAL_SHIPPING',
  IconInterstitialSideHustles = 'ICON_INTERSTITIAL_SIDE_HUSTLES',
  IconInterstitialSimplySpend = 'ICON_INTERSTITIAL_SIMPLY_SPEND',
  IconInterstitialSmartDeposit = 'ICON_INTERSTITIAL_SMART_DEPOSIT',
  IconInterstitialSmartDepositActive = 'ICON_INTERSTITIAL_SMART_DEPOSIT_ACTIVE',
  IconInterstitialTimer = 'ICON_INTERSTITIAL_TIMER',
  IconInterstitialTree = 'ICON_INTERSTITIAL_TREE',
  IconInterstitialTwoFactorAuth = 'ICON_INTERSTITIAL_TWO_FACTOR_AUTH',
  IconInterstitialWallet = 'ICON_INTERSTITIAL_WALLET',
  IconInvest = 'ICON_INVEST',
  IconLearningCenter = 'ICON_LEARNING_CENTER',
  IconLightningBolt = 'ICON_LIGHTNING_BOLT',
  IconLive = 'ICON_LIVE',
  IconLocalOffers = 'ICON_LOCAL_OFFERS',
  IconLocation = 'ICON_LOCATION',
  IconLock = 'ICON_LOCK',
  IconLockSolid = 'ICON_LOCK_SOLID',
  IconMiniArrowLrgDown = 'ICON_MINI_ARROW_LRG_DOWN',
  IconMiniArrowLrgUp = 'ICON_MINI_ARROW_LRG_UP',
  IconMiniArrowSmDown = 'ICON_MINI_ARROW_SM_DOWN',
  IconMiniArrowSmUp = 'ICON_MINI_ARROW_SM_UP',
  IconMiniArticle = 'ICON_MINI_ARTICLE',
  IconMiniAudio = 'ICON_MINI_AUDIO',
  IconMiniCheckmark = 'ICON_MINI_CHECKMARK',
  IconMiniIndicatorTriangle = 'ICON_MINI_INDICATOR_TRIANGLE',
  IconMiniLightningBolt = 'ICON_MINI_LIGHTNING_BOLT',
  IconMiniLock = 'ICON_MINI_LOCK',
  IconMiniNew = 'ICON_MINI_NEW',
  IconMiniPlay = 'ICON_MINI_PLAY',
  IconMiniSelectionCheck = 'ICON_MINI_SELECTION_CHECK',
  IconMinus = 'ICON_MINUS',
  IconNew = 'ICON_NEW',
  IconOneTime = 'ICON_ONE_TIME',
  IconPets = 'ICON_PETS',
  IconPlane = 'ICON_PLANE',
  IconPlayMini = 'ICON_PLAY_MINI',
  IconPlayVideo = 'ICON_PLAY_VIDEO',
  IconPlus = 'ICON_PLUS',
  IconProductBanking = 'ICON_PRODUCT_BANKING',
  IconProductBenefits = 'ICON_PRODUCT_BENEFITS',
  IconProductColorAchievements = 'ICON_PRODUCT_COLOR_ACHIEVEMENTS',
  IconProductColorEarly = 'ICON_PRODUCT_COLOR_EARLY',
  IconProductColorEarn = 'ICON_PRODUCT_COLOR_EARN',
  IconProductColorEmergencyFund = 'ICON_PRODUCT_COLOR_EMERGENCY_FUND',
  IconProductColorGrow = 'ICON_PRODUCT_COLOR_GROW',
  IconProductColorInvest = 'ICON_PRODUCT_COLOR_INVEST',
  IconProductColorInvite = 'ICON_PRODUCT_COLOR_INVITE',
  IconProductColorLater = 'ICON_PRODUCT_COLOR_LATER',
  IconProductColorLocalFoundMoney = 'ICON_PRODUCT_COLOR_LOCAL_FOUND_MONEY',
  IconProductColorProtect = 'ICON_PRODUCT_COLOR_PROTECT',
  IconProductColorSave = 'ICON_PRODUCT_COLOR_SAVE',
  IconProductColorSpend = 'ICON_PRODUCT_COLOR_SPEND',
  IconProductEarly = 'ICON_PRODUCT_EARLY',
  IconProductEarn = 'ICON_PRODUCT_EARN',
  IconProductEmergency = 'ICON_PRODUCT_EMERGENCY',
  IconProductGoHenry = 'ICON_PRODUCT_GO_HENRY',
  IconProductGrow = 'ICON_PRODUCT_GROW',
  IconProductInvest = 'ICON_PRODUCT_INVEST',
  IconProductInvestHub = 'ICON_PRODUCT_INVEST_HUB',
  IconProductInvestProduct = 'ICON_PRODUCT_INVEST_PRODUCT',
  IconProductLater = 'ICON_PRODUCT_LATER',
  IconProductProtect = 'ICON_PRODUCT_PROTECT',
  IconProductSave = 'ICON_PRODUCT_SAVE',
  IconProductSpend = 'ICON_PRODUCT_SPEND',
  IconProtected = 'ICON_PROTECTED',
  IconReversal = 'ICON_REVERSAL',
  IconRoundUps = 'ICON_ROUND_UPS',
  IconScooter = 'ICON_SCOOTER',
  IconSearch = 'ICON_SEARCH',
  IconSendCheck = 'ICON_SEND_CHECK',
  IconSendMoneyInstant = 'ICON_SEND_MONEY_INSTANT',
  IconShare = 'ICON_SHARE',
  IconShoesAccessories = 'ICON_SHOES_ACCESSORIES',
  IconSideHustles = 'ICON_SIDE_HUSTLES',
  IconSimplySpend = 'ICON_SIMPLY_SPEND',
  IconSportsOutdoors = 'ICON_SPORTS_OUTDOORS',
  IconTimer = 'ICON_TIMER',
  IconTransactionAcorns = 'ICON_TRANSACTION_ACORNS',
  IconTransactionAtm = 'ICON_TRANSACTION_ATM',
  IconTransactionBankFee = 'ICON_TRANSACTION_BANK_FEE',
  IconTransactionCheck = 'ICON_TRANSACTION_CHECK',
  IconTransactionCheckDeposit = 'ICON_TRANSACTION_CHECK_DEPOSIT',
  IconTransactionDirectDeposit = 'ICON_TRANSACTION_DIRECT_DEPOSIT',
  IconTransactionDistribution = 'ICON_TRANSACTION_DISTRIBUTION',
  IconTransactionDividend = 'ICON_TRANSACTION_DIVIDEND',
  IconTransactionEarnReward = 'ICON_TRANSACTION_EARN_REWARD',
  IconTransactionEarnRewardsMatch = 'ICON_TRANSACTION_EARN_REWARDS_MATCH',
  IconTransactionGift = 'ICON_TRANSACTION_GIFT',
  IconTransactionGoHenry = 'ICON_TRANSACTION_GO_HENRY',
  IconTransactionHamburger = 'ICON_TRANSACTION_HAMBURGER',
  IconTransactionId = 'ICON_TRANSACTION_ID',
  IconTransactionInstantRoundUp = 'ICON_TRANSACTION_INSTANT_ROUND_UP',
  IconTransactionOneTime = 'ICON_TRANSACTION_ONE_TIME',
  IconTransactionOriginalTransaction = 'ICON_TRANSACTION_ORIGINAL_TRANSACTION',
  IconTransactionRebalance = 'ICON_TRANSACTION_REBALANCE',
  IconTransactionRecurringDeposit = 'ICON_TRANSACTION_RECURRING_DEPOSIT',
  IconTransactionRefund = 'ICON_TRANSACTION_REFUND',
  IconTransactionRoundUp = 'ICON_TRANSACTION_ROUND_UP',
  IconTransactionSpendCard = 'ICON_TRANSACTION_SPEND_CARD',
  IconTransactionStatus = 'ICON_TRANSACTION_STATUS',
  IconTransactionTransferIn = 'ICON_TRANSACTION_TRANSFER_IN',
  IconTransactionTransferInOut = 'ICON_TRANSACTION_TRANSFER_IN_OUT',
  IconTransactionTransferOut = 'ICON_TRANSACTION_TRANSFER_OUT',
  IconTransactionType = 'ICON_TRANSACTION_TYPE',
  IconTransfer = 'ICON_TRANSFER',
  IconTravelTransportation = 'ICON_TRAVEL_TRANSPORTATION',
  IconTrustedPartners = 'ICON_TRUSTED_PARTNERS',
  IconUtilityAccessibility = 'ICON_UTILITY_ACCESSIBILITY',
  IconUtilityAccountDetails = 'ICON_UTILITY_ACCOUNT_DETAILS',
  IconUtilityAchievement = 'ICON_UTILITY_ACHIEVEMENT',
  IconUtilityAcorn = 'ICON_UTILITY_ACORN',
  IconUtilityAdd = 'ICON_UTILITY_ADD',
  IconUtilityAi = 'ICON_UTILITY_AI',
  IconUtilityAlert = 'ICON_UTILITY_ALERT',
  IconUtilityApy = 'ICON_UTILITY_APY',
  IconUtilityArrowLeft = 'ICON_UTILITY_ARROW_LEFT',
  IconUtilityArrowRight = 'ICON_UTILITY_ARROW_RIGHT',
  IconUtilityArExperience = 'ICON_UTILITY_AR_EXPERIENCE',
  IconUtilityBackupCodes = 'ICON_UTILITY_BACKUP_CODES',
  IconUtilityBag = 'ICON_UTILITY_BAG',
  IconUtilityBank = 'ICON_UTILITY_BANK',
  IconUtilityBankAdd = 'ICON_UTILITY_BANK_ADD',
  IconUtilityBankFees = 'ICON_UTILITY_BANK_FEES',
  IconUtilityBell = 'ICON_UTILITY_BELL',
  IconUtilityBellFilled = 'ICON_UTILITY_BELL_FILLED',
  IconUtilityBeneficiaries = 'ICON_UTILITY_BENEFICIARIES',
  IconUtilityBinoculars = 'ICON_UTILITY_BINOCULARS',
  IconUtilityBirthday = 'ICON_UTILITY_BIRTHDAY',
  IconUtilityBonds = 'ICON_UTILITY_BONDS',
  IconUtilityBook = 'ICON_UTILITY_BOOK',
  IconUtilityBookmark = 'ICON_UTILITY_BOOKMARK',
  IconUtilityBookmarkFilled = 'ICON_UTILITY_BOOKMARK_FILLED',
  IconUtilityBox = 'ICON_UTILITY_BOX',
  IconUtilityBudgeting = 'ICON_UTILITY_BUDGETING',
  IconUtilityCalendar = 'ICON_UTILITY_CALENDAR',
  IconUtilityCamera = 'ICON_UTILITY_CAMERA',
  IconUtilityCancel = 'ICON_UTILITY_CANCEL',
  IconUtilityCar = 'ICON_UTILITY_CAR',
  IconUtilityCashOwed = 'ICON_UTILITY_CASH_OWED',
  IconUtilityCellTower = 'ICON_UTILITY_CELL_TOWER',
  IconUtilityChatBubble = 'ICON_UTILITY_CHAT_BUBBLE',
  IconUtilityCheckmark = 'ICON_UTILITY_CHECKMARK',
  IconUtilityClose = 'ICON_UTILITY_CLOSE',
  IconUtilityCoin = 'ICON_UTILITY_COIN',
  IconUtilityCollapseMenu = 'ICON_UTILITY_COLLAPSE_MENU',
  IconUtilityCompanyBuilding = 'ICON_UTILITY_COMPANY_BUILDING',
  IconUtilityController = 'ICON_UTILITY_CONTROLLER',
  IconUtilityCopy = 'ICON_UTILITY_COPY',
  IconUtilityCrane = 'ICON_UTILITY_CRANE',
  IconUtilityCredit = 'ICON_UTILITY_CREDIT',
  IconUtilityCrypto = 'ICON_UTILITY_CRYPTO',
  IconUtilityCurrentLocation = 'ICON_UTILITY_CURRENT_LOCATION',
  IconUtilityCustomize = 'ICON_UTILITY_CUSTOMIZE',
  IconUtilityCustomStocks = 'ICON_UTILITY_CUSTOM_STOCKS',
  IconUtilityCyberSecurity = 'ICON_UTILITY_CYBER_SECURITY',
  IconUtilityDelete = 'ICON_UTILITY_DELETE',
  IconUtilityDocuments = 'ICON_UTILITY_DOCUMENTS',
  IconUtilityDocumentDownload = 'ICON_UTILITY_DOCUMENT_DOWNLOAD',
  IconUtilityDocumentUpload = 'ICON_UTILITY_DOCUMENT_UPLOAD',
  IconUtilityDots = 'ICON_UTILITY_DOTS',
  IconUtilityDown = 'ICON_UTILITY_DOWN',
  IconUtilityDownFilled = 'ICON_UTILITY_DOWN_FILLED',
  IconUtilityEarnJobs = 'ICON_UTILITY_EARN_JOBS',
  IconUtilityEdit = 'ICON_UTILITY_EDIT',
  IconUtilityEntries = 'ICON_UTILITY_ENTRIES',
  IconUtilityEth = 'ICON_UTILITY_ETH',
  IconUtilityExpand = 'ICON_UTILITY_EXPAND',
  IconUtilityExpandMenu = 'ICON_UTILITY_EXPAND_MENU',
  IconUtilityFace = 'ICON_UTILITY_FACE',
  IconUtilityFaceId = 'ICON_UTILITY_FACE_ID',
  IconUtilityFastQuote = 'ICON_UTILITY_FAST_QUOTE',
  IconUtilityFilter = 'ICON_UTILITY_FILTER',
  IconUtilityFlame = 'ICON_UTILITY_FLAME',
  IconUtilityFlashOff = 'ICON_UTILITY_FLASH_OFF',
  IconUtilityFlashOn = 'ICON_UTILITY_FLASH_ON',
  IconUtilityFlexible = 'ICON_UTILITY_FLEXIBLE',
  IconUtilityGift = 'ICON_UTILITY_GIFT',
  IconUtilityGoal = 'ICON_UTILITY_GOAL',
  IconUtilityGovernment = 'ICON_UTILITY_GOVERNMENT',
  IconUtilityGradCap = 'ICON_UTILITY_GRAD_CAP',
  IconUtilityHamburgerMenu = 'ICON_UTILITY_HAMBURGER_MENU',
  IconUtilityHealth = 'ICON_UTILITY_HEALTH',
  IconUtilityHeart = 'ICON_UTILITY_HEART',
  IconUtilityHeartAdd = 'ICON_UTILITY_HEART_ADD',
  IconUtilityHeartFilled = 'ICON_UTILITY_HEART_FILLED',
  IconUtilityHelp = 'ICON_UTILITY_HELP',
  IconUtilityHide = 'ICON_UTILITY_HIDE',
  IconUtilityHistory = 'ICON_UTILITY_HISTORY',
  IconUtilityHome = 'ICON_UTILITY_HOME',
  IconUtilityInfo = 'ICON_UTILITY_INFO',
  IconUtilityInvestorProfile = 'ICON_UTILITY_INVESTOR_PROFILE',
  IconUtilityInvite = 'ICON_UTILITY_INVITE',
  IconUtilityJobAlerts = 'ICON_UTILITY_JOB_ALERTS',
  IconUtilityKeypad = 'ICON_UTILITY_KEYPAD',
  IconUtilityLaptop = 'ICON_UTILITY_LAPTOP',
  IconUtilityLargeCheckmark = 'ICON_UTILITY_LARGE_CHECKMARK',
  IconUtilityLargePlus = 'ICON_UTILITY_LARGE_PLUS',
  IconUtilityLeaf = 'ICON_UTILITY_LEAF',
  IconUtilityLibrary = 'ICON_UTILITY_LIBRARY',
  IconUtilityLightbulb = 'ICON_UTILITY_LIGHTBULB',
  IconUtilityLocalOffers = 'ICON_UTILITY_LOCAL_OFFERS',
  IconUtilityLoginActivity = 'ICON_UTILITY_LOGIN_ACTIVITY',
  IconUtilityLogOut = 'ICON_UTILITY_LOG_OUT',
  IconUtilityMail = 'ICON_UTILITY_MAIL',
  IconUtilityManualLinking = 'ICON_UTILITY_MANUAL_LINKING',
  IconUtilityMapPin = 'ICON_UTILITY_MAP_PIN',
  IconUtilityMatch = 'ICON_UTILITY_MATCH',
  IconUtilityMedia = 'ICON_UTILITY_MEDIA',
  IconUtilityMenu = 'ICON_UTILITY_MENU',
  IconUtilityMobilePhone = 'ICON_UTILITY_MOBILE_PHONE',
  IconUtilityMorning = 'ICON_UTILITY_MORNING',
  IconUtilityNew = 'ICON_UTILITY_NEW',
  IconUtilityNight = 'ICON_UTILITY_NIGHT',
  IconUtilityNotifications = 'ICON_UTILITY_NOTIFICATIONS',
  IconUtilityOneTime = 'ICON_UTILITY_ONE_TIME',
  IconUtilityPassword = 'ICON_UTILITY_PASSWORD',
  IconUtilityPause = 'ICON_UTILITY_PAUSE',
  IconUtilityPet = 'ICON_UTILITY_PET',
  IconUtilityPhone = 'ICON_UTILITY_PHONE',
  IconUtilityPin = 'ICON_UTILITY_PIN',
  IconUtilityPlane = 'ICON_UTILITY_PLANE',
  IconUtilityPlug = 'ICON_UTILITY_PLUG',
  IconUtilityPointer = 'ICON_UTILITY_POINTER',
  IconUtilityPortfolioType = 'ICON_UTILITY_PORTFOLIO_TYPE',
  IconUtilityPotential = 'ICON_UTILITY_POTENTIAL',
  IconUtilityPreferences = 'ICON_UTILITY_PREFERENCES',
  IconUtilityProfile = 'ICON_UTILITY_PROFILE',
  IconUtilityQr = 'ICON_UTILITY_QR',
  IconUtilityQuestionnaire = 'ICON_UTILITY_QUESTIONNAIRE',
  IconUtilityQuestionMark = 'ICON_UTILITY_QUESTION_MARK',
  IconUtilityQuickWithdraw = 'ICON_UTILITY_QUICK_WITHDRAW',
  IconUtilityReload = 'ICON_UTILITY_RELOAD',
  IconUtilityRenters = 'ICON_UTILITY_RENTERS',
  IconUtilityRisk = 'ICON_UTILITY_RISK',
  IconUtilityRocket = 'ICON_UTILITY_ROCKET',
  IconUtilityRoundUpsRealTime = 'ICON_UTILITY_ROUND_UPS_REAL_TIME',
  IconUtilitySafari = 'ICON_UTILITY_SAFARI',
  IconUtilityScales = 'ICON_UTILITY_SCALES',
  IconUtilityScience = 'ICON_UTILITY_SCIENCE',
  IconUtilityScooter = 'ICON_UTILITY_SCOOTER',
  IconUtilitySearch = 'ICON_UTILITY_SEARCH',
  IconUtilitySettings = 'ICON_UTILITY_SETTINGS',
  IconUtilityShareAndroid = 'ICON_UTILITY_SHARE_ANDROID',
  IconUtilityShareIos = 'ICON_UTILITY_SHARE_IOS',
  IconUtilityShareLink = 'ICON_UTILITY_SHARE_LINK',
  IconUtilityShieldCheck = 'ICON_UTILITY_SHIELD_CHECK',
  IconUtilityShipping = 'ICON_UTILITY_SHIPPING',
  IconUtilityShow = 'ICON_UTILITY_SHOW',
  IconUtilitySilverware = 'ICON_UTILITY_SILVERWARE',
  IconUtilitySingleCoin = 'ICON_UTILITY_SINGLE_COIN',
  IconUtilitySmartDepositShine = 'ICON_UTILITY_SMART_DEPOSIT_SHINE',
  IconUtilitySort = 'ICON_UTILITY_SORT',
  IconUtilitySpace = 'ICON_UTILITY_SPACE',
  IconUtilitySpendCardDispute = 'ICON_UTILITY_SPEND_CARD_DISPUTE',
  IconUtilitySpendCardLocked = 'ICON_UTILITY_SPEND_CARD_LOCKED',
  IconUtilitySprayBottle = 'ICON_UTILITY_SPRAY_BOTTLE',
  IconUtilitySprout = 'ICON_UTILITY_SPROUT',
  IconUtilityStackedCoins = 'ICON_UTILITY_STACKED_COINS',
  IconUtilityStar = 'ICON_UTILITY_STAR',
  IconUtilityStocks = 'ICON_UTILITY_STOCKS',
  IconUtilitySubscription = 'ICON_UTILITY_SUBSCRIPTION',
  IconUtilitySun = 'ICON_UTILITY_SUN',
  IconUtilityTax = 'ICON_UTILITY_TAX',
  IconUtilityTextMessage = 'ICON_UTILITY_TEXT_MESSAGE',
  IconUtilityThematicInvestments = 'ICON_UTILITY_THEMATIC_INVESTMENTS',
  IconUtilityTimer = 'ICON_UTILITY_TIMER',
  IconUtilityTouchId = 'ICON_UTILITY_TOUCH_ID',
  IconUtilityTrash = 'ICON_UTILITY_TRASH',
  IconUtilityTree = 'ICON_UTILITY_TREE',
  IconUtilityTwoFactorAuth = 'ICON_UTILITY_TWO_FACTOR_AUTH',
  IconUtilityUp = 'ICON_UTILITY_UP',
  IconUtilityUpFilled = 'ICON_UTILITY_UP_FILLED',
  IconUtilityWand = 'ICON_UTILITY_WAND',
  IconUtilityWithdraw = 'ICON_UTILITY_WITHDRAW',
  IconVideo = 'ICON_VIDEO',
  IconVideo12 = 'ICON_VIDEO12',
  IconVideoControls_10SForward = 'ICON_VIDEO_CONTROLS_10S_FORWARD',
  IconVideoControls_10SRewind = 'ICON_VIDEO_CONTROLS_10S_REWIND',
  IconVideoControlsMuted = 'ICON_VIDEO_CONTROLS_MUTED',
  IconVideoControlsPause = 'ICON_VIDEO_CONTROLS_PAUSE',
  IconVideoControlsPlay = 'ICON_VIDEO_CONTROLS_PLAY',
  IconVideoControlsReplay = 'ICON_VIDEO_CONTROLS_REPLAY',
  IconVideoControlsSoundOn = 'ICON_VIDEO_CONTROLS_SOUND_ON',
  IconViews = 'ICON_VIEWS',
  IconWithdraw = 'ICON_WITHDRAW',
}

/** Identity Document Requested Alert. */
export type IdentityDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'IdentityDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum IdentitySubaccount {
  Bank = 'BANK',
  Invest = 'INVEST',
}

export type IdentityVerification = {
  canRetry: Maybe<Scalars['Boolean']>
  verificationStatus: VerificationStatus
}

export type Image = {
  __typename?: 'Image'
  url: Scalars['String']
}

export enum ImageType {
  Back = 'back',
  Front = 'front',
}

export type ImplicitToken = {
  __typename?: 'ImplicitToken'
  token: Scalars['String']
}

/**
 * An abstract representation of some reward a subscriber will be afforded
 * upon subscription to some Offer.
 */
export type Incentive = {
  /**
   * Arbitrary human-readable identifier that can be used by clients
   * to localize related copy.
   */
  copyKey: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Description of what the incentive provides the subscriber. */
  description: Scalars['String']
  id: Scalars['ID']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type IncorrectOldPasswordException = {
  __typename?: 'IncorrectOldPasswordException'
  message: Maybe<Scalars['String']>
}

/** One of the entered deposit amounts was incorrect */
export type IncorrectRdvAmounts = {
  __typename?: 'IncorrectRdvAmounts'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type IncorrectSecurityAnswerException = {
  __typename?: 'IncorrectSecurityAnswerException'
  message: Maybe<Scalars['String']>
}

export type IncorrectSsnException = {
  __typename?: 'IncorrectSsnException'
  message: Maybe<Scalars['String']>
}

export type InitiateBankingKycInput = {
  accountTypes: BankAccountTypeConfig[]
}

export type InitiateBankingKycPayload = {
  __typename?: 'InitiateBankingKYCPayload'
  kycStatus: Maybe<KycStatus>
  message: Maybe<Scalars['String']>
  success: Maybe<Scalars['Boolean']>
}

export type InitiateChallengeInput = {
  authenticatorId?: InputMaybe<Scalars['ID']>
  mfaToken: Scalars['ID']
  type?: InputMaybe<AuthType>
  userId: Scalars['ID']
}

export type InitiateChallengeResult =
  | AuthenticatorNotFoundException
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | InitiatePushChallengeSuccess
  | InvalidMfaTokenException
  | PhoneNumberOptedOutException
  | PushAuthChallenge
  | SmsAuthChallenge

export type InitiateEmailChallengeInput = {
  email: Scalars['EmailAddress']
}

export type InitiateEmailChallengeResult =
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | ExistingEmailVerifiedException

export type InitiateMoneyAssignmentInput = {
  transactionId: Scalars['ID']
}

export type InitiateMoneyAssignmentResult =
  | InitiateMoneyAssignmentSuccess
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError

export type InitiateMoneyAssignmentSuccess = {
  __typename?: 'InitiateMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type InitiatePushChallengeResult =
  | ChallengeRateExceededException
  | InitiatePushChallengeSuccess
  | NoRegisteredPushAuthenticatorsException

export type InitiatePushChallengeSuccess = {
  __typename?: 'InitiatePushChallengeSuccess'
  challenges: Maybe<PushAuthChallenge[]>
}

export type InitiateSmsChallengeInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type InitiateSmsChallengeResult =
  | ChallengeRateExceededException
  | InvalidPhoneNumberException
  | PhoneNumberOptedOutException
  | SmsAuthChallenge

export type InitiateTransferInput = {
  /** Amount of currency to transfer */
  amount: CurrencyAmountInput
  /** UUID of account to move money from */
  fromAccountId: Scalars['ID']
  /** Idempotency key for customer request */
  nonce?: InputMaybe<Scalars['ID']>
  /** UUID of account to move money into */
  toAccountId: Scalars['ID']
}

export type InitiateTransferPayload = {
  __typename?: 'InitiateTransferPayload'
  transfer: Maybe<Transfer>
}

export type InitiateVerificationResult = VerificationProfile

export type InstitutionNotSupportedError = {
  __typename?: 'InstitutionNotSupportedError'
  message: Scalars['String']
}

/** Insufficient Funds user alert. */
export type InsufficientFundsUserAlert = UserAlertsItem & {
  __typename?: 'InsufficientFundsUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type Intent = {
  __typename?: 'Intent'
  amount: CurrencyAmount
  /** @deprecated Use `nonce` as the unique identifier for Intents instead. */
  id: Scalars['ID']
  nonce: Scalars['UUID']
  status: Maybe<IntentStatus>
}

/** Input the account types of the transfer. */
export type IntentFilterInput = {
  fromAccountType?: InputMaybe<Scalars['String']>
  toAccountType?: InputMaybe<Scalars['String']>
}

export enum IntentStatus {
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Reversed = 'REVERSED',
  Reversing = 'REVERSING',
  Submitted = 'SUBMITTED',
}

export type InteractionRatingResponse = {
  __typename?: 'InteractionRatingResponse'
  interactionId: Scalars['String']
  message: Scalars['String']
}

/** Internal Error */
export type InternalErrorException = {
  __typename?: 'InternalErrorException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The account number is invalid */
export type InvalidAccountNumber = {
  __typename?: 'InvalidAccountNumber'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Investment Account must be a Custodial account */
export type InvalidAccountTypeException = {
  __typename?: 'InvalidAccountTypeException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidAcornsEarlyTokenException = {
  __typename?: 'InvalidAcornsEarlyTokenException'
  message: Scalars['String']
}

/** Risk Level cannot be changed on Later and Early accounts */
export type InvalidActionOnAccount = {
  __typename?: 'InvalidActionOnAccount'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidAddressError = {
  __typename?: 'InvalidAddressError'
  /** Error details. Not for user display. */
  errorMessage: Maybe<Scalars['String']>
  requestId: Scalars['ID']
}

/** Invalid Address */
export type InvalidAddressException = {
  __typename?: 'InvalidAddressException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Allocations exceed max threshold for non managed portfolios */
export type InvalidAllocationPercentError = {
  __typename?: 'InvalidAllocationPercentError'
  /** Maximum allocation percent for the given portfolio Type */
  maxAllocationPercent: Scalars['Int']
}

export type InvalidAppleAccountException = {
  __typename?: 'InvalidAppleAccountException'
  message: Maybe<Scalars['String']>
  subId: Maybe<Scalars['String']>
}

export type InvalidContentTypeException = {
  __typename?: 'InvalidContentTypeException'
  contentType: Scalars['String']
}

/** Occurs when exactly one conversion ID (email, phone, etc) was not provided */
export type InvalidConversionIdentifierException = {
  __typename?: 'InvalidConversionIdentifierException'
  message: Scalars['String']
}

export type InvalidCredentialsException = {
  __typename?: 'InvalidCredentialsException'
  message: Maybe<Scalars['String']>
}

export type InvalidDateException = {
  __typename?: 'InvalidDateException'
  message: Scalars['String']
}

/** Date of birth does not meet validity criteria */
export type InvalidDateOfBirthException = {
  __typename?: 'InvalidDateOfBirthException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidDeviceParametersException = {
  __typename?: 'InvalidDeviceParametersException'
  message: Maybe<Scalars['String']>
}

/** Invalid email id */
export type InvalidEmailException = {
  __typename?: 'InvalidEmailException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The file uploaded does not have an allowed file extension */
export type InvalidFile = {
  __typename?: 'InvalidFile'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** First Name does not meet validity criteria */
export type InvalidFirstNameException = {
  __typename?: 'InvalidFirstNameException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidIdentityTokenException = {
  __typename?: 'InvalidIdentityTokenException'
  message: Maybe<Scalars['String']>
}

/** Invalid Investment Account */
export type InvalidInvestmentAccountException = {
  __typename?: 'InvalidInvestmentAccountException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Last Name does not meet validity criteria */
export type InvalidLastNameException = {
  __typename?: 'InvalidLastNameException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** This account is not supported */
export type InvalidManualLink = {
  __typename?: 'InvalidManualLink'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type InvalidMfaTokenException = {
  __typename?: 'InvalidMfaTokenException'
  userId: Maybe<Scalars['ID']>
}

export type InvalidOauthAppClientIdException = {
  __typename?: 'InvalidOauthAppClientIdException'
  oauthAppClientId: Scalars['ID']
}

export type InvalidOptionException = {
  __typename?: 'InvalidOptionException'
  message: Scalars['String']
}

export type InvalidPasswordException = {
  __typename?: 'InvalidPasswordException'
  message: Maybe<Scalars['String']>
}

export type InvalidPasswordResetException = {
  __typename?: 'InvalidPasswordResetException'
  errors: PasswordResetErrors[]
}

export type InvalidPasswordResetTokenException = {
  __typename?: 'InvalidPasswordResetTokenException'
  invalidToken: Scalars['String']
}

/** Invalid Phone Number */
export type InvalidPhoneException = {
  __typename?: 'InvalidPhoneException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidPhoneNumberException = {
  __typename?: 'InvalidPhoneNumberException'
  message: Maybe<Scalars['String']>
}

export type InvalidPinException = {
  __typename?: 'InvalidPinException'
  message: Maybe<Scalars['String']>
}

/** Portfolio ID must be valid */
export type InvalidPortfolioIdException = {
  __typename?: 'InvalidPortfolioIdException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidPromoCodeError = {
  __typename?: 'InvalidPromoCodeError'
  name: Scalars['String']
}

export type InvalidReferralRelationship = {
  __typename?: 'InvalidReferralRelationship'
  message: Scalars['String']
}

/** The routing number provided is unsupported or invalid */
export type InvalidRoutingNumber = {
  __typename?: 'InvalidRoutingNumber'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The provided security is not valid for allocation */
export type InvalidSecurityError = {
  __typename?: 'InvalidSecurityError'
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

/** Invalid Security For Allocation */
export type InvalidSecurityForAllocationError = {
  __typename?: 'InvalidSecurityForAllocationError'
  reason: InvalidSecurityForAllocationReasonEnum
  /** ID of the invalid security */
  securityId: Scalars['ID']
}

export enum InvalidSecurityForAllocationReasonEnum {
  SecurityDeactivated = 'SECURITY_DEACTIVATED',
}

/** Returned when a given singleRuleId does not match with a rule in the ruleset to be updated */
export type InvalidSingleRuleIdError = {
  __typename?: 'InvalidSingleRuleIdError'
  message: Scalars['String']
}

/** Occurs when attribution does not match standardized attributes */
export type InvalidSourceAttributesException = {
  __typename?: 'InvalidSourceAttributesException'
  incorrectAttributes: Array<Scalars['String']>
}

/** SSN does not meet validity criteria */
export type InvalidSsnException = {
  __typename?: 'InvalidSsnException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Custodian is not able to open an account based on their residential address */
export type InvalidStateException = {
  __typename?: 'InvalidStateException'
  /** message */
  message: Maybe<Scalars['String']>
  /** Custodian's State */
  state: Maybe<Scalars['String']>
}

/** User is not in the correct subscription tier for the requested investment account */
export type InvalidSubscriptionTierException = {
  __typename?: 'InvalidSubscriptionTierException'
  /** User current subscription tier */
  currentUserTierKey: Maybe<Scalars['String']>
}

/** The given termination age is not valid for the custodian's state */
export type InvalidTerminationAgeException = {
  __typename?: 'InvalidTerminationAgeException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type InvalidTier = {
  __typename?: 'InvalidTier'
  message: Scalars['String']
  validTiers: Tier[]
}

export type InvalidTierForMigrationError = {
  __typename?: 'InvalidTierForMigrationError'
  message: Scalars['String']
}

export type InvalidTierPrice = {
  __typename?: 'InvalidTierPrice'
  message: Scalars['String']
  validTierPrices: TierPrice[]
}

export type InvalidTierPriceCombination = {
  __typename?: 'InvalidTierPriceCombination'
  message: Scalars['String']
  tier: Tier
}

/** Returned if there is no available tier based on the provided tierPriceId */
export type InvalidTierPriceId = {
  __typename?: 'InvalidTierPriceId'
  message: Scalars['String']
}

export type InvalidUserIdException = {
  __typename?: 'InvalidUserIdException'
  message: Scalars['String']
}

export type InvalidUserTokenException = {
  __typename?: 'InvalidUserTokenException'
  userTokenId: Scalars['ID']
}

export type InvestHistorySummary = PastSummary & {
  __typename?: 'InvestHistorySummary'
  dividends: CurrencyAmount
  earnRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  referralRewards: CurrencyAmount
}

/** Enum for valid keys in Investing Strategy Factors */
export enum InvestingStrategyFactorKey {
  AnnualIncome = 'ANNUAL_INCOME',
  CombinedAnnualIncome = 'COMBINED_ANNUAL_INCOME',
  Employees = 'EMPLOYEES',
  EmploymentStatus = 'EMPLOYMENT_STATUS',
  FilingType = 'FILING_TYPE',
  FinancialEducation = 'FINANCIAL_EDUCATION',
  InvestmentGoal = 'INVESTMENT_GOAL',
  MaritalStatus = 'MARITAL_STATUS',
  NetWorth = 'NET_WORTH',
  NetWorthEstimate = 'NET_WORTH_ESTIMATE',
  SelfEmployedIncome = 'SELF_EMPLOYED_INCOME',
}

/** Factors affecting outcome of recommendation */
export type InvestingStrategyFactors = {
  key: InvestingStrategyFactorKey
  value: Scalars['JSON']
}

/** Investment class fields declarations and definitions */
export type Investment = {
  __typename?: 'Investment'
  allocations: Maybe<InvestmentAllocation[]>
  /**
   * Non-negative dollar amount invested as either a credit or debit. Debit amounts are not guaranteed to match the original requested amount due to market fluctuation.
   * @deprecated Use the more explicit requestedAmount and transferredAmount fields.
   */
  amount: Scalars['Float']
  /** Amount collected by Acorns to cover owed money. */
  amountCollected: Maybe<MonetaryAmount>
  /** Cash Owed from chargeback on this investment. */
  cashOwed: Maybe<MonetaryAmount>
  createdAt: Scalars['DateTime']
  /** @deprecated Legacy field do not use will always be null. */
  description: Maybe<Scalars['String']>
  /** @deprecated Legacy field do not use will always be null. */
  details: Maybe<Scalars['JSON']>
  /** Dividend's security name */
  dividendInvestmentSecurityName: Maybe<Scalars['String']>
  /** Dividend's security ticker */
  dividendInvestmentSecurityTicker: Maybe<Scalars['String']>
  /** Stubbed Field: Campaign ID for found money reward investment */
  earnRewardCampaignId: Maybe<Scalars['ID']>
  /** Name of partner for found money reward investment */
  earnRewardInvestmentPartner: Maybe<Scalars['String']>
  /** Url logo for found money reward investment */
  earnRewardInvestmentPartnerLogoUrl: Maybe<Scalars['URL']>
  /** Type of earn reward investment */
  earnRewardInvestmentType: Maybe<EarnRewardInvestType>
  /** Estimated date for an investment to be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  executionDate: Maybe<Scalars['DateTime']>
  /** Holdings Transfer Information */
  holdingsTransfer: Maybe<HoldingsTransfer>
  /** Unique identifier of the Investment. */
  id: Scalars['ID']
  /** Investment account details */
  investmentAccount: InvestmentAccount
  /** Stubbed Field: Status of investment */
  investmentStatus: Maybe<InvestmentStatusV2>
  /** Transaction type of the investment */
  investmentTransactionType: InvestmentTransactionType
  /** Stubbed Field: Type of investment */
  investmentType: Maybe<InvestmentType>
  /** An IRA Distribution or a withdraw investment for Later account */
  iraDistribution: Maybe<IraDistribution>
  /** Note for outside contribution investment */
  outsideContributionNote: Maybe<Scalars['String']>
  /** Name of the person who made an outside contribution */
  outsideContributionNoteAuthor: Maybe<Scalars['String']>
  pending: Maybe<Scalars['Boolean']>
  /** Percentage of match a credit Match investment received */
  percentageMatch: Maybe<Scalars['Float']>
  receivedAt: Maybe<Scalars['DateTime']>
  /** Reason for the reinvestment */
  reinvestmentReason: Maybe<ReinvestmentReason>
  requestedAmount: MonetaryAmount
  reversible: Scalars['Boolean']
  /** Stubbed Field: Name for round up investment */
  roundUpMerchantName: Maybe<Scalars['String']>
  /** Stubbed Field: Multiplier for round up invesment */
  roundUpMultiplier: Maybe<Scalars['Int']>
  /** Stubbed Field: Transaction amount for round up investment */
  roundUpTransactionAmount: Maybe<MonetaryAmount>
  /** Type of the round up */
  roundUpType: Maybe<InvestmentRoundUpType>
  /** @deprecated Legacy field do not use will always be null. */
  shares: Maybe<Scalars['Int']>
  /** @deprecated Legacy field do not use will cause operations to fail. */
  status: InvestmentStatus
  /** URLs that can be used to download documentation of the trade */
  tradeConfirmationUrls: Maybe<Array<Scalars['URL']>>
  /** Stubbed Field: Exact traded amount for an investment after considering other factors; ex: cash owed deductions */
  tradedAmount: Maybe<MonetaryAmount>
  transferredAmount: Maybe<MonetaryAmount>
  type: Scalars['String']
  /** @deprecated Legacy field do not use will always be null. */
  typeHelp: Maybe<Scalars['String']>
}

/** Investment Account Object */
export type InvestmentAccount = TimestampsInterface & {
  __typename?: 'InvestmentAccount'
  beneficiary: Maybe<Beneficiary>
  /** Internal ID of the beneficiary */
  beneficiaryId: Maybe<Scalars['ID']>
  cashBalance: MonetaryAmount
  cashOwed: MonetaryAmount
  closedAt: Maybe<Scalars['DateTime']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  currentBalance: Maybe<MonetaryAmount>
  currentBalanceWithPending: MonetaryAmount
  /** Whether or not the user has made their first investment on this account. */
  hasInvested: Scalars['Boolean']
  /** Internal UUID of the Investment Account */
  id: Scalars['ID']
  investmentAccountType: InvestmentAccountType
  /** Name of the Investment Account */
  name: Scalars['String']
  /** The net investments in this investment account. */
  netInvestments: MonetaryAmount
  pendingBalance: MonetaryAmount
  pendingWithdrawals: Withdrawal[]
  performance: Maybe<Performance>
  portfolio: Maybe<Portfolio>
  portfolios: Maybe<BasePortfolio[]>
  product: InvestmentProduct
  /** Recap of the investment account's activity and statistics over the last quarter. */
  quarterlyRecap: Maybe<InvestmentAccountRecap>
  /** Whether or not quarterly recap generation is enabled for this investment account. */
  quarterlyRecapsEnabled: Scalars['Boolean']
  recommendedPortfolio: Maybe<Portfolio>
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>
  /** The current status of the account */
  requirements: AccountRequirements
  /** The all-time returns in this investment account. */
  returnsAllTime: MonetaryAmount
  status: InvestmentAccountStatus
  summary: InvestmentAccountSummary
  /** The total account value in this investment account. */
  totalAccountValue: MonetaryAmount
  /** The total amount that is invested in bonds in this investment account. */
  totalBonds: MonetaryAmount
  /** The total amount that is invested in crypto in this investment account. */
  totalCrypto: MonetaryAmount
  /** The total amount that is invested in equities in this investment account. */
  totalEquities: MonetaryAmount
  /** Total matched contributions all-time. */
  totalMatched: MonetaryAmount
  /** Total matched contribution amount by tax year. */
  totalMatchedByYear: MonetaryAmount
  transferability: Maybe<InvestmentAccountTransferability>
  trustedContact: Maybe<TrustedContact>
  type: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Age of the account owner */
  userAge: Maybe<Scalars['Int']>
  /** UUID for the user */
  userId: Scalars['ID']
  /** @deprecated Use id instead. */
  uuid: Scalars['ID']
  /** Withdrawing from this account would incur a tax penalty */
  withdrawalsIncurTaxPenalty: Maybe<Scalars['Boolean']>
  yearToDateReturn: Maybe<MarketReturn>
}

/** Investment Account Object */
export type InvestmentAccountPerformanceArgs = {
  days: Scalars['Int']
}

/** Investment Account Object */
export type InvestmentAccountSummaryArgs = {
  endPeriod?: InputMaybe<Scalars['Date']>
  startPeriod?: InputMaybe<Scalars['Date']>
}

/** Investment Account Object */
export type InvestmentAccountTotalMatchedByYearArgs = {
  year: Scalars['Int']
}

export type InvestmentAccountAlreadyClosed = {
  __typename?: 'InvestmentAccountAlreadyClosed'
  /** Date and Time of account closure if account is already closed */
  accountClosedAt: Scalars['DateTime']
}

export type InvestmentAccountClosureInProgress = {
  __typename?: 'InvestmentAccountClosureInProgress'
  /** Message displayed to customer when closure is already in progress */
  clientMessage: Scalars['String']
}

export enum InvestmentAccountClosureReason {
  /** Can't afford at this time */
  CantAffordAtThisTime = 'CANT_AFFORD_AT_THIS_TIME',
  /** Change age of transfer */
  ChangeAgeOfTransfer = 'CHANGE_AGE_OF_TRANSFER',
  /** Going to a competitor */
  GoingToACompetitor = 'GOING_TO_A_COMPETITOR',
  /** Had a bad experience */
  HadABadExperience = 'HAD_A_BAD_EXPERIENCE',
  /** Not seeing the value */
  NotSeeingTheValue = 'NOT_SEEING_THE_VALUE',
  /** No longer use */
  NoLongerUse = 'NO_LONGER_USE',
  /** Other */
  Other = 'OTHER',
  /** Rolling over to another ira */
  RollingOverToAnotherIra = 'ROLLING_OVER_TO_ANOTHER_IRA',
  /** Switching to another savings plan */
  SwitchingToAnotherSavingsPlan = 'SWITCHING_TO_ANOTHER_SAVINGS_PLAN',
  /** Using funds for another purpose */
  UsingFundsForAnotherPurpose = 'USING_FUNDS_FOR_ANOTHER_PURPOSE',
  /** Using funds for the good of the child */
  WithdrawalForChild = 'WITHDRAWAL_FOR_CHILD',
}

/** The state of a customers request to close an Investment Account. Only one may be active at a time. */
export type InvestmentAccountClosureRequest = {
  __typename?: 'InvestmentAccountClosureRequest'
  id: Scalars['ID']
}

/** Generic Error */
export type InvestmentAccountCreationException = {
  __typename?: 'InvestmentAccountCreationException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment account must transfer funds before closure */
export type InvestmentAccountNeedsTransferException = {
  __typename?: 'InvestmentAccountNeedsTransferException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The investment account is still open. */
export type InvestmentAccountNotClosedException = {
  __typename?: 'InvestmentAccountNotClosedException'
  /** Type of investment account */
  accountType: Maybe<InvestmentAccountType>
}

/** Investment Account Not Found */
export type InvestmentAccountNotFoundException = {
  __typename?: 'InvestmentAccountNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Investment Account Not Supported */
export type InvestmentAccountNotSupportedException = {
  __typename?: 'InvestmentAccountNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Outside contribution made to an investment account. */
export type InvestmentAccountOutsideContribution = {
  __typename?: 'InvestmentAccountOutsideContribution'
  /** Monetary amount of the contribution. */
  amount: MonetaryAmount
  /** Name of the contributor */
  contributorName: Scalars['String']
  /** Note from the contributor. */
  note: Maybe<Scalars['String']>
}

/** Aggregation of investment account activity and stats over a period of time. */
export type InvestmentAccountRecap = {
  __typename?: 'InvestmentAccountRecap'
  /** Age of the investment account's beneficiary. */
  beneficiaryAge: Maybe<Scalars['Int']>
  /** Nickname of the investment account's custodian. */
  beneficiaryCustodianNickname: Maybe<Scalars['String']>
  /** First name of the investment account's beneficiary. */
  beneficiaryFirstName: Maybe<Scalars['String']>
  /** Last name of the investment account's beneficiary. */
  beneficiaryLastName: Maybe<Scalars['String']>
  /** Contributions to the investment account made by non-owners. */
  contributionsByOthers: Maybe<InvestmentAccountOutsideContribution[]>
  /** Creation date of the investment account recap. */
  createdAt: Scalars['Date']
  /** Start date of the investment account recap. */
  endsAt: Scalars['Date']
  /** Unique identifier of the investment account recap. */
  id: Scalars['ID']
  /** Investment account for which the recap was generated for. */
  investmentAccount: InvestmentAccount
  /** Unique identifier of the investment account for which the investment account recap was generated for. */
  investmentAccountId: Scalars['ID']
  /** Latest value of the investment account over the timeframe of the recap. */
  latestAccountValue: Maybe<MonetaryAmount>
  /** Market value of the investment account over the timeframe. */
  performance: Maybe<Performance>
  /** Whether or not the recap has public access enabled. */
  public: Scalars['Boolean']
  /** Web URL that the recap is publicly available at. */
  publicUrl: Maybe<Scalars['URL']>
  /** Start date of the investment account recap. */
  startsAt: Scalars['Date']
  /** Total amount contributed to the investment account over the timeframe. */
  totalContributions: Maybe<MonetaryAmount>
  /** Total amount contributed to the investment account by non-owners over the timeframe. Only applies to UGMA and UTMA type investment accounts. */
  totalContributionsByOthers: Maybe<MonetaryAmount>
  /** Date of last update made to the investment account recap. */
  updatedAt: Scalars['Date']
  /** Record of whether or not the recap has been viewed by the investment account owner. */
  viewed: Scalars['Boolean']
}

/** Investment Account Recap Not Found */
export type InvestmentAccountRecapNotFoundException = {
  __typename?: 'InvestmentAccountRecapNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

export enum InvestmentAccountReopenCheck {
  /** Account locked check */
  AccountLockedCheck = 'ACCOUNT_LOCKED_CHECK',
  /** Account suspended check */
  AccountSuspendedCheck = 'ACCOUNT_SUSPENDED_CHECK',
  /** Backup withholding check */
  BackupWithholdingCheck = 'BACKUP_WITHHOLDING_CHECK',
  /** Investment collections check */
  InvestmentCollectionsCheck = 'INVESTMENT_COLLECTIONS_CHECK',
  /** Spend collections check */
  SpendCollectionsCheck = 'SPEND_COLLECTIONS_CHECK',
  /** Underage check */
  UnderageCheck = 'UNDERAGE_CHECK',
}

/** An investment account reopen request */
export type InvestmentAccountReopenRequest = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequest'
  /** A list of actions performed on this account reopen request */
  adminActions: InvestmentAccountReopenRequestAction[]
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The ID of the reopen request */
  id: Scalars['Int']
  /** The investment account for which this reopen request was made */
  investmentAccount: InvestmentAccount
  /** The UUID of the investment account for which this request was made */
  investmentAccountId: Scalars['ID']
  /** A list of update notes for this investment account reopen request */
  notes: InvestmentAccountReopenRequestNote[]
  /** A list of reopen checks for this investment account reopen request */
  reopenChecks: UserInvestmentAccountReopenCheck[]
  /** The state of the investment account reopen request */
  state: InvestmentAccountReopenRequestState
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** The owner of the investment account associated with the reopen_request */
  user: User_V2
  /** The ID of the user to whom the investment account the request was made for belongs */
  userId: Scalars['Int']
}

/** An admin action performed on an investment account reopen request */
export type InvestmentAccountReopenRequestAction = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestAction'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The starting state of the reopen request */
  fromState: Scalars['String']
  /** The UUID of the reopen request admin action */
  id: Scalars['ID']
  /** The investment account for the corresponding reopen request */
  investmentAccount: InvestmentAccount
  /** A note associated with this action */
  note: Maybe<InvestmentAccountReopenRequestNote>
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** The end state of the reopen request */
  toState: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** A note sent to the user regarding an investment account reopen request */
export type InvestmentAccountReopenRequestNote = TimestampsInterface & {
  __typename?: 'InvestmentAccountReopenRequestNote'
  /** The action associated with this note */
  adminAction: InvestmentAccountReopenRequestAction
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** A boolean indicating if an email has been sent for this note */
  emailSent: Scalars['Boolean']
  /** The UUID of the reopen request note */
  id: Scalars['ID']
  /** The note text */
  note: Scalars['String']
  /** The associated reopen request */
  reopenRequest: InvestmentAccountReopenRequest
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export enum InvestmentAccountReopenRequestState {
  /** Indicates that the request has been approved */
  Approved = 'APPROVED',
  /** Indicates that the request must be reviewed by invest ops */
  PendingReview = 'PENDING_REVIEW',
  /** Indicates that the request is pending user action */
  PendingUserAction = 'PENDING_USER_ACTION',
  /** Indicates that the request has been rejected */
  Rejected = 'REJECTED',
  /** Indicates that the request has been made but not yet processed */
  Requested = 'REQUESTED',
}

export enum InvestmentAccountStatus {
  /** Investment account is closed */
  Closed = 'CLOSED',
  /** Investment account has reached transfer age */
  LockedForTransfer = 'LOCKED_FOR_TRANSFER',
  /** Investment account is open */
  Open = 'OPEN',
  /** Account has started account closure process */
  PendingClosure = 'PENDING_CLOSURE',
  /** Account has been created but is not fully activated/open */
  PendingOpen = 'PENDING_OPEN',
  /** Account has started account reopen process */
  PendingReopen = 'PENDING_REOPEN',
}

/** Investment account summary data */
export type InvestmentAccountSummary = {
  __typename?: 'InvestmentAccountSummary'
  /** The date of the user's first investment into this account */
  firstInvestmentDate: Maybe<Scalars['DateTime']>
  /** The date of the user's most recent one-time investment into this account */
  mostRecentOneTimeInvestmentDate: Maybe<Scalars['DateTime']>
  /**
   * The total credits credited to this account.
   * @deprecated Use referral_rewards and found_money_rewards instead
   */
  totalCredits: Scalars['Float']
  /** The total amount deposited by the user into this account. Does not include rewards */
  totalDeposits: Scalars['Float']
  /** The total amount contributed by the user on the current year for this account */
  totalDepositsCurrentYear: Scalars['Float']
  /** The total amount contributed by the user on the current year within the specified timeframe for this account */
  totalDepositsCurrentYearWithinTimeFrame: Scalars['Float']
  /** The total amount contributed by the user on the previous year for this account */
  totalDepositsPreviousYear: Scalars['Float']
  /** The total dividends invested in this account. */
  totalDividends: Scalars['Float']
  /** The total found money rewards allocated to this account */
  totalFoundMoneyRewards: Scalars['Float']
  /** The total amount invested into this account. Includes rewards */
  totalInvested: Scalars['Float']
  /**
   * The total amount contributed by the user on the current year for this account
   * @deprecated Use total_deposits_current_year
   */
  totalInvestedCurrentYear: Scalars['Float']
  /** The total amount invested into this account. Includes rewards but excludes investments created from Acorns Transfer such as from checking or emergency fund */
  totalInvestedExcludingAcornsBanking: Scalars['Float']
  /**
   * The total amount contributed by the user on the previous year for this account
   * @deprecated Use total_deposits_previous_year
   */
  totalInvestedPreviousYear: Scalars['Float']
  /** The total amount matched rewarded */
  totalMatchRewards: Scalars['Float']
  /** The total one time investments made in this account. */
  totalOneTime: Scalars['Float']
  /** The total outside contributions to this account. */
  totalOutsideContributions: Scalars['Float']
  /** The total plan investments invested with this account. */
  totalPlan: Scalars['Float']
  /** The recurring investment total invested in this account. */
  totalRecurring: Scalars['Float']
  /** The total referral rewards to this account. */
  totalReferralRewards: Scalars['Float']
  /** The total round ups contributed to this account. */
  totalRoundUps: Scalars['Float']
  /** The total real time round ups contributed to this account. */
  totalRtru: Scalars['Float']
  /** The total amount withdrawn for this account */
  totalWithdrawn: Scalars['Float']
  /** The total amount withdrawn for this account. Excludes withdrawn to Acorns accounts such as from checking or emergency fund */
  totalWithdrawnExcludingAcornsBanking: Scalars['Float']
}

/** Transfer information for the given investment account */
export type InvestmentAccountTransferability = {
  __typename?: 'InvestmentAccountTransferability'
  /** The beneficiary investment account's age of transfer */
  transferAge: Scalars['Int']
  /** The beneficiary investment account's date of transfer */
  transferDate: Scalars['Date']
  /** The beneficiary investment account's age of transfer reached */
  transferReached: Scalars['Boolean']
  /** The beneficiary investment account's state of residence */
  transferStateCode: UsStateCodes
}

export enum InvestmentAccountType {
  /** Basic investment account */
  BasicInvestment = 'BASIC_INVESTMENT',
  /** Roth IRA investment account */
  RothIra = 'ROTH_IRA',
  /** Simplified Employee Pension investment account */
  SimplifiedEmployeePension = 'SIMPLIFIED_EMPLOYEE_PENSION',
  /** Traditional IRA investment account */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Uniform Gift to Minors Act Custodial Investment Account */
  Ugma = 'UGMA',
  /** Uniform Transfer to Minors Act Custodial Investment Account */
  Utma = 'UTMA',
  /** @deprecated Use BASIC_INVESTMENT. */
  AcornsInvestingAccount = 'acornsInvestingAccount',
  /** @deprecated Use ROTH_IRA */

  /** @deprecated Use SIMPLIFIED_EMPLOYEE_PENSION */

  /** @deprecated Use TRADITIONAL_IRA. */
}

export enum InvestmentAccountTypes {
  RothIra = 'RothIRA',
  SimplifiedEmployeePension = 'SimplifiedEmployeePension',
  TraditionalIra = 'TraditionalIRA',
}

/** Filter for InvestmentAccountsByUserId query */
export type InvestmentAccountsByUserIdFilter = {
  /** Optionally filter by account status */
  accountStatus?: InputMaybe<InvestmentAccountStatus>
  /** Investment Account Product Name */
  product?: InputMaybe<InvestmentProduct>
}

/** Additional pagination information */
export type InvestmentAggregation = {
  __typename?: 'InvestmentAggregation'
  totalPendingAmount: Maybe<MonetaryAmount>
}

/** Amount of an asset that was bought or sold for a specific Investment. */
export type InvestmentAllocation = {
  __typename?: 'InvestmentAllocation'
  /** Dollar amount sold or bought of the associated security. */
  amount: Scalars['Float']
  /** Price that the shares of the associated security were bought or sold at. */
  price: MonetaryAmount
  /** Indicates whether the shares were allocated to a self-directed Portfolio. */
  selfDirected: Scalars['Boolean']
  /** Shares sold or bought of the associated security. */
  shares: Scalars['Float']
  /** Indicates the state of the holding allocated to the portfolio. */
  status: InvestmentAllocationStatus
  /** Trading symbol of the associated security. */
  symbol: Scalars['String']
  /** Indicates the type of holding allocated to the portfolio. */
  type: InvestmentAllocationType
}

export enum InvestmentAllocationStatus {
  /** Shares that have been returned due to a declined funding transfer. */
  Chargeback = 'CHARGEBACK',
  /** Shares that have been bought or sold but are not yet settled to the account. */
  Pending = 'PENDING',
  /** Shares that have settled in the account. */
  Settled = 'SETTLED',
}

export enum InvestmentAllocationType {
  Buy = 'BUY',
  Sell = 'SELL',
}

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory'
  bond: Scalars['Float']
  crypto: Scalars['Float']
  equity: Scalars['Float']
  realEstate: Scalars['Float']
}

/** An individual edge within the paginated list of Investment */
export type InvestmentEdge = {
  __typename?: 'InvestmentEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The Investment record in the edge */
  node: Investment
}

export enum InvestmentFrequency {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export enum InvestmentGoal {
  /** User is looking for a balanced portfolio */
  Balanced = 'BALANCED',
  /** User is looking for conservative growth in their investments */
  Conservative = 'CONSERVATIVE',
  /** User is looking for exponential growth in their investments */
  ExponentialGrowth = 'EXPONENTIAL_GROWTH',
  /** User is looking for moderate growth in their investments */
  ModerateGrowth = 'MODERATE_GROWTH',
  /** User is looking to reduce risk in their investments */
  ReducedRisk = 'REDUCED_RISK',
}

/** When investment id and investment account id do not match */
export type InvestmentNotFoundException = {
  __typename?: 'InvestmentNotFoundException'
  /** ID */
  id: Maybe<Scalars['ID']>
}

/** Relay style pagination information for Investment */
export type InvestmentPagination = {
  __typename?: 'InvestmentPagination'
  aggregation: Maybe<InvestmentAggregation>
  edges: InvestmentEdge[]
  pageInfo: PageInfo
}

export enum InvestmentProduct {
  /** Early investment product */
  Early = 'EARLY',
  /** Invest investment product */
  Invest = 'INVEST',
  /** Later investment product */
  Later = 'LATER',
}

export enum InvestmentRoundUpType {
  Automatic = 'AUTOMATIC',
  RealTime = 'REAL_TIME',
}

export enum InvestmentStatus {
  All = 'all',
  Finished = 'finished',
  Unfinished = 'unfinished',
}

/** Investment statuses that are used by frontend clients and external queries */
export enum InvestmentStatusV2 {
  /** Investment not translated */
  NotTranslated = 'NOT_TRANSLATED',
  /** Investment pending authorization */
  Pending = 'PENDING',
  /** Investment refunded */
  Refunded = 'REFUNDED',
  /** Investment returned */
  Returned = 'RETURNED',
  /** Investment reversed */
  Reversed = 'REVERSED',
  /** Investment revoked */
  Revoked = 'REVOKED',
  /** Investment settled */
  Settled = 'SETTLED',
  /** Investment transferred */
  Transferring = 'TRANSFERRING',
}

export enum InvestmentTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

/** All investment types */
export enum InvestmentType {
  AutomatedRebalance = 'AUTOMATED_REBALANCE',
  CashOwedCollection = 'CASH_OWED_COLLECTION',
  CashReinvestment = 'CASH_REINVESTMENT',
  DirectDepositSplit = 'DIRECT_DEPOSIT_SPLIT',
  Dividend = 'DIVIDEND',
  EarlyGift = 'EARLY_GIFT',
  EarnReward = 'EARN_REWARD',
  Fee = 'FEE',
  GiftCard = 'GIFT_CARD',
  HoldingsTransfer = 'HOLDINGS_TRANSFER',
  IraTransfer = 'IRA_TRANSFER',
  Match = 'MATCH',
  MatchRemoval = 'MATCH_REMOVAL',
  OneTimeInvestment = 'ONE_TIME_INVESTMENT',
  RecurringInvestment = 'RECURRING_INVESTMENT',
  Refund = 'REFUND',
  Reversal = 'REVERSAL',
  RoundUp = 'ROUND_UP',
  SecurityLiquidation = 'SECURITY_LIQUIDATION',
  Withdrawal = 'WITHDRAWAL',
}

export enum InvestmentTypes {
  Credit = 'credit',
  Debit = 'debit',
}

/** Investment cannot be cancelled */
export type InvestmentUncancellableException = {
  __typename?: 'InvestmentUncancellableException'
  /** ID */
  id: Maybe<Scalars['ID']>
}

/** Investments Paused user alert. */
export type InvestmentsPausedUserAlert = UserAlertsItem & {
  __typename?: 'InvestmentsPausedUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type InvestorQuestionsInput = {
  employedAffiliatedWithBrokerDealer?: InputMaybe<Scalars['Boolean']>
  shareholderOrDirector?: InputMaybe<Scalars['Boolean']>
  subjectToBackupWithholding?: InputMaybe<Scalars['Boolean']>
}

export type Invitation = {
  __typename?: 'Invitation'
  createdAt: Scalars['DateTime']
  id: Scalars['ReferralCode']
}

/** Type wrapper for the Invoice object from the billing vendor */
export type Invoice = {
  __typename?: 'Invoice'
  account: Maybe<VendorCustomerAccount>
  id: Maybe<Scalars['String']>
  lineItems: Maybe<Array<Maybe<InvoiceLineItem>>>
  lineItemsAmountSum: Maybe<Scalars['Float']>
  /**
   * Default type for state is 'all'.
   * Possible types are 'open', 'pending', 'processing', 'past_due', 'paid', 'closed', 'failed', 'voided'
   */
  state: Maybe<Scalars['String']>
  uuid: Maybe<Scalars['String']>
}

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection'
  chargeInvoice: Maybe<Invoice>
  creditInvoices: Maybe<Array<Maybe<Invoice>>>
  object: Maybe<Scalars['String']>
}

export type InvoiceItem = {
  __typename?: 'InvoiceItem'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  discount: Maybe<Scalars['Float']>
  discountAmount: Maybe<Scalars['Float']>
  feeCategory: Maybe<Scalars['String']>
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem'
  addOnCode: Maybe<Scalars['String']>
  addOnId: Maybe<Scalars['String']>
  amount: Maybe<Scalars['Float']>
  description: Maybe<Scalars['String']>
  discount: Maybe<Scalars['Float']>
  id: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  origin: Maybe<Scalars['String']>
  /** Possible types are 'invoiced' and 'pending' */
  state: Maybe<Scalars['String']>
  subtotal: Maybe<Scalars['Float']>
  type: Maybe<Scalars['String']>
}

/** Job alert display info */
export type JobAlert = {
  __typename?: 'JobAlert'
  id: Scalars['ID']
  /** desired job description */
  keyPhrase: Scalars['String']
  /** desired job location */
  location: Scalars['String']
}

/** Specifies the alert criteria */
export type JobAlertCriteriaInput = {
  filters: JobSearchFilterInput[]
  location: JobLocationInput
}

export type JobLocation = {
  __typename?: 'JobLocation'
  city: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

export type JobLocationInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  /** flexible text field to input location as a single string (e.g. "New York, NY 10010" */
  value?: InputMaybe<Scalars['String']>
}

export type JobOffer = {
  __typename?: 'JobOffer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: OfferLocation
  /** Salary details */
  salary: Maybe<JobOfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

export type JobOfferSalary = {
  __typename?: 'JobOfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

/** Specifies the search criteria */
export type JobSearchCriteria = {
  __typename?: 'JobSearchCriteria'
  filters: JobSearchFilter[]
  location: JobLocation
  /** Specifies the search radius in miles */
  searchRadius: Maybe<Scalars['Int']>
}

/** Specifies the search criteria */
export type JobSearchCriteriaInput = {
  filters: JobSearchFilterInput[]
  location: JobLocationInput
  searchRadius?: InputMaybe<Scalars['Int']>
}

/** Specifies which values to filter jobs by */
export type JobSearchFilter = {
  __typename?: 'JobSearchFilter'
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Specifies which values to filter jobs by */
export type JobSearchFilterInput = {
  key: JobSearchFilterKey
  value: Scalars['String']
}

/** Supported types of search criteria */
export enum JobSearchFilterKey {
  /** finds jobs with exact match for company name */
  Company = 'COMPANY',
  /** finds jobs that have metadata matching this phrase */
  KeyPhrase = 'KEY_PHRASE',
}

/** Display wrapper for featured job searches */
export type JobSearchOffer = {
  __typename?: 'JobSearchOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo: Maybe<Image>
  /** List of filters used when searching for jobs */
  searchFilters: JobSearchFilter[]
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type JobSearchPage = {
  __typename?: 'JobSearchPage'
  recentSearches: JobSearchCriteria[]
}

export enum KycStatus {
  Accepted = 'accepted',
  ActionRequired = 'actionRequired',
  Failure = 'failure',
  Pending = 'pending',
}

export type LadderLinkResponse = {
  __typename?: 'LadderLinkResponse'
  id: Scalars['ID']
  url: Scalars['String']
  urlExpires: Scalars['Int']
}

export type LadderQuote = {
  __typename?: 'LadderQuote'
  coverage: Maybe<Scalars['Int']>
  monthlyPremium: Maybe<Scalars['Float']>
  term: Maybe<Scalars['Int']>
}

export type LadderQuoteStatus = {
  __typename?: 'LadderQuoteStatus'
  complete: Maybe<Scalars['Boolean']>
  eligible: Maybe<Scalars['Boolean']>
  valid: Maybe<Scalars['Boolean']>
}

export type LadderResponse = {
  __typename?: 'LadderResponse'
  id: Scalars['String']
  quoteStatus: Maybe<LadderQuoteStatus>
  quotes: Array<Maybe<LadderQuote>>
}

export type LaterAccount = {
  __typename?: 'LaterAccount'
  accountId: Scalars['ID']
  accountNumber: Maybe<Scalars['String']>
  amount: Scalars['Float']
  code: LaterAccountCodes
  contributionLimit: Scalars['Float']
  name: Scalars['String']
  performance: Maybe<LaterPortfolioPerformance>
  portfolioId: Scalars['ID']
  portfolioName: Scalars['String']
  recurringSettings: Maybe<RecurringInvestmentSettings>
  status: Maybe<LaterAccountStatus>
}

export type LaterAccountAlreadyVerified = LaterTypedException & {
  __typename?: 'LaterAccountAlreadyVerified'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountCodes {
  Roth = 'ROTH',
  Sep = 'SEP',
  Traditional = 'TRADITIONAL',
}

export type LaterAccountIneligibleForVerification = LaterTypedException & {
  __typename?: 'LaterAccountIneligibleForVerification'
  id: Scalars['ID']
  message: Scalars['String']
}

export type LaterAccountInfo = {
  __typename?: 'LaterAccountInfo'
  investmentAccountId: Scalars['ID']
  plan: InvestmentAccountTypes
  status: LaterAccountStatus
  userId: Scalars['ID']
}

export type LaterAccountInfoOrError =
  | LaterAccountAlreadyVerified
  | LaterAccountIneligibleForVerification
  | LaterAccountInfo
  | LaterAccountNotFound

export type LaterAccountNotFound = LaterTypedException & {
  __typename?: 'LaterAccountNotFound'
  id: Scalars['ID']
  message: Scalars['String']
}

export enum LaterAccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  FailedToCreate = 'FAILED_TO_CREATE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export type LaterBeneficiary = {
  accountId: Scalars['String']
  beneficiaryId: Maybe<Scalars['ID']>
  percentageShare: Maybe<Scalars['Float']>
  type: Maybe<BeneficiaryType>
}

export type LaterContributionAbilityResult = ContributionAbilityByYear

export type LaterContributionLimitMet = {
  __typename?: 'LaterContributionLimitMet'
  year: Scalars['Int']
}

/** Sell shares to pay down cash owed by the customer. */
export type LaterDebtCollectionItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterDebtCollectionItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterDividendsItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterDividendsItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    etfCategory: Scalars['String']
    etfTicker: Scalars['String']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Sell shares for the fee. This happens for Paypal users or if users never accepted the new EFT */
export type LaterFeeInvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterFeeInvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterFullContributionSuccess = {
  __typename?: 'LaterFullContributionSuccess'
  year: Scalars['Int']
}

export type LaterHistoryItem = {
  amount: Scalars['Float']
  date: Scalars['DateTime']
  pending: Maybe<Scalars['Boolean']>
  reversible: Maybe<Scalars['Boolean']>
  status: Scalars['String']
  taxYear: Scalars['Int']
  tradeConfirmUrl: Maybe<Scalars['String']>
  type: Maybe<LaterHistoryItemType>
}

export enum LaterHistoryItemType {
  Deposit = 'deposit',
  Rollover = 'rollover',
  Transfer = 'transfer',
  Withdrawal = 'withdrawal',
}

export type LaterHistorySummary = PastSummary & {
  __typename?: 'LaterHistorySummary'
  currentYear: Scalars['String']
  dividends: CurrencyAmount
  iraMatchRewards: CurrencyAmount
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
  previousYear: Scalars['String']
  previousYearContributions: CurrencyAmount
}

export type LaterIndividualBeneficiary = LaterBeneficiary & {
  __typename?: 'LaterIndividualBeneficiary'
  accountId: Scalars['String']
  addressLine1: Maybe<Scalars['String']>
  addressLine2: Maybe<Scalars['String']>
  beneficiaryId: Maybe<Scalars['ID']>
  birthDate: Scalars['DateTime']
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare: Maybe<Scalars['Float']>
  relationship: Scalars['String']
  state: Maybe<Scalars['String']>
  type: Maybe<BeneficiaryType>
  zip: Maybe<Scalars['String']>
}

export type LaterIndividualBeneficiaryResponse = {
  __typename?: 'LaterIndividualBeneficiaryResponse'
  accountId: Scalars['ID']
  addressLine1: Maybe<Scalars['String']>
  addressLine2: Maybe<Scalars['String']>
  beneficiaryId: Scalars['ID']
  birthDate: Maybe<Scalars['DateTime']>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare: Maybe<Scalars['Float']>
  relationship: Scalars['String']
  state: Maybe<Scalars['String']>
  zip: Maybe<Scalars['String']>
}

/** A generic money movement line item for the Later account */
export type LaterInvestmentItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'LaterInvestmentItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** The percentage that the user elected for withholding */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A matching investment made into a customers account by the firm. */
export type LaterMatchItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterMatchItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A removal of matching investments made into a customers account by the firm. */
export type LaterMatchRemovalItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterMatchRemovalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterPartialContributionSuccess = {
  __typename?: 'LaterPartialContributionSuccess'
  acceptedAmount: CurrencyAmount
  year: Scalars['Int']
}

export type LaterPortfolioPerformance = {
  __typename?: 'LaterPortfolioPerformance'
  periodMarketChange: Scalars['Float']
  periodMarketChangePercent: Scalars['Float']
  periodMarketChangePercentWithoutFees: Scalars['Float']
  periodMarketChangeWithoutFees: Scalars['Float']
}

export type LaterProgramAccountContributionInput = {
  amount: CurrencyAmountInput
  fundingTransferCreated?: InputMaybe<Scalars['Boolean']>
  nonce: Scalars['ID']
  programAccountType: ProgramAccountType
  year?: InputMaybe<Scalars['Int']>
}

export type LaterProgramAccountContributionResult =
  | LaterContributionLimitMet
  | LaterFullContributionSuccess
  | LaterPartialContributionSuccess

export type LaterRebalanceItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterRebalanceItem'
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is refunded to the customer */
export type LaterRefundedItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterRefundedItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Cash that is reinvested into the investment account */
export type LaterReinvestmentItem = PastCoreTradedItem &
  PastItem & {
    __typename?: 'LaterReinvestmentItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type LaterTypedException = {
  id: Scalars['ID']
  message: Scalars['String']
}

/** Object representing an outside contribution prospect */
export type LaterWaitlistProspect = Prospect & {
  __typename?: 'LaterWaitlistProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type LaterWithdrawal = LaterHistoryItem & {
  __typename?: 'LaterWithdrawal'
  amount: Scalars['Float']
  date: Scalars['DateTime']
  earlyDistributionTaxExceptionReason: Maybe<Scalars['String']>
  federalTaxes: Maybe<Scalars['Float']>
  name: Scalars['String']
  pending: Maybe<Scalars['Boolean']>
  reversible: Maybe<Scalars['Boolean']>
  stateTaxes: Maybe<Scalars['Float']>
  status: Scalars['String']
  taxYear: Scalars['Int']
  tradeConfirmUrl: Maybe<Scalars['String']>
  type: Maybe<LaterHistoryItemType>
  withdrawalId: Scalars['ID']
  withdrawalType: Maybe<LaterWithdrawalType>
}

export type LaterWithdrawalItem = PastCoreTradedItem &
  PastItem &
  PastUserTransferItem & {
    __typename?: 'LaterWithdrawalItem'
    amount: CurrencyAmount
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    federalWithholdings: Maybe<LaterWithholdingValues>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    stateWithholdings: Maybe<LaterWithholdingValues>
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    /** Location of the investment's trade confirmation document */
    tradeConfirmationUrl: Maybe<Scalars['URL']>
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Reason for withdrawing from a later account */
export enum LaterWithdrawalReason {
  DirectTransfer = 'direct_transfer',
  EarlyWithdrawal = 'early_withdrawal',
  OverContribution = 'over_contribution',
  Retirement = 'retirement',
  Rollover = 'rollover',
}

/** Reason for withdrawing from a later account Deprecated - this can be derived from the LaterWithdrawalReason below */
export enum LaterWithdrawalType {
  EarlyDistribution = 'EarlyDistribution',
  IneligibleContribution = 'IneligibleContribution',
  NormalDistribution = 'NormalDistribution',
}

/** Tuple of fields related to withholdings elected at either the state or federal level */
export type LaterWithholdingValues = {
  __typename?: 'LaterWithholdingValues'
  amount: CurrencyAmount
  /** The percentage that the user elected for withholding */
  percentage: Scalars['Float']
}

/** Customer information used for link session */
export type LayerLinkSession = {
  __typename?: 'LayerLinkSession'
  /** City associated with address of customer */
  city: Maybe<Scalars['String']>
  /** Country associated with address of customer */
  country: Maybe<Scalars['String']>
  /** Date of birth of customer */
  dateOfBirth: Maybe<Scalars['Date']>
  /** First name of customer */
  firstName: Maybe<Scalars['String']>
  /** Last name of customer */
  lastName: Maybe<Scalars['String']>
  linkedSubaccounts: Maybe<LinkedSubaccount[]>
  /** SSN of customer */
  ssn: Maybe<Scalars['String']>
  /** State associated with address of customer */
  state: Maybe<Scalars['String']>
  /** Street associated with address of customer */
  street1: Maybe<Scalars['String']>
  /** Street (line 2) associated with address of customer */
  street2: Maybe<Scalars['String']>
  /** Zip code associated with address of customer */
  zipCode: Maybe<Scalars['String']>
}

/** Attributes for identifiers to create Layer session */
export type LayerLinkSessionInput = {
  /** Code to authorize user-permissioned identity information */
  publicToken: Scalars['String']
}

export type LearnAnswer = {
  __typename?: 'LearnAnswer'
  id: Scalars['ID']
  isCorrect: Scalars['Boolean']
  value: Scalars['String']
}

export type LearnAnswerInput = {
  id: Scalars['ID']
  value: Scalars['String']
}

export type LearnArticle = {
  __typename?: 'LearnArticle'
  authors: LearnAuthor[]
  body: Scalars['String']
  contentImage: Maybe<LearnVisualAsset>
  disclaimer: Scalars['String']
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  featuredVideos: LearnMediaReference[]
  id: Scalars['ID']
  learnProductKey: Maybe<LearnProductKey>
  mainBody: Scalars['String']
  metadata: LearnMetadata
  publishedAt: Maybe<Scalars['String']>
  summary: Scalars['String']
  tags: LearnTag[]
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: LearnTopic[]
}

export type LearnArticlePreview = {
  __typename?: 'LearnArticlePreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnArticlePreviewLocked = {
  __typename?: 'LearnArticlePreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export enum LearnAspectRatioType {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

export type LearnAuthor = {
  __typename?: 'LearnAuthor'
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  photo: Maybe<LearnVisualAsset>
}

export type LearnConnection = {
  edges: LearnEdge[]
  pageInfo: LearnPageInfo
}

export type LearnContentCategory = LearnTier | LearnTopic

export type LearnContentCommunityStats = LearnContentStats

export type LearnContentDuration = Milliseconds

export type LearnContentElapsedMillisecondsUpdatedResult = {
  __typename?: 'LearnContentElapsedMillisecondsUpdatedResult'
  contentId: Scalars['ID']
  elapsedTime: Milliseconds
}

export type LearnContentFilterByTierIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId: Scalars['ID']
  topicId?: InputMaybe<Scalars['ID']>
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentFilterByTopicIdInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId?: InputMaybe<Scalars['ID']>
  topicId: Scalars['ID']
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentFilterInput = {
  contentType?: InputMaybe<LearnSearchContentType>
  durationMillisecondsEnd?: InputMaybe<MillisecondsInput>
  durationMillisecondsStart?: InputMaybe<MillisecondsInput>
  tierId?: InputMaybe<Scalars['ID']>
  topicId?: InputMaybe<Scalars['ID']>
  viewStatus?: InputMaybe<LearnContentViewStatus>
}

export type LearnContentInteractionState = LearnInteractionState

export type LearnContentPageInput = {
  after?: InputMaybe<Scalars['ID']>
  limit: Scalars['Int']
}

export type LearnContentPreview =
  | CoursePreview
  | CoursePreviewLocked
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked
  | LearnPollPreview
  | LearnPollPreviewLocked
  | LessonPreview
  | LessonPreviewLocked
  | QuizPreview
  | QuizPreviewLocked

export enum LearnContentSortType {
  Duration = 'DURATION',
  MostRecent = 'MOST_RECENT',
  MostRelevant = 'MOST_RELEVANT',
  MostViewed = 'MOST_VIEWED',
  Trending = 'TRENDING',
}

export type LearnContentStats = {
  __typename?: 'LearnContentStats'
  communityAvg: Maybe<Scalars['Int']>
  views: Maybe<Scalars['Int']>
}

export enum LearnContentType {
  Article = 'ARTICLE',
  Course = 'COURSE',
  Lesson = 'LESSON',
  MediaArticle = 'MEDIA_ARTICLE',
  Poll = 'POLL',
  Quiz = 'QUIZ',
}

export enum LearnContentViewStatus {
  Unviewed = 'UNVIEWED',
  Viewed = 'VIEWED',
}

export type LearnCourse = Course | CourseLocked

export type LearnCoursePreview = CoursePreview | CoursePreviewLocked

export type LearnEdge = {
  cursor: Scalars['ID']
}

export type LearnInsight = {
  __typename?: 'LearnInsight'
  cuePointMillis: Milliseconds
  description: Scalars['String']
  id: Scalars['ID']
  title: Scalars['String']
}

export type LearnInteractionState = {
  __typename?: 'LearnInteractionState'
  elapsedTime: Maybe<LearnContentDuration>
  isFavorites: Scalars['Boolean']
  isHelpful: Maybe<Scalars['Boolean']>
  progress: Maybe<LearnProgress>
}

export type LearnMedia = LearnMediaArticle

export type LearnMediaArticle = {
  __typename?: 'LearnMediaArticle'
  audioTheme: Maybe<LearnMediaTheme>
  authors: LearnAuthor[]
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  insights: LearnInsight[]
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: LearnPoll[]
  preEventDescription: Maybe<Scalars['String']>
  startsAt: Maybe<Scalars['String']>
  tags: LearnTag[]
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: LearnTopic[]
}

export type LearnMediaPreview = {
  __typename?: 'LearnMediaPreview'
  audioTheme: Maybe<LearnMediaTheme>
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  mediaType: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  startsAt: Maybe<Scalars['String']>
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaPreviewLocked = {
  __typename?: 'LearnMediaPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  mediaType: Maybe<LearnMediaType>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  title: Scalars['String']
  views: Scalars['Int']
}

export type LearnMediaReference = {
  __typename?: 'LearnMediaReference'
  aspectRatio: LearnAspectRatioType
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  reference: Scalars['String']
  theme: Maybe<LearnMediaTheme>
  title: Maybe<Scalars['String']>
  transcript: Maybe<Scalars['String']>
  type: LearnMediaType
}

export type LearnMediaTheme = LearnThemeLiteral

export enum LearnMediaType {
  Audio = 'AUDIO',
  LiveVideo = 'LIVE_VIDEO',
  Video = 'VIDEO',
}

export type LearnMetadata = {
  __typename?: 'LearnMetadata'
  contentStats: Maybe<LearnContentCommunityStats>
  interactionState: Maybe<LearnContentInteractionState>
}

export type LearnNextStepAction = {
  __typename?: 'LearnNextStepAction'
  ctaLabel: Maybe<Scalars['String']>
  id: Scalars['ID']
  illustration: Maybe<Image>
  title: Scalars['String']
  url: Scalars['String']
}

export type LearnPageInfo = {
  __typename?: 'LearnPageInfo'
  count: Scalars['Int']
  cursor: Scalars['ID']
  hasNextPage: Scalars['Boolean']
}

export type LearnPoll = {
  __typename?: 'LearnPoll'
  cuePointMillis: Maybe<Milliseconds>
  id: Scalars['ID']
  options: Maybe<Array<Scalars['String']>>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollOption = {
  __typename?: 'LearnPollOption'
  count: Scalars['Int']
  option: Scalars['String']
}

export type LearnPollPreview = {
  __typename?: 'LearnPollPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  options: Maybe<LearnPollOption[]>
  pollType: LearnPollType
  question: Scalars['String']
  title: Scalars['String']
}

export type LearnPollPreviewLocked = {
  __typename?: 'LearnPollPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  lockedReason: Maybe<Scalars['String']>
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type LearnPollResponse = {
  __typename?: 'LearnPollResponse'
  isSuccess: Scalars['Boolean']
  selectedOption: Scalars['String']
  stats: Maybe<LearnPollOption[]>
}

export enum LearnPollType {
  Emoji = 'EMOJI',
  Option = 'OPTION',
  YesNo = 'YES_NO',
}

export enum LearnProductKey {
  Learn = 'LEARN',
  LearnPremium = 'LEARN_PREMIUM',
}

export type LearnProgress = {
  __typename?: 'LearnProgress'
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export type LearnProgressInput = {
  currentValue: Scalars['Int']
  unitType: LearnProgressUnit
}

export enum LearnProgressUnit {
  Percents = 'PERCENTS',
  Seconds = 'SECONDS',
  Stages = 'STAGES',
}

export type LearnProgressUpdatedResult = {
  __typename?: 'LearnProgressUpdatedResult'
  contentId: Scalars['ID']
  progress: LearnProgress
}

export type LearnQuestion = {
  __typename?: 'LearnQuestion'
  answers: LearnAnswer[]
  id: Scalars['ID']
  incrementStep: Maybe<Scalars['Int']>
  insight: Maybe<LearnQuestionInsight>
  questionBody: Scalars['String']
  questionType: LearnQuestionType
  rangeEnd: Maybe<Scalars['Int']>
  rangeLabel: Maybe<Scalars['String']>
  rangeStart: Maybe<Scalars['Int']>
  rangeType: Maybe<LearnRangeType>
  statement: Maybe<Scalars['String']>
  statementHighLight: Maybe<Scalars['String']>
  unitType: Maybe<Scalars['String']>
}

export type LearnQuestionInsight = {
  __typename?: 'LearnQuestionInsight'
  featuredImage: Maybe<Image>
  id: Scalars['ID']
  insightText: Scalars['String']
  media: Maybe<LearnMediaReference>
  mediaType: Maybe<LearnMediaType>
  title: Scalars['String']
}

export enum LearnQuestionType {
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  MultiSelect = 'MULTI_SELECT',
  NumericRange = 'NUMERIC_RANGE',
  SingleSelect = 'SINGLE_SELECT',
  TwoOptions = 'TWO_OPTIONS',
}

export type LearnQuiz = Quiz | QuizLocked

export type LearnQuizAnswerResult = {
  __typename?: 'LearnQuizAnswerResult'
  isCorrect: Scalars['Boolean']
  questionId: Scalars['ID']
  quizId: Scalars['ID']
}

export type LearnQuizPreview = QuizPreview | QuizPreviewLocked

export enum LearnRangeType {
  Dial = 'DIAL',
  Slider = 'SLIDER',
}

export enum LearnSearchContentType {
  Article = 'ARTICLE',
  Audio = 'AUDIO',
  Course = 'COURSE',
  Video = 'VIDEO',
}

export type LearnSearchTermSavedResult = {
  __typename?: 'LearnSearchTermSavedResult'
  term: Scalars['String']
}

export type LearnTag = {
  __typename?: 'LearnTag'
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnThemeLiteral = {
  __typename?: 'LearnThemeLiteral'
  value: Scalars['String']
}

export type LearnTier = {
  __typename?: 'LearnTier'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnTopic = {
  __typename?: 'LearnTopic'
  icon: LearnVisualAsset
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearnVisualAsset = Image

export type LegacyAlertDismissalSuccess = {
  __typename?: 'LegacyAlertDismissalSuccess'
  id: Scalars['ID']
}

/** An upload from backend */
export type LegacyUploadDocument = {
  __typename?: 'LegacyUploadDocument'
  documentType: DocumentType
  id: Scalars['ID']
  userId: Scalars['ID']
}

/** Input for creating a legacy document upload */
export type LegacyUploadDocumentInput = {
  /** the type of document being uploaded */
  documentType: DocumentType
  /** the multipart document upload file */
  upload: Scalars['Upload']
}

/** LegacyUploadDocumentResult */
export type LegacyUploadDocumentResult =
  | FileDoesNotExistInS3
  | FileTooLarge
  | InvalidFile
  | LegacyUploadDocument
  | UploadDoesNotExist

export type Lesson = {
  __typename?: 'Lesson'
  authors: LearnAuthor[]
  featuredImage: Image
  id: Scalars['ID']
  insights: LearnInsight[]
  media: LearnMediaReference
  metadata: LearnMetadata
  polls: LearnPoll[]
  title: Scalars['String']
}

export type LessonPreview = {
  __typename?: 'LessonPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  parentContentId: Scalars['ID']
  title: Scalars['String']
}

export type LessonPreviewLocked = {
  __typename?: 'LessonPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  parentContentId: Scalars['ID']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export enum LinkCustomization {
  /** A link customization for optionally accessing the users ssn. */
  CardLink = 'CARD_LINK',
  /** The standard link customization. */
  Default = 'DEFAULT',
  /** A link customization for only accessing funding source information. */
  FundingSourceLink = 'FUNDING_SOURCE_LINK',
  /** A link customization for not requiring the users name. */
  SansNameLink = 'SANS_NAME_LINK',
}

/** Input for creating a manual, ACH funding source */
export type LinkManualFundingSourceInput = {
  /** the account number of the funding source being linked */
  accountNumber: Scalars['String']
  /** the routing number of the funding source being linked */
  routingNumber: Scalars['RoutingNumber']
}

/** LinkManualFundingSourceResult */
export type LinkManualFundingSourceResult =
  | CurrentBankStatementNotProvided
  | FundingSourceAccount
  | FundingSourceAlreadyExists
  | FundingSourceCredentialsExceedLinkLimit
  | InvalidAccountNumber
  | InvalidManualLink
  | InvalidRoutingNumber
  | PreviousFundingSourcePending
  | RdvVerificationRequired

export type LinkOidcCredentialsInput = {
  idToken: Scalars['String']
  nonce: Scalars['String']
  oidcProvider: OidcProvider
  udid: Scalars['String']
}

export type LinkOidcCredentialsResult =
  | InvalidAppleAccountException
  | InvalidIdentityTokenException
  | LinkOidcCredentialsSuccess
  | OidcCredentialsAlreadyLinkedException
  | OidcCredentialsTakenException

export type LinkOidcCredentialsSuccess = {
  __typename?: 'LinkOidcCredentialsSuccess'
  email: Scalars['EmailAddress']
  oidcProvider: OidcProvider
  userId: Scalars['ID']
}

export enum LinkProviderType {
  /** Direct bank provider type. */
  DirectBank = 'DIRECT_BANK',
  /** Plaid provider type */
  Plaid = 'PLAID',
  /** Spend provider type. */
  Spend = 'SPEND',
}

/** Attributes for a linked account created through Plaid Link */
export type LinkSessionInput = {
  /** The Authorization Code returned from the Authorization Server */
  authorizationCode: Scalars['String']
  /** Flag to determine if round-ups should be disabled */
  disableRoundUps?: InputMaybe<Scalars['Boolean']>
  /** Financial Institution ID */
  financialInstitutionId: Scalars['String']
  /** Vendor session correlation id */
  linkSessionId?: InputMaybe<Scalars['String']>
  /** Linked Account ID */
  linkedAccountId?: InputMaybe<Scalars['String']>
}

export enum LinkSessionLanguage {
  /** English */
  En = 'EN',
  /** Spanish */
  Es = 'ES',
  /** French */
  Fr = 'FR',
  /** Dutch */
  Nl = 'NL',
}

/** Returns a Link Token or Link URL for use with Account Linking. */
export type LinkSessionResult =
  | RawLinkSession
  | UnrecoverableLinkedAccountError
  | WebviewLinkSession

/** Miscellaneous attributes about a Linked Account */
export type LinkedAccount = TimestampsInterface & {
  __typename?: 'LinkedAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Error code attached to operation done on account */
  errorCode: Maybe<Scalars['String']>
  /** Plaid account ID */
  externalId: Maybe<Scalars['ID']>
  /** Source of linked account (plaid or spend) */
  externalSource: LinkedAccountExternalSourceEnum
  financialInstitution: Maybe<FinancialInstitution>
  /** ID of the financial institution this linked account is for */
  financialInstitutionId: Maybe<Scalars['ID']>
  /** Linked Account ID */
  id: Scalars['ID']
  /** Name of the associated institution this linked account is for */
  institutionName: Maybe<Scalars['String']>
  /** Is the account linked? */
  linked: Scalars['Boolean']
  linkedSubaccounts: LinkedSubaccount[]
  /** The logo url for the institution associated with the account */
  logoUrl: Scalars['String']
  /** This field should only be fetched for initializing a Plaid Link session */
  publicToken: Maybe<Scalars['String']>
  /** Status indicating potential user action required */
  status: LinkedAccountStatusEnum
  /** DateTime of when Transactions were last synced for financial institution */
  transactionsLastSyncedAt: Maybe<Scalars['DateTime']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Correlated User UUID */
  userId: Scalars['ID']
}

/** A Linked Account Alert. */
export type LinkedAccountAlert = UserAlertsItem & {
  __typename?: 'LinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from linked account alert query */
export type LinkedAccountAlertsResponse =
  | LinkedAccountAlert
  | RelinkLinkedAccountAlert

export enum LinkedAccountExternalSourceEnum {
  /** The link was created directly between the corresponding bank's API and Acorns */
  DirectBank = 'direct_bank',
  /** The user linked by manually entering an account & routing number */
  Manual = 'manual',
  /** PayPal direct connection was used to link this account */
  Paypal = 'paypal',
  /** The link was created through Plaid and represents an external financial institution */
  Plaid = 'plaid',
  /** This account has an internal Acorns spend account associated with it */
  Spend = 'spend',
}

export enum LinkedAccountLinkingErrorsEnum {
  /** Online banking system is down */
  InstitutionDown = 'INSTITUTION_DOWN',
  /** Online banking system is unresponsive */
  InstitutionNotAvailable = 'INSTITUTION_NOT_AVAILABLE',
  /** Online banking system is unresponsive */
  InstitutionNotResponding = 'INSTITUTION_NOT_RESPONDING',
  /** Online banking system is not supported anymore */
  InstitutionNoLongerSupported = 'INSTITUTION_NO_LONGER_SUPPORTED',
  /** Server error */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Error with incorrect institution security questions */
  InvalidMfa = 'INVALID_MFA',
  /** Online banking credentials have been updated */
  InvalidUpdatedUsername = 'INVALID_UPDATED_USERNAME',
  /** Online banking account is locked */
  ItemLocked = 'ITEM_LOCKED',
  /** Error with institution security settings */
  ItemNotSupported = 'ITEM_NOT_SUPPORTED',
  /** Error with institution security questions */
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  /** Online banking account is not fully set up */
  UserSetupRequired = 'USER_SETUP_REQUIRED',
}

export type LinkedAccountNotFound = {
  __typename?: 'LinkedAccountNotFound'
  message: Scalars['String']
}

export enum LinkedAccountStatusEnum {
  /** The user must take action with their financial institution to fix the issue */
  ExternalAction = 'externalAction',
  /** The user must relink and update their linked account to continue functioning */
  Relink = 'relink',
  /** The linked account is working and requires no action */
  Success = 'success',
  /** The linked account or financial institution is no longer supported and can be unlinked */
  Unsupported = 'unsupported',
}

/** An individual account between an individual user and financial institution */
export type LinkedSubaccount = TimestampsInterface & {
  __typename?: 'LinkedSubaccount'
  /** Last 4 Digits of Account Number */
  accountNumberLastFour: Maybe<Scalars['String']>
  /** Roles this linked account can be assigned to */
  allowedRoles: LinkedSubaccountRoleEnum[]
  /** Balance available (via Plaid/Spend) */
  balanceAvailable: Maybe<Scalars['Float']>
  /** Current balance of subaccount (via Plaid/Spend) */
  balanceCurrent: Maybe<Scalars['Float']>
  /** Spending limit of balance */
  balanceLimit: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Plaid ID for linked subaccount */
  externalId: Maybe<Scalars['String']>
  /** External source of subaccount (plaid, spend, paypal, manual) */
  externalSource: Maybe<Scalars['String']>
  /** Internal ID for linked subaccount */
  id: Scalars['ID']
  /** Subaccount Linked? */
  linked: Scalars['Boolean']
  linkedAccount: LinkedAccount
  /** Internal ID for the corresponding linked account */
  linkedAccountId: Scalars['ID']
  /** Name of linked subaccount (Department) */
  name: Scalars['String']
  /** Official name (verbose) */
  officialName: Maybe<Scalars['String']>
  paymentEngines: LinkedSubaccountPaymentEngineEnum[]
  /** The role of the linked subaccount */
  role: Maybe<LinkedSubaccountRoleEnum>
  /** Financial institution routing number. */
  routingNumber: Maybe<Scalars['String']>
  /** The status of the linked subaccount */
  status: Maybe<FundingSourceStatusEnum>
  /** Subtype (ie checking) */
  subaccountSubtype: Scalars['String']
  /** Type (depository, credit) */
  subaccountType: Scalars['String']
  /** Transactions count */
  transactionsLastSyncedCount: Scalars['Int']
  /** RDVs and docs have been verified and approved for this account */
  transfersApproved: Maybe<Scalars['Boolean']>
  /** Is the account at risk or does it have insufficient funds? */
  transfersAtRisk: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /**
   * Subaccount Verified?
   * @deprecated This will be removed in favor of "transfersApproved"
   */
  verified: Maybe<Scalars['Boolean']>
}

export enum LinkedSubaccountPaymentEngineEnum {
  /** The linked subaccount is linked in ProfitStars */
  ProfitStars = 'profitStars',
}

export enum LinkedSubaccountRoleEnum {
  /** The subaccount is the primary funding source of the user */
  PrimaryFunding = 'primaryFunding',
  /** The subaccount is the secondary funding source of the user */
  SecondaryFunding = 'secondaryFunding',
}

/** Liquidation information */
export type Liquidation = TimestampsInterface & {
  __typename?: 'Liquidation'
  accountId: Scalars['ID']
  billingCycle: BillingCycle
  billingCycleId: Scalars['ID']
  collectedAmount: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeExecutions: Array<Maybe<FeeExecution>>
  id: Scalars['ID']
  investmentId: Scalars['ID']
  requestedAmount: Scalars['Float']
  state: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Liquidation of holdings is currently unavailable. */
export type LiquidationUnavailableError = {
  __typename?: 'LiquidationUnavailableError'
  /** Reason for liquidation being unavailable. */
  reason: LiquidationUnavailableReason
}

export enum LiquidationUnavailableReason {
  /** The funding source is frozen. */
  FundingSourceFrozen = 'FUNDING_SOURCE_FROZEN',
  /** The associated funding source requires RDV. */
  FundingSourceRdvRequired = 'FUNDING_SOURCE_RDV_REQUIRED',
  /** No funding source exists for the investment account. */
  FundingSourceRequired = 'FUNDING_SOURCE_REQUIRED',
}

export type LockBankCardInput = {
  lockReason: BankCardTemporaryLockReason
}

export type LockBankCardPayload = {
  __typename?: 'LockBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type LoginAccess = {
  __typename?: 'LoginAccess'
  loginAllowed: Scalars['Boolean']
  loginRevokedAt: Maybe<Scalars['DateTime']>
  loginRevokedReason: Maybe<Scalars['String']>
}

export type LoginRateLimitedException = {
  __typename?: 'LoginRateLimitedException'
  message: Maybe<Scalars['String']>
}

export type LogoutDeviceInput = {
  deviceId: Scalars['ID']
}

export type LogoutDeviceResult =
  | DeviceNotFoundException
  | LogoutDeviceSuccess
  | RefreshTokenNotFoundException

export type LogoutDeviceSuccess = {
  __typename?: 'LogoutDeviceSuccess'
  Device: Device
}

export type LogoutResult =
  | AuthTokenNotFoundException
  | LogoutSuccess
  | RefreshTokenNotFoundException

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess'
  userId: Scalars['ID']
}

export enum MailInDocumentType {
  BillNegotiation = 'BILL_NEGOTIATION',
  FeeNegotiation = 'FEE_NEGOTIATION',
}

export type MakeInvestmentInput = {
  /** The amount of the investment */
  amount: Scalars['Float']
  /** ID of the funding source to fund the investment If omitted, the user's primary funding source is used */
  fundingSourceId?: InputMaybe<Scalars['ID']>
  /** ID of the investment account If omitted, the user's basic investment account is used */
  investmentAccountId?: InputMaybe<Scalars['ID']>
  /** The type of the investment: - `credit` if transferring from the funding source -> investment account - `debit` if transferring from the investment account -> funding source */
  type: InvestmentTypes
}

export type MakeInvestmentPayload = {
  __typename?: 'MakeInvestmentPayload'
  id: Scalars['ID']
}

export type MalformedRecurringTransferException = {
  __typename?: 'MalformedRecurringTransferException'
  pathExceptions: RecurringTransferPathException[]
}

export enum ManagePayoutRelationshipAction {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export enum ManagePayoutRelationshipResult {
  Fail = 'FAIL',
  Success = 'SUCCESS',
}

export enum MaritalStatus {
  /** User is currently in a civil union */
  CivilUnion = 'civil_union',
  /** User is no longer married due to legal separation */
  Divorced = 'divorced',
  /** User is married currently */
  Married = 'married',
  /** User has never been married */
  Single = 'single',
  /** User is no longer married due to death of spouse */
  Widowed = 'widowed',
}

export type MarkAllAsReadResult = MarkAllAsReadSuccess | UpdateMessageFailed

export type MarkAllAsReadSuccess = {
  __typename?: 'MarkAllAsReadSuccess'
  markedAsReadCount: Scalars['Int']
}

export type MarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsHelpfulResult =
  | RecordDoesNotExistError
  | UpdateLearnContentHelpfulnessResult

export type MarkLearnContentAsViewedInput = {
  contentId: Scalars['ID']
}

export type MarkLearnContentAsViewedResult =
  | RecordDoesNotExistError
  | ViewedLearnContentResult

export type Market = {
  __typename?: 'Market'
  isOpen: Scalars['Boolean']
}

export type MarketReturn = {
  __typename?: 'MarketReturn'
  marketValue: MonetaryAmount
  percent: Scalars['Float']
}

/** A match program entitles eligible investment accounts to matching contributions provided by Acorns. */
export type MatchProgram = TimestampsInterface & {
  __typename?: 'MatchProgram'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Description of the Program Match */
  description: Scalars['String']
  /** Investment Account types supports by the program */
  eligibleInvestmentAccountTypes: InvestmentAccountType[]
  /** ID of the Program Match */
  id: Scalars['ID']
  /** Match percentage for the program */
  matchPercentage: Scalars['Float']
  /** Name of the Program Match */
  name: Scalars['String']
  /** Description of the Program Match */
  requiredContributionVestingDays: Scalars['Int']
  /** Tier the program is available on. */
  tier: Maybe<Tier>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Cannot open early account because the custodian is already at max */
export type MaxAccountsCreatedException = {
  __typename?: 'MaxAccountsCreatedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type Message = {
  body: MessageTextAsset
  deepLink: Maybe<Scalars['URL']>
  externalId: Scalars['ID']
  icon: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  messageCategory: Maybe<MessageCategory>
  messageType: MessageType
  platforms: Platform[]
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
}

export enum MessageCategory {
  Account = 'ACCOUNT',
  Banking = 'BANKING',
  BenefitsHub = 'BENEFITS_HUB',
  Braze = 'BRAZE',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Milestone = 'MILESTONE',
  Onboarding = 'ONBOARDING',
}

/** Specifies a Message Connection */
export type MessageConnection = {
  __typename?: 'MessageConnection'
  edges: MessageEdge[]
  pageInfo: MessagePageInfo
}

/** Specifies a Message Edge */
export type MessageEdge = {
  __typename?: 'MessageEdge'
  cursor: Scalars['ID']
  node: Message
}

export type MessageFeedbackInput = {
  customFeedback?: InputMaybe<Scalars['String']>
  feedbackReason: MessageFeedbackReason
}

export enum MessageFeedbackReason {
  InaccurateInformation = 'INACCURATE_INFORMATION',
  NotHelpful = 'NOT_HELPFUL',
  Offensive = 'OFFENSIVE',
  Other = 'OTHER',
}

/** Specifies Page Information */
export type MessagePageInfo = {
  __typename?: 'MessagePageInfo'
  endCursor: Maybe<Scalars['ID']>
  hasNextPage: Scalars['Boolean']
}

export type MessagePageInput = {
  after?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
}

export enum MessageStatus {
  Dismissed = 'DISMISSED',
  Read = 'READ',
}

/** A pair of a status and a desired boolean for it. */
export type MessageStatusFilterInput = {
  key: MessageStatus
  value: Scalars['Boolean']
}

export type MessageTextAsset = StringKeyAsset

export enum MessageType {
  Alert = 'ALERT',
  Notification = 'NOTIFICATION',
}

export type MessageVisualAsset = DesignLibraryIcon | Image

export type MfaMissingAuthAlert = AuthAlert & {
  __typename?: 'MfaMissingAuthAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Value of money measured in currency */
export type MicrosMoney = {
  __typename?: 'MicrosMoney'
  /** System of money that is used in a particular country */
  currency: Currency
  /** Monetary value */
  value: Scalars['Micros']
}

/** The mighty oak card waiver for a user */
export type MightyOakCardWaiver = {
  __typename?: 'MightyOakCardWaiver'
  mightyOakCardWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

/** Mighty Oak Waiver expired */
export type MightyOakCardWaiverExpiredException = {
  __typename?: 'MightyOakCardWaiverExpiredException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Mighty Oak Waiver not found */
export type MightyOakCardWaiverNotFoundException = {
  __typename?: 'MightyOakCardWaiverNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** result from attempting to create a provisional waiver for a user */
export type MightyOakWaiverResult =
  | BillingProfileNotFoundException
  | MightyOakCardWaiver
  | MightyOakCardWaiverExpiredException
  | MightyOakCardWaiverNotFoundException

export type Milestone = {
  __typename?: 'Milestone'
  /** how many account points the user has earned for this milestone so far */
  accountPoints: AccountPoints
  /**
   * how many challenge points the user has earned for completing this milestone. The specific challenge is indicated by the ID
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  challengePoints: Maybe<ChallengePointsEarned>
  /** key that maps to client-defined milestone description */
  descriptionKey: Scalars['StringKey']
  /** optional destination label and deep link for milestone action */
  destination: Maybe<Destination>
  /**
   * key that maps to client-defined milestone details
   * @deprecated leverage accountPoints.detailsKey
   */
  detailsKey: Maybe<Scalars['StringKey']>
  /** milestone education tip content */
  educationTip: EducationTip
  /** the first time the user completed the milestone */
  firstCompletedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** @deprecated No longer needed since the logo will be dynamically set based on milestone status. Use 'logo' instead */
  inactiveLogo: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** the most recent time the user completed the milestone */
  lastCompletedAt: Maybe<Scalars['DateTime']>
  /** logo that matches the milestone status */
  logo: Image
  /** @deprecated Do not use anymore. This field has been replaced by nameKey. */
  name: Scalars['String']
  /** key that maps to descriptive identifier */
  nameKey: Scalars['StringKey']
  /** information the user's progress towards completion */
  progress: MilestoneProgress
  /** milestone rule enum which can be used for grouping and fetch string mappings */
  rule: MilestoneRuleType
  /** key that maps to simplified descriptive identifier */
  simpleNameKey: Scalars['StringKey']
  /** the user-specific status */
  status: MilestoneStatus
  /** the milestone category */
  theme: MilestoneTheme
  /** how many times the user completed this milestone */
  timesCompleted: Scalars['Int']
}

export type MilestoneChallengePointsArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneAccountLevelDefinition = {
  __typename?: 'MilestoneAccountLevelDefinition'
  /** image to display as the background when the level is active */
  activeBackground: Image
  /** image to display as the foreground when the level is active */
  activeForeground: Image
  /** level id, e.g. 3 */
  id: Scalars['Int']
  /** image to display as the background when the level is inactive */
  inactiveBackground: Image
  /** max points for the level. If min and max are the same value, there is no higher level */
  max: Scalars['Int']
  /** minimum points needed for the level */
  min: Scalars['Int']
}

export type MilestoneAchievementActionRule = {
  __typename?: 'MilestoneAchievementActionRule'
  actions: MilestoneAchievementActionType[]
  milestoneID: Scalars['ID']
}

export enum MilestoneAchievementActionType {
  AnalyticsEvent = 'ANALYTICS_EVENT',
  NativeNotification = 'NATIVE_NOTIFICATION',
}

export type MilestoneByThemeFilterInput = {
  /** No longer in use. Will be ignored if provided. */
  challengeId?: InputMaybe<Scalars['ID']>
  rule?: InputMaybe<MilestoneRuleType>
}

export type MilestoneChallenge = {
  __typename?: 'MilestoneChallenge'
  /** Static date label for when the challenge becomes inactive (NOTE: is relative to PST) */
  closingAt: Scalars['String']
  /** additional information about this challenge */
  details: Maybe<Scalars['String']>
  /** Internal UTC timestamp. For display, use 'closingAt'instead */
  endsAt: Scalars['DateTime']
  /** optional deeplink to challenge FAQ */
  faqDeepLink: Maybe<Scalars['URL']>
  /** list of user milestones, grouped and ordered */
  groupedMilestones: MilestoneGroup[]
  id: Scalars['ID']
  /** optional logo for the challenge */
  logo: Maybe<Image>
  /** number of milestones the user has completed for the challenge */
  milestonesCompleted: DiscreteMilestoneProgress
  /** descriptive identifier */
  name: Scalars['String']
  /** number of points the user has earned for the challenge. May be null if not applicable to the current challenge */
  pointsEarned: Maybe<DiscreteMilestoneProgress>
  /** optional deeplink to official challenge rules */
  rulesDeepLink: Maybe<Scalars['URL']>
}

export type MilestoneChallengePointsRule = {
  __typename?: 'MilestoneChallengePointsRule'
  challengeID: Scalars['ID']
  /** legal copy about how points are earned */
  details: Scalars['String']
  /** specifies the max points that can be earned if the milestone is completed more than once */
  maxPointsAllowed: Scalars['Int']
  /** how many points are earned each time the milestone is completed */
  pointsPerCompletion: Scalars['Int']
  /** summarized information about how points are earned */
  summary: Maybe<Scalars['String']>
}

export type MilestoneDefinition = {
  __typename?: 'MilestoneDefinition'
  accountPointsRule: Maybe<AccountPointsRule>
  /** optional datetime arg required for some milestone rules (e.g. ACTIVE_CUSTOMER) */
  arg1DateTime: Maybe<Scalars['DateTime']>
  /** optional integer arg required for some milestone rules (e.g. BALANCED_REACHED) */
  arg1Int: Maybe<Scalars['Int']>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  challengePointsRule: Maybe<MilestoneChallengePointsRule>
  id: Scalars['ID']
  /** optional logo used for inactive milestone states (e.g. LOCKED, NOT_STARTED) */
  inactiveLogo: Maybe<Image>
  /** whether or not this milestone can be completed more than once */
  isRepeatable: Scalars['Boolean']
  /** default logo */
  logo: Image
  /** list of MilestoneGroupID for groups to which this milestone belongs */
  milestoneGroups: Array<Scalars['ID']>
  /** descriptive identifier */
  name: Scalars['String']
  /** the rule that determines how this milestone changes status */
  rule: MilestoneRule
  /** the milestone category */
  theme: MilestoneTheme
}

export type MilestoneDefinitionChallengePointsRuleArgs = {
  challengeId: Scalars['ID']
}

export type MilestoneEligibility = {
  __typename?: 'MilestoneEligibility'
  eligible: Scalars['Boolean']
  scope: MilestoneEligibilityScope
}

export enum MilestoneEligibilityScope {
  AccountSetupComplete = 'ACCOUNT_SETUP_COMPLETE',
  /** @deprecated this value was only used for the AccountSetup feature experiment that is now over */
  AccountSetupExp = 'ACCOUNT_SETUP_EXP',
}

export type MilestoneGroup = MilestoneRuleGroup | MilestoneThemeGroup

export type MilestoneGroupAchievementActionRule = {
  __typename?: 'MilestoneGroupAchievementActionRule'
  actions: MilestoneAchievementActionType[]
  milestoneGroupID: Scalars['ID']
}

export type MilestoneGroupDefinition = {
  __typename?: 'MilestoneGroupDefinition'
  id: Scalars['ID']
  milestoneIDs: Array<Scalars['ID']>
}

export type MilestoneHub = {
  __typename?: 'MilestoneHub'
  /** list of user milestones, grouped and ordered */
  groupedMilestones: MilestoneGroup[]
  /** static list of min and max values for each account level */
  levelDefinitions: MilestoneAccountLevelDefinition[]
  userAccount: MilestoneHubAccount
}

export type MilestoneHubAccount = {
  __typename?: 'MilestoneHubAccount'
  /** shows progress of points earned vs points needed to move to the next level. NOTE: the currentInt can exceed the targetInt if the user is at the highest level */
  accountPointsProgress: DiscreteMilestoneProgress
  /** current level achieved */
  currentLevel: Scalars['Int']
  /** shows progress of milestones completed vs milestones available */
  milestoneProgress: DiscreteMilestoneProgress
}

export type MilestoneHubDefinition = {
  __typename?: 'MilestoneHubDefinition'
  id: Scalars['ID']
  milestoneIds: Array<Scalars['ID']>
}

export type MilestoneProgress =
  | CurrencyMilestoneProgress
  | DiscreteMilestoneProgress

/** defines how a milestone is completed */
export type MilestoneRule = {
  __typename?: 'MilestoneRule'
  /** denotes if an argument input needs to be provided for the creation of a MilestoneDefinition */
  argInput: MilestoneRuleArgInput
  id: Scalars['ID']
  /** the rule name */
  name: Scalars['String']
  /** the milestone supported themes */
  themes: MilestoneTheme[]
}

export enum MilestoneRuleArgInput {
  Datetime = 'DATETIME',
  Int = 'INT',
  None = 'NONE',
}

export type MilestoneRuleGroup = {
  __typename?: 'MilestoneRuleGroup'
  contents: MilestoneRuleGroupContent[]
  descriptionKey: Scalars['StringKey']
  groupCompletion: DiscreteMilestoneProgress
  logo: Image
  nameKey: Scalars['StringKey']
  rule: MilestoneRuleType
}

export type MilestoneRuleGroupContent = Milestone

export enum MilestoneRuleType {
  ActiveCustomer = 'ACTIVE_CUSTOMER',
  BalanceReached = 'BALANCE_REACHED',
  CardActivation = 'CARD_ACTIVATION',
  /** @deprecated Use CREATE_ACORNS_ACCOUNT instead */
  CompleteRegistration = 'COMPLETE_REGISTRATION',
  CreateAcornsAccount = 'CREATE_ACORNS_ACCOUNT',
  FirstInvestment = 'FIRST_INVESTMENT',
  FundingSourceLinked = 'FUNDING_SOURCE_LINKED',
  RealtimeRoundup = 'REALTIME_ROUNDUP',
  RecurringInvestmentMonthly = 'RECURRING_INVESTMENT_MONTHLY',
  RewardCreated = 'REWARD_CREATED',
  Roundup = 'ROUNDUP',
  Signup = 'SIGNUP',
  SmartDepositCompleted = 'SMART_DEPOSIT_COMPLETED',
  Verified = 'VERIFIED',
}

export enum MilestoneStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
}

export enum MilestoneTheme {
  AccountSetup = 'ACCOUNT_SETUP',
  Acorns = 'ACORNS',
  Early = 'EARLY',
  Earn = 'EARN',
  Invest = 'INVEST',
  Later = 'LATER',
  Spend = 'SPEND',
}

export type MilestoneThemeGroup = {
  __typename?: 'MilestoneThemeGroup'
  contents: MilestoneThemeGroupContent[]
  descriptionKey: Scalars['StringKey']
  destination: Maybe<Destination>
  groupCompletion: DiscreteMilestoneProgress
  groupPointsProgress: Maybe<DiscreteMilestoneProgress>
  isLocked: Scalars['Boolean']
  logo: Image
  nameKey: Scalars['StringKey']
  theme: MilestoneTheme
}

export type MilestoneThemeGroupContent = Milestone | MilestoneRuleGroup

export type Milliseconds = {
  __typename?: 'Milliseconds'
  value: Scalars['Int']
}

export type MillisecondsInput = {
  value: Scalars['Int']
}

/** Miscellaneous document requested. */
export type MiscDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'MiscDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Returned when the provided distribution units are not all matching */
export type MismatchedDistributionUnitsError = {
  __typename?: 'MismatchedDistributionUnitsError'
  message: Scalars['String']
}

/** Missing required agreements for user */
export type MissingAgreementsException = {
  __typename?: 'MissingAgreementsException'
  userId: Maybe<Scalars['ID']>
}

/** Cannot open early account because the beneficiary does not have an SSN */
export type MissingBeneficiarySsnException = {
  __typename?: 'MissingBeneficiarySsnException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** The user needs to attach a funding source to close their early account */
export type MissingFundingSourceException = {
  __typename?: 'MissingFundingSourceException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type MissingIdImageException = {
  __typename?: 'MissingIdImageException'
  userId: Scalars['ID']
}

export type MissingRequiredAgreementsException = {
  __typename?: 'MissingRequiredAgreementsException'
  message: Maybe<Scalars['String']>
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlert = Alert & {
  __typename?: 'MissingSsnBeneficiaryAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The given beneficiary does not have an associated SSN. */
export type MissingSsnBeneficiaryAlertItem = UserAlertsItem & {
  __typename?: 'MissingSsnBeneficiaryAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Returned when an existing customer ruleset is not found, and no override archetype ruleset was provided. */
export type MissingValidRulesetError = {
  __typename?: 'MissingValidRulesetError'
  message: Scalars['String']
}

export type ModifyMoneyAssignmentInput = {
  /** The target account IDs and amount to assign for each account */
  accountAssignments: AccountMoneyAssignmentInput[]
  /** The incoming transaction ID for money assignment between accounts */
  transactionId: Scalars['ID']
}

export type ModifyMoneyAssignmentResult =
  | ModifyMoneyAssignmentSuccess
  | MoneyAssignmentAlreadyTransferredError
  | MoneyAssignmentNotFoundError

export type ModifyMoneyAssignmentSuccess = {
  __typename?: 'ModifyMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount'
  currency: Currency
  value: Scalars['Float']
}

/** Input for anything money related */
export type MonetaryAmountInput = {
  /** The currency of the amount */
  currency: Currency
  /** The total amount */
  value: Scalars['Float']
}

/** A monetrary reward that will be provided to a subscriber in some fashion. */
export type MonetaryIncentive = Incentive & {
  __typename?: 'MonetaryIncentive'
  /** Amount of the monetary reward. */
  amount: CurrencyAmount
  copyKey: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['ID']
  /** Is the monetary reward recurring. */
  recurring: Scalars['Boolean']
  /** Total amount of the reward if recurring. */
  totalAmount: CurrencyAmount
  /**
   * Arbitrary string denoting to fulfillment processes how monetary
   * reward should be provided to a subscriber.
   *
   * Ex. "INVESTMENT"
   */
  type: Scalars['String']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type MoneyAssignmentAlreadyTransferredError = {
  __typename?: 'MoneyAssignmentAlreadyTransferredError'
  message: Scalars['String']
}

export type MoneyAssignmentConnection = {
  __typename?: 'MoneyAssignmentConnection'
  edges: MoneyAssignmentEdge[]
  pageInfo: MoneyManagerPageInfo
}

export type MoneyAssignmentEdge = {
  __typename?: 'MoneyAssignmentEdge'
  cursor: Scalars['String']
  node: MoneyManagerMoneyAssignment
}

export type MoneyAssignmentNotFoundError = {
  __typename?: 'MoneyAssignmentNotFoundError'
  message: Scalars['String']
}

export type MoneyInEventInput = {
  accountId: Scalars['String']
  customerTag: Scalars['String']
  description: Scalars['String']
  id: Scalars['ID']
  ingestedAt: Scalars['String']
  transactionAmount: Scalars['String']
  transactionId: Scalars['String']
  transactionTag: Scalars['String']
  transactionTypeCode: Scalars['String']
}

/** The target account as the result of a MoneyAssignment */
export type MoneyManagerAllocation = {
  __typename?: 'MoneyManagerAllocation'
  amount: MoneyRulesCurrencyAmount
  beneficiary: Maybe<Beneficiary>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  destinationAccount: MoneyRulesDestination
  id: Scalars['ID']
  /**
   * Deprecated - Use rules instead
   * @deprecated Field no longer supported
   */
  rule: MoneyRulesRule
  rules: MoneyRulesRule[]
  status: MoneyManagerAllocationStatus
  transferId: Maybe<Scalars['ID']>
}

export enum MoneyManagerAllocationNotEditableReason {
  LaterLimitReached = 'LATER_LIMIT_REACHED',
  NoPercentageRemaining = 'NO_PERCENTAGE_REMAINING',
}

/** Represents the allocation amount details. */
export type MoneyManagerAllocationOption = {
  __typename?: 'MoneyManagerAllocationOption'
  /** The amount of the allocation. */
  amount: MoneyRulesCurrencyAmount
  /** Deposit amounts normalized to various cadences. */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>
  /** The percentage of the allocation. */
  percent: Scalars['Float']
  /** The remainder details of the allocation. */
  remainder: MoneyManagerAllocationRemainder
}

/** Input object for allocation amounts query. */
export type MoneyManagerAllocationOptionsInput = {
  /** Pass in an archetype to use as a "starting point" for the algorithm instead of the customer's current ruleset */
  archetype?: InputMaybe<MoneyRulesArchetype>
  /** Any staged rules to consider when calculating allocation options */
  stagedRules?: InputMaybe<MoneyManagerStagedRulesInput[]>
  /** The target account identifier to get allocation options for */
  targetAccountId: Scalars['ID']
  /** Set as `true` to base the algorithm on all deposit amounts rather than just the next deposit. */
  useTotalDepositAmount?: InputMaybe<Scalars['Boolean']>
}

/** Represents the remainder details for the allocation option */
export type MoneyManagerAllocationRemainder = {
  __typename?: 'MoneyManagerAllocationRemainder'
  /** The amount of the remainder allocation. */
  amount: MoneyRulesCurrencyAmount
  /** The percentage of the remainder allocation. */
  percent: Scalars['Float']
}

export enum MoneyManagerAllocationStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type MoneyManagerAutomationTarget = {
  __typename?: 'MoneyManagerAutomationTarget'
  amount: MoneyRulesCurrencyAmount
  /** Was the goal set by the customer? */
  customSelection: Scalars['Boolean']
  /** The suggested period of the original target suggestion. */
  suggestedPeriod: Maybe<MoneyManagerPeriod>
  type: MoneyManagerAutomationTargetType
}

export enum MoneyManagerAutomationTargetType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
}

export type MoneyManagerCascadeObjective = {
  __typename?: 'MoneyManagerCascadeObjective'
  accountType: ProductAccountType
  /** Is this active for the customer's current state? */
  isLocked: Scalars['Boolean']
  objectiveType: MoneyManagerCascadeObjectiveType
  /** Target & contribution data. Null for OVERFLOW objectives (or in a weird case where we're having trouble getting Later data) */
  target: Maybe<MoneyManagerCascadeTarget>
}

export enum MoneyManagerCascadeObjectiveType {
  Balance = 'BALANCE',
  Overflow = 'OVERFLOW',
}

export type MoneyManagerCascadeTarget = {
  __typename?: 'MoneyManagerCascadeTarget'
  /** Can the customer change this value? */
  isEditable: Scalars['Boolean']
  /** Balance in (or contributions YTD to) the destination account */
  progressAmount: MoneyRulesCurrencyAmount
  /** How close is the customer to the target? 0-100 */
  progressPercentage: Maybe<Scalars['Int']>
  /** The automation target or contribution limit for the accountType */
  targetAmount: Maybe<MoneyRulesCurrencyAmount>
}

export type MoneyManagerCategoriesInput = {
  amount?: InputMaybe<MoneyRulesCurrencyAmountInput>
  archetype?: InputMaybe<MoneyRulesArchetype>
  stagedRules?: InputMaybe<MoneyManagerStagedRulesInput[]>
  /** Base calculations on the customer's monthly deposit amount, instead of their next predicted paycheck. Default: False */
  useMonthlyDepositAmount?: InputMaybe<Scalars['Boolean']>
}

export type MoneyManagerCategoriesResult = MoneyManagerCategoriesSuccess

export type MoneyManagerCategoriesSuccess = {
  __typename?: 'MoneyManagerCategoriesSuccess'
  categories: MoneyManagerCategory[]
}

export type MoneyManagerCategory = {
  __typename?: 'MoneyManagerCategory'
  allocations: MoneyManagerCategoryAllocation[]
  categoryAmount: Maybe<MoneyRulesCurrencyAmount>
  categoryPercent: Scalars['Float']
  categoryType: MoneyManagerCategoryType
  isActive: Scalars['Boolean']
}

export type MoneyManagerCategoryAllocation = {
  __typename?: 'MoneyManagerCategoryAllocation'
  accountId: Scalars['ID']
  accountType: ProductAccountType
  amount: Maybe<MoneyRulesCurrencyAmount>
  beneficiary: Maybe<Beneficiary>
  isEditable: Scalars['Boolean']
  /** Deposit amounts normalized to various cadences */
  normalizedAmounts: Maybe<MoneyManagerNormalizedAmounts>
  notEditableReason: Maybe<MoneyManagerAllocationNotEditableReason>
  percent: Scalars['Float']
  singleRuleId: Maybe<Scalars['Int']>
}

export enum MoneyManagerCategoryType {
  Giving = 'GIVING',
  Investing = 'INVESTING',
  Kids = 'KIDS',
  Saving = 'SAVING',
  Spending = 'SPENDING',
}

export type MoneyManagerDeposit = {
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerDepositAssignment = MoneyManagerMoneyAssignment & {
  __typename?: 'MoneyManagerDepositAssignment'
  allocations: MoneyManagerAllocation[]
  amount: MoneyRulesCurrencyAmount
  createdAt: Scalars['DateTime']
  deposit: MoneyManagerDeposit
  id: Scalars['ID']
  status: MoneyManagerMoneyAssignmentStatus
  type: MoneyManagerMoneyAssignmentType
  userId: Scalars['String']
}

export enum MoneyManagerDepositCategory {
  OneTime = 'ONE_TIME',
  Other = 'OTHER',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING',
}

export enum MoneyManagerDepositState {
  /** The customer has never had the Money Manager process a deposit and is waiting for the first deposit to arrive */
  AwaitingFirstDeposit = 'AWAITING_FIRST_DEPOSIT',
  /** The most recent deposit has arrived and has been split and waiting for the next deposit */
  AwaitingNextDeposit = 'AWAITING_NEXT_DEPOSIT',
  /** The current deposit has arrived and is pending */
  DepositArrived = 'DEPOSIT_ARRIVED',
}

/** Represents the current summary and state of money manager deposits */
export type MoneyManagerDepositSummary = {
  __typename?: 'MoneyManagerDepositSummary'
  /** The amount of the deposit based off the deposit state */
  amount: Maybe<MoneyRulesCurrencyAmount>
  /** Most recently created pending MoneyAssignment that has not yet been split */
  pendingMoneyAssignment: Maybe<MoneyManagerMoneyAssignment>
  /** The projected deposit amount based on annual income */
  predictedDepositAmount: Maybe<MoneyRulesCurrencyAmount>
  /** The state of Money Manager deposits for the customer */
  state: Maybe<MoneyManagerDepositState>
}

export type MoneyManagerEligiblityResult = {
  __typename?: 'MoneyManagerEligiblityResult'
  isEligible: Scalars['Boolean']
}

export type MoneyManagerError = {
  message: Scalars['String']
}

export type MoneyManagerGlobalConfig = {
  __typename?: 'MoneyManagerGlobalConfig'
  recurringDepositsConfig: MoneyManagerRecurringDepositsConfig
}

export type MoneyManagerInputError = MoneyManagerError & {
  __typename?: 'MoneyManagerInputError'
  message: Scalars['String']
}

export type MoneyManagerMoneyAssignment = {
  allocations: MoneyManagerAllocation[]
  amount: MoneyRulesCurrencyAmount
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** The status of the MoneyAssignment as a whole including the Assignment Target Allocations */
  status: MoneyManagerMoneyAssignmentStatus
  type: MoneyManagerMoneyAssignmentType
  userId: Scalars['String']
}

export enum MoneyManagerMoneyAssignmentStatus {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Transferring = 'TRANSFERRING',
}

export enum MoneyManagerMoneyAssignmentType {
  Deposit = 'DEPOSIT',
  Rebalance = 'REBALANCE',
}

export type MoneyManagerNormalizedAmounts = {
  __typename?: 'MoneyManagerNormalizedAmounts'
  daily: Maybe<MoneyRulesCurrencyAmount>
  monthly: Maybe<MoneyRulesCurrencyAmount>
  weekly: Maybe<MoneyRulesCurrencyAmount>
  yearly: Maybe<MoneyRulesCurrencyAmount>
}

export type MoneyManagerPageInfo = {
  __typename?: 'MoneyManagerPageInfo'
  hasNextPage: Scalars['Boolean']
  /** We don't actually have the ability to determine if there was a previous page. Will return true if a cursor was provided */
  hasPreviousPage: Scalars['Boolean']
  limit: Scalars['Int']
}

export type MoneyManagerPageInput = {
  after?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
}

export type MoneyManagerPaycheck = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerPaycheck'
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  employer: Scalars['String']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerPeriod = {
  __typename?: 'MoneyManagerPeriod'
  unit: MoneyManagerPeriodUnit
  value: Scalars['Int']
}

export type MoneyManagerPeriodInput = {
  unit: MoneyManagerPeriodUnit
  value: Scalars['Int']
}

export enum MoneyManagerPeriodUnit {
  Month = 'MONTH',
  Week = 'WEEK',
}

export type MoneyManagerRecurringDeposit = MoneyManagerDeposit & {
  __typename?: 'MoneyManagerRecurringDeposit'
  amount: MoneyRulesCurrencyAmount
  category: MoneyManagerDepositCategory
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  userId: Scalars['String']
}

export type MoneyManagerRecurringDepositsConfig = {
  __typename?: 'MoneyManagerRecurringDepositsConfig'
  allowedFrequencies: MoneyManagerRecurringFrequency[]
  maximumAmount: MoneyRulesCurrencyAmount
  minimumAmount: MoneyRulesCurrencyAmount
}

export enum MoneyManagerRecurringFrequency {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type MoneyManagerRulesetNotFoundError = MoneyManagerError & {
  __typename?: 'MoneyManagerRulesetNotFoundError'
  message: Scalars['String']
}

export type MoneyManagerScheduledDeposit = {
  amount: MoneyRulesCurrencyAmount
  expectedDate: Maybe<Scalars['DateTime']>
}

export type MoneyManagerScheduledPaycheck = MoneyManagerScheduledDeposit & {
  __typename?: 'MoneyManagerScheduledPaycheck'
  amount: MoneyRulesCurrencyAmount
  employer: Scalars['String']
  expectedDate: Maybe<Scalars['DateTime']>
}

export type MoneyManagerScheduledRecurringDeposit =
  MoneyManagerScheduledDeposit & {
    __typename?: 'MoneyManagerScheduledRecurringDeposit'
    amount: MoneyRulesCurrencyAmount
    expectedDate: Maybe<Scalars['DateTime']>
  }

export type MoneyManagerSettings = {
  __typename?: 'MoneyManagerSettings'
  depositSources: MoneyRulesSourceSetting[]
  processRecurringDeposits: Scalars['Boolean']
  status: MoneyManagerStatus
  userId: Scalars['ID']
}

export type MoneyManagerSourceSetting = {
  __typename?: 'MoneyManagerSourceSetting'
  depositType: MoneyRulesDepositType
  displayName: Maybe<Scalars['String']>
  enabled: Scalars['Boolean']
  source: Scalars['String']
}

/** Input type for MoneyManager allocation. */
export type MoneyManagerStagedRulesInput = {
  distribution: MoneyRulesDistributionInput
  singleRuleId: Scalars['Int']
}

export enum MoneyManagerState {
  /** The customer has never had the Money Manager turned on */
  NotSetup = 'NOT_SETUP',
  /** The Money Manager is turned off */
  Off = 'OFF',
  /** The Money Manager is turned on */
  On = 'ON',
}

export enum MoneyManagerStatus {
  NotSetup = 'NOT_SETUP',
  Off = 'OFF',
  On = 'ON',
}

/** Represents the current summary and state of the money manager */
export type MoneyManagerSummary = {
  __typename?: 'MoneyManagerSummary'
  depositSummary: MoneyManagerDepositSummary
  /** The amount received by the Money Manager this month */
  receivedThisPeriodAmount: MoneyRulesCurrencyAmount
  /** The amount scheduled for the Money Manager for this month */
  scheduledThisPeriodAmount: MoneyRulesCurrencyAmount
  /**
   * The state of the Money Manager for the customer
   * @deprecated Use status on MoneyManagerSettings instead
   */
  state: MoneyManagerState
}

export enum MoneyRulesAccountType {
  Checking = 'CHECKING',
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Savings = 'SAVINGS',
}

export enum MoneyRulesArchetype {
  DebtFocused = 'DEBT_FOCUSED',
  Default = 'DEFAULT',
  GivingFocused = 'GIVING_FOCUSED',
}

export type MoneyRulesArchetypesInput = {
  archetypes?: InputMaybe<MoneyRulesArchetype[]>
  date?: InputMaybe<Scalars['DateTime']>
}

export type MoneyRulesArchetypesResult = MoneyRulesArchetypesSuccess

export type MoneyRulesArchetypesSuccess = {
  __typename?: 'MoneyRulesArchetypesSuccess'
  rulesets: MoneyRulesRuleset[]
}

export type MoneyRulesCancelMoneyAssignmentSuccess = {
  __typename?: 'MoneyRulesCancelMoneyAssignmentSuccess'
  moneyAssignment: MoneyManagerMoneyAssignment
}

export type MoneyRulesCondition = {
  __typename?: 'MoneyRulesCondition'
  fallback: Maybe<MoneyRulesDestination>
  type: MoneyRulesConditionType
  unit: MoneyRulesConditionUnit
  value: Scalars['Float']
}

export type MoneyRulesConditionInput = {
  fallback?: InputMaybe<MoneyRulesDestinationInput>
  type: MoneyRulesConditionType
  unit: MoneyRulesConditionUnit
  value: Scalars['Float']
}

export enum MoneyRulesConditionType {
  DebtExists = 'DEBT_EXISTS',
  HighInterestDebtExists = 'HIGH_INTEREST_DEBT_EXISTS',
  SourceAmountAtLeast = 'SOURCE_AMOUNT_AT_LEAST',
}

export enum MoneyRulesConditionUnit {
  Currency = 'CURRENCY',
}

export type MoneyRulesCurrencyAmount = {
  __typename?: 'MoneyRulesCurrencyAmount'
  currency: Currency
  value: Scalars['Float']
}

export type MoneyRulesCurrencyAmountInput = {
  currency: Currency
  value: Scalars['Float']
}

export enum MoneyRulesDepositType {
  OneTime = 'ONE_TIME',
  Paycheck = 'PAYCHECK',
  Recurring = 'RECURRING',
}

export type MoneyRulesDestination = {
  __typename?: 'MoneyRulesDestination'
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
}

export type MoneyRulesDestinationInput = {
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
}

export type MoneyRulesDistribution = {
  __typename?: 'MoneyRulesDistribution'
  unit: MoneyRulesDistributionUnit
  value: Scalars['Float']
}

export type MoneyRulesDistributionInput = {
  unit: MoneyRulesDistributionUnit
  value: Scalars['Float']
}

export enum MoneyRulesDistributionUnit {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
}

export type MoneyRulesMoneySource = {
  __typename?: 'MoneyRulesMoneySource'
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
  amount: MoneyRulesCurrencyAmount
}

export type MoneyRulesMoneySourceInput = {
  accountId: Scalars['String']
  accountType: MoneyRulesAccountType
  amount: MoneyRulesCurrencyAmountInput
}

export type MoneyRulesMoneySplit = {
  __typename?: 'MoneyRulesMoneySplit'
  destination: MoneyRulesDestination
  distribution: MoneyRulesDistribution
}

export type MoneyRulesRule = {
  __typename?: 'MoneyRulesRule'
  conditions: MoneyRulesCondition[]
  destination: MoneyRulesDestination
  distribution: MoneyRulesDistribution
  priority: Scalars['Int']
  ruleType: MoneyRulesRuleType
}

export type MoneyRulesRuleInput = {
  conditions: MoneyRulesConditionInput[]
  destination: MoneyRulesDestinationInput
  distribution: MoneyRulesDistributionInput
  priority: Scalars['Int']
  ruleType: MoneyRulesRuleType
}

export enum MoneyRulesRuleType {
  FlatPct = 'FLAT_PCT',
  FlatPctAdjustedForIncomeShare = 'FLAT_PCT_ADJUSTED_FOR_INCOME_SHARE',
  FlatPctUpToLaterGoal = 'FLAT_PCT_UP_TO_LATER_GOAL',
  FlatPctUpToLaterGoalAdjustedForIncomeShare = 'FLAT_PCT_UP_TO_LATER_GOAL_ADJUSTED_FOR_INCOME_SHARE',
  FlatValue = 'FLAT_VALUE',
  FullRemainder = 'FULL_REMAINDER',
  UpToCheckingGoal = 'UP_TO_CHECKING_GOAL',
  UpToLaterLimit = 'UP_TO_LATER_LIMIT',
  UpToSavingsGoal = 'UP_TO_SAVINGS_GOAL',
  UpToSavingsGoalCappedAdjustedForIncomeShare = 'UP_TO_SAVINGS_GOAL_CAPPED_ADJUSTED_FOR_INCOME_SHARE',
}

export type MoneyRulesRuleset = {
  __typename?: 'MoneyRulesRuleset'
  archetype: MoneyRulesArchetype
  createdAt: Scalars['DateTime']
  isCustomized: Scalars['Boolean']
  minimumAmount: Scalars['Int']
  rules: MoneyRulesRule[]
}

export type MoneyRulesRulesetInput = {
  archetype: MoneyRulesArchetype
  minimumAmount: Scalars['Int']
  rules: MoneyRulesRuleInput[]
}

export type MoneyRulesRulesetNotFoundException = {
  __typename?: 'MoneyRulesRulesetNotFoundException'
  message: Scalars['String']
}

export type MoneyRulesSettings = {
  __typename?: 'MoneyRulesSettings'
  depositSources: MoneyRulesSourceSetting[]
  /** @deprecated Use status instead */
  moneyManagerEnabled: Scalars['Boolean']
  processRecurringDeposits: Scalars['Boolean']
  userId: Scalars['ID']
}

export type MoneyRulesSourceSetting = {
  __typename?: 'MoneyRulesSourceSetting'
  depositType: MoneyRulesDepositType
  displayName: Maybe<Scalars['String']>
  enabled: Scalars['Boolean']
  source: Scalars['String']
}

export type MoneyRulesSplitOverridesInput = {
  acornsIncomePercentage?: InputMaybe<Scalars['Float']>
  adjustForAcornsIncomeShare?: InputMaybe<Scalars['Boolean']>
  grossYearlyIncome?: InputMaybe<Scalars['Int']>
  stateOfResidence?: InputMaybe<StateCode>
}

export type MoneyRulesSuggestedSplits = {
  __typename?: 'MoneyRulesSuggestedSplits'
  moneySource: MoneyRulesMoneySource
  rulesetVersion: Maybe<Scalars['Int']>
  splits: Array<Maybe<MoneyRulesMoneySplit>>
}

export type MoneyRulesSuggestionResult = MoneyRulesSuggestedSplits

export type MoneyRulesUpdateArchetypeResult = MoneyRulesUpdateRulesetSuccess

export type MoneyRulesUpdateCustomerMoneyRulesResult =
  MoneyRulesUpdateRulesetSuccess

export type MoneyRulesUpdateRulesetSuccess = {
  __typename?: 'MoneyRulesUpdateRulesetSuccess'
  resultingRuleset: MoneyRulesRuleset
}

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal'
  isPredicted: Scalars['Boolean']
  totalAmount: FormattedMonetaryAmount
  yearMonth: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** DEPRECATED - use agreeToAcceptanceDocument instead */
  acceptDocument: AcceptDocumentResponse
  activateBankCard: Maybe<ActivateBankCardPayload>
  /** @implicit(userId: ID!) */
  addCohortEligibility: AddCohortEligibilityResult
  /** @implicit(userId: String!) */
  addFavoritePartnerOffers: FavoritePartnerOfferGroup
  /** Saves new search term and returns that term when it is saved */
  addSearchTermToLearnSearchHistory: AddSearchTermToLearnSearchHistoryResult
  /** Adds a security to a portfolio */
  addSecurityToPortfolio: AddSecurityToPortfolioResult
  /** Add a Self Directed Portfolio */
  addSelfDirectedPortfolio: AddSelfDirectedPortfolioResult
  /** Add a trusted contact for a user */
  addTrustedContact: UpdateTrustedContactResult
  agreeToAcceptanceDocument: Maybe<Scalars['Void']>
  /** Validate a challenge. */
  answerChallenge: AnswerChallengeResult
  /** @implicit(userId: ID!) */
  answerLearnQuizQuestion: AnswerLearnQuizQuestionResult
  /** Apply a promotion to an existing subscription. May entitle a subscriber to promotional pricing for their subscription and/or additional incentives. */
  applyPromotion: ApplyPromotionResult
  /** Apply a promotional waiver */
  applyPromotionalWaiver: Maybe<ApplyPromotionalWaiverResult>
  /** Apply a provisional (open ended) waiver */
  applyProvisionalWaiver: Maybe<ApplyProvisionalWaiverResult>
  archiveInvalidSmartDepositSettings: ArchiveInvalidSmartDepositRecordsResult
  /** @implicit(userId: String!) */
  askFinancialAdvisorQuestion: FinancialAdvisorQuestionResponse
  /** Assign a linked subaccount to a role (i.e. funding source) */
  assignLinkedSubaccount: Maybe<LinkedSubaccount>
  /** Request an AuthSession for the provided credentials. */
  authenticate: AuthenticateResult
  authenticateForFeeNegotiation: AuthenticateForFeeNegotiationResult
  authenticateForFeeNegotiationChallenge: AuthenticateNegotiationStatusResult
  authenticateForFeeNegotiationChallengeMethod: AuthenticateNegotiationStatusResult
  /** Batch adds tier-subscription items for users for specified user uuids, tierIds, tierPriceId */
  batchAddTierSubscriptions: BatchAddTierSubscriptionsResult
  /** @implicit(userId: ID!) */
  blockDevice: BlockDeviceResult
  cancelCheckPayment: Maybe<CancelCheckPaymentResult>
  /** @implicit(userId: UUID!) */
  cancelIntent: CancelIntentResult
  /** Cancel pending investment */
  cancelInvestment: CancelInvestmentResult
  /** Cancel an existing account closure request */
  cancelInvestmentAccountClosureRequest: CancelInvestmentAccountClosureRequestResult
  /** Gives the customer the ability to cancel a pending Money Assignment */
  cancelMoneyAssignment: Maybe<CancelMoneyAssignmentResult>
  /** @implicit(userId: ID!) */
  cancelRecurringTransfer: Maybe<CancelRecurringTransferResult>
  cancelTransfer: Maybe<CancelTransferPayload>
  /** Change the amount of an outside contribution payment intent */
  changeOutsideContributionAmount: ChangeOutsideContributionAmountResult
  changePIN: Maybe<Scalars['Void']>
  /** Changes a users password if password change criteria is met */
  changePassword: Maybe<Scalars['Void']>
  /** @implicit(userId: ID!) */
  changePasswordAuth: ChangePasswordResult
  clearSupportSiteCache: Maybe<ClearSupportSiteCache>
  closeBankAccount: CloseBankAccountResult
  /** Start the account closure process for the specified investment account */
  closeInvestmentAccount: CloseInvestmentAccountResult
  /** Close an open Acorns user account */
  closeUserAccount: CloseUserAccountResult
  completeCheckDeposit: Maybe<CompleteCheckDepositPayload>
  /** Mark account as having completed the registration funnel */
  completeFunnelOnboarding: CompleteFunnelOnboardingResult
  completeRegistration: Maybe<User>
  configureSplitDepositDirectDepositIntentSetting: ConfigureSplitDepositDirectDepositIntentPayload
  configureSplitDepositDirectDepositSetting: ConfigureSplitDepositDirectDepositSettingPayload
  connectACHAccount: ConnectAchAccountResult
  connectLadderCustomer: Maybe<LadderLinkResponse>
  consumeUserToken: ConsumeUserTokenResult
  /** @implicit(userId: ID!) */
  createAuthProfile: CreateAuthProfileResult
  createAuthenticatedSupportTicket: Maybe<SupportTicket>
  createBankAccount: Maybe<CreateBankAccountPayload>
  /** Create a beneficiary */
  createBeneficiary: CreateBeneficiaryResult
  /** Get Pinwheel Link Token */
  createDirectDepositLinkInfo: CreateDirectDepositLinkInfoSwitch
  createDocumentUpload: CreateDocumentUpload
  /** Initiate a face liveness session with AWS Rekognition */
  createFaceLivenessSession: FaceLivenessSession
  createIRAWithProfile: Maybe<CreateInvestmentAccountResponse>
  /** @implicit(userId: UUID!) */
  createIntent: CreateIntentResult
  /** Calculates portfolio recommendation based off of specific factors for specific account type */
  createInvestingStrategyRecommendation: CreateInvestingStrategyRecommendationResult
  createInvestmentAccount: Maybe<CreateInvestmentAccountResponse>
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  createJobAlert: Maybe<CreateJobAlertResult>
  createLadderQuote: Maybe<LadderResponse>
  createLaterContribution: Maybe<Scalars['Void']>
  /** (Internal-only) Provision a new offer. */
  createOffer: CreateOfferResult
  /** Create a new Outside Contribution */
  createOutsideContribution: CreateOutsideContributionResult
  /** Generate outside contribution payment token */
  createOutsideContributionCheckoutCart: CreateOutsideContributionCheckoutCartResult
  /** Create a linked account */
  createPlaidLinkedAccount: Maybe<LinkedAccount>
  /** Create a Prospect User */
  createProspectUser: CreateProspectUserResult
  createReferralCampaign: CreateReferralCampaignResult
  createReferralCampaignReward: CreateReferralCampaignRewardResult
  createReferralPayout: CreateReferralPayoutResult
  /** @implicit(userId: ID!) */
  createReferralRelationship: CreateReferralRelationshipResult
  createSavingsAccount: CreateSavingsAccountResult
  /** (Internal-only) Provision a new subscription migration. */
  createSubscriptionMigration: CreateSubscriptionMigrationResult
  /** @deprecated Replaced with createSupportTicketOrException mutation. */
  createSupportTicket: Maybe<SupportTicket>
  createSupportTicketOrException: Maybe<SupportTicketResponse>
  createSupportTicketWithCustomFields: Maybe<SupportTicketWithCustomFieldsResponse>
  createSuspendedUserSupportTicket: Maybe<SupportTicketWithCustomFieldsResponse>
  /** Create a presigned post for direct to s3 file upload */
  createUploadUrl: CreateUploadUrlResult
  createUser: Maybe<Session>
  /** Creates a new user and user profile */
  createUserProfile: CreateUserProfileResult
  /** Create a billing vendor invoice */
  createVendorInvoice: Maybe<CreateVendorInvoiceResult>
  /** Create a new billing vendor line item */
  createVendorLineItem: Maybe<CreateVendorLineItemResult>
  /** Deactivates the specified account and returns the newley deactived account. */
  deactivateAccount: Maybe<Account>
  /** Deactivate a beneficiary that is no longer used */
  deactivateBeneficiary: DeactivateBeneficiaryResult
  /** Deactivate a user's subscription */
  deactivateTierSubscription: DeactivateTierSubscriptionResult
  deleteExpiredBankCardOrder: Maybe<DeleteExpiredBankCardOrderResult>
  /** Deletes a trusted contact for a user */
  deleteTrustedContact: DeleteTrustedContactResult
  /** Deregister and Authenticator. */
  deregisterAuthenticator: DeregisterAuthenticatorResult
  destroySession: Maybe<Scalars['Void']>
  /** @implicit(userId: ID!) */
  dismissMessage: UpdateMessageResult
  /** @implicit(userId: ID!) */
  dismissMessages: DismissMessagesResult
  /** Edit a trusted contact for a user */
  editTrustedContact: UpdateTrustedContactResult
  /** Enable quarterly investment account recaps for an investment account. */
  enableQuarterlyRecaps: EnableQuarterlyRecapsResult
  /** Explicitly end the chat session. */
  endChatSession: EndChatSessionResponse
  exchangeAcornsEarlyToken: ExchangeAcornsEarlyTokenResult
  /** Expire a promotional waiver */
  expirePromotionalWaiver: Maybe<ExpirePromotionalWaiverResult>
  /** Mark an open billing vendor invoice as failed */
  failVendorInvoice: Maybe<FailVendorInvoiceResult>
  /** Record an action feed event */
  feedEvent: Maybe<ActionFeedEventResponse>
  /** Generate a link token for layer account linking */
  generateLayerLinkSession: GenerateLayerLinkSessionResult
  /** Generate a Link Token and return either the Link Token of Link URL for use with Account Linking. */
  generateLinkSession: LinkSessionResult
  /** @implicit(userId: ID!) */
  generateReferralCode: GenerateReferralCodeResult
  /** @implicit(userId: ID!) */
  hideMessage: UpdateMessageResult
  /** @implicit(userId: ID!) */
  hideMessageByExternalId: UpdateMessageResult
  initiateBankingKYC: InitiateBankingKycPayload
  /** Initiate challenge following credentials validation. */
  initiateChallenge: InitiateChallengeResult
  /** Initiate registration of an EmailAuthenticator. */
  initiateEmailChallenge: InitiateEmailChallengeResult
  initiateLaterProgramAccountContribution: Maybe<LaterProgramAccountContributionResult>
  /** Gives the customer the ability to immediately start the allocation of a pending Money Assignment */
  initiateMoneyAssignment: Maybe<InitiateMoneyAssignmentResult>
  /** @implicit(userId: ID!) */
  initiatePartnerDataShare: PartnerDataShareResponse
  /** Initiate sending push notifications to registered PushAuthenticator(s). */
  initiatePushChallenge: InitiatePushChallengeResult
  /** Initiate registration of a PhoneAuthenticator. */
  initiateSMSChallenge: InitiateSmsChallengeResult
  initiateTransfer: Maybe<InitiateTransferPayload>
  /** @implicit(userId: ID!) */
  initiateVerification: InitiateVerificationResult
  laterCreateIndividualBeneficiary: Maybe<LaterIndividualBeneficiaryResponse>
  laterTotalLiquidation: Maybe<Scalars['Void']>
  /** Make a withdrawal from a later account One of either earlyDistributionTaxExceptionReason or reason is required; reason is newer/preferred withdrawalType is no longer supported, since it can be derived */
  laterWithdrawal: Maybe<Scalars['Void']>
  /** Legacy document upload */
  legacyUploadDocument: LegacyUploadDocumentResult
  linkACHAccount: Maybe<Scalars['Void']>
  /** Link a funding source via account and routing number */
  linkManualFundingSource: LinkManualFundingSourceResult
  /** Link OIDC credentials to an existing account */
  linkOidcCredentials: LinkOidcCredentialsResult
  lockBankCard: Maybe<LockBankCardPayload>
  /** @implicit(userId: ID!) */
  logout: LogoutResult
  /** @implicit(userId: ID!) */
  logoutDevice: LogoutDeviceResult
  makeInvestment: MakeInvestmentPayload
  managePayoutRelationship: PayoutRelationshipResult
  /** @implicit(userId: ID!) */
  markAllAsRead: MarkAllAsReadResult
  /** Marks content with given ID as helpful and returns ID and helpful flag or error if it does not exist */
  markLearnContentAsHelpful: MarkLearnContentAsHelpfulResult
  /** Saves content as viewed and returns id and date when it is viewed or error if content does not exist */
  markLearnContentAsViewed: MarkLearnContentAsViewedResult
  /** Gives the customer the ability update the assignment target amounts for a pending Money Assignment */
  modifyMoneyAssignment: ModifyMoneyAssignmentResult
  /** Open a Core InvestmentAccount */
  openCoreInvestmentAccount: OpenCoreInvestmentAccountResult
  /** Create an Acorns Early Account */
  openEarlyAccount: OpenEarlyAccountResult
  orderBankCard: Maybe<OrderBankCardResult>
  /** @implicit(userId: String!) */
  postBankFeeNegotiation: BenefitsMessage
  /** @implicit(userId: String!) */
  postUserReportedBankFeeRefund: BenefitsMessage
  /** Rate a message where canRate is true. */
  rateChatMessage: RateChatMessageResponse
  /** @implicit(userId: String!) */
  rateFinancialAdvisorResponse: InteractionRatingResponse
  /** @implicit(userId: ID!) */
  readMessage: UpdateMessageResult
  /** Record view_at timestamp on investment account recap. */
  recordInvestmentAccountRecapView: RecordInvestmentAccountRecapViewResult
  /** Record an Action or Event from Friend */
  recordReferralEvent: RecordReferralEventResult
  /** Record an external payment for manual billing vendor invoices */
  recordVendorExternalTransaction: Maybe<RecordVendorExternalTransactionResult>
  redeemGiftcard: Maybe<Scalars['Void']>
  refreshAuthToken: RefreshAuthTokenResult
  /** @deprecated Implicit cookie auth no longer supported. */
  refreshCookie: Maybe<Scalars['Void']>
  /** Regenerate public token for an investment account recap. */
  regenerateInvestmentAccountRecapPublicToken: RegenerateInvestmentAccountRecapPublicTokenResult
  registerCredentials: RegisterCredentialsResult
  /** Register a PushAuthenticator and SNS device token. */
  registerDeviceTokenAndPushAuthenticator: RegisterDeviceTokenAndPushAuthenticatorResult
  /** Register an EmailAuthenticator. */
  registerEmailAuthenticator: RegisterEmailAuthenticatorResult
  /** Registers linked subaccount after beginning the link session */
  registerLayerLinkSession: RegisterLayerLinkSessionResult
  /** Save a linked account */
  registerLinkSession: Maybe<RegisterLinkSessionResult>
  /** Register OIDC credentials */
  registerOidcCredentials: RegisterOidcCredentialsResult
  /** Register a PhoneAuthenticator. */
  registerPhoneAuthenticator: RegisterPhoneAuthenticatorResult
  /** Registers a prospect user with associated source attributes */
  registerProspect: RegisterProspectResult
  /** Re-initiate registration of an Authenticator. */
  reinitiateChallenge: ReinitiateSmsChallengeResult
  reissueBankCard: Maybe<ReissueBankCardResult>
  /** @implicit(userId: ID!) */
  removeCohortEligibility: RemoveCohortEligibilityResult
  /** @implicit(userId: String!) */
  removeFavoritePartnerOffers: FavoritePartnerOfferGroup
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  removeJobAlert: Maybe<RemoveJobAlertResult>
  /** Removes a security from a portfolio */
  removeSecurityFromPortfolio: RemoveSecurityFromPortfolioResult
  /** Start the process for removing a self directed portfolio from an investment account */
  removeSelfDirectedPortfolio: RemoveSelfDirectedPortfolioResult
  /** Reopen a closed Acorns user account */
  reopenUserAccount: ReopenUserAccountResult
  reportBankCardLostStolen: Maybe<ReportBankCardLostStolenPayload>
  requestAccountClosure: Maybe<Scalars['Void']>
  /** Attempts to close a single or multiple Early investment accounts */
  requestEarlyAccountClosure: RequestEarlyAccountClosureResult[]
  /** Attempts to reopen an investment account. */
  requestInvestmentAccountReopen: RequestInvestmentAccountReopenResult
  /** Requests start of layer session for user-permissioned information */
  requestLayerSession: RequestLayerSessionResult
  /** Request to be waived from being migrated to a new Subscription. */
  requestSubscriptionMigrationWaiver: RequestSubscriptionMigrationWaiverResult
  /** Resends an already sent chat message. For use when the bot does not respond in a reasonable timeframe */
  resendChatMessage: ResendChatMessageResponse
  resetPIN: Maybe<Scalars['Void']>
  resetPassword: Maybe<Scalars['Void']>
  /** Resets a password if the password reset token exists (legacy Backend flow) */
  resetPasswordByToken: ResetPasswordByTokenResult
  /** Resets a password if the password reset token exists (updated flow through web app) */
  resetPasswordWithToken: ResetPasswordWithTokenResult
  /** Saves poll respond and returns stats for related poll or error if poll does not exists */
  respondToLearnPoll: RespondToLearnPollResult
  /** Restore user login access */
  restoreLoginAccess: RestoreLoginAccessResult
  /** Retriggers RDVs for the user. */
  retriggerRdvs: RetriggerRdvsResult
  revokeLoginAccess: RevokeLoginAccessResult
  /** Revokes given reset password token */
  revokePasswordResetToken: RevokePasswordResetTokenResult
  /** Update a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>
  /** Save upload url after direct s3 upload and create upload record */
  saveUploadUrl: LegacyUploadDocumentResult
  /** Save uploads url after direct s3 upload and create upload record one by one */
  saveUploadUrls: SaveUploadUrlsResult
  /** @implicit(userId: ID!) */
  scheduleRecurringTransfer: Maybe<ScheduleRecurringTransferResult>
  sendBrazeEvent: Scalars['String']
  /** Send a chat message as a user to the bot. The bot will respond asynchronously on the subscription for the user's session. */
  sendChatMessage: SendChatMessageResponse
  sendCheckPayment: Maybe<SendCheckPaymentResult>
  /**
   * Send a referral event to Extole. User ID is a required field on the input type,
   * but is not a field level argument as this mutation is only used internally
   */
  sendReferralEvent: Maybe<Scalars['Boolean']>
  sessionRefresh: Maybe<Session>
  /** @implicit(userId: ID!) */
  setAuthenticationPIN: SetAuthenticationPinResult
  /** Update a beneficiary's SSN/TIN */
  setBeneficiarySsn: SetBeneficiarySsnResult
  /** @implicit(userId: ID!) */
  setDefaultAuthenticator: SetDefaultAuthenticatorResult
  /** @implicit(userId: String!) */
  setFavoritePartnerOffers: FavoritePartnerOfferGroup
  /** Set a given investment account recap's public access. */
  setInvestmentAccountRecapPublicAccess: SetInvestmentAccountRecapPublicAccessResult
  /** Updates a plaid account with a new linking error code. Returns the updated linked account. */
  setLinkingError: Maybe<LinkedAccount>
  /** Set the manual flag to true on a round up */
  setManualRoundUps: RoundUp[]
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.updateNegotiationStatus instead
   */
  setNegotiationStatus: SetNegotiationStatusResult
  setPortfolio: User
  /** Set a funding source as preferred withdrawal account */
  setPreferredWithdrawalAccount: SetPreferredWithdrawalAccountResult
  setReferralCampaignFlags: SetReferralCampaignFlagsResult
  /** @implicit(userId: String!) */
  setUserPartnerStatus: UserPartnerStatusResponse
  splitDeposit: SplitDepositMutation
  splitDepositSettings: SplitDepositSettingsMutation
  /** Add a direct deposit employer */
  startAcornsPdfSwitch: Maybe<Scalars['Boolean']>
  /** Start a chat session with the bot */
  startChatSession: StartChatSessionResponse
  startCheckDeposit: Maybe<StartCheckDepositPayload>
  /** Persists a user intention of perform an online switch. */
  startOnlineSwitch: StartOnlineSwitchPayload
  /** Submits a direct deposit switch via ClickSwitch */
  startSubmittableSwitch: Maybe<StartSubmittableSwitchPayload>
  /** @deprecated Use cancelRecurringTransfer instead. */
  stopRecurringInvestment: RecurringInvestmentPayload
  stub: Maybe<Scalars['String']>
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitBankFeeNegotiation: SubmitBankFeeNegotiationResult
  /** Submit Earn missing credit request */
  submitEarnMissingCreditRequest: SubmitEarnMissingCreditRequestResult
  submitRDVs: Scalars['Boolean']
  submitSpendTransactionsDispute: SpendTransactionsDisputeResult
  /**
   * @implicit(userId: String!)
   * @deprecated Use mutation.postUserReportedBankFeeRefund instead
   */
  submitUserReportedBankFeeRefund: SubmitUserReportedBankFeeRefundResult
  /** Eventually will replace the current 'subscribeUserToTier' mutation */
  subscribeToTier: SubscribeToTierResult
  /**
   * Attempt to subscribe a user to a specific Tier + TierPrice
   * Reliant on some synchronous calls to service (for statuses)
   */
  subscribeUserToTier: SubscribeUserToTierResult
  /**
   * Subscribes a user to the cheapest default tier based on their current open accounts
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByOpenAccounts: TierSubscription
  /**
   * Subscribes a user to the cheapest default tier available with provided productKey
   * @deprecated Will be removed soon in-favor-of the more generic Mutation.subscribeUserToTier.
   */
  subscribeUserToTierByProductKey: TierSubscription
  /** Mark an open billing vendor invoice as successful */
  succeedVendorInvoice: Maybe<SucceedVendorInvoiceResult>
  /** @deprecated Use Mutation.suspendUserDeposits or Mutation.unsuspendUserDeposits instead */
  suspendDeposits: Maybe<Scalars['Void']>
  /** Suspend user deposits */
  suspendUserDeposits: Scalars['Void']
  /** @implicit(userId: String!) */
  syncBankFeeTransactions: SyncBankFeeTransactionsResult
  /** Syncs a user's current primary funding source to vendor */
  syncFundingSourceToVendor: Maybe<SyncFundingSourceToVendorResult>
  /** Returns the tax withholding amounts for state and federal */
  taxWithholdingAmounts: Maybe<TaxWithholdingAmounts>
  /** Unauthenticated mutation for creating a presigned post for direct to s3 file upload */
  unauthenticatedCreateUploadUrl: CreateUploadUrlResult
  /** Unauthenticated mutation for saving upload url after direct s3 upload and create upload record */
  unauthenticatedSaveUploadUrl: UnauthenticatedSaveUploadUrlResult
  /** @implicit(userId: ID!) */
  unblockDevice: UnblockDeviceResult
  /** Unlink account and all attached subaccounts */
  unlinkLinkedAccount: Maybe<LinkedAccount>
  unlockBankCard: Maybe<UnlockBankCardPayload>
  /** Removes content with given ID from helpful section and returns ID and helpful flag or error if it does not exist */
  unmarkLearnContentAsHelpful: UnmarkLearnContentAsHelpfulResult
  /** Unsubscribes a user to from their current tier */
  unsubscribeUserFromTier: UnsubscribeUserFromTierResult
  /** Unsuspend user deposits */
  unsuspendUserDeposits: Scalars['Void']
  /** Updates Account Portfolio */
  updateAccountPortfolio: UpdateAccountPortfolioResponse
  /** Update a single address for a user */
  updateAddress: Maybe<Address>
  /** Updates source attribution data for a user */
  updateAttribution: UpdateAttributionResult
  /** @implicit(userId: ID!) */
  updateAuthEmail: UpdateAuthEmailResult
  /** @implicit(userId: ID!) */
  updateAuthPhoneNumber: UpdateAuthPhoneNumberResult
  updateBankAccountGoal: UpdateBankAccountGoalResult
  updateBankCardPin: Maybe<UpdateBankCardPinPayload>
  updateBanners: Maybe<Array<Maybe<BannersResponse>>>
  /** Update a beneficiary's basic info */
  updateBeneficiaryInfo: UpdateBeneficiaryInfoResult
  /** @implicit(userId: String!) */
  updateBenefitStatus: UpdateBenefitStatusResponse
  updateContactInfo: Maybe<User>
  /** @implicit(userId: ID!) */
  updateCredentials: UpdateCredentialsResult
  /** @implicit(userId: ID!) */
  updateCustomerMoneyRules: Maybe<MoneyRulesUpdateCustomerMoneyRulesResult>
  /** Updates elapsed time, the time the user spent in the quiz. */
  updateElapsedTimeForLearnQuiz: UpdateElapsedTimeForLearnQuizResult
  updateEmail: Maybe<User>
  updateEmployment: Maybe<User>
  /** @deprecated Replaced with updateBanners mutation. */
  updateHelpcenterBanner: Maybe<HelpcenterBannerResponse>
  updateInvestorQuestions: Maybe<User>
  updateLadderQuote: Maybe<LadderResponse>
  /** Updates progress for related content and returns id and progress for that content or error if related content does not exist */
  updateLearnContentProgress: UpdateLearnProgressResult
  /** Updates a plaid account with a new link session id. To be used after re-authenticating a linked account */
  updateLinkedAccount: Maybe<LinkedAccount>
  /** Update money manager allocations */
  updateMoneyManagerAllocations: UpdateMoneyManagerAllocationsResult
  /** Sets a money manager automation target. */
  updateMoneyManagerAutomationTarget: UpdateMoneyManagerAutomationTargetResult
  /** Update the money manager settings for a customer */
  updateMoneyManagerSettings: UpdateMoneyManagerSettingsResult
  /**
   * Update the money rules source settings for a customer
   * @deprecated Use updateMoneyManagerSettings instead
   */
  updateMoneyRulesSourceSettings: Maybe<UpdateMoneyRulesSourceSettingsResult>
  /** @implicit(userId: String!) */
  updateNegotiationStatus: BenefitsMessage
  updateNotification: Maybe<Scalars['Void']>
  /** Returns the user profile with the updated optedOutOfTargeting field */
  updateOptOutOfTargeting: Maybe<Profile>
  /** Updates user profile information */
  updatePersonalInfo: Maybe<User>
  /** Update the securities and target allocation percentages of the portfolio */
  updatePortfolioSecurities: UpdatePortfolioSecuritiesResult
  /** Update a single profile for a user */
  updateProfile: Maybe<Profile>
  /** Update the JSON configuration file associated with promoted brands */
  updatePromotedCampaigns: Maybe<UpdatePromotedCampaignsResult>
  /** @deprecated Use scheduleRecurringTransfer instead. */
  updateRecurringInvestment: RecurringInvestmentPayload
  updateReferralCampaign: UpdateReferralCampaignResult
  updateReferralPayout: UpdateReferralPayoutResult
  /** Mutation to update referral relationship status */
  updateReferralRelationship: UpdateReferralRelationshipResult
  /**
   * Update a Referral Reward as Rewarded or Cancelled.
   * Returns UpdateReferralRewardError if given rewardId is not found
   */
  updateReferralRewardStatus: UpdateReferralRewardResponse
  /** @implicit(userId: ID) */
  updateReferralUserProfile: Maybe<Scalars['ID']>
  /** Updates a registration record */
  updateRegistration: Result
  /** Update a single Round Up Account for a given ID */
  updateRoundUpAccount: Maybe<RoundUpAccount>
  /** Update a certificate or card signature for a user */
  updateSignature: Maybe<Signature>
  /** Update a user's suitability */
  updateSuitability: Maybe<Suitability_UpdateSuitabilityResult>
  /** Mutation to update user profile and automation target. */
  updateUserProfileAndAutomationTarget: UpdateUserProfileAndAutomationTargetResult
  /**
   * Update the user switch state in the Direct Deposit Database using the
   * switchState Enum. This switch state provides us insight into the status of a
   * user in the PDF DD flow.
   */
  updateUserSwitchState: UpdateUserSwitchState
  /** @implicit(userId: ID!) */
  updateVerificationProfile: UpdateVerificationProfileResult
  /** Upgrade to JWT authentication */
  upgradeAuthentication: UpgradeAuthenticationResult
  uploadAudienceList: Scalars['String']
  uploadCheck: Maybe<UploadCheckPayload>
  uploadDocuments: FileOrException[]
  uploadUnsolicitedDocuments: FileOrException[]
  /** Create or update a User Match Record */
  upsertUserMatch: UpsertUserMatchResult
  /** Request an MFA token for the provided credentials. */
  validateCredentials: ValidateCredentialsResult
  /** Validates and compares a face liveness session via AWS Rekognition with an ID image uploaded to S3 */
  validateFaceLivenessSession: ValidateFaceLivenessSessionResult
  /** Validate a user suspended upload token */
  validateUserSuspendedUploadToken: ValidateUserSuspendedUploadTokenResult
  vendAuthSession: VendAuthSessionResult
  verifyDevice: VerifyDeviceResult
  /** @implicit(userId: ID!) */
  verifyIdentityByDocuments: VerifyIdentityByDocumentsResult
  /** Verify and create a later account */
  verifyLaterAccountOrError: LaterAccountInfoOrError
  /** @implicit(userId: ID!) */
  verifyPasswords: VerifyPasswordsResult
  /** Verify a user's manually linked funding source with RDVs */
  verifyRdvs: VerifyRdvsResult
}

export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput
}

export type MutationActivateBankCardArgs = {
  input: ActivateBankCardInput
}

export type MutationAddCohortEligibilityArgs = {
  input: AddCohortEligibilityInput
}

export type MutationAddFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationAddSearchTermToLearnSearchHistoryArgs = {
  input: AddSearchTermToLearnSearchHistoryInput
}

export type MutationAddSecurityToPortfolioArgs = {
  input: AddSecurityToPortfolioInput
}

export type MutationAddSelfDirectedPortfolioArgs = {
  input: AddSelfDirectedPortfolioInput
}

export type MutationAddTrustedContactArgs = {
  input: TrustedContactInput
}

export type MutationAgreeToAcceptanceDocumentArgs = {
  id: Scalars['ID']
}

export type MutationAnswerChallengeArgs = {
  input: ChallengeAnswerInput
}

export type MutationAnswerLearnQuizQuestionArgs = {
  input: AnswerLearnQuizQuestionInput
}

export type MutationApplyPromotionArgs = {
  input: ApplyPromotionInput
}

export type MutationApplyPromotionalWaiverArgs = {
  input: ApplyPromotionalWaiverInput
}

export type MutationApplyProvisionalWaiverArgs = {
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Scalars['String']
}

export type MutationAskFinancialAdvisorQuestionArgs = {
  question: Scalars['String']
  sessionId: Scalars['String']
}

export type MutationAssignLinkedSubaccountArgs = {
  input: AssignLinkedSubaccountInput
  linkedSubaccountId: Scalars['ID']
}

export type MutationAuthenticateArgs = {
  alternateAuthenticatorId?: InputMaybe<Scalars['ID']>
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>
  input: AuthenticateInput
}

export type MutationAuthenticateForFeeNegotiationArgs = {
  input: AuthenticateForFeeNegotiationInput
}

export type MutationAuthenticateForFeeNegotiationChallengeArgs = {
  input: AuthenticateForFeeNegotiationChallengeInput
}

export type MutationAuthenticateForFeeNegotiationChallengeMethodArgs = {
  input: AuthenticateForFeeNegotiationChallengeMethodInput
}

export type MutationBatchAddTierSubscriptionsArgs = {
  input: BatchAddTierSubscriptionsInput
}

export type MutationBlockDeviceArgs = {
  input: BlockDeviceInput
}

export type MutationCancelCheckPaymentArgs = {
  id: Scalars['ID']
}

export type MutationCancelIntentArgs = {
  nonce: Scalars['UUID']
}

export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput
}

export type MutationCancelInvestmentAccountClosureRequestArgs = {
  input: CancelInvestmentAccountClosureRequestInput
}

export type MutationCancelMoneyAssignmentArgs = {
  input: CancelMoneyAssignmentInput
}

export type MutationCancelRecurringTransferArgs = {
  id: Scalars['ID']
}

export type MutationCancelTransferArgs = {
  accountId: Scalars['ID']
  id: Scalars['ID']
}

export type MutationChangeOutsideContributionAmountArgs = {
  input: ChangeOutsideContributionAmountInput
}

export type MutationChangePinArgs = {
  answer: Scalars['String']
  newPIN: Scalars['String']
  oldPIN: Scalars['String']
  questionId: Scalars['String']
}

export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
  securityAnswer?: InputMaybe<SecurityAnswer>
}

export type MutationChangePasswordAuthArgs = {
  input: ChangePasswordInput
}

export type MutationCloseBankAccountArgs = {
  input: CloseBankAccountInput
}

export type MutationCloseInvestmentAccountArgs = {
  input: CloseInvestmentAccountInput
}

export type MutationCompleteCheckDepositArgs = {
  input: CompleteCheckDepositInput
}

export type MutationConfigureSplitDepositDirectDepositIntentSettingArgs = {
  input: ConfigureSplitDepositDirectDepositIntentSettingInput
}

export type MutationConfigureSplitDepositDirectDepositSettingArgs = {
  input: ConfigureSplitDepositDirectDepositSettingInput
}

export type MutationConnectAchAccountArgs = {
  input: ConnectAchAccountInput
}

export type MutationConnectLadderCustomerArgs = {
  quoteId: Scalars['ID']
}

export type MutationConsumeUserTokenArgs = {
  userTokenId: Scalars['ID']
}

export type MutationCreateAuthProfileArgs = {
  input?: InputMaybe<CreateAuthProfileInput>
}

export type MutationCreateAuthenticatedSupportTicketArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput
}

export type MutationCreateBeneficiaryArgs = {
  input: BeneficiaryInput
}

export type MutationCreateDirectDepositLinkInfoArgs = {
  input: CreateDirectDepositLinkInfoInput
}

export type MutationCreateDocumentUploadArgs = {
  input: CreateDocumentUploadInput
}

export type MutationCreateIraWithProfileArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>
  profileAttributes: Array<InputMaybe<ProfileAttribute>>
}

export type MutationCreateIntentArgs = {
  input: CreateIntentInput
}

export type MutationCreateInvestingStrategyRecommendationArgs = {
  input: CreateInvestingStrategyRecommendationInput
}

export type MutationCreateInvestmentAccountArgs = {
  iraType?: InputMaybe<InvestmentAccountTypes>
  portfolioId?: InputMaybe<Scalars['String']>
}

export type MutationCreateJobAlertArgs = {
  alertCriteria: JobAlertCriteriaInput
}

export type MutationCreateLadderQuoteArgs = {
  address: Scalars['String']
  age: Scalars['Int']
  city: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phone: Scalars['String']
  state: StateCode
  zip: Scalars['String']
}

export type MutationCreateLaterContributionArgs = {
  accountId: Scalars['ID']
  amount: Scalars['Float']
  year?: InputMaybe<Scalars['Int']>
}

export type MutationCreateOfferArgs = {
  input: CreateOfferInput
}

export type MutationCreateOutsideContributionArgs = {
  input: CreateOutsideContributionInput
}

export type MutationCreateOutsideContributionCheckoutCartArgs = {
  input: CreateOutsideContributionCheckoutCartInput
}

export type MutationCreatePlaidLinkedAccountArgs = {
  input: CreatePlaidLinkedAccountInput
  publicToken: Scalars['String']
}

export type MutationCreateProspectUserArgs = {
  input: CreateProspectUserInput
}

export type MutationCreateReferralCampaignArgs = {
  input: CreateReferralCampaignInput
}

export type MutationCreateReferralCampaignRewardArgs = {
  input: CreateReferralCampaignRewardInput
}

export type MutationCreateReferralPayoutArgs = {
  input: CreateReferralPayoutInput
}

export type MutationCreateReferralRelationshipArgs = {
  referralCode: Scalars['String']
}

export type MutationCreateSavingsAccountArgs = {
  input: CreateSavingsAccountInput
}

export type MutationCreateSubscriptionMigrationArgs = {
  input: CreateSubscriptionMigrationInput
}

export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateSupportTicketOrExceptionArgs = {
  input: CreateSupportTicketInput
}

export type MutationCreateSupportTicketWithCustomFieldsArgs = {
  input: CreateCustomSupportTicketInput
}

export type MutationCreateSuspendedUserSupportTicketArgs = {
  input: CreateSuspendedUserSupportTicketInput
}

export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput
}

export type MutationCreateVendorInvoiceArgs = {
  input: CreateVendorInvoiceInput
}

export type MutationCreateVendorLineItemArgs = {
  input: CreateVendorLineItemInput
}

export type MutationDeactivateAccountArgs = {
  accountId: Scalars['ID']
}

export type MutationDeactivateBeneficiaryArgs = {
  id: Scalars['ID']
}

export type MutationDeactivateTierSubscriptionArgs = {
  input: DeactivateTierSubscriptionInput
}

export type MutationDeleteTrustedContactArgs = {
  id: Scalars['ID']
}

export type MutationDeregisterAuthenticatorArgs = {
  input: DeregisterAuthenticatorInput
}

export type MutationDismissMessageArgs = {
  input: DismissMessageInput
}

export type MutationDismissMessagesArgs = {
  input: DismissMessagesInput
}

export type MutationEditTrustedContactArgs = {
  id: Scalars['ID']
  input: TrustedContactInput
}

export type MutationEnableQuarterlyRecapsArgs = {
  input: EnableQuarterlyRecapsInput
}

export type MutationEndChatSessionArgs = {
  sessionId: Scalars['ID']
}

export type MutationExchangeAcornsEarlyTokenArgs = {
  token: Scalars['String']
}

export type MutationExpirePromotionalWaiverArgs = {
  input: ExpirePromotionalWaiverInput
}

export type MutationFailVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

export type MutationFeedEventArgs = {
  feedEvent: ActionFeedEvent
}

export type MutationGenerateLayerLinkSessionArgs = {
  input: GenerateLayerLinkSessionInput
}

export type MutationGenerateLinkSessionArgs = {
  input: GenerateLinkSessionInput
  userId?: InputMaybe<Scalars['ID']>
}

export type MutationHideMessageArgs = {
  input: HideMessageInput
}

export type MutationHideMessageByExternalIdArgs = {
  input: HideMessageByExternalIdInput
}

export type MutationInitiateBankingKycArgs = {
  input: InitiateBankingKycInput
}

export type MutationInitiateChallengeArgs = {
  input: InitiateChallengeInput
}

export type MutationInitiateEmailChallengeArgs = {
  input: InitiateEmailChallengeInput
}

export type MutationInitiateLaterProgramAccountContributionArgs = {
  input: LaterProgramAccountContributionInput
}

export type MutationInitiateMoneyAssignmentArgs = {
  input: InitiateMoneyAssignmentInput
}

export type MutationInitiatePartnerDataShareArgs = {
  input: PartnerDataShareInput
}

export type MutationInitiateSmsChallengeArgs = {
  input: InitiateSmsChallengeInput
}

export type MutationInitiateTransferArgs = {
  input: InitiateTransferInput
}

export type MutationLaterCreateIndividualBeneficiaryArgs = {
  accountId: Scalars['ID']
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  birthDate: Scalars['DateTime']
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  percentageShare?: InputMaybe<Scalars['Float']>
  relationship?: InputMaybe<Scalars['String']>
  ssn?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type MutationLaterTotalLiquidationArgs = {
  input?: InputMaybe<LaterTotalLiquidationInput>
  investmentAccountId: Scalars['ID']
}

export type MutationLaterWithdrawalArgs = {
  amount: Scalars['Float']
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: InputMaybe<LaterWithdrawalType>
}

export type MutationLegacyUploadDocumentArgs = {
  input: LegacyUploadDocumentInput
}

export type MutationLinkAchAccountArgs = {
  account: Scalars['String']
  routing: Scalars['String']
}

export type MutationLinkManualFundingSourceArgs = {
  input: LinkManualFundingSourceInput
}

export type MutationLinkOidcCredentialsArgs = {
  input: LinkOidcCredentialsInput
}

export type MutationLockBankCardArgs = {
  input: LockBankCardInput
}

export type MutationLogoutDeviceArgs = {
  input: LogoutDeviceInput
}

export type MutationMakeInvestmentArgs = {
  input: MakeInvestmentInput
}

export type MutationManagePayoutRelationshipArgs = {
  input: ManagePayoutRelationshipInput
}

export type MutationMarkLearnContentAsHelpfulArgs = {
  input: MarkLearnContentAsHelpfulInput
}

export type MutationMarkLearnContentAsViewedArgs = {
  input: MarkLearnContentAsViewedInput
}

export type MutationModifyMoneyAssignmentArgs = {
  input: ModifyMoneyAssignmentInput
}

export type MutationOpenCoreInvestmentAccountArgs = {
  input: OpenCoreInvestmentAccountInput
}

export type MutationOpenEarlyAccountArgs = {
  input: OpenEarlyAccountInput
}

export type MutationOrderBankCardArgs = {
  input: OrderBankCardInput
}

export type MutationPostBankFeeNegotiationArgs = {
  linkedAccountId: Scalars['String']
}

export type MutationPostUserReportedBankFeeRefundArgs = {
  submissionId: Scalars['String']
  totalRefunds: Scalars['Float']
}

export type MutationRateChatMessageArgs = {
  feedbackInput?: InputMaybe<MessageFeedbackInput>
  messageId: Scalars['ID']
  rating?: InputMaybe<Scalars['Int']>
}

export type MutationRateFinancialAdvisorResponseArgs = {
  interactionId: Scalars['String']
  rating: Scalars['Int']
}

export type MutationReadMessageArgs = {
  input: ReadMessageInput
}

export type MutationRecordInvestmentAccountRecapViewArgs = {
  input: RecordInvestmentAccountRecapViewInput
}

export type MutationRecordReferralEventArgs = {
  input: RecordReferralEventInput
}

export type MutationRecordVendorExternalTransactionArgs = {
  input: RecordVendorExternalTransactionInput
  invoiceId: Scalars['ID']
}

export type MutationRedeemGiftcardArgs = {
  pin: Scalars['String']
}

export type MutationRefreshAuthTokenArgs = {
  input: RefreshAuthTokenInput
}

export type MutationRegenerateInvestmentAccountRecapPublicTokenArgs = {
  input: RegenerateInvestmentAccountRecapPublicTokenInput
}

export type MutationRegisterCredentialsArgs = {
  input: RegisterCredentialsInput
}

export type MutationRegisterDeviceTokenAndPushAuthenticatorArgs = {
  input: RegisterDeviceTokenAndPushAuthenticatorInput
}

export type MutationRegisterEmailAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput
  input: RegisterEmailAuthenticatorInput
}

export type MutationRegisterLayerLinkSessionArgs = {
  input: LayerLinkSessionInput
}

export type MutationRegisterLinkSessionArgs = {
  input: LinkSessionInput
}

export type MutationRegisterOidcCredentialsArgs = {
  input: RegisterOidcCredentialsInput
}

export type MutationRegisterPhoneAuthenticatorArgs = {
  challengeAnswerInput: ChallengeAnswerInput
  input: RegisterPhoneAuthenticatorInput
}

export type MutationRegisterProspectArgs = {
  input: RegisterProspectInput
}

export type MutationReinitiateChallengeArgs = {
  input: ReinitiateSmsChallengeInput
}

export type MutationReissueBankCardArgs = {
  input: ReissueBankCardInput
}

export type MutationRemoveCohortEligibilityArgs = {
  input: RemoveCohortEligibilityInput
}

export type MutationRemoveFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationRemoveJobAlertArgs = {
  id: Scalars['String']
}

export type MutationRemoveSecurityFromPortfolioArgs = {
  input: RemoveSecurityFromPortfolioInput
}

export type MutationRemoveSelfDirectedPortfolioArgs = {
  input: RemoveSelfDirectedPortfolioInput
}

export type MutationReportBankCardLostStolenArgs = {
  input: ReportBankCardLostStolenInput
}

export type MutationRequestAccountClosureArgs = {
  input: RequestAccountClosureInput
}

export type MutationRequestEarlyAccountClosureArgs = {
  input: RequestEarlyAccountClosureInput
}

export type MutationRequestInvestmentAccountReopenArgs = {
  input: RequestInvestmentAccountReopenInput
}

export type MutationRequestLayerSessionArgs = {
  input: RequestLayerSessionInput
}

export type MutationRequestSubscriptionMigrationWaiverArgs = {
  input: RequestSubscriptionMigrationWaiverInput
}

export type MutationResendChatMessageArgs = {
  messageId: Scalars['ID']
  sessionId: Scalars['ID']
}

export type MutationResetPinArgs = {
  email: Scalars['String']
}

export type MutationResetPasswordArgs = {
  email: Scalars['String']
}

export type MutationResetPasswordByTokenArgs = {
  input: ResetPasswordByTokenInput
}

export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput
}

export type MutationRespondToLearnPollArgs = {
  input: RespondToLearnPollInput
}

export type MutationRestoreLoginAccessArgs = {
  input: RestoreLoginAccessInput
}

export type MutationRevokeLoginAccessArgs = {
  input: RevokeLoginAccessInput
}

export type MutationRevokePasswordResetTokenArgs = {
  input: RevokePasswordResetTokenInput
}

export type MutationRoundUpProfileArgs = {
  input: RoundUpProfileInput
}

export type MutationSaveUploadUrlArgs = {
  input: SaveUploadUrlInput
}

export type MutationSaveUploadUrlsArgs = {
  input: SaveUploadUrlsInput
}

export type MutationScheduleRecurringTransferArgs = {
  input: ScheduleRecurringTransferInput
}

export type MutationSendBrazeEventArgs = {
  input: SendBrazeEventInput
}

export type MutationSendChatMessageArgs = {
  message: Scalars['String']
  sessionId: Scalars['ID']
}

export type MutationSendCheckPaymentArgs = {
  input: SendCheckPaymentInput
}

export type MutationSendReferralEventArgs = {
  input: ReferralEventInput
}

export type MutationSessionRefreshArgs = {
  longSession?: InputMaybe<Scalars['Boolean']>
  pin: Scalars['String']
}

export type MutationSetAuthenticationPinArgs = {
  input: SetAuthenticationPinInput
}

export type MutationSetBeneficiarySsnArgs = {
  id: Scalars['ID']
  ssn: Scalars['String']
}

export type MutationSetDefaultAuthenticatorArgs = {
  input: SetDefaultAuthenticatorInput
}

export type MutationSetFavoritePartnerOffersArgs = {
  input: FavoritePartnerOfferInput
}

export type MutationSetInvestmentAccountRecapPublicAccessArgs = {
  input: SetInvestmentAccountRecapPublicAccessInput
}

export type MutationSetLinkingErrorArgs = {
  linkedAccountId: Scalars['ID']
  linkingErrorCode: SetLinkingErrorInput
}

export type MutationSetManualRoundUpsArgs = {
  roundUpIds: Array<Scalars['ID']>
}

export type MutationSetNegotiationStatusArgs = {
  input: SetNegotiationStatusInput
}

export type MutationSetPortfolioArgs = {
  input: SetPortfolioInput
}

export type MutationSetPreferredWithdrawalAccountArgs = {
  input: SetPreferredWithdrawalAccountInput
}

export type MutationSetReferralCampaignFlagsArgs = {
  input: SetReferralCampaignFlagsInput
}

export type MutationSetUserPartnerStatusArgs = {
  input: PartnerStatusInput
}

export type MutationSplitDepositArgs = {
  id: Scalars['ID']
}

export type MutationSplitDepositSettingsArgs = {
  employerHidden?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
}

export type MutationStartAcornsPdfSwitchArgs = {
  input: StartAcornsPdfSwitchInput
}

export type MutationStartChatSessionArgs = {
  type?: InputMaybe<SessionType>
}

export type MutationStartCheckDepositArgs = {
  input: StartCheckDepositInput
}

export type MutationStartOnlineSwitchArgs = {
  input: StartOnlineSwitchInput
}

export type MutationStartSubmittableSwitchArgs = {
  input: StartSubmittableSwitchInput
}

export type MutationStopRecurringInvestmentArgs = {
  investmentAccountId?: InputMaybe<Scalars['String']>
}

export type MutationStubArgs = {
  id: Scalars['UUID']
}

export type MutationSubmitBankFeeNegotiationArgs = {
  input: SubmitBankFeeNegotiationInput
}

export type MutationSubmitEarnMissingCreditRequestArgs = {
  input: SubmitEarnMissingCreditRequestInput
}

export type MutationSubmitRdVsArgs = {
  deposits: Array<InputMaybe<Scalars['Float']>>
}

export type MutationSubmitSpendTransactionsDisputeArgs = {
  input: SubmitSpendTransactionsDisputeInput
}

export type MutationSubmitUserReportedBankFeeRefundArgs = {
  input: SubmitUserReportedBankFeeRefundInput
}

export type MutationSubscribeToTierArgs = {
  input: SubscribeToTierInput
}

export type MutationSubscribeUserToTierArgs = {
  input: SubscribeUserToTierInput
}

export type MutationSubscribeUserToTierByProductKeyArgs = {
  input?: InputMaybe<SubscribeUserToTierByProductKeyInput>
}

export type MutationSucceedVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

export type MutationSuspendDepositsArgs = {
  suspended: Scalars['Boolean']
}

export type MutationSyncBankFeeTransactionsArgs = {
  input: SyncBankFeeTransactionsInput
}

export type MutationTaxWithholdingAmountsArgs = {
  investmentId: Scalars['ID']
  totalSharesAmount: CurrencyAmountInput
}

export type MutationUnauthenticatedCreateUploadUrlArgs = {
  input: UnauthenticatedCreateUploadUrlInput
}

export type MutationUnauthenticatedSaveUploadUrlArgs = {
  input: UnauthenticatedSaveUploadUrlInput
}

export type MutationUnblockDeviceArgs = {
  input: UnblockDeviceInput
}

export type MutationUnlinkLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

export type MutationUnmarkLearnContentAsHelpfulArgs = {
  input: UnmarkLearnContentAsHelpfulInput
}

export type MutationUnsubscribeUserFromTierArgs = {
  input?: InputMaybe<UnsubscribeUserFromTierInput>
}

export type MutationUpdateAccountPortfolioArgs = {
  input: UpdateAccountPortfolioInput
}

export type MutationUpdateAddressArgs = {
  addressType: AddressType
  input: AddressInput
  ownerId?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateAttributionArgs = {
  input: UpdateAttributionInput
}

export type MutationUpdateAuthEmailArgs = {
  input: UpdateAuthEmailInput
}

export type MutationUpdateAuthPhoneNumberArgs = {
  input: UpdateAuthPhoneNumberInput
}

export type MutationUpdateBankAccountGoalArgs = {
  input: UpdateBankAccountGoalInput
}

export type MutationUpdateBankCardPinArgs = {
  input: UpdateBankCardPinInput
}

export type MutationUpdateBannersArgs = {
  input: UpdateBannersInput
}

export type MutationUpdateBeneficiaryInfoArgs = {
  id: Scalars['ID']
  input: BeneficiaryInfoInput
}

export type MutationUpdateBenefitStatusArgs = {
  input: UpdateBenefitStatusInput
}

export type MutationUpdateContactInfoArgs = {
  input: ContactInfoInput
}

export type MutationUpdateCredentialsArgs = {
  input: UserCredentialsInput
}

export type MutationUpdateCustomerMoneyRulesArgs = {
  input: MoneyRulesRulesetInput
}

export type MutationUpdateElapsedTimeForLearnQuizArgs = {
  input: UpdateElapsedTimeForLearnQuizInput
}

export type MutationUpdateEmailArgs = {
  email: Scalars['String']
}

export type MutationUpdateEmploymentArgs = {
  input: EmploymentInput
}

export type MutationUpdateHelpcenterBannerArgs = {
  input: HelpcenterContentInput
}

export type MutationUpdateInvestorQuestionsArgs = {
  input: InvestorQuestionsInput
}

export type MutationUpdateLadderQuoteArgs = {
  coverage: Scalars['Int']
  quoteId: Scalars['ID']
}

export type MutationUpdateLearnContentProgressArgs = {
  input: UpdateLearnProgressInput
}

export type MutationUpdateLinkedAccountArgs = {
  input: UpdateLinkedAccountInput
  linkedAccountId: Scalars['ID']
}

export type MutationUpdateMoneyManagerAllocationsArgs = {
  input: UpdateMoneyManagerAllocationsInput
}

export type MutationUpdateMoneyManagerAutomationTargetArgs = {
  input: UpdateMoneyManagerAutomationTargetInput
}

export type MutationUpdateMoneyManagerSettingsArgs = {
  input: UpdateMoneyManagerSettingsInput
}

export type MutationUpdateMoneyRulesSourceSettingsArgs = {
  input: UpdateMoneyRulesSourceSettingsInput
}

export type MutationUpdateNegotiationStatusArgs = {
  negotiationStatusInput: NegotiationStatus
}

export type MutationUpdateNotificationArgs = {
  active: Scalars['Boolean']
  category?: InputMaybe<Scalars['String']>
  channel: Scalars['String']
  subcategory?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  uuid?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateOptOutOfTargetingArgs = {
  input: UpdateOptOutOfTargetingInput
}

export type MutationUpdatePersonalInfoArgs = {
  input: PersonalInfoInput
}

export type MutationUpdatePortfolioSecuritiesArgs = {
  input: UpdatePortfolioSecuritiesInput
}

export type MutationUpdateProfileArgs = {
  input: ProfileInput
}

export type MutationUpdatePromotedCampaignsArgs = {
  input?: InputMaybe<UpdatePromotedCampaignsInput>
}

export type MutationUpdateRecurringInvestmentArgs = {
  input: RecurringInvestmentInput
}

export type MutationUpdateReferralCampaignArgs = {
  input: UpdateReferralCampaignInput
}

export type MutationUpdateReferralPayoutArgs = {
  input: UpdateReferralPayoutInput
}

export type MutationUpdateReferralRelationshipArgs = {
  input: UpdateReferralRelationshipInput
}

export type MutationUpdateReferralRewardStatusArgs = {
  rewardId: Scalars['ID']
  rewardStatus: ReferralRewardUpdateStatus
}

export type MutationUpdateReferralUserProfileArgs = {
  email: Scalars['String']
  updateInfo: ReferralUserUpdateInput
}

export type MutationUpdateRegistrationArgs = {
  input: RegistrationInput
}

export type MutationUpdateRoundUpAccountArgs = {
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
}

export type MutationUpdateSignatureArgs = {
  signatureType: SignatureType
  svgFile: Scalars['String']
}

export type MutationUpdateSuitabilityArgs = {
  suitabilityInput: Suitability_SuitabilityInput[]
}

export type MutationUpdateUserProfileAndAutomationTargetArgs = {
  input: UpdateUserProfileAndAutomationTargetInput
}

export type MutationUpdateUserSwitchStateArgs = {
  input: UpdateUserSwitchStateInput
}

export type MutationUpdateVerificationProfileArgs = {
  input: VerificationProfileInput
}

export type MutationUploadAudienceListArgs = {
  input: UploadAudienceListInput
}

export type MutationUploadCheckArgs = {
  input: UploadCheckInput
}

export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput
}

export type MutationUploadUnsolicitedDocumentsArgs = {
  input: UploadUnsolicitedDocumentsInput
}

export type MutationUpsertUserMatchArgs = {
  input: UpsertUserMatchInput
}

export type MutationValidateCredentialsArgs = {
  input: ValidateCredentialsInput
}

export type MutationValidateFaceLivenessSessionArgs = {
  sessionId: Scalars['ID']
}

export type MutationValidateUserSuspendedUploadTokenArgs = {
  input: ValidateUserSuspendedUploadTokenInput
}

export type MutationVendAuthSessionArgs = {
  input: VendAuthSessionInput
}

export type MutationVerifyDeviceArgs = {
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>
  input: VerifyDeviceInput
}

export type MutationVerifyIdentityByDocumentsArgs = {
  input: ValidateDocumentsInput
}

export type MutationVerifyLaterAccountOrErrorArgs = {
  investmentAccountId: Scalars['ID']
}

export type MutationVerifyPasswordsArgs = {
  input: VerifyPasswordsInput
}

export type MutationVerifyRdvsArgs = {
  input: VerifyRdvsInput
}

export type NativeLoginInput = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
}

/** The provided security percent is negative */
export type NegativeSecurityPercentError = {
  __typename?: 'NegativeSecurityPercentError'
  /** The security in question */
  securityId: Scalars['ID']
}

export enum NegotiationMethod {
  Automatic = 'AUTOMATIC',
  Letter = 'LETTER',
}

export type NegotiationServiceConnectionFailure = {
  __typename?: 'NegotiationServiceConnectionFailure'
  message: Scalars['String']
}

export type NegotiationStatus = {
  negotiationMethod: NegotiationType
  operator: Scalars['String']
  refundAmount?: InputMaybe<Scalars['Float']>
  status: BankFeeNegotiationInternalStatus
  submissionId: Scalars['ID']
}

export enum NegotiationType {
  AutomatedNegotiation = 'AUTOMATED_NEGOTIATION',
  MailInNegotiation = 'MAIL_IN_NEGOTIATION',
}

export enum NetTermsType {
  Eom = 'eom',
  Net = 'net',
}

/** The next billing date for a user */
export type NextBillingDate = {
  __typename?: 'NextBillingDate'
  next_billing_date: Maybe<Scalars['String']>
}

export type NextTransferDateResult =
  | MalformedRecurringTransferException
  | RecurringTransferDate

/** Cannot open early account because the beneficiary id is invalid */
export type NoBeneficiaryFoundException = {
  __typename?: 'NoBeneficiaryFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** No Funding Source Alert. */
export type NoFundingSourceUserAlert = UserAlertsItem & {
  __typename?: 'NoFundingSourceUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type NoProspectRecord = {
  __typename?: 'NoProspectRecord'
  message: Scalars['String']
}

export type NoRegisteredPushAuthenticatorsException = {
  __typename?: 'NoRegisteredPushAuthenticatorsException'
  userId: Scalars['ID']
}

/** The user needs to close all other investment accounts before closing this account */
export type NonBasicAccountOpenException = {
  __typename?: 'NonBasicAccountOpenException'
  /** message */
  errorMessage: Maybe<Scalars['String']>
}

/** Returned when one or more singleRuleId's are not unique */
export type NonUniqueSingleRuleIdsError = {
  __typename?: 'NonUniqueSingleRuleIdsError'
  message: Scalars['String']
}

export type Notification = {
  __typename?: 'Notification'
  active: Scalars['Boolean']
  category: Maybe<Scalars['String']>
  subcategory: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
}

export type NotificationMessage = Message & {
  __typename?: 'NotificationMessage'
  body: MessageTextAsset
  createdAt: Scalars['DateTime']
  deepLink: Maybe<Scalars['URL']>
  externalId: Scalars['ID']
  icon: Maybe<MessageVisualAsset>
  id: Scalars['ID']
  isDismissed: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isRead: Scalars['Boolean']
  messageCategory: MessageCategory
  messageType: MessageType
  platforms: Platform[]
  readAt: Maybe<Scalars['DateTime']>
  title: MessageTextAsset
  trackingId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
}

export type Notifications = {
  __typename?: 'Notifications'
  emails: Maybe<Array<Maybe<Notification>>>
  pushes: Maybe<Array<Maybe<Notification>>>
}

export type OauthApp = {
  __typename?: 'OauthApp'
  accessTokenAudience: Array<Maybe<Scalars['String']>>
  accessTokenExpiry: Maybe<Scalars['Int']>
  active: Scalars['Boolean']
  contactEmail: Maybe<Scalars['String']>
  contactName: Maybe<Scalars['String']>
  contract: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  externalApp: Scalars['Boolean']
  imageUri: Scalars['String']
  name: Scalars['String']
  oauthAppId: Scalars['ID']
  pageType: Scalars['String']
  redirectUri: Maybe<Scalars['String']>
  refreshTokenExpiry: Maybe<Scalars['Int']>
  scopes: OauthAppScope[]
  secret: Maybe<Scalars['String']>
  type: OauthAppType
  updatedAt: Scalars['DateTime']
}

export type OauthAppClient = {
  __typename?: 'OauthAppClient'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  imageUri: Scalars['String']
  name: Scalars['String']
  oauthAppClientId: Scalars['ID']
  oauthAppId: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type OauthAppClientNotFoundException = {
  __typename?: 'OauthAppClientNotFoundException'
  oauthAppClientId: Scalars['ID']
}

export type OauthAppImageUpload = {
  __typename?: 'OauthAppImageUpload'
  expiresAt: Scalars['DateTime']
  uploadUrl: Scalars['URL']
}

export type OauthAppNotFoundException = {
  __typename?: 'OauthAppNotFoundException'
  oauthAppId: Scalars['ID']
}

export type OauthAppScope = {
  __typename?: 'OauthAppScope'
  description: Maybe<Scalars['String']>
  identifier: Scalars['String']
  required: Scalars['Boolean']
  title: Scalars['String']
}

export enum OauthAppType {
  Aggregator = 'AGGREGATOR',
  Partner = 'PARTNER',
}

/** Occupation that a user can select */
export type Occupation = {
  __typename?: 'Occupation'
  id: Scalars['ID']
  name: Scalars['String']
}

export type Offer = {
  __typename?: 'Offer'
  /**
   * Meta field enabling clients to delegate to the backend
   * more logic determining when it is valid to present the Offer.
   *
   * Examples: "SUBSCRIPTION_CANCELLATION", "PASSIONS_PRODUCT_EXPLORATION"
   */
  availableIn: Maybe<Array<Scalars['String']>>
  /** The cohort of subscribers the Offer is available to (driven by the Offer type). */
  availableTo: OfferAvailability
  createdAt: Scalars['DateTime']
  /** Once subscribed to how long is the Offer valid for. */
  expiresAfter: Maybe<OfferExpiration>
  expiresAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** What the Offer entitles a subscriber access to. */
  offering: Offering
  /** Amount the subscriber agrees to pay for access to the Offer's offering. */
  price: OfferPrice
  /** URL to the terms and conditions of the Offer. */
  termsUrl: Scalars['URL']
  /** Indicates semantics of the Offer (generally whom it is available to and when). */
  type: OfferType
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum OfferAvailability {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Existing = 'EXISTING',
  New = 'NEW',
  None = 'NONE',
}

export type OfferExpiration = {
  __typename?: 'OfferExpiration'
  period: OfferExpirationPeriod
  value: Scalars['Int']
}

export enum OfferExpirationPeriod {
  Month = 'MONTH',
}

export enum OfferGroupsType {
  Category = 'CATEGORY',
  Ranked = 'RANKED',
}

export type OfferLocation = {
  __typename?: 'OfferLocation'
  city: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
}

export type OfferLocationInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type OfferPrice = {
  __typename?: 'OfferPrice'
  amount: CurrencyAmount
  type: OfferPriceType
}

export type OfferPriceInput = {
  amount: CurrencyAmountInput
  type: OfferPriceType
}

export enum OfferPriceType {
  Free = 'FREE',
  Monthly = 'MONTHLY',
}

export enum OfferType {
  Promotional = 'PROMOTIONAL',
  Standard = 'STANDARD',
}

/** An Offering is something that a subscriber subscribes to access to. */
export type Offering = Product | Tier

export type OidcCredentialsAlreadyLinkedException = {
  __typename?: 'OidcCredentialsAlreadyLinkedException'
  subId: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type OidcCredentialsNotFoundException = {
  __typename?: 'OidcCredentialsNotFoundException'
  oidcProvider: Maybe<OidcProvider>
  userId: Scalars['ID']
}

export type OidcCredentialsTakenException = {
  __typename?: 'OidcCredentialsTakenException'
  subId: Maybe<Scalars['String']>
  userId: Scalars['ID']
}

export type OidcLoginInput = {
  idToken: Scalars['String']
  nonce: Scalars['String']
}

export enum OidcProvider {
  Apple = 'APPLE',
}

export type OnboardingBenefitsInput = {
  product?: InputMaybe<OnboardingProducts>
}

export enum OnboardingGroups {
  Family = 'FAMILY',
  Future = 'FUTURE',
  Security = 'SECURITY',
}

export type OnboardingProductStatus = {
  __typename?: 'OnboardingProductStatus'
  claimStatus: ClaimStatus
  claimedOn: Maybe<Scalars['String']>
  details: Maybe<Array<Maybe<ClaimStatusDetails>>>
  expiresOn: Maybe<Scalars['String']>
  updatedBy: Maybe<Scalars['String']>
  updatedOn: Maybe<Scalars['String']>
}

export type OnboardingProductTile = {
  __typename?: 'OnboardingProductTile'
  claimDetails: OnboardingProductStatus
  product: OnboardingProducts
  status: BenefitProductStatus
}

export enum OnboardingProducts {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
}

export enum OnboardingRequirement {
  AffiliatedWithBrokerDealer = 'AFFILIATED_WITH_BROKER_DEALER',
  AnnualIncome = 'ANNUAL_INCOME',
  CheckingSignature = 'CHECKING_SIGNATURE',
  CombinedAnnualIncome = 'COMBINED_ANNUAL_INCOME',
  DateOfBirth = 'DATE_OF_BIRTH',
  Ecbsv = 'ECBSV',
  Employees = 'EMPLOYEES',
  EmploymentStatus = 'EMPLOYMENT_STATUS',
  FilingType = 'FILING_TYPE',
  FinancialEducation = 'FINANCIAL_EDUCATION',
  FirstName = 'FIRST_NAME',
  IntroInvestmentAccounts = 'INTRO_INVESTMENT_ACCOUNTS',
  InvestmentGoal = 'INVESTMENT_GOAL',
  LandingCheckingAccount = 'LANDING_CHECKING_ACCOUNT',
  LastName = 'LAST_NAME',
  LinkedFundingSource = 'LINKED_FUNDING_SOURCE',
  MailingAddress = 'MAILING_ADDRESS',
  MaritalStatus = 'MARITAL_STATUS',
  NetWorth = 'NET_WORTH',
  Occupation = 'OCCUPATION',
  PhoneNumber = 'PHONE_NUMBER',
  ResidentialAddress = 'RESIDENTIAL_ADDRESS',
  ReviewSavingsAccount = 'REVIEW_SAVINGS_ACCOUNT',
  ReviewSummary = 'REVIEW_SUMMARY',
  ShareholderOrDirector = 'SHAREHOLDER_OR_DIRECTOR',
  SocialSecurityNumber = 'SOCIAL_SECURITY_NUMBER',
  SubjectToBackupWithholding = 'SUBJECT_TO_BACKUP_WITHHOLDING',
  Subscription = 'SUBSCRIPTION',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
}

export type OnboardingTileGroup = {
  __typename?: 'OnboardingTileGroup'
  group: OnboardingGroups
  products: Maybe<Array<Maybe<OnboardingProductTile>>>
}

export type OnboardingTipItem = {
  __typename?: 'OnboardingTipItem'
  body: Scalars['String']
  headline: Scalars['String']
  id: Scalars['ID']
  image: Image
  title: Scalars['String']
  type: OnboardingTipType
}

export enum OnboardingTipType {
  /** feature */
  Feature = 'feature',
  /** introduction */
  Intro = 'intro',
}

export type OnboardingTips = {
  __typename?: 'OnboardingTips'
  items: OnboardingTipItem[]
}

export enum OnboardingType {
  Checking = 'CHECKING',
  Early = 'EARLY',
  EmergencySavings = 'EMERGENCY_SAVINGS',
  Invest = 'INVEST',
  Later = 'LATER',
  MoneyManager = 'MONEY_MANAGER',
}

/** Online Switches are performed through the Employer's URL. */
export type OnlineSwitch = SwitchInterface & {
  __typename?: 'OnlineSwitch'
  source: SwitchSource
  type: SwitchType
  /** Employer URL */
  url: Scalars['String']
  vendorTargetId: Maybe<Scalars['ID']>
}

/** Cannot close user account if user has open spend/investment accounts */
export type OpenAccountsException = {
  __typename?: 'OpenAccountsException'
  /** User's open account types */
  openAccountTypes: Maybe<Array<Scalars['String']>>
}

/** Input for creating a Core InvestmentAccount */
export type OpenCoreInvestmentAccountInput = {
  /** ID of the portfolio for this investment account */
  portfolioId: Scalars['String']
}

/** Result from opening a Core InvestmentAccount */
export type OpenCoreInvestmentAccountResult =
  | CoreAccountAlreadyExistsException
  | InvalidPortfolioIdException
  | InvestmentAccount
  | InvestmentAccountCreationException
  | UserClosedException
  | UserNotFoundException

/** Input for creating an early investment account */
export type OpenEarlyAccountInput = {
  /** Beneficiary ID */
  beneficiaryId: Scalars['ID']
  /** Name of investment account */
  investmentAccountName?: InputMaybe<Scalars['String']>
  /** State in which to open the investment account (defaults to custodian's state) */
  stateCode?: InputMaybe<Scalars['String']>
  /** Termination age of the investment account */
  terminationAge: Scalars['Int']
}

/** Result from opening an Early Investment Account */
export type OpenEarlyAccountResult =
  | BeneficiaryAccountExistsException
  | CoreAccountClosedException
  | InternalErrorException
  | InvalidStateException
  | InvalidSubscriptionTierException
  | InvalidTerminationAgeException
  | InvestmentAccount
  | MaxAccountsCreatedException
  | MissingBeneficiarySsnException
  | NoBeneficiaryFoundException
  | UserClosedException
  | UserNotFoundException
  | UserNotVerifiedException

export enum OperationStage {
  AuthCompleted = 'AUTH_COMPLETED',
  AuthFailed = 'AUTH_FAILED',
  AwaitingTfaCode = 'AWAITING_TFA_CODE',
  AwaitingTfaOption = 'AWAITING_TFA_OPTION',
  ProcessingCredentials = 'PROCESSING_CREDENTIALS',
  ProcessingTfaCode = 'PROCESSING_TFA_CODE',
  ProcessingTfaOption = 'PROCESSING_TFA_OPTION',
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderBankCardInput = {
  bankCardTier?: InputMaybe<BankCardTier>
  bankType?: InputMaybe<BankType>
  employmentStatus?: InputMaybe<Scalars['String']>
  isDocumentsAccepted: Scalars['Boolean']
  isReopen?: InputMaybe<Scalars['Boolean']>
  paymentProcessor?: InputMaybe<BankCardPaymentProcessor>
  prefundTransfer?: InputMaybe<BankCardPrefundTransfer>
  requestVersion?: InputMaybe<RequestVersions>
}

export type OrderBankCardResult = BankCardOrder

export enum Origin {
  ExternalGiftCard = 'external_gift_card',
  Prepayment = 'prepayment',
}

/** Outside contribution object */
export type OutsideContribution = TimestampsInterface & {
  __typename?: 'OutsideContribution'
  accountId: Scalars['ID']
  checkoutCart: OutsideContributionCheckoutCart
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  failureReason: Maybe<Scalars['String']>
  id: Scalars['ID']
  investmentId: Maybe<Scalars['ID']>
  note: Maybe<Scalars['String']>
  noteAuthor: Maybe<Scalars['String']>
  paymentMethodId: Scalars['ID']
  state: ContributionState
  transferRequestId: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** an outside contribution checkout cart object */
export type OutsideContributionCheckoutCart = TimestampsInterface & {
  __typename?: 'OutsideContributionCheckoutCart'
  code: OutsideContributionCode
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  feeAmount: Scalars['String']
  id: Scalars['ID']
  investmentAmount: Scalars['String']
  paymentIntentId: Scalars['ID']
  status: CheckoutCartStatus
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

/** Code for outside contribution */
export type OutsideContributionCode = TimestampsInterface & {
  __typename?: 'OutsideContributionCode'
  /** Unique code that has one-to-one relationship with investment Account */
  code: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  investmentAccountId: Scalars['ID']
  recipientFirstName: Scalars['String']
  /** This is the id of who the contribution is going to. Most likely beneficiary id */
  recipientId: Scalars['ID']
  signupBonusUrl: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  userId: Scalars['ID']
}

/** Object representing an outside contribution prospect */
export type OutsideContributionProspect = Prospect & {
  __typename?: 'OutsideContributionProspect'
  email: Scalars['String']
  id: Scalars['ID']
}

export type OverrideInput = {
  originalAutoAdd?: InputMaybe<Scalars['ID']>
  originalFallback?: InputMaybe<Scalars['ID']>
  originalQa?: InputMaybe<Scalars['ID']>
}

export enum PackageStatus {
  /** Available for Pickup */
  AvailableForPickup = 'availableForPickup',
  /** Customer Recall */
  CustomerRecall = 'customerRecall',
  /** Dead Letter */
  DeadLetter = 'deadLetter',
  /** Delivered */
  Delivered = 'delivered',
  /** Delivery Status Not Updated */
  DeliveryStatusNotUpdated = 'deliveryStatusNotUpdated',
  /** Forwarded to New Address */
  ForwardedToNewAddress = 'forwardedToNewAddress',
  /** Logged at USPS */
  LoggedAtUsps = 'loggedAtUSPS',
  /** New Item */
  NewItem = 'newItem',
  /** Found – No Status */
  NoStatus = 'noStatus',
  /** Not Found */
  NotFound = 'notFound',
  /** Notice Left for Recipient */
  NoticeLeftForRecipient = 'noticeLeftForRecipient',
  /** Other */
  Other = 'other',
  /** Out for Delivery */
  OutForDelivery = 'outForDelivery',
  /** Returned to Sender */
  ReturnedToSender = 'returnedToSender',
  /** Scanned in Route */
  ScannedInRoute = 'scannedInRoute',
  /** Undeliverable */
  Undeliverable = 'undeliverable',
}

/** Pagination meta information about the current response */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** Indicates records exist after the given cursor */
  hasNextPage: Scalars['Boolean']
  /** Indicates records exist before the given cursor */
  hasPreviousPage: Scalars['Boolean']
  /** Number of records returned in the response */
  limit: Scalars['Int']
}

/** Pagination input to fetch pages of records */
export type PageInput = {
  /** Cursor to fetch records starting after */
  after?: InputMaybe<Scalars['ID']>
  /** How many records to return */
  first?: InputMaybe<Scalars['Int']>
}

export enum PageName {
  AboutPortfolio = 'ABOUT_PORTFOLIO',
  AddressEdit = 'ADDRESS_EDIT',
  AddressInvalid = 'ADDRESS_INVALID',
  AddressPreview = 'ADDRESS_PREVIEW',
  AddressSuggestion = 'ADDRESS_SUGGESTION',
  /** @deprecated Animation removed as a page in the web funnel */
  Analyzing = 'ANALYZING',
  BankLinkSuccess = 'BANK_LINK_SUCCESS',
  CardOrderReview = 'CARD_ORDER_REVIEW',
  CardSignature = 'CARD_SIGNATURE',
  ChooseFundingSource = 'CHOOSE_FUNDING_SOURCE',
  ContactInfo = 'CONTACT_INFO',
  CryptoLander = 'CRYPTO_LANDER',
  DateOfBirth = 'DATE_OF_BIRTH',
  DirectBankIntegration = 'DIRECT_BANK_INTEGRATION',
  DirectBankIntegrationRedirect = 'DIRECT_BANK_INTEGRATION_REDIRECT',
  DirectToMobile = 'DIRECT_TO_MOBILE',
  /** @deprecated Page removed from funnel */
  EsgDetails = 'ESG_DETAILS',
  /** @deprecated Page removed from funnel */
  EsgEducation = 'ESG_EDUCATION',
  Funding = 'FUNDING',
  Hdyhau = 'HDYHAU',
  Institutions = 'INSTITUTIONS',
  InvestorQuestions = 'INVESTOR_QUESTIONS',
  InvestInterstitial = 'INVEST_INTERSTITIAL',
  LaterInterstitial = 'LATER_INTERSTITIAL',
  ManualFundingSource = 'MANUAL_FUNDING_SOURCE',
  MfaSetUp = 'MFA_SET_UP',
  MocReferralReminder = 'MOC_REFERRAL_REMINDER',
  MocRoutingInterstitial = 'MOC_ROUTING_INTERSTITIAL',
  MocSuccess = 'MOC_SUCCESS',
  Occupation = 'OCCUPATION',
  OneTimeDeposit = 'ONE_TIME_DEPOSIT',
  OneTimeInvestment = 'ONE_TIME_INVESTMENT',
  PersonalInfo = 'PERSONAL_INFO',
  PhoneNumber = 'PHONE_NUMBER',
  PlaidLinkRedirect = 'PLAID_LINK_REDIRECT',
  PortfolioDetails = 'PORTFOLIO_DETAILS',
  PreviewPortfolio = 'PREVIEW_PORTFOLIO',
  PricingInterstitial = 'PRICING_INTERSTITIAL',
  ProductOnboarding = 'PRODUCT_ONBOARDING',
  ProgressScreen_1 = 'PROGRESS_SCREEN_1',
  ProgressScreen_2 = 'PROGRESS_SCREEN_2',
  ProgressScreen_3 = 'PROGRESS_SCREEN_3',
  RecurringDeposit = 'RECURRING_DEPOSIT',
  RecurringInvestment = 'RECURRING_INVESTMENT',
  /** @deprecated Page removed from funnel */
  ReferralDisclosure = 'REFERRAL_DISCLOSURE',
  /** @deprecated Page removed from funnel */
  ReferralReward = 'REFERRAL_REWARD',
  RoundUpsFunding = 'ROUND_UPS_FUNDING',
  RoundUpsInterstitial = 'ROUND_UPS_INTERSTITIAL',
  RoundUpsPast = 'ROUND_UPS_PAST',
  RoundUpsSetUp = 'ROUND_UPS_SET_UP',
  SecondChanceBankLink = 'SECOND_CHANCE_BANK_LINK',
  SecondChanceInstitutions = 'SECOND_CHANCE_INSTITUTIONS',
  /** @deprecated Page removed from funnel */
  SelectPortfolioTheme = 'SELECT_PORTFOLIO_THEME',
  /** @deprecated Page removed from funnel */
  SelectTier = 'SELECT_TIER',
  /** @deprecated The shipping address page was originally rolled out with multiple components combined in one. This has been replaced with ADDRESS_EDIT, ADDRESS_INVALID, ADDRESS_PREVIEW, and ADDRESS_SUGGESTION. */
  ShippingAddress = 'SHIPPING_ADDRESS',
  Signup = 'SIGNUP',
  Ssn = 'SSN',
  SubscriptionActive = 'SUBSCRIPTION_ACTIVE',
  Success = 'SUCCESS',
  SuitabilityQuestions = 'SUITABILITY_QUESTIONS',
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
}

/** Query attributes for Direct Deposit Parameterized PDF Generation */
export type ParameterizedPdfInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Date Signed */
  dateSigned: Scalars['String']
  /** Value of Amount Option Chosen */
  distributionAmount?: InputMaybe<Scalars['Float']>
  /** Amount Option */
  distributionType: DirectDepositDistribution
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
}

export type PartnerDataShare = {
  __typename?: 'PartnerDataShare'
  partner: BenefitsPartner
  userId: Scalars['ID']
}

export type PartnerDataShareInput = {
  product: BenefitsProduct
}

export type PartnerDataShareResponse =
  | PartnerDataShare
  | ProductNotSupportedException

export type PartnerDetailsResponse = {
  __typename?: 'PartnerDetailsResponse'
  partnerLogoUrl: Scalars['String']
  partnerName: BenefitsPartner
}

export type PartnerDocumentUrlResponse = {
  __typename?: 'PartnerDocumentUrlResponse'
  documentUrl: Scalars['String']
}

export type PartnerOfferGroup = {
  __typename?: 'PartnerOfferGroup'
  /** display body for the group */
  body: Maybe<Scalars['String']>
  carouselType: CarouselType
  id: Scalars['ID']
  /** list of offers in the group */
  offers: PartnerOfferGroupItem[]
  /** display title for the group */
  title: Maybe<Scalars['String']>
}

/** Used to customize offer group contents */
export type PartnerOfferGroupFilterInput = {
  /** Location is required for job offers */
  location?: InputMaybe<OfferLocationInput>
}

export type PartnerOfferGroupItem =
  | EarnOffer
  | JobOffer
  | JobSearchOffer
  | PromoOffer

/** Specifies the offer group type input */
export type PartnerOfferGroupsTypeInput = {
  type: OfferGroupsType
}

export type PartnerStatusInput = {
  acornsPartnerStatus: AcornsPartnerStatus
  partner: BenefitsPartner
  partnerData?: InputMaybe<Scalars['String']>
  partnerEventPayload?: InputMaybe<Scalars['String']>
  partnerStatus?: InputMaybe<Scalars['String']>
  partnerUpdatedDt?: InputMaybe<Scalars['DateTime']>
  product: BenefitsProduct
}

export type PartnerUrlInput = {
  product: BenefitsProduct
}

export type PartnerUrlResponse = {
  __typename?: 'PartnerUrlResponse'
  partnerUrl: Scalars['String']
  status: AcornsPartnerStatus
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum PasswordResetErrors {
  InvalidPasswordLength = 'INVALID_PASSWORD_LENGTH',
  InvalidPasswordMissingLowerCase = 'INVALID_PASSWORD_MISSING_LOWER_CASE',
  InvalidPasswordMissingNumber = 'INVALID_PASSWORD_MISSING_NUMBER',
  InvalidPasswordMissingSpecialCharacter = 'INVALID_PASSWORD_MISSING_SPECIAL_CHARACTER',
  InvalidPasswordMissingUpperCase = 'INVALID_PASSWORD_MISSING_UPPER_CASE',
  InvalidSsn = 'INVALID_SSN',
  NewPasswordMatchesOldPassword = 'NEW_PASSWORD_MATCHES_OLD_PASSWORD',
  PasswordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH',
}

export type PasswordResetForm = {
  __typename?: 'PasswordResetForm'
  fields: Array<Maybe<PasswordResetFormFields>>
  userId: Maybe<Scalars['ID']>
}

export type PasswordResetFormFields = {
  __typename?: 'PasswordResetFormFields'
  key: Scalars['String']
  value: Maybe<Scalars['String']>
}

/** Decorator type for items that have attached notes for display */
export type PastAnnotatedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Annotation on the item */
  note: Maybe<Scalars['String']>
  /** Author of the note */
  noteAuthor: Maybe<Scalars['String']>
}

/** Recurrence setting for a recurring Transfer */
export type PastBeneficiaryInfo = {
  __typename?: 'PastBeneficiaryInfo'
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
}

export type PastBeneficiaryTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastBeneficiaryTransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastCashOwedCollectionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastCashOwedCollectionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastCashReinvestmentInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastCashReinvestmentInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastItem must implement */
export type PastCoreCombinedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  isCombinedInvestment: Scalars['Boolean']
}

/** A generic money movement line item for the Core account */
export type PastCoreItem = PastItem & {
  __typename?: 'PastCoreItem'
  amount: Maybe<CurrencyAmount>
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** Metrics for core to be displayed in the summary */
export type PastCoreSummary = {
  __typename?: 'PastCoreSummary'
  dividends: CurrencyAmount
  foundMoneyRewards: CurrencyAmount
  investments: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  referralRewards: CurrencyAmount
  withdrawals: CurrencyAmount
}

/** A base set of fields that each traded PastItem must implement */
export type PastCoreTradedItem = {
  /** Past Item ID */
  id: Scalars['ID']
  /** Location of the investment's trade confirmation document */
  tradeConfirmationUrl: Maybe<Scalars['URL']>
}

export type PastDividendInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastDividendInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields all Early items share */
export type PastEarlyItem = {
  beneficiaryAccountId: Scalars['String']
  beneficiaryId: Scalars['String']
}

/** Metrics for early to be displayed in the summary */
export type PastEarlySummary = {
  __typename?: 'PastEarlySummary'
  contributions: CurrencyAmount
  dividends: CurrencyAmount
  /** Total gain / loss including fees */
  netReturns: CurrencyAmount
  withdrawals: CurrencyAmount
}

export type PastEmployeeContributionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastEmployeeContributionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastExternalTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastExternalTransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastExternalTransferReversedInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastExternalTransferReversedInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastFeeInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastFeeInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastGiftCardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastGiftCardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastIraTransferInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastIRATransferInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastItem must implement */
export type PastInvestmentItem = {
  accountName: Scalars['String']
  /** An estimated completion date for when the investment will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  moneyManagerTransfer: Scalars['Boolean']
  productAccountType: ProductAccountType
  transactionDescription: Scalars['String']
  transactionType: TransactionType
}

/** A base set of fields that each type of PastItem must implement */
export type PastItem = {
  amount: Maybe<CurrencyAmount>
  /** When this was first created */
  createdAt: Scalars['DateTime']
  /** Flags inclusion in the pending transfer drawer */
  drawerInclusion: Scalars['Boolean']
  /** Past Item ID */
  id: Scalars['ID']
  /** The corresponding product of the item */
  productType: ProductType
  /** Whether or not the transaction is reversible */
  reversible: Scalars['Boolean']
  /** The current state of the item */
  status: PastItemStatus
  /** The title of the item */
  title: Scalars['String']
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

/** PastItem connection object */
export type PastItemConnection = {
  __typename?: 'PastItemConnection'
  edges: PastItemEdge[]
  pageInfo: PageInfo
}

export type PastItemEdge = {
  __typename?: 'PastItemEdge'
  cursor: Scalars['ID']
  node: Maybe<PastItem>
}

export enum PastItemStatus {
  Complete = 'complete',
  Pending = 'pending',
  Selling = 'selling',
  Transferring = 'transferring',
}

export type PastItemsAccountFilter = {
  /** Requested Account ID */
  id: Scalars['ID']
  /** Product Account Type */
  productAccountType: ProductAccountType
}

export type PastLaterSummary = {
  __typename?: 'PastLaterSummary'
  contributions: CurrencyAmount
  currentYearContributions: CurrencyAmount
  dividends: CurrencyAmount
  netReturns: CurrencyAmount
  priorYearContributions: CurrencyAmount
  withdrawals: CurrencyAmount
}

export type PastLumpSumInvestment = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastLumpSumInvestment'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastMatchRemovalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastMatchRemovalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastOutsideContributionInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastOutsideContributionInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRealTimeRoundUpInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRealTimeRoundUpInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRebalanceInvestmentItem = PastInvestmentItem &
  PastItem & {
    __typename?: 'PastRebalanceInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    /** The current state of the item */
    status: PastItemStatus
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Recurring information for a recurring transfer */
export type PastRecurrenceItem = PastScheduledItem & {
  __typename?: 'PastRecurrenceItem'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  beneficiary: Maybe<PastBeneficiaryInfo>
  moneyManagerTransfer: Scalars['Boolean']
  recurrence: PastRecurrenceSettings
}

/** Recurrence setting for a recurring Transfer */
export type PastRecurrenceSettings = {
  __typename?: 'PastRecurrenceSettings'
  accountId: Scalars['String']
  /** @deprecated Use daysOfMonth instead */
  dayOfMonth: Maybe<Scalars['Float']>
  daysOfMonth: Maybe<Array<Scalars['Float']>>
  frequency: RecurrenceFrequency
  id: Maybe<Scalars['String']>
  weekday: Maybe<DayOfWeek>
}

export type PastRecurringInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRecurringInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReferralRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReferralRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReferralRewardMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReferralRewardMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRefundInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRefundInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastReversalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastReversalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRewardInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRewardInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    moneyManagerTransfer: Scalars['Boolean']
    partnerLogoUrl: Maybe<Scalars['URL']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRewardMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRewardMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    merchantName: Maybe<Scalars['String']>
    moneyManagerTransfer: Scalars['Boolean']
    partnerLogoUrl: Maybe<Scalars['URL']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRoundUpItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRoundUpItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastRoundUpMatchInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastRoundUpMatchInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each type of PastScheduledItem must implement */
export type PastScheduledItem = {
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
}

export type PastSecurityLiquidationInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastSecurityLiquidationInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PastSmartDepositInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastSmartDepositInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A generic money movement line item for the Spend account */
export type PastSpendItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'PastSpendItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Metrics for spend to be displayed in the summary */
export type PastSpendSummary = {
  __typename?: 'PastSpendSummary'
  /** Primary account's current available balance */
  availableBalance: Maybe<CurrencyAmount>
  /**
   * Withdrawals for this month. Current month is based on current PST time
   * @deprecated Use
   */
  debits: Maybe<CurrencyAmount>
  /** Withdrawals/purchases for the last 30 days. Based on current PST time */
  debitsLast30Days: Maybe<CurrencyAmount>
  /**
   * One time or direct deposits for this month. Current month is based on current PST time
   * @deprecated Use
   */
  deposits: Maybe<CurrencyAmount>
  /** One time or direct deposits for the last 30 days. Based on current PST time */
  depositsLast30Days: Maybe<CurrencyAmount>
  /** @deprecated Will be displayed on Past Core Summary */
  foundMoneyPlus: Maybe<CurrencyAmount>
  instantRoundUps: Maybe<CurrencyAmount>
}

/** Recurrence setting for a recurring Transfer */
export type PastSplitDepositAllocationSettings = {
  __typename?: 'PastSplitDepositAllocationSettings'
  allocationList: PastSplitDepositAllocations[]
  expectedNextDeposit: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
}

export type PastSplitDepositAllocations = {
  __typename?: 'PastSplitDepositAllocations'
  allocationAmount: Maybe<CurrencyAmount>
  allocationPercent: Scalars['String']
  name: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

/** Split Paycheck information for a direct deposit */
export type PastSplitDepositItem = PastScheduledItem & {
  __typename?: 'PastSplitDepositItem'
  /** type of account transactions is associated with */
  accountType: ProductAccountType
  allocations: PastSplitDepositAllocationSettings
  /** amount a schedulted transaction is for */
  amount: CurrencyAmount
  awaitingConfiguration: Scalars['Boolean']
  moneyManagerTransfer: Scalars['Boolean']
}

/** A base set of fields for transaction summary that each type of HistorySummary must implement */
export type PastSummary = {
  moneyIn: CurrencyAmount
  moneyOut: CurrencyAmount
}

export type PastSummaryFilter = {
  /** Requested Account ID and Type */
  account?: InputMaybe<PastItemsAccountFilter>
  /** Time to filter transaction by */
  timeframe?: InputMaybe<TimeFrameFilter>
}

/** A base set of fields that each type of PastItem must implement */
export type PastTargetedTransferItem = {
  sourceAccountTitle: Maybe<Scalars['String']>
  targetAccountTitle: Maybe<Scalars['String']>
}

/** Adds an estimated completion date field for items that correspond to user external transfers */
export type PastUserTransferItem = {
  /** An estimated completion date for when a user transfer will be completed */
  estimatedCompletionDate: Maybe<Scalars['DateTime']>
  /** Indicates whether the user transfer is a recurring investment */
  isRecurring: Maybe<Scalars['Boolean']>
}

export type PastWithdrawalInvestmentItem = PastInvestmentItem &
  PastItem &
  PastTargetedTransferItem & {
    __typename?: 'PastWithdrawalInvestmentItem'
    accountName: Scalars['String']
    amount: Maybe<CurrencyAmount>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when the investment will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type PayoutRelationshipResult = {
  __typename?: 'PayoutRelationshipResult'
  action: Maybe<ManagePayoutRelationshipAction>
  result: Maybe<ManagePayoutRelationshipResult>
}

/** Query attributes for Direct Deposit PDF URL Generation */
export type PdfDownloadUrlInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName: Scalars['String']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** User ID */
  userId?: InputMaybe<Scalars['ID']>
}

/** Returns URL with JWT token to lambda for Front-end */
export type PdfDownloadUrlPayload = {
  __typename?: 'PdfDownloadUrlPayload'
  /** PDF Download URL */
  url: Scalars['String']
}

/** Performance values for a given Investment Account */
export type Performance = {
  __typename?: 'Performance'
  /** Investment account values based on previous market day's closing prices */
  accountValues: Maybe<Array<Maybe<AccountValue>>>
  /** The dollar change in account value over the reporting period */
  marketChange: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period */
  marketChangePercent: Maybe<Scalars['Float']>
  /** The percentage change in account value over the reporting period (excluding fees) */
  marketChangePercentWithoutFees: Maybe<Scalars['Float']>
  /** The dollar change in account value over the reporting period (excluding fees) */
  marketChangeWithoutFees: Maybe<Scalars['Float']>
  /** Investment account value based on previous market day's closing prices */
  previousCloseAmount: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period
   * @deprecated Will not be supported in the future
   */
  totalInvested: Maybe<Scalars['Float']>
  /**
   * The total dollar amount invested over the reporting period (including pending investments)
   * @deprecated Will not be supported in the future
   */
  totalInvestedWithPending: Maybe<Scalars['Float']>
}

/** User profile update fields */
export type PersonalInfoInput = {
  address1?: InputMaybe<Scalars['String']>
  address2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  employer?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  occupation?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  ssn?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  usCitizen?: InputMaybe<Scalars['Boolean']>
  zip?: InputMaybe<Scalars['String']>
}

/** Miscellaneous attributes and information about a user's phone numbers */
export type Phone = TimestampsInterface & {
  __typename?: 'Phone'
  /** Country code */
  countryCode: Scalars['String']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Internal ID for phone */
  id: Scalars['ID']
  /** Phone Number */
  phoneNumber: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
  /** Phone has been verified */
  verified: Scalars['Boolean']
}

export type PhoneAuthenticator = Authenticator & {
  __typename?: 'PhoneAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  phoneNumber: Scalars['PhoneNumber']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type PhoneNumberOptedOutException = {
  __typename?: 'PhoneNumberOptedOutException'
  message: Maybe<Scalars['String']>
}

export enum PinwheelLinkTokenRequiredJobs {
  DirectDepositSwitch = 'DirectDepositSwitch',
}

/** The link token for use in the client. */
export type PlaidLayerLinkSession = {
  __typename?: 'PlaidLayerLinkSession'
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Undefined = 'UNDEFINED',
  Web = 'WEB',
}

export type PoliciesRecordDoesNotExistException = {
  __typename?: 'PoliciesRecordDoesNotExistException'
  policyInput: Maybe<Scalars['String']>
}

export type Policy = {
  __typename?: 'Policy'
  name: Scalars['String']
}

export type PolicyNotAddedException = {
  __typename?: 'PolicyNotAddedException'
  policyInput: Maybe<Scalars['String']>
}

/** Acorns Managed Portfolio Object */
export type Portfolio = BasePortfolio & {
  __typename?: 'Portfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /**
   * Indicates the ETFs that the portfolio is composed of
   * @deprecated Use BasePortfolio.portfolioSecurityAllocations instead
   */
  etfs: Maybe<Etf[]>
  /**
   * Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount).
   * @deprecated Use Portfolio.portfolioSecurities instead.
   */
  holdings: Maybe<PortfolioHolding[]>
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the minimum ratio that must be allocated to the managed portfolio */
  minimumManagedAllocationPercent: Scalars['Float']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  /** Indicates a key based off of the portfolio name */
  nameKey: Scalars['String']
  pendingBalance: MonetaryAmount
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<PortfolioSecurity[]>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<PortfolioSecurityAllocation[]>
  /** Indicates the display priority */
  position: Maybe<Scalars['Int']>
  /** Indicates the projection of the portfolio */
  projection: Maybe<PortfolioProjection>
  /** Indicates how risky the portfolio is */
  riskLevel: PortfolioRiskLevel
  /** Indicates if the portfolio is standard or sustainable */
  theme: PortfolioTheme
  yearToDateReturn: Maybe<MarketReturn>
}

/** Portfolio Allocation Object */
export type PortfolioAllocation = {
  __typename?: 'PortfolioAllocation'
  /** Percentage of investment allocated to this portfolio */
  allocationPercent: Scalars['Float']
  /** ID of the PortfolioAllocation */
  portfolioId: Scalars['ID']
}

export type PortfolioAlreadyRemovedError = {
  __typename?: 'PortfolioAlreadyRemovedError'
  /** Date and Time of removal if portfolio is already removed */
  portfolioRemovedAt: Scalars['DateTime']
}

export enum PortfolioCustomizationLevel {
  /** Additional pre-approved Security's may be added to the Portfolio at pre-set allocations. */
  Addon = 'ADDON',
  /** Portfolio holdings and allocation percentages are fully configurable. */
  FullyConfigured = 'FULLY_CONFIGURED',
  /** Portfolio holdings and allocation percentages are pre-set. */
  None = 'NONE',
}

/** Portfolio Holding */
export type PortfolioHolding = {
  __typename?: 'PortfolioHolding'
  /** The dollar amount of shares a user has */
  amount: Scalars['Float']
  id: Scalars['ID']
  /** The Acorns-assigned name of the ETF */
  name: Scalars['String']
  /** The actual percentage of a user's portfolio the ETF accounts for */
  percentage: Scalars['Float']
  /** The quanity of shares a user has */
  shares: Scalars['Float']
  /** The ETF's trading symbol */
  symbol: Scalars['String']
}

/** Portfolio Not Found */
export type PortfolioNotFoundException = {
  __typename?: 'PortfolioNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Portfolio Not Supported */
export type PortfolioNotSupportedException = {
  __typename?: 'PortfolioNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Portfolio Projection */
export type PortfolioProjection = {
  __typename?: 'PortfolioProjection'
  /** The projected average growth rate */
  averageGrowthRate: Scalars['Float']
  /** The projected highest growth rate */
  highestGrowthRate: Scalars['Float']
  /** The projected lowest growth rate */
  lowestGrowthRate: Scalars['Float']
}

export type PortfolioRemovalInProgressError = {
  __typename?: 'PortfolioRemovalInProgressError'
  /** Message displayed to customer when a portfolio removal is already in progress */
  clientMessage: Scalars['String']
}

export enum PortfolioRiskLevel {
  Aggressive = 'AGGRESSIVE',
  Conservative = 'CONSERVATIVE',
  Custom = 'CUSTOM',
  Moderate = 'MODERATE',
  ModeratelyAggressive = 'MODERATELY_AGGRESSIVE',
  ModeratelyConservative = 'MODERATELY_CONSERVATIVE',
}

/** Portfolio Security */
export type PortfolioSecurity = {
  __typename?: 'PortfolioSecurity'
  /** The current percentage of the market value over the customer's total balance */
  currentAllocationPercentage: Scalars['Float']
  id: Scalars['ID']
  /** The market value of shares owned by the customer */
  marketValue: MonetaryAmount
  /** The Acorns-assigned name of the security */
  name: Scalars['String']
  /** The quantity of shares a user has */
  shares: Scalars['Float']
  /** The security's trading symbol */
  symbol: Scalars['String']
  /**
   * DEPRECATED: The target percentage of the market value over the customer's total balance
   * @deprecated Will not be populated with self directed investments release.
   */
  targetAllocationPercentage: Maybe<Scalars['Float']>
  /** The customer's returns for today */
  todaysReturn: MarketReturn
  /** The customer's returns for all time for the security */
  totalReturn: MarketReturn
}

/** Security allocation */
export type PortfolioSecurityAllocation = {
  __typename?: 'PortfolioSecurityAllocation'
  allocationPercent: Scalars['Float']
  /** @deprecated Use Security.displayName instead */
  displayName: Scalars['String']
  id: Scalars['ID']
  /** Indicates the investment category for the security */
  investmentCategories: InvestmentCategory
  /** @deprecated Use Security.shortName instead */
  name: Scalars['String']
  /** Indicates whether the Security can be removed from an Investment Account's base Portfolio. */
  removableFromBasePortfolio: Scalars['Boolean']
  security: Maybe<Security>
  symbol: Scalars['String']
}

/** Portfolio Security Limit Reached */
export type PortfolioSecurityLimitReached = {
  __typename?: 'PortfolioSecurityLimitReached'
  /** Maximum amount of security allowed */
  limit: Scalars['Int']
}

export enum PortfolioTheme {
  SelfDirected = 'SELF_DIRECTED',
  Standard = 'STANDARD',
  Sustainable = 'SUSTAINABLE',
}

/** Failed to update portfolio on investment account */
export type PortfolioUpdateFailedException = {
  __typename?: 'PortfolioUpdateFailedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type PositiveCurrencyAmountInput = {
  currency: Currency
  value: Scalars['PositiveFloat']
}

/** the selected funding source is not eligible to be preferred. It's either inactive or unlinked */
export type PreferredAccountNotEligibleError = {
  __typename?: 'PreferredAccountNotEligibleError'
  /** requested funding source is not eligible */
  fundingSourceUuid: Maybe<Scalars['ID']>
}

/** The user has only one active FS. Must have two to set preferred withdrawal account */
export type PreferredAccountNotSupportedError = {
  __typename?: 'PreferredAccountNotSupportedError'
  /** doesn't support setting preferred account for the user. */
  userUuid: Maybe<Scalars['ID']>
}

/** Presentation-driven entity for an associated Product */
export type PresentableProduct = {
  __typename?: 'PresentableProduct'
  /** Keys to strings to display description of associated product */
  descriptionKeys: Array<Scalars['StringKey']>
  /** Associated product */
  product: Product
}

export enum PresentableWithdrawalStatus {
  Canceled = 'canceled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Refunded = 'refunded',
  SellingInvestments = 'sellingInvestments',
  Transferring = 'transferring',
}

/** Existing funding source in pending state */
export type PreviousFundingSourcePending = {
  __typename?: 'PreviousFundingSourcePending'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Canonical representation of an Acorns product that can be used and billed for. */
export type Product = {
  __typename?: 'Product'
  /** Indicates whether or not the Product is available to new Users. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  descriptionKeys: Maybe<Array<Scalars['String']>>
  id: Scalars['ID']
  key: ProductKey
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum ProductAccountType {
  Brokerage = 'BROKERAGE',
  Checking = 'CHECKING',
  Custodial = 'CUSTODIAL',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS',
}

/** Ref for product name */
export enum ProductKey {
  BenefitsGohenryStandard = 'BENEFITS_GOHENRY_STANDARD',
  BenefitsInsuranceStandard = 'BENEFITS_INSURANCE_STANDARD',
  BenefitsTaxfilingStandard = 'BENEFITS_TAXFILING_STANDARD',
  BenefitsWillStandard = 'BENEFITS_WILL_STANDARD',
  Early = 'EARLY',
  EarlyMatch = 'EARLY_MATCH',
  EarlyPublishing = 'EARLY_PUBLISHING',
  EarlySelfDirectedInvest = 'EARLY_SELF_DIRECTED_INVEST',
  Earn = 'EARN',
  EarnChoice = 'EARN_CHOICE',
  EarnPrime = 'EARN_PRIME',
  EmergencyFund = 'EMERGENCY_FUND',
  Invest = 'INVEST',
  Later = 'LATER',
  LaterMatch = 'LATER_MATCH',
  Learn = 'LEARN',
  LearnPremium = 'LEARN_PREMIUM',
  MightyOakCard = 'MIGHTY_OAK_CARD',
  MoneyManager = 'MONEY_MANAGER',
  PremiumEducation = 'PREMIUM_EDUCATION',
  SelfDirectedInvest = 'SELF_DIRECTED_INVEST',
  Spend = 'SPEND',
  StandardBenefitsInsurance = 'STANDARD_BENEFITS_INSURANCE',
}

export type ProductNotSupportedException = {
  __typename?: 'ProductNotSupportedException'
  message: Scalars['String']
}

export enum ProductSetupTipType {
  /** Banking - setup digital wallet */
  BankingDigitalWallet = 'banking_digital_wallet',
  /** Banking - setup direct deposit */
  BankingMightyOakCardDirectDeposit = 'banking_mighty_oak_card_direct_deposit',
  /** home - try benefits hub */
  BenefitsHub = 'benefits_hub',
  /** checking engagement wizard - activate card */
  CheckingEngagementWizardActivateCard = 'checking_engagement_wizard_activate_card',
  /** checking engagement wizard - add to digital wallet */
  CheckingEngagementWizardDigitalWallet = 'checking_engagement_wizard_digital_wallet',
  /** checking engagement wizard - direct deposit */
  CheckingEngagementWizardDirectDeposit = 'checking_engagement_wizard_direct_deposit',
  /** checking engagement wizard - set up emergency fund */
  CheckingEngagementWizardEmergencyFund = 'checking_engagement_wizard_emergency_fund',
  /** checking engagement wizard - go henry account connected */
  CheckingEngagementWizardGoHenry = 'checking_engagement_wizard_go_henry',
  /** checking engagement wizard - pay bills */
  CheckingEngagementWizardPayBills = 'checking_engagement_wizard_pay_bills',
  /** checking engagement wizard - set auto roundups */
  CheckingEngagementWizardSetAutoRoundups = 'checking_engagement_wizard_set_auto_roundups',
  /** early - setup direct deposit */
  EarlyDirectDeposit = 'early_direct_deposit',
  /** early - setup recurring transfers */
  EarlyRecurringTransfer = 'early_recurring_transfer',
  /** early - try sustainable portfolio */
  EarlyTrySustainablePortfolio = 'early_try_sustainable_portfolio',
  /** home - earn android extension */
  EarnAndroidExtension = 'earn_android_extension',
  /** home - earn safari extension */
  EarnSafariExtension = 'earn_safari_extension',
  /** home - harvest bank fees */
  HarvestBankFees = 'harvest_bank_fees',
  /** home - link primary checking */
  HomeLinkPrimaryChecking = 'home_link_primary_checking',
  /** home - link roundup cards */
  HomeLinkRoundupCards = 'home_link_roundup_cards',
  /** home - set auto roundups */
  HomeSetAutoRoundups = 'home_set_auto_roundups',
  /** home - try self-directed portfolio */
  HomeTrySelfDirectedPortfolio = 'home_try_self_directed_portfolio',
  /** home - try sustainable portfolio */
  HomeTrySustainablePortfolio = 'home_try_sustainable_portfolio',
  /** invest - add bitcoin to diversified portfolio */
  InvestAddBitcoin = 'invest_add_bitcoin',
  /** invest hub - link primary checking */
  InvestHubLinkPrimaryChecking = 'invest_hub_link_primary_checking',
  /** invest hub - link roundup cards */
  InvestHubLinkRoundupCards = 'invest_hub_link_roundup_cards',
  /** invest hub - set auto roundups */
  InvestHubSetAutoRoundups = 'invest_hub_set_auto_roundups',
  /** invest hub - try self-directed portfolio */
  InvestHubTrySelfDirectedPortfolio = 'invest_hub_try_self_directed_portfolio',
  /** invest - link primary checking */
  InvestLinkPrimaryChecking = 'invest_link_primary_checking',
  /** invest - link roundup cards */
  InvestLinkRoundupCards = 'invest_link_roundup_cards',
  /** invest - make first investment */
  InvestMakeFirstInvestment = 'invest_make_first_investment',
  /** invest - schedule regular deposits */
  InvestScheduleRegularDeposits = 'invest_schedule_regular_deposits',
  /** invest - set auto roundups */
  InvestSetAutoRoundups = 'invest_set_auto_roundups',
  /** invest - try self-directed portfolio */
  InvestTrySelfDirectedPortfolio = 'invest_try_self_directed_portfolio',
  /** invest - try sustainable portfolio */
  InvestTrySustainablePortfolio = 'invest_try_sustainable_portfolio',
  /** later - link primary checking */
  LaterLinkPrimaryChecking = 'later_link_primary_checking',
  /** later - make first investment */
  LaterMakeFirstInvestment = 'later_make_first_investment',
  /** later schedule regular deposits */
  LaterScheduleRegularDeposits = 'later_schedule_regular_deposits',
  /** later - set a beneficiary */
  LaterSetABeneficiary = 'later_set_a_beneficiary',
  /** later - try sustainable portfolio */
  LaterTrySustainablePortfolio = 'later_try_sustainable_portfolio',
  /**
   * all contexts - nps survey
   * @deprecated deprecated tip no longer used on clients
   */
  NpsSurvey = 'nps_survey',
  /** home - path to million promotion */
  PathToMillion = 'path_to_million',
  /** all contexts - referral promotion */
  ReferralPromotion = 'referral_promotion',
  /** spend - setup direct deposit */
  SpendDirectDeposit = 'spend_direct_deposit',
  /** spend - incentive to setup direct deposit */
  SpendDirectDepositIncentive = 'spend_direct_deposit_incentive',
  /** spend - setup recurring deposit */
  SpendRecurringDeposit = 'spend_recurring_deposit',
  /** spend - set spend as primary */
  SpendSetAsPrimary = 'spend_set_as_primary',
  /** spend - setup smart deposit */
  SpendSmartDeposit = 'spend_smart_deposit',
  /** spend - smart deposit sweepstakes */
  SpendSmartDepositSweepstakes = 'spend_smart_deposit_sweepstakes',
  /** home - wildfire chrome extension */
  WildfireChromeExtension = 'wildfire_chrome_extension',
}

export enum ProductType {
  Core = 'core',
  Early = 'early',
  Later = 'later',
  Spend = 'spend',
}

/** Miscellaneous attributes and information about a user */
export type Profile = TimestampsInterface & {
  __typename?: 'Profile'
  /** Annual income */
  annualIncome: Maybe<Scalars['Int']>
  /** Combined annual income */
  combinedAnnualIncome: Maybe<Scalars['Int']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Debt */
  debt: Maybe<Scalars['Boolean']>
  /** Employees */
  employees: Maybe<Employees>
  /** Employment status */
  employmentStatus: Maybe<EmploymentStatus>
  /** Filing type */
  filingType: Maybe<FilingType>
  /** Financial education */
  financialEducation: Maybe<FinancialEducation>
  /** First name */
  firstName: Maybe<Scalars['String']>
  /** Funds availability */
  fundsAvailability: Maybe<FundsAvailability>
  /** High-interest debt */
  highInterestDebt: Maybe<Scalars['Boolean']>
  /** Investment goal */
  investmentGoal: Maybe<InvestmentGoal>
  /** Last name */
  lastName: Maybe<Scalars['String']>
  /** Marital status */
  maritalStatus: Maybe<MaritalStatus>
  /** Monthly expenses */
  monthlyExpenses: Maybe<Scalars['Float']>
  /** Net worth */
  netWorth: Maybe<Scalars['Float']>
  /** has user opted out of targeting */
  optedOutOfTargeting: Scalars['Boolean']
  /** Retirement plan access */
  retirementPlanAccess: Maybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome: Maybe<Scalars['Int']>
  /** Signature type */
  signatures: Array<Maybe<Signature>>
  /** Last four of SSN */
  ssnLastFour: Maybe<Scalars['String']>
  /** User has paused their transfers */
  transfersPaused: Maybe<Scalars['Boolean']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export type ProfileAttribute = {
  key: Scalars['String']
  value: Scalars['JSON']
}

/** Changeable attributes for user profiles */
export type ProfileInput = {
  /** Non-self employed income */
  annualIncome?: InputMaybe<Scalars['Int']>
  /** Total annual income */
  combinedAnnualIncome?: InputMaybe<Scalars['Int']>
  /** Debt */
  debt?: InputMaybe<Scalars['Boolean']>
  /** Number of employees the user has (if self employed) */
  employees?: InputMaybe<Employees>
  /** Status of user's employment */
  employmentStatus?: InputMaybe<EmploymentStatus>
  /** How the user files their taxes */
  filingType?: InputMaybe<FilingType>
  /** User's level of financial education */
  financialEducation?: InputMaybe<FinancialEducation>
  /** Funds availability */
  fundsAvailability?: InputMaybe<FundsAvailability>
  /** High-interest debt */
  highInterestDebt?: InputMaybe<Scalars['Boolean']>
  /** User's investment goal */
  investmentGoal?: InputMaybe<InvestmentGoal>
  /** Marital status */
  maritalStatus?: InputMaybe<MaritalStatus>
  /** Monthly expenses */
  monthlyExpenses?: InputMaybe<Scalars['Float']>
  /** Net worth */
  netWorth?: InputMaybe<Scalars['Float']>
  /** How the user wants to access their retirement plan */
  retirementPlanAccess?: InputMaybe<RetirementPlanAccess>
  /** Self employed income */
  selfEmployedIncome?: InputMaybe<Scalars['Int']>
  /** Pause transfers */
  transfersPaused?: InputMaybe<Scalars['Boolean']>
}

export enum ProgramAccountType {
  Plan = 'PLAN',
}

export type PromoCode = {
  __typename?: 'PromoCode'
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  description: Scalars['String']
  id: Scalars['ID']
  internalMemo: Maybe<Scalars['String']>
  name: Scalars['String']
  publishEnd: Maybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  qualificationAmount: Scalars['Int']
  rewards: PromoCodeReward[]
  status: PromoCodeStatus
  termsUrl: Maybe<Scalars['URL']>
  title: Scalars['String']
}

export enum PromoCodeBusinessLine {
  Affiliate = 'AFFILIATE',
  Brand = 'BRAND',
  Organic = 'ORGANIC',
  PaidMedia = 'PAID_MEDIA',
}

export type PromoCodeCustomer = {
  __typename?: 'PromoCodeCustomer'
  promoCode: PromoCode
  userId: Scalars['ID']
}

export type PromoCodeEdge = {
  __typename?: 'PromoCodeEdge'
  cursor: Scalars['String']
  node: PromoCode
}

export type PromoCodeFieldLengthError = {
  __typename?: 'PromoCodeFieldLengthError'
  field: Scalars['String']
  max: Scalars['Int']
}

export type PromoCodePaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>
}

export type PromoCodePaginatedInfo = {
  __typename?: 'PromoCodePaginatedInfo'
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>
}

export enum PromoCodeQualificationAction {
  InitialInvestment = 'INITIAL_INVESTMENT',
  InitialRecurringInvestment = 'INITIAL_RECURRING_INVESTMENT',
  InitialRoundup = 'INITIAL_ROUNDUP',
  InitialSubscriptionPayment = 'INITIAL_SUBSCRIPTION_PAYMENT',
}

export type PromoCodeReward = {
  __typename?: 'PromoCodeReward'
  amount: Scalars['Float']
  id: Scalars['ID']
  type: PromoCodeRewardType
}

export type PromoCodeRewardEdge = {
  __typename?: 'PromoCodeRewardEdge'
  cursor: Scalars['String']
  node: PromoCodeReward
}

export enum PromoCodeRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER',
}

export type PromoCodeRewardsConnection = {
  __typename?: 'PromoCodeRewardsConnection'
  edges: Maybe<PromoCodeRewardEdge[]>
  pageInfo: PromoCodePaginatedInfo
}

export enum PromoCodeStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type PromoCodesConnection = {
  __typename?: 'PromoCodesConnection'
  edges: Maybe<PromoCodeEdge[]>
  pageInfo: PromoCodePaginatedInfo
}

/** Display wrapper for featured promo offer */
export type PromoOffer = {
  __typename?: 'PromoOffer'
  /** Background/featured image */
  backgroundImage: Image
  /** Display body for the offer */
  body: Maybe<Scalars['String']>
  /** Desktop Background/featured image */
  desktopBackgroundImage: Image
  id: Scalars['ID']
  /** Company/partner logo */
  logo: Maybe<Image>
  /** Partner url */
  partnerUrl: Scalars['URL']
  /** Display subtitle for the offer */
  subtitle: Maybe<Scalars['String']>
  /** Display title for the offer */
  title: Scalars['String']
}

export type PromotedBenefit = {
  __typename?: 'PromotedBenefit'
  product: BenefitsTrackerProducts
  promotedThrough: BenefitPromotedThrough[]
}

export type PromotedCampaigns = {
  __typename?: 'PromotedCampaigns'
  campaignIds: Array<Maybe<Scalars['ID']>>
}

/** Time-bound pricing and/or additional incentives offered to subscibers of a particular offering (tier or product). */
export type Promotion = {
  __typename?: 'Promotion'
  /** Wether or not the promotion is available for new applications. */
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  /** How long the promotion lasts once applied to a subscription. */
  duration: Maybe<PromotionDuration>
  /** When the promotion is set to expire and become inactive. */
  expiresAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** Additional incentives the promotion entitles subscribers to. */
  incentives: Maybe<Incentive[]>
  name: Scalars['String']
  /** Services that the promotion is for. */
  offering: Offering
  /** Metadata indicating in what contexts a client should present the promotion. */
  presentInContexts: Array<Scalars['String']>
  /** Link to legal terms and conditions of the promotion. */
  termsUrl: Scalars['URL']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type PromotionConsumedError = {
  __typename?: 'PromotionConsumedError'
  message: Scalars['String']
}

export type PromotionDuration = {
  __typename?: 'PromotionDuration'
  period: PromotionDurationPeriod
  periodCount: Scalars['Int']
}

export enum PromotionDurationPeriod {
  Month = 'MONTH',
}

export type PromotionExpiredError = {
  __typename?: 'PromotionExpiredError'
  expiredAt: Scalars['DateTime']
  message: Scalars['String']
}

export type PromotionFilterInput = {
  presentInContexts?: InputMaybe<PromotionPresentInContextsFilterInput>
}

export type PromotionNotFoundError = {
  __typename?: 'PromotionNotFoundError'
  message: Scalars['String']
}

export type PromotionPresentInContextsFilterInput = {
  in?: InputMaybe<Array<Scalars['String']>>
}

/** promotional waiver */
export type PromotionalWaiver = {
  __typename?: 'PromotionalWaiver'
  promotion: Maybe<WaiverPromotion>
  promotionalWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

export type PromotionalWaiver_V2 = {
  __typename?: 'PromotionalWaiver_V2'
  promotion: WaiverPromotion_V2
  promotionalWaiverPeriodEndDate: Scalars['String']
  userId: Scalars['ID']
}

export type Prospect = {
  email: Scalars['String']
  id: Scalars['ID']
}

export enum ProspectType {
  Grow = 'GROW',
  LaterWaitlist = 'LATER_WAITLIST',
  OutsideContribution = 'OUTSIDE_CONTRIBUTION',
}

/** provisional fee waiver */
export type ProvisionalWaiver = {
  __typename?: 'ProvisionalWaiver'
  userId: Scalars['ID']
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Maybe<Scalars['String']>
}

export type ProvisionalWaiver_V2 = {
  __typename?: 'ProvisionalWaiver_V2'
  userId: Scalars['ID']
  waiverPeriodEndDate: Scalars['String']
  waiverReason: Scalars['String']
}

/** Statuses after a campaign is published */
export enum PublishedCampaignStatus {
  Complete = 'COMPLETE',
  Live = 'LIVE',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
}

export type PushAuthChallenge = AuthChallenge & {
  __typename?: 'PushAuthChallenge'
  alternateAuthenticators: AuthenticatorInfo[]
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  id: Scalars['ID']
  pushState: ChallengePushState
  updatedAt: Scalars['DateTime']
}

export type PushAuthenticator = Authenticator & {
  __typename?: 'PushAuthenticator'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['ID']
  deviceType: DeviceType
  id: Scalars['ID']
  lastAuthenticatedAt: Maybe<Scalars['DateTime']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  type: AuthType
  updatedAt: Scalars['DateTime']
}

export type PushAuthenticatorAlreadyExistsException = {
  __typename?: 'PushAuthenticatorAlreadyExistsException'
  authenticatorId: Scalars['ID']
  message: Maybe<Scalars['String']>
}

export type QualificationSubTypeMismatchError = {
  __typename?: 'QualificationSubTypeMismatchError'
  message: Scalars['String']
}

export type Query = {
  __typename?: 'Query'
  /** Fetch mighty oak card waiver for user. */
  MightyOakCardWaiver: MightyOakWaiverResult
  /** Get an acceptance document by type */
  acceptanceDocument: Maybe<AcceptanceDocument>
  /** Get a list of documents the user needs to accept */
  acceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>
  accountPointsRuleByMilestoneId: Maybe<AccountPointsRule>
  accountPointsRules: Maybe<AccountPointsRule[]>
  accountStrength: Maybe<AccountStrengthResult>
  /** Fetch a list of accounts for a user */
  accounts: Array<Maybe<Account>>
  /** query action feed cards */
  actionFeed: Maybe<Array<Maybe<ActionCard>>>
  /** Query for the list of eligible Action Screen widgets for the current user */
  actionScreen: ActionScreenComponent[]
  /** @implicit(userId: String) */
  activeEarnOffers: EarnOfferQueryPage
  /** @deprecated Field no longer supported */
  activeReferralCampaigns: Maybe<ActiveReferralCampaignOutput>
  /** @deprecated Use the past queries instead. */
  activity: Maybe<Array<Maybe<Activity>>>
  /** query account summary information */
  activitySummary: Maybe<ActivitySummaryResponse>
  /** Used to determine if an address is deliverable or offer corrections to make it deliverable. */
  addressDeliverability: Maybe<AddressDeliverabilityResult>
  /** Fetch a list of addresses for a user */
  addresses: Array<Maybe<Address>>
  /** @implicit(userId: ID!) */
  advocate: Maybe<Advocate>
  /**
   * @implicit(userId: ID!)
   * @deprecated Field no longer supported
   */
  advocateFriendsStatuses: Maybe<AdvocateFriendsStatuses>
  /** Fetch all beneficiary alerts for a user */
  alertHubBeneficiaryAlerts: Maybe<AlertHubBeneficiaryAlert[]>
  /** Get all acceptance documents */
  allAcceptanceDocuments: Maybe<Array<Maybe<AcceptanceDocument>>>
  /** Pulls all accounts for a customer. */
  allAccounts: CustomerAccount[]
  allBankAccounts: Maybe<Array<Maybe<BankAccount>>>
  allBankCards: Maybe<Array<Maybe<BankCard>>>
  allBankDocuments: Maybe<Array<Maybe<BankDocument>>>
  allBankStatements: Maybe<Array<Maybe<BankStatement>>>
  allBankTransactions: Maybe<BankTransactionConnection>
  /** Get the Card Delivery Status */
  allCardTrackingStatuses: Maybe<CardDeliveryStatus[]>
  /** Fetch pages of messages for the user starting from the most recent message */
  allChatHistoryMessages: AllChatHistoryMessages
  allCheckPayments: Maybe<AllCheckPaymentsResult>
  allCloseAccountReasons: Maybe<Array<Maybe<CloseAccountReason>>>
  /** Returns list of categories and nested subcategories for dynamic values in contact form */
  allContactCategories: Maybe<ContactCategory[]>
  /** @deprecated Use Query.investmentAccountsByUserId instead. */
  allInvestmentAccounts: Maybe<InvestmentAccount[]>
  /** Fetches all messages for a user. Leverages Hedwig's DB for notifications/alerts and queries external services for alerts. Make sure a `x-client-platform` header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  allMessages: Maybe<Message[]>
  /** Fetch all Core items for the Past screen. */
  allPastCoreItemChildren: Maybe<PastItem[]>
  /** Fetch all Core items for the Past screen. Defaults to only return non-pending transactions */
  allPastCoreItems: Maybe<PastItemConnection>
  /** Fetch all Early items for the Past screen. Defaults to only return non-pending transactions */
  allPastEarlyItems: Maybe<PastItemConnection>
  allPastItems: Maybe<PastItemConnection>
  /** Fetch all Later items for the Past screen. Defaults to only return non-pending transactions */
  allPastLaterItems: Maybe<PastItemConnection>
  /** Fetch all pending items across all product types. */
  allPastPendingItems: Maybe<PastItem[]>
  /** Fetch all of a users scheduled transactions from their product accounts */
  allPastScheduledItems: Maybe<PastScheduledItem[]>
  allPastSpendItems: Maybe<PastItemConnection>
  allReturnedCheckDeposits: Maybe<ReturnedCheckDeposit[]>
  allSuitabilityQuestions: Maybe<Array<Maybe<SuitabilityQuestion>>>
  /** Returns all support articles */
  allSupportArticles: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns all the current categories within the Help Center */
  allSupportCategories: Maybe<Array<Maybe<SupportCategory>>>
  /** Returns all support sections */
  allSupportSections: Maybe<Array<Maybe<SupportSection>>>
  /** Returns all support ticket forms */
  allSupportTicketForms: Maybe<Array<Maybe<SupportTicketForm>>>
  allTransferableFrom: Maybe<TransferableFrom[]>
  allTransferableTo: Maybe<TransferableTo[]>
  /** Fetch all trusted contacts for a user by user uuid */
  allTrustedContactsByUserId: Array<Maybe<TrustedContact>>
  /** @implicit(userId: ID!) */
  authAlerts: Maybe<AuthAlert[]>
  /** @implicit(userId: ID!) */
  authProfile: Maybe<AuthProfile>
  authenticateForFeeNegotiationStatusByLinkedAccountId: Maybe<AuthenticateForFeeNegotiationStatus>
  /** Returns backend job batches for order types */
  backendJobBatchAutomatedOrders: Maybe<BackendJobBatch[]>
  /** Returns backend job batches for money movement */
  backendJobBatchMoneyMovement: Maybe<BackendJobBatch[]>
  /** Returns backend job batches for order types */
  backendJobBatchOrders: Maybe<BackendJobBatch[]>
  /** Returns backend job batches for profit star deposits */
  backendJobBatchProfitStars: Maybe<BackendJobBatch[]>
  /** Returns all order aggregation stats */
  backendJobBatchSummary: Maybe<BackendJobBatchSummary>
  bankAccountClosureReasons: BankAccountClosureReason[]
  bankAccountDisclosures: Maybe<Array<Maybe<BankAccountDisclosure>>>
  /** Returns the bank account state for a given account type. */
  bankAccountState: Maybe<BankAccountStateResult>
  bankCardOrder: Maybe<BankCardOrder>
  /** Returns a temporary encrypted token for a digitally active bank card's display details */
  bankCardPanDisplay: BankCardPanDisplayResult
  /** Returns an encrypted token for virtual bank card provisioning */
  bankCardProvisioningDetails: BankCardProvisioningDetailsResult
  bankCardReissue: Maybe<BankCardReissue>
  /** @implicit(userId: String!) */
  bankFeeNegotiationsByUserId: FeeNegotiationSummary
  /**
   * @implicit(userId: ID!)
   * @deprecated Use query.bankFeesByUserId instead
   */
  bankFeeSummaryByUserId: Maybe<BankFeeSummary>
  /** @implicit(userId: ID!) */
  bankFeesByUserId: Maybe<BankFee[]>
  /** Returns interest rates for banking products. Omit filter to return data for all products. */
  bankInterestRates: BankInterestRatesResult
  /** @deprecated Incorrect and no longer in use, we are removing this method in the future */
  bankMetadata: Maybe<BankMetadata>
  bankTransaction: Maybe<BankTransaction>
  bankingEmploymentStatuses: Array<Scalars['String']>
  /**
   * Returns the KYC status and verification details for the user, if it exists.
   * This is used to determine if the user has completed Banking KYC and if any action is required.
   */
  bankingKycDetails: Maybe<BankingKyc>
  /** Returns Acorns banners information data */
  banners: Maybe<Array<Maybe<BannersResponse>>>
  /** Fetch all beneficiaries for a user */
  beneficiaries: Maybe<Beneficiary[]>
  /** Fetch a beneficiary with a given ID */
  beneficiary: Maybe<Beneficiary>
  /** Fetch all beneficiary alerts for a user */
  beneficiaryAlerts: Maybe<Alert[]>
  /** @implicit(userId: String!) */
  benefitPartnerByUserId: BenefitPartnerResponse
  /** Fetch billing cycles given an ID */
  billingCycle: Maybe<BillingCycle>
  /** Fetch billing cycles given a user ID */
  billingCycles: Maybe<BillingCycle[]>
  /** Fetch the data used in determining how a user is billed */
  billingProfile: Maybe<BillingProfile>
  /** @implicit(userId: ID!) */
  calculateMoneySplits: Maybe<MoneyRulesSuggestionResult>
  /** @implicit(userId: ID!) */
  campaignHistory: Maybe<CampaignHistoryConnection>
  /** @implicit(userId: ID!) */
  challenges: Maybe<AuthChallenge[]>
  /** Investment account closure reasons */
  closureReasonsByInvestmentAccountType: InvestmentAccountClosureReason[]
  /** @implicit(userId: ID!) */
  cohortEligibility: CohortEligibility[]
  /** @implicit(userId: ID!) */
  cohortEligibility_v2: Maybe<CohortEligibility_V2[]>
  /** Fetch the combined performance of user's investment accounts */
  combinedPerformanceByUserId: CombinedPerformance
  /** Returns info for completed quiz such as user score, average score, number of total and correct questions */
  completedQuizByQuizId: Maybe<CompletedQuiz>
  /** @implicit(userId: String!) */
  connectionsByUserId: ConnectionSummary
  /** Returns contact form alert message if it has been set in Zesty */
  contactFormAlert: Maybe<ContactFormAlert>
  /**
   * Returns a course or null if it does not exist
   * @deprecated This endpoint is being removed and being replaced by course_v2 in order to support locked content
   */
  course: Maybe<Course>
  /** Returns a learn course or null if it does not exist */
  course_v2: Maybe<LearnCourse>
  /**
   * Returns a list of courses for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  coursesByTierId: Maybe<CoursePreview[]>
  /** Returns a list of courses for given topic */
  coursesByTopicId: Maybe<CoursePreview[]>
  /** Returns a list of courses for given topic */
  coursesByTopicId_v2: Maybe<LearnCoursePreview[]>
  /** Returns a personalized list of courses */
  coursesPersonalizedByUserId: Maybe<CoursePreview[]>
  /** Get the currently offered crypto ETF that can be added to a managed Portfolio. */
  cryptoEtf: Maybe<Etf>
  /** Fetch a user's customer account closure record */
  customerAccountClosureRequest: Maybe<CustomerAccountClosure>
  /**
   * Get a customer's Earn onboarding program and status
   * @deprecated The Earn Onboarding program has been discontinued
   */
  customerEarnOnboardingProgram: Maybe<CustomerEarnOnboardingProgram>
  /** @implicit(userId: ID!) */
  customerMoneyRules: Maybe<CustomerMoneyRulesResult>
  /** @implicit(userId: ID!) */
  device: Maybe<Device>
  /** @implicit(userId: ID!) */
  devicesByUserId: Maybe<Device[]>
  /** Return the user's direct deposit status */
  directDepositInfo: DirectDepositInfoPayload
  /** Return the user switches' state */
  directDepositState: DirectDepositStatePayload
  /** Returns portfolio diversification information for a provided customer */
  diversificationInfoByInvestmentAccountId: Maybe<DiversificationInfo>
  documentRequest: Maybe<DocumentRequest>
  documentRequests: Maybe<DocumentRequestsConnection>
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountClosureReasons: InvestmentAccountClosureReason[]
  /** State and Territory regulations for Early Account for the given Custodian */
  earlyAccountStateRegulation: EarlyAccountStateRegulationResult
  /** DEPRECATED - Use InvestmentAccountTransferability instead */
  earlyAccountTransferInfo: Maybe<EarlyAccountTransferInfo>
  /** Get a list of Earn CTA Data */
  earnCTADataByUserId: Maybe<EarnCtaRecord[]>
  /** Retrieve EarnOffer by campaignOfferId with fall back support by campaignId */
  earnOfferByCampaignOfferId: Maybe<EarnOffer>
  /** Get the reward information associated with investment IDs */
  earnRewardsByInvestmentIds: Maybe<EarnReward[]>
  /** @deprecated Use feature specific eligibility queries. */
  eligibility: Maybe<Eligibility>
  /** Check for existence of credentials and formatting of input for a given email */
  emailAddressValidation: EmailAddressValidation
  estimatedCheckPaymentDates: Maybe<EstimatedCheckPaymentDates>
  /** The estimated clawback match */
  estimatedMatchRemoval: Maybe<MonetaryAmount>
  estimatedTransferDates: Maybe<EstimatedTransferDatesPayload>
  /** Fetches stored information about the ETF. */
  etf: Maybe<Etf>
  /** Evaluates check deposit session to determine if it is submittable. */
  evaluateCheckDeposit: Maybe<EvaluateCheckDepositPayload>
  /** @implicit(userId: ID!) */
  extoleCampaignHistory: Maybe<ExtoleCampaignHistoryConnection>
  /** @implicit(userId: ID!) */
  extoleReferralHistory: Maybe<ExtoleReferralHistory>
  /** Retrieves list of favorite EarnOffers that the user is currently eligible for */
  favoriteEarnOffers: FavoritePartnerOfferGroup
  /** Returns a personalized list of featured learn content */
  featuredLearnContentPersonalizedByUserId: Maybe<FeaturedLearnContentPreview[]>
  /** @implicit(userId: ID!) */
  featuredMilestones: FeaturedMilestones
  /**
   * @implicit(userId: ID!)
   * @deprecated This will no longer be used to support the account setup user state, replace with featuredMilestones
   */
  featuredMilestones_v2: Maybe<FeaturedMilestonesV2>
  /** Fetch a fee given the ID */
  fee: Maybe<Fee>
  /** Fetch all fees given an argument */
  fees: Maybe<Fee[]>
  financialAdvisorQuestions: FinancialAdvisorQuestionsResponse
  financialGoalsRecommendation: FinancialGoalsResult
  /** Fetch a Financial Institution by external ID */
  financialInstitution: Maybe<FinancialInstitution>
  /** Fetch all Financial Institutions */
  financialInstitutions: FinancialInstitutionTypePagination
  /** query finish setup information */
  finishSetup: Maybe<FinishSetup>
  /** Returns acorns footer content */
  footerContent: Maybe<FooterContent>
  /**
   * Get a list of Found Money rewards
   * @deprecated This has been replaced by foundMoneyRewardsV2
   */
  foundMoneyRewards: Maybe<Array<Maybe<FoundMoneyReward>>>
  /** Get a list of Found Money rewards */
  foundMoneyRewardsV2: Maybe<EarnReward[]>
  /** Get a summary of all Found Money rewards */
  foundMoneySummary: Maybe<FoundMoneySummary>
  /**
   * @implicit(userId: ID!)
   * @deprecated Field no longer supported
   */
  friend: Maybe<Friend>
  /** @implicit(userId: ID!) */
  friendV2: Maybe<FriendV2Output>
  fundSpendInActivation: Maybe<FundSpendInActivationPayload>
  /** Fetches a list of funding source(s) for the user */
  fundingSourceAccounts: Maybe<FundingSourceAccount[]>
  /** Get information about a user's primary funding source */
  fundingSourceInfo: Maybe<FundingSourceInfo>
  /** Generate Updated Base 64 Encoded PDF String */
  generateUpdatedPdf: Maybe<GenerateUpdatedPdfPayload>
  /** @implicit(userId: ID!) */
  getBillingHistory: Maybe<BillingInvoice[]>
  getPartnerDetails: PartnerDetailsResponse
  /** @implicit(userId: String!) */
  getPartnerDocumentByUserId: PartnerDocumentUrlResponse
  /** @implicit(userId: String!) */
  getPartnerUrl: PartnerUrlResponse
  /** @deprecated No longer in use */
  getUsersBankFromAccountType: Maybe<GetUsersBankFromAccountTypePayload>
  /** Lookup billing vendor invoice by invoice id */
  getVendorInvoice: Maybe<Invoice>
  /** Returns help form submission content */
  helpFormContent: Maybe<HelpFormContent>
  /**
   * Returns helpcenter banner information data
   * @deprecated Replaced with banners query.
   */
  helpcenterBanner: Maybe<HelpcenterBannerResponse>
  /** Returns instant support articles from search term currently in search field */
  instantSearchSupportArticles: Maybe<Array<Maybe<SearchSupportArticleResult>>>
  /** @implicit(userId: UUID!) */
  intent: Maybe<Intent>
  /** @implicit(userId: UUID!) */
  intents: Intent[]
  /** Retrieve an Investment by it's unqiue `id`. */
  investment: Maybe<Investment>
  /** Fetches an investment account for the authorized user */
  investmentAccount: Maybe<InvestmentAccount>
  /** Return an investment account by the beneficiary ID */
  investmentAccountByBeneficiaryId: Maybe<InvestmentAccount>
  /** Get an investment account recap by it's unique id. */
  investmentAccountRecap: Maybe<InvestmentAccountRecap>
  /** Get an investment account recap by it's unique public token. */
  investmentAccountRecapByPublicToken: Maybe<InvestmentAccountRecap>
  /** Fetch user's investment accounts */
  investmentAccountsByUserId: InvestmentAccount[]
  /** Returns investments between the provided date range (default is 1 month) for the provided investment account id */
  investmentsByInvestmentAccountId: Maybe<InvestmentPagination>
  /** Fetch user's referral invitation */
  invitationForUser: Maybe<Referral>
  /**
   * @implicit(userId: String!)
   * @deprecated Job Alerts are no longer supported
   */
  jobAlerts: Maybe<JobAlert[]>
  jobEducationContent: Maybe<Jobs_Education>
  /** @implicit(userId: String!) */
  jobSearch: Maybe<Jobs_Offer[]>
  /** @implicit(userId: String!) */
  jobSearchPage: Maybe<JobSearchPage>
  /** @implicit(userId: String!) */
  jobSearchV2: Maybe<Jobs_OfferConnection>
  laterAccounts: Maybe<Array<Maybe<LaterAccount>>>
  laterBeneficiaries: Maybe<Array<Maybe<LaterIndividualBeneficiary>>>
  /**
   * Contribution ability per year; only years in the current "tax window" returned
   * @deprecated Use laterUserContributionAbility
   */
  laterContributionAbility: Maybe<Array<Maybe<ContributionAbility>>>
  laterContributionHistory: Maybe<ContributionHistoryItem[]>
  laterHistory: Maybe<Array<Maybe<LaterHistoryItem>>>
  laterPortfolioPerformance: Maybe<LaterPortfolioPerformance>
  laterUserContributionAbility: Maybe<LaterContributionAbilityResult>
  /** Returns the Article with given id */
  learnArticle: Maybe<LearnArticle>
  /** Returns all results that match given term. Results can be filtered and sorted. */
  learnContentBySearchTerm: Maybe<ContentPreviewConnection>
  /**
   * Returns all results that match given tier. Results can be filtered and sorted.
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  learnContentByTierId: Maybe<ContentPreviewConnection>
  /** Returns all results that match given topic. Results can be filtered and sorted. */
  learnContentByTopicId: Maybe<ContentPreviewConnection>
  /** Returns a list of all Learn Hub tiers and topics combined */
  learnContentCategories: Maybe<LearnContentCategory[]>
  /** Returns a list of content previews corresponding the given content ids */
  learnContentPreviewsByContentIds: Maybe<LearnContentPreview[]>
  /** Returns up to 3 recommendations for search terms of at least 3 chars */
  learnContentRecommendationsBySearchTerm: Maybe<LearnContentPreview[]>
  /** Returns recent search terms and popular searches */
  learnContentSearchHistoryByUserId: Maybe<SearchHistory>
  /** Returns a learn media content or null if one does not exist for the ID */
  learnMedia: Maybe<LearnMedia>
  /** Returns a list of course next step actions */
  learnNextStepActionsByCourseId: Maybe<LearnNextStepAction[]>
  /** Returns a list of next step actions for the requested media */
  learnNextStepActionsByMediaId: Maybe<LearnNextStepAction[]>
  /** Returns a list of question insights related to the incorrect questions */
  learnQuestionInsightsByQuizId: Maybe<LearnQuestionInsight[]>
  /** Returns a list of learn content for given action feed context */
  learnWidgetContent: Maybe<LearnContentPreview[]>
  /** Fetch a linked account */
  linkedAccount: Maybe<LinkedAccount>
  /** Fetch alerts for linked account */
  linkedAccountAlerts: Maybe<LinkedAccountAlertsResponse[]>
  /** Fetch webhook URLs */
  linkedAccountWebhooks: Webhooks
  /** Fetch linked accounts for a given user */
  linkedAccounts: LinkedAccount[]
  /** Fetch a linked subaccount */
  linkedSubaccount: Maybe<LinkedSubaccount>
  /** Fetch linked subaccounts for a given user */
  linkedSubaccounts: LinkedSubaccount[]
  /** Fetch a liquidation given the ID */
  liquidation: Maybe<Liquidation>
  /** Fetch all liquidations given an argument */
  liquidations: Maybe<Liquidation[]>
  /** @implicit(userId: ID!) */
  listBenefitsByUserId: Maybe<BenefitTileGroup[]>
  market: Maybe<Market>
  /** Get a match program by it's id. */
  matchProgram: Maybe<MatchProgram>
  /** Fetches a message based on a user ID and internal message ID. */
  message: Maybe<Message>
  /** Fetches a message based on a user ID and external message ID. */
  messageByExternalId: Maybe<Message>
  /** Fetches messages for a user. Supports pagination (offset/count) and filtering. Make sure an x-client-platform header is passed in as a string that is a comma-separated list of valid platforms. Will return messages that support any of the passed platforms */
  messages: Maybe<MessageConnection>
  /** @implicit(userId: ID!) */
  milestone: Maybe<Milestone>
  milestoneAccountLevelDefinitions: Maybe<MilestoneAccountLevelDefinition[]>
  milestoneAchievementActionRule: Maybe<MilestoneAchievementActionRule>
  milestoneAchievementActionRules: MilestoneAchievementActionRule[]
  milestoneAchievementActionTypes: MilestoneAchievementActionType[]
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  milestoneChallenge: Maybe<MilestoneChallenge>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRuleByMilestoneIdByChallengeId: Maybe<MilestoneChallengePointsRule>
  /** @deprecated This was only relevant for the Path to $1M sweepstakes. */
  milestoneChallengePointsRulesByMilestoneId: Maybe<
    MilestoneChallengePointsRule[]
  >
  milestoneDefinition: Maybe<MilestoneDefinition>
  milestoneDefinitions: Maybe<MilestoneDefinition[]>
  /** @implicit(userId: ID!) */
  milestoneEligibilityByScopes: Maybe<MilestoneEligibility[]>
  milestoneGroupAchievementActionRule: Maybe<MilestoneGroupAchievementActionRule>
  milestoneGroupAchievementActionRules: Maybe<
    MilestoneGroupAchievementActionRule[]
  >
  milestoneGroupDefinition: Maybe<MilestoneGroupDefinition>
  milestoneGroupDefinitions: Maybe<MilestoneGroupDefinition[]>
  /** @implicit(userId: ID!) */
  milestoneHub: Maybe<MilestoneHub>
  milestoneHubDefinition: Maybe<MilestoneHubDefinition>
  milestoneHubDefinitions: MilestoneHubDefinition[]
  /**
   * @implicit(userId: ID!)
   * @deprecated This query was only relevant for the initial rollout of milestone hub, replace with milestoneEligibilityByScopes
   */
  milestoneHubEligible: Maybe<Eligibility>
  milestoneRules: Maybe<MilestoneRule[]>
  /** @implicit(userId: ID!) */
  milestonesByTheme: Maybe<MilestoneThemeGroup>
  /** @implicit(userId: ID!) */
  moneyAssignment: Maybe<MoneyManagerMoneyAssignment>
  /** Get the possible allocation amounts for a given account based off the customers existing rules and any staged rules */
  moneyManagerAllocationOptions: MoneyManagerAllocationOption[]
  /** Retrieves the default money manager automation targets for a user based on their income. */
  moneyManagerAutomationTargetDefaults: MoneyManagerAutomationTarget[]
  /** @implicit(userId: ID!) */
  moneyManagerAutomationTargets: MoneyManagerAutomationTarget[]
  /** @implicit(userId: ID!) */
  moneyManagerCascadeObjectives: MoneyManagerCascadeObjective[]
  /** @implicit(userId: ID!) */
  moneyManagerCategories: Maybe<MoneyManagerCategoriesResult>
  /** @implicit(userId: ID!) */
  moneyManagerDepositHistory: MoneyAssignmentConnection
  /** @implicit(userId: ID!) */
  moneyManagerEligiblity: Maybe<MoneyManagerEligiblityResult>
  moneyManagerGlobalConfig: MoneyManagerGlobalConfig
  /** @implicit(userId: ID!) */
  moneyManagerScheduledDeposits: MoneyManagerScheduledDeposit[]
  /** @implicit(userId: ID!) */
  moneyManagerScheduledPaycheckPerEmployer: Array<
    Maybe<MoneyManagerScheduledPaycheck>
  >
  /** @implicit(userId: ID!) */
  moneyManagerSettings: MoneyManagerSettings
  /** @implicit(userId: ID!) */
  moneyManagerSummary: Maybe<MoneyManagerSummary>
  moneyRulesArchetypes: Maybe<MoneyRulesArchetypesResult>
  /**
   * @implicit(userId: ID!)
   * @deprecated Use moneyManagerSettings instead
   */
  moneyRulesSettings: Maybe<MoneyRulesSettings>
  /** Fetch the next billing date for a user */
  nextBillingDate: Maybe<NextBillingDate>
  nextTransferDate: Maybe<NextTransferDateResult>
  notifications: Maybe<Notifications>
  /** Fetch a list of occupations */
  occupations: Maybe<Array<Maybe<Occupation>>>
  offer: Maybe<Offer>
  /** @implicit(userId: ID!) */
  onboardingBenefits: Maybe<OnboardingTileGroup[]>
  /** Determines requirements that have not been met yet for specific onboarding flow */
  onboardingRequirements: Maybe<OnboardingRequirement[]>
  /** query the account onboarding tips modal */
  onboardingTips: Maybe<OnboardingTips>
  /** Fetch a code given the code uuid */
  outsideContributionCode: Maybe<OutsideContributionCode>
  /** Fetch a code given the code string */
  outsideContributionCodeByCode: Maybe<OutsideContributionCode>
  /** Fetch a code given the investment account id */
  outsideContributionCodeByInvestmentAccountId: Maybe<OutsideContributionCode>
  /** Base 64 Encoded Parameterized PDF String */
  parameterizedPdf: Maybe<GenerateUpdatedPdfPayload>
  partnerOfferGroup: Maybe<PartnerOfferGroup>
  partnerOfferGroupCategories: Maybe<PartnerOfferGroup[]>
  /** @implicit(deviceId: String) */
  partnerOfferGroupsByType: Maybe<PartnerOfferGroup[]>
  passwordResetFormFieldsByToken: Maybe<PasswordResetForm>
  pastCoreSummary: Maybe<PastCoreSummary>
  pastEarlySummary: Maybe<PastEarlySummary>
  pastLaterSummary: Maybe<PastLaterSummary>
  /** Totals for Spend */
  pastSpendSummary: Maybe<PastSpendSummary>
  pastSpendTransactionItem: Maybe<PastItem>
  pastSummary: Maybe<PastSummary>
  payoutRelationships: Array<Maybe<ReferralPayoutRelationship>>
  /** PDF Download URL */
  pdfDownloadUrl: Maybe<PdfDownloadUrlPayload>
  /** @implicit(userId: ID!) */
  pendingMoneyAssignments: MoneyManagerMoneyAssignment[]
  /** @deprecated Calculations have been updated in newer API's. Use InvestmentAccount.performance instead. */
  performance: Maybe<Performance>
  /** @implicit(userId: String) */
  personalizedEarnOffers: Maybe<EarnOffer[]>
  /** Get personalized offers for a given user */
  personalizedFoundMoney: Maybe<FoundMoneyCampaignV2[]>
  /** Portfolios */
  portfolios: Portfolio[]
  /** Lookup a specific Product by it's unique id. */
  product: Maybe<Product>
  /** Lookup a specific Product by it's unique key. */
  productByKey: Maybe<Product>
  /** List all Products. */
  products: Maybe<Product[]>
  /** Fetch a single profile for a user */
  profile: Profile
  /** @implicit(userId: ID!) */
  promoCodeApplied: Maybe<PromoCode>
  /**
   * @implicit(userId: ID!)
   * @deprecated This was only relevant for the Path to $1M sweepstakes.
   */
  promoMilestoneChallengeId: Maybe<Scalars['ID']>
  /** @implicit(userId: ID!) */
  promotedBenefitsByUserId: PromotedBenefit[]
  promotedCampaigns: Maybe<PromotedCampaigns>
  /** @implicit(userId: String) */
  promotedEarnOffers: Maybe<EarnOffer[]>
  /** Lookup a particular promotion by it's unique id. */
  promotion: Maybe<Promotion>
  /** Get a list of promotions to which a user is eligible. */
  promotionsByUserId: Maybe<Promotion[]>
  /** Returns quiz with given id or null if it does not exists */
  quiz: Maybe<Quiz>
  /** Fetch the user's recommended portfolio */
  recommendedPortfolio: Maybe<Suitability_Portfolio>
  /** Get recommended search terms for clients to populate the AI search page with */
  recommendedSearchTerms: Array<Scalars['String']>
  /** Fetch recurring investment settings for the specified InvestmentAccount (defaults to the authenticated User's Core InvestmentAccount if not specified). */
  recurringInvestmentSettings: Maybe<RecurringInvestmentSettings>
  /** @implicit(userId: ID!) */
  recurringTransfers: Maybe<Array<Maybe<RecurringTransfer>>>
  referralCampaignRewards: Maybe<ReferralRewardsConnection>
  referralCampaigns: Maybe<ReferralCampaignConnection>
  /** Fetch user's referral */
  referralForUser: Maybe<Referral>
  /** @implicit(userId: ID!) */
  referralHistory: Maybe<ReferralHistory>
  referralPayouts: Maybe<ReferralPayoutConnection>
  referralRelationships: Maybe<ReferralRelationshipConnection>
  /** @implicit(userId: ID!) */
  registeredAuthenticators: Maybe<Authenticator[]>
  /** Fetches a registration record for a prospective user */
  registration: Result
  /** Retrieves contextual information to direct user's registration funnel experience */
  registrationFunnel: Maybe<RegistrationFunnel>
  /** Returns related Course for Article */
  relatedCourseByArticleId: Maybe<Course>
  /** Returns related Course for Article */
  relatedCourseByArticleId_v2: Maybe<LearnCourse>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId: Maybe<CoursePreview[]>
  /** Returns a list of related courses based on shared tags */
  relatedCoursePreviewsByCourseId_v2: Maybe<LearnCoursePreview[]>
  /** Returns a list of related articles based on primary topic */
  relatedLearnContentByArticleId: Maybe<LearnContentPreview[]>
  /** Returns a list of learn content related to the provided media ID */
  relatedLearnContentByMediaId: Maybe<LearnContentPreview[]>
  /** Returns related Quiz for Course */
  relatedQuizByCourseId: Maybe<Quiz>
  /** Returns related Quiz for Course */
  relatedQuizByCourseId_v2: Maybe<LearnQuiz>
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId: Maybe<QuizPreview[]>
  /** Returns a list of 5 quizzes that are contained in courses with similar tags as the given course */
  relatedQuizzesByCourseId_v2: Maybe<LearnQuizPreview[]>
  remoteStrings: Maybe<Scalars['JSON']>
  /** Fetch a round up account for a specified linked subaccount */
  roundUpAccount: Maybe<RoundUpAccount>
  /** List round up accounts for a given user */
  roundUpAccounts: RoundUpAccount[]
  /** Fetch a single round up profile for a user */
  roundUpProfile: Maybe<RoundUpProfile>
  /** List round ups for a given user */
  roundUps: RoundUpTypePagination
  sampleMailInDocument: Maybe<SampleMailInDocument>
  savingsAccountEligibilityByUserId: Maybe<SavingsAccountEligibility>
  /** @implicit(deviceId: String) */
  searchActiveEarnOffers: EarnOfferQueryPage
  /** Employer Search */
  searchEmployers: Maybe<SearchEmployersPayload>
  /** Fuzzy search for securities of the provided types (declared in SearchSecuritiesInput.securityTypes) by symbol and company name. Securities are selected as "candidates" and then ordered by SearchSecuritiesInput.orderby. Results are served using a cursor-based pagination dictated by the page-size SearchSecuritiesInput.limit and the cursor SearchSecuritiesInput.after */
  searchSecurities: Maybe<SearchSecuritiesResponse>
  /** Returns all relevant support articles and all categories given a query */
  searchSupportArticles: Maybe<SearchSupportResult>
  /** Search for securities of the provided types (declared in SecuritiesBySectorInput.securityTypes) that are a part of any/all of the provided trading sectors in SecuritiesBySectorInput.sectors. Securities of the requested type that contain 1+ of the provided trading sectors are selected and then ordered by SecuritiesBySectorInput.orderBy. Results are served using a cursor-based pagination dictated by the page-size SecuritiesBySectorInput.limit and the cursor SecuritiesBySectorInput.after. */
  securitiesBySector: Maybe<SecuritiesBySectorResponse>
  securitiesBySymbols: Maybe<SecuritiesBySymbolsResponse>
  securityBySymbol: Maybe<Security>
  securityPerformanceBySymbol: Maybe<SecurityPerformance>
  /** Provide historical end of day prices for many Securities */
  securityPerformancesBySymbol: Maybe<SecurityPerformance[]>
  settings: Maybe<Settings>
  /** Fetch a list of signatures for a user */
  signatures: Array<Maybe<Signature>>
  smartDepositMetadata: Maybe<SmartDepositMetadataResult>
  /**
   * Pulls all accounts a customer can withdraw from.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_DEPOSIT)
   */
  sourceAccounts: CustomerAccount[]
  spendAccount: Maybe<SpendAccount>
  spendAlerts: Maybe<Array<Maybe<SpendAlert>>>
  spendAtms: Maybe<SpendAtmsResult>
  splitDepositSettings: Maybe<SplitDepositSettings>
  splitDepositSettingsByUserId: Maybe<SplitDepositSettings[]>
  /** Gets a list of the requesting user's statement documents based on investment account and statement type */
  statements: Maybe<Array<Maybe<Statement>>>
  subscriptionMigration: Maybe<SubscriptionMigration>
  subscriptionMigrationWaiver: Maybe<SubscriptionMigrationWaiver>
  /** @implicit(userId: ID!) */
  subscriptionMigrationWaiversByUserId: Maybe<SubscriptionMigrationWaiver[]>
  /** @implicit(userId: ID!) */
  suggestedMoneyRules: Maybe<SuggestedMoneyRulesResult>
  /** Fetch all suitability questions and answers */
  suitabilityResponses: Maybe<Suitability_SuitabilityResponse[]>
  /** Return if a client should use suitability service for a particular user */
  suitabilityServiceEnabled: Maybe<Scalars['Boolean']>
  /** Returns support article given an id */
  supportArticle: Maybe<SupportArticle>
  /** Returns all articles in section given a sectionId */
  supportArticlesBySectionId: Maybe<Array<Maybe<SupportArticle>>>
  /** Returns support category given an id */
  supportCategory: Maybe<SupportCategory>
  /**
   * See if in-app support chat is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail.
   * @deprecated Replaced with more general supportSchedule query.
   */
  supportChatEnabled: Scalars['Boolean']
  /** Returns most common faq articles if it has been set in Zesty */
  supportMostCommonFaq: Maybe<ContactFaq[]>
  /** See if specified support channel is currently enabled. This is a fault-tolerant query and thus will return \`false\` rather than fail. */
  supportSchedule: Maybe<ScheduleResult>
  /** Returns support section given an id */
  supportSection: Maybe<SupportSection>
  /** Returns all support sections by category id */
  supportSectionsByCategoryId: Maybe<Array<Maybe<SupportSection>>>
  /** Return the given support ticket form by id */
  supportTicketForm: Maybe<SupportTicketForm>
  supportTicketFormField: Maybe<SupportTicketFormField>
  /** Returns if a bank is eligible for Plaid Verification. */
  supportsPlaidVerification: SupportsPlaidVerificationResult
  /**
   * Pulls all accounts a customer can deposit into.
   * @deprecated Deprecated, replace with AllAccounts.CustomerAccountsByTransferAction(ONE_TIME_WITHDRAWAL)
   */
  targetAccounts: CustomerAccount[]
  /** Gets the requesting user's Tax Statements for all of the user accounts for the year provided */
  taxStatementsByTaxYear: StatementPagination
  /** Lookup a Tier by it's unique id. */
  tier: Maybe<Tier>
  /**
   * Returns a tier group w/ tiers, products, prices, etc. Can not be tied to
   * a specfic user (needs to support anonymous users).
   * id is optional for case of returning default
   */
  tierGroup: Maybe<TierGroup>
  /** TierGroup for specific user (includes the Tier they are subscribed to) */
  tierGroupForUser: Maybe<TierGroup>
  /**
   * Returns the cheapest tier option for a given user's open accounts
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByOpenAccounts: Maybe<TierOption>
  /**
   * Returns the cheapest tier option for a given product key
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByProductKey: Maybe<TierOption>
  /**
   * For a given TierPriceId, returns the TierOption associated with that price id.
   * Returns InvalidTierPriceId if the tier price id is not found.
   * @deprecated Use Query.tierGroup to determine available Tier offers.
   */
  tierOptionByTierPriceId: Maybe<TierOptionByTierPriceIdResult>
  /** Any arbitrary subscription (current or historical) */
  tierSubscription: Maybe<TierSubscription>
  /** A User's TierSubscription by User.uuid. */
  tierSubscriptionByUserId: Maybe<TierSubscription>
  /**
   * The current subscription for an arbitrary user
   * @deprecated Use Query.tierSubscriptionByUserId.
   */
  tierSubscriptionForUser: Maybe<TierSubscriptionForUser>
  /** All of a Users's TierSubscriptions by User.uuid. */
  tierSubscriptionHistoryByUserId: Maybe<TierSubscriptionConnection>
  /** Show all active tiers */
  tiers: Maybe<Tier[]>
  /** @deprecated Toggles no longer supported. This will always returns true. */
  toggle: Maybe<Toggle>
  /** Top Employers */
  topEmployers: TopEmployerPayload
  /**
   * Returns a list of trending content for given tier
   * @deprecated This endpoint is being removed as tiers are being replaced by product keys
   */
  trendingLearnContentByTierId: Maybe<TrendingLearnContentPreview[]>
  /** Returns a list of trending content for given topic */
  trendingLearnContentByTopicId: Maybe<TrendingLearnContentPreview[]>
  /** Returns a personalized list of trending learn content */
  trendingLearnContentPersonalizedByUserId: Maybe<TrendingLearnContentPreview[]>
  /** Get the currently authenticated user */
  user: Maybe<User>
  /** An array of the alerts for a user. */
  userAlerts: Maybe<UserAlertsResponse[]>
  /** @implicit(userId: String!) */
  userBenefitsStatus: BenefitsStatusResponse
  /** Fetch all credentials types for a given user */
  userCredentials: Array<Maybe<UserCredentials>>
  /** Fetch a single user's external matches */
  userMatches: Array<Maybe<UserMatch>>
  /** Gets user status with respect to being closed, verified, or registration complete. */
  userStatus: Maybe<UserStatus>
  /** @implicit(userId: ID!) */
  userTokensByUserId: Array<Maybe<UserToken>>
  /** Returns user winback score */
  userWinbackScore: Maybe<UserWinbackScoreRes>
  validatePasswordResetToken: ValidatePasswordResetTokenResult
  /** @implicit(userId: ID!) */
  verificationProfile: Maybe<VerificationProfile>
  verifyCheckPaymentRecipientAddress: Maybe<VerifyCheckPaymentRecipientAddressResult>
  verifyPromoCode: Maybe<VerifyPromoCodeResponse>
  withholdingDefaults: Maybe<WithholdingDefaults>
  /** Estimated withholding amounts (only on gains for Roth IRAs) */
  withholdingEstimates: Maybe<WithholdingEstimates>
  yearLaterReport: YearLaterReport
}

export type QueryAcceptanceDocumentArgs = {
  type: Scalars['String']
}

export type QueryAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>
}

export type QueryAccountPointsRuleByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

export type QueryAccountStrengthArgs = {
  accountId?: InputMaybe<Scalars['String']>
}

export type QueryAccountsArgs = {
  status?: InputMaybe<Array<InputMaybe<AccountStatus>>>
}

export type QueryActionFeedArgs = {
  input?: InputMaybe<ActionCardsInput>
}

export type QueryActionScreenArgs = {
  screenContext?: InputMaybe<ActionScreenContext>
}

export type QueryActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  tag?: InputMaybe<Scalars['String']>
}

export type QueryActivityArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type QueryActivitySummaryArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  product?: InputMaybe<ActivitySummaryProduct>
}

export type QueryAddressDeliverabilityArgs = {
  input: AddressDeliverabilityInput
}

export type QueryAddressesArgs = {
  addressType?: InputMaybe<AddressType>
}

export type QueryAllAcceptanceDocumentsArgs = {
  requiredFor?: InputMaybe<Scalars['String']>
}

export type QueryAllAccountsArgs = {
  filter?: InputMaybe<AllAccountsFilterInput>
}

export type QueryAllBankAccountsArgs = {
  input: AllBankAccountsInput
}

export type QueryAllBankCardsArgs = {
  filter?: InputMaybe<AllBankCardsFilter>
}

export type QueryAllBankDocumentsArgs = {
  input: AllBankDocumentsInput
}

export type QueryAllBankTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllCardTrackingStatusesArgs = {
  userId?: InputMaybe<Scalars['ID']>
}

export type QueryAllChatHistoryMessagesArgs = {
  pagination: PaginationInput
}

export type QueryAllCheckPaymentsArgs = {
  pageInput?: InputMaybe<PageInput>
}

export type QueryAllMessagesArgs = {
  categoryFilters?: InputMaybe<MessageCategory[]>
  statusFilters?: InputMaybe<MessageStatusFilterInput[]>
  typeFilters?: InputMaybe<MessageType[]>
}

export type QueryAllPastCoreItemChildrenArgs = {
  pastItemId: Scalars['ID']
}

export type QueryAllPastCoreItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastCoreItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllPastEarlyItemsArgs = {
  beneficiaryAccountId: Scalars['String']
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastEarlyItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllPastItemsArgs = {
  filter?: InputMaybe<AllPastItemsFilter>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllPastLaterItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<AllPastLaterItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllPastPendingItemsArgs = {
  excludeFees?: InputMaybe<Scalars['Boolean']>
}

export type QueryAllPastScheduledItemsArgs = {
  filter?: InputMaybe<AllPastScheduledItemsFilter>
}

export type QueryAllPastSpendItemsArgs = {
  accountId?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<AllPastSpendItemsSchemaFilter>
  pagination?: InputMaybe<PageInput>
}

export type QueryAllSupportArticlesArgs = {
  filter?: InputMaybe<AllSupportArticlesFilterInput>
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

export type QueryAllSupportSectionsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

export type QueryAllTransferableToArgs = {
  input: AllTransferableToInput
}

export type QueryAuthenticateForFeeNegotiationStatusByLinkedAccountIdArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryBackendJobBatchAutomatedOrdersArgs = {
  filter: BackendJobBatchAutomatedOrdersFilterInput
}

export type QueryBackendJobBatchMoneyMovementArgs = {
  filter: BackendJobBatchMoneyMovementFilterInput
}

export type QueryBackendJobBatchOrdersArgs = {
  filter: BackendJobBatchOrdersFilterInput
}

export type QueryBackendJobBatchProfitStarsArgs = {
  filter: BackendJobBatchProfitStarsFilterInput
}

export type QueryBackendJobBatchSummaryArgs = {
  filter: BackendJobBatchSummaryFilterInput
}

export type QueryBankAccountDisclosuresArgs = {
  input: BankAccountDisclosureFilter
}

export type QueryBankAccountStateArgs = {
  accountType?: InputMaybe<BankAccountType>
}

export type QueryBankCardProvisioningDetailsArgs = {
  input: BankCardProvisioningDetailsInput
}

export type QueryBankFeesByUserIdArgs = {
  filter?: InputMaybe<BankFeeFilter>
  first?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  statusFilter?: InputMaybe<Array<InputMaybe<FeeStatusFilter>>>
}

export type QueryBankInterestRatesArgs = {
  productFilter?: InputMaybe<Array<InputMaybe<BankingProduct>>>
}

export type QueryBankTransactionArgs = {
  bankAccountType?: InputMaybe<BankAccountType>
  id: Scalars['ID']
}

export type QueryBeneficiaryArgs = {
  id: Scalars['ID']
}

export type QueryBenefitPartnerByUserIdArgs = {
  input: BenefitPartnerInput
}

export type QueryBillingCycleArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryBillingCyclesArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>
}

export type QueryCalculateMoneySplitsArgs = {
  moneySource: MoneyRulesMoneySourceInput
  overrides?: InputMaybe<MoneyRulesSplitOverridesInput>
}

export type QueryCampaignHistoryArgs = {
  filter: CampaignHistoryFilter
  page: ReferralPaginatedFilter
}

export type QueryChallengesArgs = {
  deliveryType?: InputMaybe<ChallengeDeliveryType>
}

export type QueryClosureReasonsByInvestmentAccountTypeArgs = {
  product?: InputMaybe<InvestmentProduct>
}

export type QueryCohortEligibilityArgs = {
  scopes: CohortEligibilityScope[]
}

export type QueryCohortEligibility_V2Args = {
  filter?: InputMaybe<CohortEligibility_V2FilterInput>
}

export type QueryCombinedPerformanceByUserIdArgs = {
  days?: InputMaybe<Scalars['Int']>
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>
}

export type QueryCompletedQuizByQuizIdArgs = {
  quizId: Scalars['ID']
}

export type QueryCourseArgs = {
  id: Scalars['ID']
}

export type QueryCourse_V2Args = {
  id: Scalars['ID']
}

export type QueryCoursesByTierIdArgs = {
  tierId: Scalars['ID']
}

export type QueryCoursesByTopicIdArgs = {
  topicId: Scalars['ID']
}

export type QueryCoursesByTopicId_V2Args = {
  topicId: Scalars['ID']
}

export type QueryCustomerEarnOnboardingProgramArgs = {
  verifiedAt?: InputMaybe<Scalars['DateTime']>
}

export type QueryDevicesByUserIdArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>
}

export type QueryDiversificationInfoByInvestmentAccountIdArgs = {
  input: DiversificationInfoByInvestmentAccountIdInput
}

export type QueryDocumentRequestArgs = {
  input: DocumentRequestInput
}

export type QueryDocumentRequestsArgs = {
  input: DocumentRequestsInput
}

export type QueryEarlyAccountStateRegulationArgs = {
  stateCode?: InputMaybe<Scalars['String']>
}

export type QueryEarlyAccountTransferInfoArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryEarnOfferByCampaignOfferIdArgs = {
  campaignOfferId: Scalars['String']
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>
  origin: Scalars['String']
  sessionId: Scalars['String']
}

export type QueryEarnRewardsByInvestmentIdsArgs = {
  investmentIds: Array<Scalars['ID']>
}

export type QueryEligibilityArgs = {
  eligibilityScope: EligibilityScope
}

export type QueryEmailAddressValidationArgs = {
  email: Scalars['EmailAddress']
}

export type QueryEstimatedMatchRemovalArgs = {
  investmentAccountId: Scalars['ID']
  withdrawalAmount: MonetaryAmountInput
}

export type QueryEstimatedTransferDatesArgs = {
  input: EstimatedTransferDatesInput
}

export type QueryEtfArgs = {
  symbol: Scalars['String']
}

export type QueryEvaluateCheckDepositArgs = {
  input: EvaluateCheckDepositInput
}

export type QueryExtoleCampaignHistoryArgs = {
  page: ReferralPaginatedFilter
}

export type QueryFeeArgs = {
  id: Scalars['ID']
}

export type QueryFeesArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  billingCycleId?: InputMaybe<Scalars['ID']>
}

export type QueryFinancialGoalsRecommendationArgs = {
  input: FinancialGoalsInput
}

export type QueryFinancialInstitutionArgs = {
  externalId: Scalars['String']
  linkable?: InputMaybe<Scalars['Boolean']>
}

export type QueryFinancialInstitutionsArgs = {
  includeBlacklisted?: InputMaybe<Scalars['Boolean']>
  includeDirectBank?: InputMaybe<Scalars['Boolean']>
  pageInput?: InputMaybe<PageInput>
  q?: InputMaybe<Scalars['String']>
  supportsAuth?: InputMaybe<Scalars['Boolean']>
  supportsFunding?: InputMaybe<Scalars['Boolean']>
}

export type QueryFinishSetupArgs = {
  accountId: Scalars['ID']
  feedContext: FeedContext
}

export type QueryFriendArgs = {
  advocateReferralCode?: InputMaybe<Scalars['String']>
}

export type QueryGenerateUpdatedPdfArgs = {
  input: PdfDownloadUrlInput
}

export type QueryGetBillingHistoryArgs = {
  state?: InputMaybe<Array<InputMaybe<BillingCycleState>>>
}

export type QueryGetPartnerDetailsArgs = {
  input: PartnerUrlInput
}

export type QueryGetPartnerDocumentByUserIdArgs = {
  input: PartnerUrlInput
}

export type QueryGetPartnerUrlArgs = {
  input: PartnerUrlInput
}

export type QueryGetUsersBankFromAccountTypeArgs = {
  type: BankAccountType
}

export type QueryGetVendorInvoiceArgs = {
  invoiceId: Scalars['ID']
}

export type QueryHelpFormContentArgs = {
  form: HelpFormType
}

export type QueryInstantSearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean']
  query: Scalars['String']
}

export type QueryIntentArgs = {
  nonce: Scalars['UUID']
}

export type QueryIntentsArgs = {
  filter: IntentFilterInput
}

export type QueryInvestmentArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountByBeneficiaryIdArgs = {
  beneficiaryId: Scalars['ID']
}

export type QueryInvestmentAccountRecapArgs = {
  id: Scalars['ID']
}

export type QueryInvestmentAccountRecapByPublicTokenArgs = {
  publicToken: Scalars['ID']
}

export type QueryInvestmentAccountsByUserIdArgs = {
  filter?: InputMaybe<InvestmentAccountsByUserIdFilter>
}

export type QueryInvestmentsByInvestmentAccountIdArgs = {
  endDate?: InputMaybe<Scalars['Date']>
  investmentAccountId: Scalars['ID']
  pageInput?: InputMaybe<PageInput>
  startDate?: InputMaybe<Scalars['Date']>
}

export type QueryJobSearchArgs = {
  searchCriteria: JobSearchCriteriaInput
}

export type QueryJobSearchV2Args = {
  pagination: PageInput
  saveAsRecentSearch?: InputMaybe<Scalars['Boolean']>
  searchCriteria: JobSearchCriteriaInput
}

export type QueryLaterBeneficiariesArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryLaterContributionAbilityArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
}

export type QueryLaterContributionHistoryArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryLaterHistoryArgs = {
  accountId: Scalars['ID']
  limit?: InputMaybe<Scalars['Int']>
  page?: InputMaybe<Scalars['Int']>
}

export type QueryLaterPortfolioPerformanceArgs = {
  accountId: Scalars['ID']
}

export type QueryLearnArticleArgs = {
  id: Scalars['ID']
}

export type QueryLearnContentBySearchTermArgs = {
  filter?: InputMaybe<LearnContentFilterInput>
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
  term: Scalars['String']
}

export type QueryLearnContentByTierIdArgs = {
  filter: LearnContentFilterByTierIdInput
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
}

export type QueryLearnContentByTopicIdArgs = {
  filter: LearnContentFilterByTopicIdInput
  pagination: LearnContentPageInput
  sort?: InputMaybe<LearnContentSortType>
}

export type QueryLearnContentPreviewsByContentIdsArgs = {
  contentIds: Array<Scalars['ID']>
}

export type QueryLearnContentRecommendationsBySearchTermArgs = {
  term: Scalars['String']
}

export type QueryLearnMediaArgs = {
  id: Scalars['ID']
}

export type QueryLearnNextStepActionsByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryLearnNextStepActionsByMediaIdArgs = {
  mediaId: Scalars['ID']
}

export type QueryLearnQuestionInsightsByQuizIdArgs = {
  quizId: Scalars['ID']
}

export type QueryLearnWidgetContentArgs = {
  context: ActionFeedContext
}

export type QueryLinkedAccountArgs = {
  linkedAccountId: Scalars['ID']
}

export type QueryLinkedAccountsArgs = {
  externalSources?: InputMaybe<LinkedAccountExternalSourceEnum[]>
  linked?: InputMaybe<Scalars['Boolean']>
}

export type QueryLinkedSubaccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryLinkedSubaccountsArgs = {
  linked?: InputMaybe<Scalars['Boolean']>
}

export type QueryLiquidationArgs = {
  id: Scalars['ID']
}

export type QueryLiquidationsArgs = {
  accountId?: InputMaybe<Scalars['ID']>
  billingCycleId?: InputMaybe<Scalars['ID']>
}

export type QueryListBenefitsByUserIdArgs = {
  group?: InputMaybe<Scalars['String']>
  product?: InputMaybe<BenefitsTrackerProducts>
}

export type QueryMatchProgramArgs = {
  id: Scalars['ID']
}

export type QueryMessageArgs = {
  id: Scalars['ID']
}

export type QueryMessageByExternalIdArgs = {
  externalId: Scalars['ID']
}

export type QueryMessagesArgs = {
  categoryFilters?: InputMaybe<MessageCategory[]>
  pagination?: InputMaybe<MessagePageInput>
  statusFilters?: InputMaybe<MessageStatusFilterInput[]>
  typeFilters?: InputMaybe<MessageType[]>
}

export type QueryMilestoneArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneAchievementActionRuleArgs = {
  milestoneID: Scalars['ID']
}

export type QueryMilestoneChallengeArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneChallengePointsRuleByMilestoneIdByChallengeIdArgs = {
  challengeID: Scalars['ID']
  milestoneID: Scalars['ID']
}

export type QueryMilestoneChallengePointsRulesByMilestoneIdArgs = {
  milestoneID: Scalars['ID']
}

export type QueryMilestoneDefinitionArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneEligibilityByScopesArgs = {
  scopes: MilestoneEligibilityScope[]
}

export type QueryMilestoneGroupAchievementActionRuleArgs = {
  milestoneGroupID: Scalars['ID']
}

export type QueryMilestoneGroupDefinitionArgs = {
  groupID: Scalars['ID']
}

export type QueryMilestoneHubDefinitionArgs = {
  id: Scalars['ID']
}

export type QueryMilestoneHubEligibleArgs = {
  registrationCompletedAt: Scalars['DateTime']
}

export type QueryMilestonesByThemeArgs = {
  filter?: InputMaybe<MilestoneByThemeFilterInput>
  theme: MilestoneTheme
}

export type QueryMoneyAssignmentArgs = {
  id: Scalars['ID']
}

export type QueryMoneyManagerAllocationOptionsArgs = {
  input: MoneyManagerAllocationOptionsInput
}

export type QueryMoneyManagerCategoriesArgs = {
  input?: InputMaybe<MoneyManagerCategoriesInput>
}

export type QueryMoneyManagerDepositHistoryArgs = {
  pagination?: InputMaybe<MoneyManagerPageInput>
}

export type QueryMoneyRulesArchetypesArgs = {
  input?: InputMaybe<MoneyRulesArchetypesInput>
}

export type QueryNextTransferDateArgs = {
  recurrenceRule: RecurrenceRuleInput
}

export type QueryOfferArgs = {
  id: Scalars['ID']
}

export type QueryOnboardingBenefitsArgs = {
  input?: InputMaybe<OnboardingBenefitsInput>
}

export type QueryOnboardingRequirementsArgs = {
  onboardingType: OnboardingType
}

export type QueryOnboardingTipsArgs = {
  feedContext: FeedContext
}

export type QueryOutsideContributionCodeArgs = {
  id: Scalars['ID']
}

export type QueryOutsideContributionCodeByCodeArgs = {
  code: Scalars['String']
}

export type QueryOutsideContributionCodeByInvestmentAccountIdArgs = {
  investmentAccountId: Scalars['ID']
}

export type QueryParameterizedPdfArgs = {
  input: ParameterizedPdfInput
}

export type QueryPartnerOfferGroupArgs = {
  filter?: InputMaybe<PartnerOfferGroupFilterInput>
  id: Scalars['String']
}

export type QueryPartnerOfferGroupCategoriesArgs = {
  ids: Array<Scalars['ID']>
  incentiveTemplate?: InputMaybe<EarnOfferIncentiveTemplate>
}

export type QueryPartnerOfferGroupsByTypeArgs = {
  partnerOfferGroupsTypeInput: PartnerOfferGroupsTypeInput
}

export type QueryPasswordResetFormFieldsByTokenArgs = {
  resetToken: Scalars['String']
}

export type QueryPastEarlySummaryArgs = {
  beneficiaryAccountId: Scalars['String']
}

export type QueryPastLaterSummaryArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
}

export type QueryPastSpendTransactionItemArgs = {
  accountType?: InputMaybe<BankAccountType>
  transactionId: Scalars['String']
}

export type QueryPastSummaryArgs = {
  pastSummaryFilter?: InputMaybe<PastSummaryFilter>
}

export type QueryPayoutRelationshipsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  payoutId?: InputMaybe<Scalars['ID']>
  relationshipId?: InputMaybe<Scalars['ID']>
}

export type QueryPdfDownloadUrlArgs = {
  input: PdfDownloadUrlInput
}

export type QueryPerformanceArgs = {
  days: Scalars['Int']
  investmentAccountId?: InputMaybe<Scalars['ID']>
  start: Scalars['DateTime']
}

export type QueryPortfoliosArgs = {
  customizedWithSecuritySymbols?: InputMaybe<Array<Scalars['String']>>
}

export type QueryProductArgs = {
  id: Scalars['ID']
}

export type QueryProductByKeyArgs = {
  productKey: ProductKey
}

export type QueryPromotedBenefitsByUserIdArgs = {
  product?: InputMaybe<BenefitsTrackerProducts>
}

export type QueryPromotionArgs = {
  id: Scalars['ID']
}

export type QueryPromotionsByUserIdArgs = {
  filter?: InputMaybe<PromotionFilterInput>
  limit?: InputMaybe<Scalars['Int']>
}

export type QueryQuizArgs = {
  id: Scalars['ID']
}

export type QueryRecommendedSearchTermsArgs = {
  category?: InputMaybe<SearchTermCategory>
}

export type QueryRecurringInvestmentSettingsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
}

export type QueryRecurringTransfersArgs = {
  filter?: InputMaybe<RecurringTransfersFilterInput>
}

export type QueryReferralCampaignRewardsArgs = {
  filter: ReferralPaginatedFilter
}

export type QueryReferralCampaignsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

export type QueryReferralPayoutsArgs = {
  filter: ReferralPayoutsFilter
  page: ReferralPaginatedFilter
}

export type QueryReferralRelationshipsArgs = {
  filter: ReferralRelationshipsFilter
  page: ReferralPaginatedFilter
}

export type QueryRegistrationFunnelArgs = {
  filter: RegistrationFunnelFilter
}

export type QueryRelatedCourseByArticleIdArgs = {
  articleId: Scalars['ID']
}

export type QueryRelatedCourseByArticleId_V2Args = {
  articleId: Scalars['ID']
}

export type QueryRelatedCoursePreviewsByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryRelatedCoursePreviewsByCourseId_V2Args = {
  courseId: Scalars['ID']
}

export type QueryRelatedLearnContentByArticleIdArgs = {
  articleId: Scalars['ID']
}

export type QueryRelatedLearnContentByMediaIdArgs = {
  mediaId: Scalars['ID']
}

export type QueryRelatedQuizByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryRelatedQuizByCourseId_V2Args = {
  courseId: Scalars['ID']
}

export type QueryRelatedQuizzesByCourseIdArgs = {
  courseId: Scalars['ID']
}

export type QueryRelatedQuizzesByCourseId_V2Args = {
  courseId: Scalars['ID']
}

export type QueryRoundUpAccountArgs = {
  linkedSubaccountId: Scalars['ID']
}

export type QueryRoundUpsArgs = {
  autoInvestable?: InputMaybe<Scalars['Boolean']>
  instant?: InputMaybe<Scalars['Boolean']>
  investmentId?: InputMaybe<Scalars['ID']>
  manual?: InputMaybe<Scalars['Boolean']>
  pageInput?: InputMaybe<PageInput>
  state?: InputMaybe<RoundUpState[]>
  targetAccountId?: InputMaybe<Scalars['ID']>
  transactionDateAfter?: InputMaybe<Scalars['String']>
  transactionDateBefore?: InputMaybe<Scalars['String']>
}

export type QuerySampleMailInDocumentArgs = {
  typeFilter: MailInDocumentType
}

export type QuerySavingsAccountEligibilityByUserIdArgs = {
  type: SavingsAccountType
}

export type QuerySearchActiveEarnOffersArgs = {
  cursor?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  searchTerm: Scalars['String']
  tag?: InputMaybe<Scalars['String']>
}

export type QuerySearchEmployersArgs = {
  input: SearchEmployersInput
}

export type QuerySearchSecuritiesArgs = {
  input: SearchSecuritiesInput
}

export type QuerySearchSupportArticlesArgs = {
  isPrivate: Scalars['Boolean']
  query: Scalars['String']
}

export type QuerySecuritiesBySectorArgs = {
  input: SecuritiesBySectorInput
}

export type QuerySecuritiesBySymbolsArgs = {
  input: SecuritiesBySymbolsInput
}

export type QuerySecurityBySymbolArgs = {
  input: SecurityBySymbolInput
}

export type QuerySecurityPerformanceBySymbolArgs = {
  input: SecurityPerformanceBySymbolInput
}

export type QuerySecurityPerformancesBySymbolArgs = {
  input: SecurityPerformancesBySymbolInput
}

export type QuerySignaturesArgs = {
  signatureType?: InputMaybe<SignatureType>
}

export type QuerySmartDepositMetadataArgs = {
  smartDepositMetadataInput: SmartDepositMetadataInput
}

export type QuerySourceAccountsArgs = {
  filter?: InputMaybe<SourceAccountsFilterInput>
}

export type QuerySpendAtmsArgs = {
  input: SpendAtmsInput
}

export type QuerySplitDepositSettingsArgs = {
  id: Scalars['ID']
}

export type QuerySplitDepositSettingsByUserIdArgs = {
  filter?: InputMaybe<SplitDepositSettingsFilterInput>
  normalizeToFrequency?: InputMaybe<SplitDepositNormalizationFrequency>
}

export type QueryStatementsArgs = {
  investmentAccountId?: InputMaybe<Scalars['ID']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  type: Scalars['String']
}

export type QuerySubscriptionMigrationArgs = {
  id: Scalars['ID']
}

export type QuerySubscriptionMigrationWaiverArgs = {
  id: Scalars['ID']
}

export type QuerySupportArticleArgs = {
  id: Scalars['ID']
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

export type QuerySupportArticlesBySectionIdArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
  sectionId: Scalars['ID']
}

export type QuerySupportCategoryArgs = {
  categoryId: Scalars['ID']
}

export type QuerySupportScheduleArgs = {
  input: ScheduleInput
}

export type QuerySupportSectionArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
  sectionId: Scalars['ID']
}

export type QuerySupportSectionsByCategoryIdArgs = {
  categoryId: Scalars['ID']
  isPrivate?: InputMaybe<Scalars['Boolean']>
}

export type QuerySupportTicketFormArgs = {
  id: Scalars['ID']
}

export type QuerySupportTicketFormFieldArgs = {
  id: Scalars['ID']
}

export type QuerySupportsPlaidVerificationArgs = {
  routingNumber: Scalars['String']
}

export type QueryTargetAccountsArgs = {
  filter?: InputMaybe<TargetAccountsFilterInput>
}

export type QueryTaxStatementsByTaxYearArgs = {
  pageInput?: InputMaybe<PageInput>
  taxYear: Scalars['Int']
}

export type QueryTierArgs = {
  id: Scalars['ID']
}

export type QueryTierGroupArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryTierOptionByProductKeyArgs = {
  productKey: ProductKey
  tierGroupId?: InputMaybe<Scalars['ID']>
}

export type QueryTierOptionByTierPriceIdArgs = {
  tierPriceId: Scalars['ID']
}

export type QueryTierSubscriptionArgs = {
  id: Scalars['ID']
}

export type QueryTierSubscriptionHistoryByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryToggleArgs = {
  context?: InputMaybe<Scalars['JSON']>
  projectId: Scalars['String']
  toggleId: Scalars['String']
}

export type QueryTrendingLearnContentByTierIdArgs = {
  tierId: Scalars['ID']
}

export type QueryTrendingLearnContentByTopicIdArgs = {
  topicId: Scalars['ID']
}

export type QueryUserBenefitsStatusArgs = {
  benefitProductKey?: InputMaybe<Scalars['String']>
  tierKey: Scalars['String']
}

export type QueryUserCredentialsArgs = {
  credentialsType?: InputMaybe<CredentialsType>
}

export type QueryValidatePasswordResetTokenArgs = {
  resetToken: Scalars['String']
}

export type QueryVerifyCheckPaymentRecipientAddressArgs = {
  input: VerifyCheckPaymentRecipientAddressInputType
}

export type QueryVerifyPromoCodeArgs = {
  name: Scalars['String']
}

export type QueryWithholdingDefaultsArgs = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  investmentAccountId: Scalars['ID']
  withdrawalAmount: CurrencyAmountInput
}

export type QueryWithholdingEstimatesArgs = {
  federalWithholdingPercentage: Scalars['Float']
  investmentAccountId: Scalars['ID']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateWithholdingPercentage: Scalars['Float']
  withdrawalAmount: CurrencyAmountInput
}

export type QueryYearLaterReportArgs = {
  year: Scalars['Int']
}

export type Quiz = {
  __typename?: 'Quiz'
  authors: LearnAuthor[]
  description: Scalars['String']
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  metadata: LearnMetadata
  questions: LearnQuestion[]
  theme: QuizTheme
  /** @deprecated Tier will be removed */
  tier: LearnTier
  title: Scalars['String']
  topics: LearnTopic[]
}

export type QuizLocked = {
  __typename?: 'QuizLocked'
  duration: LearnContentDuration
  featuredImage: Maybe<LearnVisualAsset>
  id: Scalars['ID']
  numQuestions: Scalars['Int']
  productRequired: Scalars['String']
  title: Scalars['String']
}

export type QuizPreview = {
  __typename?: 'QuizPreview'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  isCompleted: Scalars['Boolean']
  primaryTopicName: Scalars['String']
  productRequired: Maybe<Scalars['String']>
  progress: Maybe<LearnProgress>
  quizTheme: QuizTheme
  /** @deprecated tierName is being replaced by productRequired */
  tierName: Scalars['String']
  title: Scalars['String']
}

export type QuizPreviewLocked = {
  __typename?: 'QuizPreviewLocked'
  contentId: Scalars['ID']
  contentType: LearnContentType
  duration: LearnContentDuration
  featuredImage: LearnVisualAsset
  lockedReason: Maybe<Scalars['String']>
  primaryTopicName: Scalars['String']
  productRequired: Scalars['String']
  quizTheme: QuizTheme
  title: Scalars['String']
}

export type QuizTheme = LearnThemeLiteral

export type RateLimitDoesNotExistException = {
  __typename?: 'RateLimitDoesNotExistException'
  userId: Maybe<Scalars['ID']>
}

export type RateLimitStatus = {
  __typename?: 'RateLimitStatus'
  /** The remaining duration of the block in milliseconds */
  challengeBlockDurationRemaining: Maybe<Scalars['Int']>
  isBlocked: Scalars['Boolean']
  /** The remaining duration of the block in milliseconds */
  loginBlockDurationRemaining: Maybe<Scalars['Int']>
}

/** The link token for use in the client created account link URL. */
export type RawLinkSession = {
  __typename?: 'RawLinkSession'
  /** The External ID that should be used in the link creation process. */
  externalId: Scalars['ID']
  /** The Link Token a client should use for account linking. */
  token: Scalars['String']
}

/** RDVs are required user alert. */
export type RdvRequiredUserAlert = UserAlertsItem & {
  __typename?: 'RdvRequiredUserAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** The current funding source must be verified with RDVs prior to linking */
export type RdvVerificationRequired = {
  __typename?: 'RdvVerificationRequired'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The RDVs were unable to be triggered */
export type RdvsNotTriggered = {
  __typename?: 'RdvsNotTriggered'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type ReadMessageInput = {
  messageId: Scalars['ID']
}

export type RecaptchaException = {
  __typename?: 'RecaptchaException'
  errorCodes: Maybe<Array<Maybe<Scalars['String']>>>
}

/** Recommended investing strategy */
export type RecommendedInvestingStrategy = {
  __typename?: 'RecommendedInvestingStrategy'
  accountSubtype: SuitabilityAccountSubtype
  accountType: SuitabilityAccountType
  /** Timestamp when recommendation was recorded */
  createdAt: Scalars['DateTime']
  portfolioId: Maybe<Scalars['ID']>
}

export type RecordDoesNotExistError = {
  __typename?: 'RecordDoesNotExistError'
  message: Scalars['String']
}

/** Record view_at for investment account recap. */
export type RecordInvestmentAccountRecapViewInput = {
  /** The unique identifier of the investment account recap for which to update view_at timestamp. */
  investmentAccountRecapId: Scalars['ID']
}

/** Result of record view_at timestamp for investment account recap. */
export type RecordInvestmentAccountRecapViewResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export type RecordReferralEventInput = {
  /** Time Event got Recorded */
  eventRecordedAt?: InputMaybe<Scalars['DateTime']>
  /** Type of referral event */
  eventType: ReferralEventTypeV2
  /** Friend who triggered the Event */
  friendId: Scalars['ID']
  /** subType of the Event */
  subType?: InputMaybe<ReferralEventType>
}

export type RecordReferralEventResult =
  | QualificationSubTypeMismatchError
  | ReferralEventV2
  | ReferralRelationshipMissingError
  | RelationshipAlreadyQualifiedError

export type RecordVendorExternalTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>
  collectedAt?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  paymentMethod?: InputMaybe<SubscriptionPaymentMethod>
}

export type RecordVendorExternalTransactionResult =
  | BillingVendorError
  | Transaction

export enum RecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule'
  byMonthDay: Maybe<Array<Scalars['Int']>>
  byWeekDay: Maybe<DayOfWeek[]>
  endDate: Maybe<Scalars['DateTime']>
  frequency: RecurrenceFrequency
  interval: Scalars['Int']
  startDate: Maybe<Scalars['DateTime']>
}

export type RecurrenceRuleInput = {
  byMonthDay?: InputMaybe<Array<Scalars['Int']>>
  byWeekDay?: InputMaybe<DayOfWeek[]>
  endDate?: InputMaybe<Scalars['DateTime']>
  frequency: RecurrenceFrequency
  interval: Scalars['Int']
  startDate?: InputMaybe<Scalars['DateTime']>
}

export type RecurringInvestmentInput = {
  amount: Scalars['Float']
  day: Scalars['Int']
  frequency: InvestmentFrequency
  investmentAccountId?: InputMaybe<Scalars['String']>
}

export type RecurringInvestmentPayload = {
  __typename?: 'RecurringInvestmentPayload'
  recurringInvestmentSettings: RecurringInvestmentSettings
}

/** Recurring deposit settings for an account */
export type RecurringInvestmentSettings = TimestampsInterface & {
  __typename?: 'RecurringInvestmentSettings'
  amount: Maybe<Scalars['Float']>
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  day: Maybe<Scalars['Int']>
  frequency: Maybe<InvestmentFrequency>
  /** Next scheduled date of a configured recurring investment. */
  nextInvestmentAt: Maybe<Scalars['Date']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type RecurringTransfer = {
  __typename?: 'RecurringTransfer'
  active: Scalars['Boolean']
  id: Scalars['ID']
  nextTransferDate: Maybe<Scalars['Date']>
  recurrenceRule: RecurrenceRule
  transferEvent: RecurringTransferEvent
}

export type RecurringTransferAccount = {
  __typename?: 'RecurringTransferAccount'
  id: Scalars['ID']
  type: RecurringTransferAccountType
}

export type RecurringTransferAccountIdFilterInput = {
  filter?: InputMaybe<RecurringTransferDirectionFilterInput>
  targetAccountId: Scalars['ID']
}

export type RecurringTransferAccountInput = {
  id: Scalars['ID']
  type: RecurringTransferAccountType
}

export enum RecurringTransferAccountType {
  Spend = 'SPEND',
}

export type RecurringTransferDate = {
  __typename?: 'RecurringTransferDate'
  nextTransferDate: Maybe<Scalars['Date']>
}

export enum RecurringTransferDirection {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL',
}

export type RecurringTransferDirectionFilterInput = {
  direction: RecurringTransferDirection
}

export type RecurringTransferEvent = {
  __typename?: 'RecurringTransferEvent'
  amount: CurrencyAmount
  direction: RecurringTransferDirection
  fundingSource: RecurringTransferFundingSource
  targetAccount: RecurringTransferAccount
}

export type RecurringTransferEventInput = {
  amount: CurrencyAmountInput
  direction: RecurringTransferDirection
  fundingSource: RecurringTransferFundingSourceInput
  targetAccount: RecurringTransferAccountInput
}

export type RecurringTransferFundingSource = {
  __typename?: 'RecurringTransferFundingSource'
  id: Scalars['ID']
  type: RecurringTransferFundingSourceType
}

export type RecurringTransferFundingSourceInput = {
  id: Scalars['ID']
  type: RecurringTransferFundingSourceType
}

export enum RecurringTransferFundingSourceType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
}

export type RecurringTransferPathException = {
  __typename?: 'RecurringTransferPathException'
  exception: RecurringTransferPathExceptionCase
  path: Array<Scalars['String']>
}

export enum RecurringTransferPathExceptionCase {
  Blank = 'BLANK',
  InvalidValue = 'INVALID_VALUE',
}

export type RecurringTransfersFilterInput = {
  filter?: InputMaybe<RecurringTransferAccountIdFilterInput>
  targetAccountType: RecurringTransferAccountType
}

/** Fetch a referral */
export type Referral = {
  __typename?: 'Referral'
  code: Scalars['String']
  referreeRewardAmount: Scalars['Float']
  referrerRewardAmount: Scalars['Float']
  url: Scalars['String']
}

/** Object with friend campaign information such as completed events and reward statuses */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign'
  /** The email of the advocate participating in the campaign */
  advocateEmail: Scalars['String']
  /**
   * Advocate Reward for completing all necessary steps. The object assumes that the
   * advocateUserId on type ReferralCampaign is the user that will receive the reward, but
   * friends can potentially have multiple advocates. Further investigation may be required.
   */
  advocateRewards: Maybe<ReferralReward[]>
  /** The id of the advocate participating in the campaign */
  advocateUserId: Maybe<Scalars['ID']>
  /** The id of the referral campaign that is also associated with the campaign id in Extole */
  campaignId: Scalars['ID']
  /** A list of events and their statuses to earn reward */
  events: Maybe<ReferralEvent[]>
  /** The email of the friend participating in the campaign */
  friendEmail: Scalars['String']
  /** Friend Reward for completing all necessary steps */
  friendRewards: Maybe<ReferralReward[]>
  /** The id of the friend participating in the campaign */
  friendUserId: Maybe<Scalars['ID']>
  /** The name of the campaign */
  name: Maybe<Scalars['String']>
}

export type ReferralCampaignConnection = {
  __typename?: 'ReferralCampaignConnection'
  autoAddCampaignId: Maybe<Scalars['ID']>
  edges: Maybe<ReferralCampaignEdge[]>
  fallbackCampaignId: Maybe<Scalars['ID']>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralCampaignEdge = {
  __typename?: 'ReferralCampaignEdge'
  cursor: Scalars['String']
  node: ReferralCampaignV2
}

export type ReferralCampaignReward = {
  __typename?: 'ReferralCampaignReward'
  amount: Scalars['Float']
  hurdle: Scalars['Int']
  id: Scalars['ID']
  repeated: Scalars['Boolean']
  targets: ReferralCampaignRewardTarget[]
  type: ReferralCampaignRewardType
}

export enum ReferralCampaignRewardTarget {
  Advocate = 'ADVOCATE',
  Friend = 'FRIEND',
}

export enum ReferralCampaignRewardType {
  Investment = 'INVESTMENT',
  Other = 'OTHER',
}

export type ReferralCampaignV2 = {
  __typename?: 'ReferralCampaignV2'
  actionFeedDesc: Maybe<Scalars['String']>
  activeInHouseCampaign: Maybe<Scalars['Boolean']>
  autoAdd: Scalars['Boolean']
  background: Scalars['String']
  condensedTitle: Maybe<Scalars['String']>
  description: Scalars['String']
  eligibilityEnd: Maybe<Scalars['DateTime']>
  fallback: Scalars['Boolean']
  hidden: Scalars['Boolean']
  icon: Scalars['String']
  id: Maybe<Scalars['ID']>
  internalMemo: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  publishEnd: Maybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  publishedStatus: Maybe<PublishedCampaignStatus>
  qa: Scalars['Boolean']
  qualificationAction: Scalars['String']
  qualificationAmount: Scalars['Int']
  rewards: ReferralCampaignReward[]
  status: CampaignStatus
  title: Scalars['String']
}

/** Object containing status of event associated with a Referral */
export type ReferralEvent = {
  __typename?: 'ReferralEvent'
  /** Date event was completed if status is 'COMPLETED' */
  dateCompleted: Maybe<Scalars['DateTime']>
  /**
   * Referral event nonce
   * @deprecated Field no longer supported
   */
  referralEventId: Maybe<Scalars['String']>
  /** Type of referral event */
  referralEventType: ReferralEventType
  /** Status based on activity of friend */
  status: ReferralEventStatus
}

/** input type specifying the parameters to create an event */
export type ReferralEventInput = {
  eventDetails?: InputMaybe<Scalars['JSON']>
  eventNonce?: InputMaybe<Scalars['ID']>
  eventType: ReferralEventType
  userId: Scalars['String']
}

/** Status of referral events */
export enum ReferralEventStatus {
  /** Friend has completed event */
  Completed = 'COMPLETED',
  /** Friend has not started or completed event */
  NotStarted = 'NOT_STARTED',
  /** Friend has initiated event but event has not fully processed */
  Pending = 'PENDING',
}

/** Descriptions of User actions needed to earn reward */
export enum ReferralEventType {
  /** User has made a transfer into a Spend Account */
  DepositSpend = 'DEPOSIT_SPEND',
  /** User has opened an Early account */
  EarlyAccountOpened = 'EARLY_ACCOUNT_OPENED',
  /** User has a funding source linked */
  FsLinked = 'FS_LINKED',
  /** User has made initial investment into core account */
  InvestCore = 'INVEST_CORE',
  /** User has made initial investment into early account */
  InvestEarly = 'INVEST_EARLY',
  /** User has made initial investment into later account */
  InvestLater = 'INVEST_LATER',
  /** User has opened a Later account */
  LaterAccountOpened = 'LATER_ACCOUNT_OPENED',
  /** User has signed the referral agreement */
  ReferralAgreementSigned = 'REFERRAL_AGREEMENT_SIGNED',
  /** User has completed registration */
  RegistrationCompleted = 'REGISTRATION_COMPLETED',
  /** User has initialized the registration process */
  SignedUp = 'SIGNED_UP',
  /** User has opened a Spend account */
  SpendAccountOpened = 'SPEND_ACCOUNT_OPENED',
  /** User has paid their subscription */
  SubscriptionPaid = 'SUBSCRIPTION_PAID',
  /** Unknown referral event type */
  Unknown = 'UNKNOWN',
  /** User has been verified */
  UserVerified = 'USER_VERIFIED',
}

/** Descriptions of Friend Events */
export enum ReferralEventTypeV2 {
  /** User has made initial investment */
  FirstHoldingsCreated = 'FIRST_HOLDINGS_CREATED',
  /** User has completed registration */
  UserRegistrationCompleted = 'USER_REGISTRATION_COMPLETED',
}

/** Object containing status of event associated with a Referra In-house platform */
export type ReferralEventV2 = {
  __typename?: 'ReferralEventV2'
  /** Advocate who is associated the Event */
  advocateId: Scalars['ID']
  /** Campaign associated the Event */
  campaignId: Scalars['ID']
  /** Time Event got Created */
  created: Scalars['DateTime']
  /** Is it an Eligible Event */
  eligible: Scalars['Boolean']
  /** Time Event got Recorded */
  eventRecordedAt: Maybe<Scalars['DateTime']>
  /** Type of referral event */
  eventType: ReferralEventTypeV2
  /** Friend who triggered the Event */
  friendId: Scalars['ID']
  /** Referral event Id */
  id: Scalars['ID']
  /** Relationship associated the Event */
  relationshipId: Scalars['ID']
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistory = {
  __typename?: 'ReferralHistory'
  friendHistory: Maybe<FriendHistoryConnection>
  friendSummary: Maybe<FriendSummary[]>
  /** The number of completed referrals for a user */
  numCompletedReferrals: Maybe<Scalars['Int']>
  /** The number of status pending referrals for a user */
  numPendingReferrals: Maybe<Scalars['Int']>
  /** The total monetary reward amount the user has earned */
  totalReferralRewardsEarned: Maybe<CurrencyAmount>
  userId: Maybe<Scalars['ID']>
}

/** Object that holds referral statistics for an Acorns User */
export type ReferralHistoryFriendHistoryArgs = {
  campaignId?: InputMaybe<Scalars['ID']>
  filter: ReferralPaginatedFilter
}

export type ReferralPaginatedFilter = {
  /** Cursor to start pagination results for (exclusive) */
  after?: InputMaybe<Scalars['String']>
  /** Number of nodes to return */
  limit?: InputMaybe<Scalars['Int']>
}

export type ReferralPaginatedInfo = {
  __typename?: 'ReferralPaginatedInfo'
  /** Cursor corresponding to the last node in the list of edges */
  endCursor: Maybe<Scalars['String']>
  /** Indicates whether more edges exist following the set defined by the filter */
  hasNextPage: Scalars['Boolean']
  /** Indicates whether more edges exist prior to the set defined by the filter */
  hasPreviousPage: Scalars['Boolean']
  /** Cursor corresponding to the first node in the list of edges */
  startCursor: Maybe<Scalars['String']>
}

export type ReferralPayout = {
  __typename?: 'ReferralPayout'
  advocateId: Maybe<Scalars['ID']>
  advocateOfferId: Maybe<Scalars['String']>
  campaign: Maybe<ReferralCampaignV2>
  created: Maybe<Scalars['DateTime']>
  friendId: Maybe<Scalars['ID']>
  friendOfferId: Maybe<Scalars['String']>
  payoutId: Scalars['ID']
  reason: Maybe<Scalars['String']>
  reward: Maybe<ReferralCampaignReward>
  status: Maybe<ReferralPayoutStatus>
  statusChangeAt: Maybe<Scalars['DateTime']>
  statusChangeBy: Maybe<Scalars['String']>
  updated: Maybe<Scalars['DateTime']>
}

export type ReferralPayoutConnection = {
  __typename?: 'ReferralPayoutConnection'
  edges: Maybe<ReferralPayoutEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralPayoutEdge = {
  __typename?: 'ReferralPayoutEdge'
  cursor: Scalars['String']
  node: ReferralPayout
}

export type ReferralPayoutExistsError = {
  __typename?: 'ReferralPayoutExistsError'
  message: Scalars['String']
}

export type ReferralPayoutRelationship = {
  __typename?: 'ReferralPayoutRelationship'
  advocateId: Maybe<Scalars['ID']>
  archived: Maybe<Scalars['Boolean']>
  created: Maybe<Scalars['DateTime']>
  friendId: Maybe<Scalars['ID']>
  payoutId: Scalars['ID']
  payoutRelationshipId: Maybe<Scalars['ID']>
  relationshipId: Scalars['ID']
}

export enum ReferralPayoutStatus {
  /** Payout has met the hurdle in the holdout period */
  Approved = 'APPROVED',
  /** Payout have been Cancelled */
  Cancelled = 'CANCELLED',
  /** Payout has been disqualified due to validation check fails */
  Disqualified = 'DISQUALIFIED',
  /** Payout have expired as the eligibility end date passed for disqualified payout */
  Expired = 'EXPIRED',
  /** Payout have been sent for fulfillment */
  Fulfilled = 'FULFILLED',
  /** Payout started the process for fulfillment */
  Fulfilling = 'FULFILLING',
  /** Payout has been created, but hurdle not met yet */
  Pending = 'PENDING',
  /** Payout has been rejected manually (not used) */
  Rejected = 'REJECTED',
}

export type ReferralPayoutsFilter = {
  advocateId?: InputMaybe<Scalars['ID']>
  campaignId?: InputMaybe<Scalars['ID']>
  displayCancelled?: InputMaybe<Scalars['Boolean']>
  payoutId?: InputMaybe<Scalars['ID']>
  statusList?: InputMaybe<ReferralPayoutStatus[]>
}

export type ReferralRelationship = {
  __typename?: 'ReferralRelationship'
  advocateId: Scalars['ID']
  campaignId: Scalars['ID']
  friendId: Scalars['ID']
  status: ReferralRelationshipStatus
  statusChangeAt: Maybe<Scalars['DateTime']>
}

export type ReferralRelationshipConnection = {
  __typename?: 'ReferralRelationshipConnection'
  edges: Maybe<ReferralRelationshipEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export type ReferralRelationshipEdge = {
  __typename?: 'ReferralRelationshipEdge'
  cursor: Scalars['String']
  node: ReferralRelationship
}

export type ReferralRelationshipMissingError = {
  __typename?: 'ReferralRelationshipMissingError'
  message: Scalars['String']
}

/** Status of referral relationship */
export enum ReferralRelationshipStatus {
  /** Relationship has been created */
  Created = 'CREATED',
  /** Relationship is eligible for payout */
  Eligible = 'ELIGIBLE',
  /** Relationship payout has been fulfilled */
  Fulfilled = 'FULFILLED',
  /** Relationship is ineligible for payout */
  Ineligible = 'INELIGIBLE',
  /** Friend has completed first inevestment */
  Invested = 'INVESTED',
  /** Friend has completed registration */
  Registered = 'REGISTERED',
  /** Friend should reinvest since old investement do not qualify */
  ReinvestNeeded = 'REINVEST_NEEDED',
}

export type ReferralRelationshipsFilter = {
  friendId?: InputMaybe<Scalars['ID']>
  status?: InputMaybe<ReferralRelationshipStatus>
}

/** Object containing reward information for completing a campaign */
export type ReferralReward = {
  __typename?: 'ReferralReward'
  /** Name of the referral reward */
  name: Maybe<Scalars['String']>
  /** The date the reward was fulfilled (if applicable) */
  rewardFulfilledAtDate: Maybe<Scalars['DateTime']>
  /** The status of the reward associated with activity campaign */
  rewardStatus: Maybe<ReferralRewardStatus>
  /** Value of reward for completing all events in a campaign */
  value: Scalars['String']
  /** Value type for completing all events in a campaign */
  valueType: Maybe<ReferralValueType>
}

export type ReferralRewardEdge = {
  __typename?: 'ReferralRewardEdge'
  cursor: Scalars['String']
  node: ReferralCampaignReward
}

/** The current status of a referral reward */
export enum ReferralRewardStatus {
  /** User has earned reward by completing all campaign steps, but reward still needs to be issued. */
  Earned = 'EARNED',
  /** Reward has been issued by Acorns */
  Fulfilled = 'FULFILLED',
  /** Reward has not been created */
  NotCreated = 'NOT_CREATED',
}

/** Summary of updated reward */
export type ReferralRewardSummary = {
  __typename?: 'ReferralRewardSummary'
  /** The Acorns User acting as an advocate for this referral reward */
  advocateUserId: Maybe<Scalars['ID']>
  /** Status of this referral for Friend/Acorns User */
  status: ReferralRewardStatus
}

export enum ReferralRewardUpdateStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
}

export type ReferralRewardsConnection = {
  __typename?: 'ReferralRewardsConnection'
  edges: Maybe<ReferralRewardEdge[]>
  pageInfo: ReferralPaginatedInfo
}

export enum ReferralStatus {
  /** Referral has been cancelled */
  Cancelled = 'CANCELLED',
  /** User and Friend have completed referral and should be rewarded */
  Completed = 'COMPLETED',
  /** Referral has expired because events were not finished before campaign end date */
  Expired = 'EXPIRED',
  /** Friend has used referral code but still has events they need to complete */
  Pending = 'PENDING',
  /** User and Friend have been rewarded */
  Rewarded = 'REWARDED',
  /** Referral has been sent to a friend */
  Sent = 'SENT',
}

/** input type specifyig the parameters that can be updated */
export type ReferralUserUpdateInput = {
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
}

/** Value types of reward associated with completion of a referral */
export enum ReferralValueType {
  Usd = 'USD',
}

export type RefreshAuthTokenInput = {
  pin?: InputMaybe<Scalars['String']>
  refreshToken: Scalars['String']
}

export type RefreshAuthTokenRateLimitedException = {
  __typename?: 'RefreshAuthTokenRateLimitedException'
  message: Maybe<Scalars['String']>
}

export type RefreshAuthTokenResult =
  | AuthSession
  | InvalidPinException
  | RefreshAuthTokenRateLimitedException
  | TokenExpiredException
  | UserSuspendedException

export type RefreshTokenNotFoundException = {
  __typename?: 'RefreshTokenNotFoundException'
  userId: Scalars['ID']
}

export type RefundBankAccount = {
  __typename?: 'RefundBankAccount'
  accountNickname: Maybe<Scalars['String']>
  accountNumber: Maybe<Scalars['String']>
  accountType: Maybe<Scalars['String']>
}

/** Configuration for regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenInput = {
  /** The unique identifier of the investment account recap for which a public token is being regenerated. */
  id: Scalars['ID']
}

/** Result of regenerating the public token of an investment account recap. */
export type RegenerateInvestmentAccountRecapPublicTokenResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

export type RegisterAccountTypeResult = RegisterAccountTypeResultTemporaryImpl

export type RegisterAccountTypeResultTemporaryImpl = {
  __typename?: 'RegisterAccountTypeResultTemporaryImpl'
  someField: Scalars['String']
}

export type RegisterCredentialsInput = {
  acceptanceDocumentVersionUuids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >
  email: Scalars['EmailAddress']
  password: Scalars['String']
  udid: Scalars['String']
  usResident?: InputMaybe<Scalars['Boolean']>
}

export type RegisterCredentialsResult =
  | AuthSession
  | EmailTakenException
  | InvalidPasswordException
  | MissingRequiredAgreementsException

export type RegisterDeviceTokenAndPushAuthenticatorInput = {
  deviceId: Scalars['ID']
  deviceToken: Scalars['String']
  deviceType: DeviceType
  name?: InputMaybe<Scalars['String']>
}

export type RegisterDeviceTokenAndPushAuthenticatorResult =
  | InvalidDeviceParametersException
  | PushAuthenticator
  | PushAuthenticatorAlreadyExistsException

export type RegisterEmailAuthenticatorInput = {
  email: Scalars['EmailAddress']
  name?: InputMaybe<Scalars['String']>
  setDefault?: InputMaybe<Scalars['Boolean']>
}

export type RegisterEmailAuthenticatorResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | EmailAuthenticator
  | ExistingEmailVerifiedException

/** Returns Layer session information */
export type RegisterLayerLinkSessionResult =
  | LayerLinkSession
  | UnrecoverableError

/** Returns a Linked Account Type or AsyncLinkSessionResult. */
export type RegisterLinkSessionResult = AsyncLinkSessionResult | LinkedAccount

export type RegisterOidcCredentialsInput = {
  /** Identity token signed by external Oidc provider */
  idToken: Scalars['String']
  /** Nonce used in the request to prevent replay attacks. */
  nonce: Scalars['String']
  oidcProvider: OidcProvider
  /** A unique identifier representing the Device the client is running on. */
  udid: Scalars['String']
}

export type RegisterOidcCredentialsResult =
  | AuthSession
  | EmailTakenException
  | InvalidAppleAccountException
  | InvalidCredentialsException
  | UserSuspendedException

export type RegisterPhoneAuthenticatorInput = {
  name?: InputMaybe<Scalars['String']>
  phoneNumber: Scalars['PhoneNumber']
  setDefault?: InputMaybe<Scalars['Boolean']>
}

export type RegisterPhoneAuthenticatorResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthenticatorTypeAlreadyRegisteredException
  | InvalidPhoneNumberException
  | PhoneAuthenticator

/** Input for the registerProspect mutation initially registering a prospect user. */
export type RegisterProspectInput = {
  /** Flag indicating if source identifier can be overridden or not */
  amendableSource?: InputMaybe<Scalars['Boolean']>
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: SourceAttributesInput
}

/** Union for the result of the registerProspect mutation */
export type RegisterProspectResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | RegistrationFunnel

/** Properties for displaying drawer content on page */
export type RegistrationDrawerContent = {
  __typename?: 'RegistrationDrawerContent'
  body: Scalars['String']
  image: Scalars['URL']
  title: Scalars['String']
}

/** Information about funnel experience */
export type RegistrationFunnel = {
  __typename?: 'RegistrationFunnel'
  /** List of pages within funnel */
  flow: RegistrationPage[]
  /** User's funnel information */
  metadata: FunnelMetadata
  sourceAttributes: SourceAttributes
}

/** Available fields to filter for a specific user's funnel experience */
export type RegistrationFunnelFilter = {
  /** Email address for prospect that was used during initial sign up */
  email?: InputMaybe<Scalars['String']>
  /** User's unique identifier */
  userId?: InputMaybe<Scalars['ID']>
}

/** Registration fields */
export type RegistrationInput = {
  /** The entry point for a registration */
  funnel: Funnel
}

/** Single page within registration flow */
export type RegistrationPage = {
  __typename?: 'RegistrationPage'
  actions: RegistrationPageAction[]
  content: Maybe<RegistrationPageContent>
  isBackEnabled: Scalars['Boolean']
  name: PageName
}

/** CTAs that can be performed on the page */
export type RegistrationPageAction = {
  __typename?: 'RegistrationPageAction'
  /** Page that CTA will route to */
  nextPage: PageName
  type: ActionType
}

/** Base interface for registration page components */
export type RegistrationPageContent = {
  campaignId: Scalars['String']
  title: Scalars['String']
}

/** Properties for displaying banner on page */
export type RegistrationProminenceBannerContent = RegistrationPageContent & {
  __typename?: 'RegistrationProminenceBannerContent'
  campaignId: Scalars['String']
  drawer: Maybe<RegistrationDrawerContent>
  icon: Scalars['URL']
  title: Scalars['String']
}

export type ReinitiateSmsChallengeInput = {
  challengeId: Scalars['ID']
}

export type ReinitiateSmsChallengeResult =
  | AuthChallengeExpiredException
  | ChallengeRateExceededException
  | EmailAuthChallenge
  | PhoneNumberOptedOutException
  | SmsAuthChallenge

/** The reason why the reinvestment was created */
export enum ReinvestmentReason {
  /** Reinvestment was created due to a debit overselling than what was requested */
  Oversell = 'OVERSELL',
}

export type ReissueBankCardEligibility =
  | ReissueBankCardEligible
  | ReissueBankCardIneligible

export type ReissueBankCardEligible = {
  __typename?: 'ReissueBankCardEligible'
  originalCardCreatedAt: Scalars['Date']
}

export type ReissueBankCardExistsError = {
  __typename?: 'ReissueBankCardExistsError'
  /** BankCardRequest id / new bank card id */
  id: Scalars['ID']
}

export type ReissueBankCardIneligible = {
  __typename?: 'ReissueBankCardIneligible'
  issues: Array<Maybe<ReissueBankCardIneligibleIssue>>
}

export enum ReissueBankCardIneligibleIssue {
  ActiveBankCardRequest = 'ACTIVE_BANK_CARD_REQUEST',
  CardAdminLocked = 'CARD_ADMIN_LOCKED',
  FirstCardNotIssuedYet = 'FIRST_CARD_NOT_ISSUED_YET',
}

export type ReissueBankCardInput = {
  mailingAddress: BankCardRequestMailingAddressInput
  reason: BankCardRequestReason
  reasonComment?: InputMaybe<Scalars['String']>
  reasonDate?: InputMaybe<Scalars['Date']>
}

export type ReissueBankCardResult = BankCardRequest | ReissueBankCardExistsError

export enum RejectedReason {
  DocumentExpired = 'documentExpired',
  IncorrectDocumentType = 'incorrectDocumentType',
  IncorrectName = 'incorrectName',
  InvalidResidentialAddress = 'invalidResidentialAddress',
  MismatchedName = 'mismatchedName',
  MissingName = 'missingName',
  NoVisibleDate = 'noVisibleDate',
  NotEligibleForPromotion = 'notEligibleForPromotion',
  PoorImageQuality = 'poorImageQuality',
  SsnAlreadyUsed = 'ssnAlreadyUsed',
}

export type RelationshipAlreadyQualifiedError = {
  __typename?: 'RelationshipAlreadyQualifiedError'
  message: Scalars['String']
}

/** Relink Linked Account Alert. */
export type RelinkLinkedAccountAlert = UserAlertsItem & {
  __typename?: 'RelinkLinkedAccountAlert'
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type RemoveAccountTypeResult = RemoveAccountTypeResultTemporaryImpl

export type RemoveAccountTypeResultTemporaryImpl = {
  __typename?: 'RemoveAccountTypeResultTemporaryImpl'
  someField: Scalars['String']
}

/** Input for removing cohorts */
export type RemoveCohortEligibilityInput = {
  /** List of cohort slugs to remove */
  remove: Array<Scalars['String']>
}

/** Removed Cohorts Result */
export type RemoveCohortEligibilityResult = UserCohorts

export type RemoveJobAlertResult = RemovedJobAlert

export type RemovePolicyInput = {
  name: Scalars['String']
}

export type RemovePolicyResult =
  | PoliciesRecordDoesNotExistException
  | ValidPolicies

/** Input to remove a security from a portfolio */
export type RemoveSecurityFromPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** The market exchange symbol of the ETF to remove from the portfolio */
  symbol: Scalars['String']
}

/** Result from removing a security from a portfolio */
export type RemoveSecurityFromPortfolioResult =
  | InvestmentAccountNotFoundException
  | InvestmentAccountNotSupportedException
  | Portfolio
  | PortfolioNotFoundException
  | PortfolioNotSupportedException
  | SecurityNotSupportedException

/** Remove self directed portfolio from an investment account closure request */
export type RemoveSelfDirectedPortfolioInput = {
  /** List of closure reason keys */
  accountClosureReasons?: InputMaybe<Array<Scalars['String']>>
  /** Any closure reason comments the user may have */
  comments?: InputMaybe<Scalars['String']>
  /** The ID of the investment account to be closed */
  investmentAccountId: Scalars['ID']
}

/** Self Directed Portfolio Closure Response */
export type RemoveSelfDirectedPortfolioResult =
  | AccountNotFoundException
  | InvestmentAccount
  | InvestmentAccountAlreadyClosed
  | InvestmentAccountClosureInProgress
  | PortfolioAlreadyRemovedError
  | PortfolioNotFoundException
  | PortfolioRemovalInProgressError

/** Indicates remove operation succeeded */
export type RemovedJobAlert = {
  __typename?: 'RemovedJobAlert'
  id: Scalars['ID']
}

/** Reopen User Account Response */
export type ReopenUserAccountResult =
  | UserNotFoundException
  | UserReopenLockedException
  | UserReopenSuspendedException
  | User_V2

export type ReportBankCardLostStolenInput = {
  lockReason: BankCardPermanentLockReason
}

export type ReportBankCardLostStolenPayload = {
  __typename?: 'ReportBankCardLostStolenPayload'
  bankCard: Maybe<BankCard>
}

export type RequestAccountClosureInput = {
  comments?: InputMaybe<Scalars['String']>
  reason: Scalars['String']
}

/** Input for closing an early investment account */
export type RequestEarlyAccountClosureInput = {
  /** The ID's of the early accounts to be closed */
  investmentAccountIds: Array<Scalars['ID']>
  /** The reason for the account closure */
  reason: InvestmentAccountClosureReason
}

/** Result from closing an Investment Account */
export type RequestEarlyAccountClosureResult =
  | AccountAlreadyClosedException
  | ClosureRequestExistsException
  | FundingSourceRequiresRdvException
  | InternalErrorException
  | InvalidAccountTypeException
  | InvestmentAccount
  | InvestmentAccountNeedsTransferException
  | MissingFundingSourceException

/** Input for requesting to reopen an investment account */
export type RequestInvestmentAccountReopenInput = {
  /** The ID of the investment account to be reopened */
  investmentAccountId: Scalars['ID']
}

/** Result from requesting to reopen an investment account */
export type RequestInvestmentAccountReopenResult =
  | ExistingRequestPendingReview
  | ExistingRequestPendingUserAction
  | InvalidSubscriptionTierException
  | InvestmentAccountNotClosedException
  | InvestmentAccountNotFoundException
  | InvestmentAccountReopenRequest

export type RequestLayerSessionInput = {
  publicToken: Scalars['String']
}

export type RequestLayerSessionResult =
  | RequestedLayerLinkSession
  | UnrecoverableError

export type RequestSubscriptionMigrationWaiverInput = {
  reason: SubscriptionMigrationWaiverReason
  subscriptionMigrationId: Scalars['ID']
}

export type RequestSubscriptionMigrationWaiverResult =
  | InvalidTierForMigrationError
  | SubscriptionMigrationInvalidError
  | SubscriptionMigrationWaiver

export enum RequestVersions {
  September_2022 = 'SEPTEMBER_2022',
}

/** Submitted customer information */
export type RequestedLayerLinkSession = {
  __typename?: 'RequestedLayerLinkSession'
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  dateOfBirth: Maybe<Scalars['Date']>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  ssnStorageResult: SsnStorageResult
  state: Maybe<Scalars['String']>
  street1: Maybe<Scalars['String']>
  street2: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export type ResendChatMessageResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageNotFound

export type ResetPasswordByTokenException = {
  __typename?: 'ResetPasswordByTokenException'
  message: Maybe<Scalars['String']>
}

export type ResetPasswordByTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>
  newPw: Scalars['String']
  newPwConfirmation: Scalars['String']
  resetToken: Scalars['String']
  securityAnswer?: InputMaybe<Scalars['String']>
}

export type ResetPasswordByTokenResult =
  | IncorrectSecurityAnswerException
  | IncorrectSsnException
  | InvalidPasswordException
  | ResetPasswordByTokenException
  | ResetPasswordByTokenSuccess
  | UserCredentialsNotFoundException

export type ResetPasswordByTokenSuccess = {
  __typename?: 'ResetPasswordByTokenSuccess'
  userId: Scalars['ID']
}

export type ResetPasswordWithTokenInput = {
  last4Ssn?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  passwordConfirmation: Scalars['String']
  resetToken: Scalars['String']
}

export type ResetPasswordWithTokenResult =
  | InvalidPasswordResetException
  | InvalidPasswordResetTokenException
  | ResetPasswordWithTokenSuccess
  | UserCredentialsNotFoundException

export type ResetPasswordWithTokenSuccess = {
  __typename?: 'ResetPasswordWithTokenSuccess'
  userId: Scalars['ID']
}

export type ResetRateLimitResult =
  | RateLimitDoesNotExistException
  | ResetRateLimitSuccess

export type ResetRateLimitSuccess = {
  __typename?: 'ResetRateLimitSuccess'
  challengeRateLimitReset: Maybe<Scalars['Boolean']>
  loginRateLimitReset: Maybe<Scalars['Boolean']>
  userId: Maybe<Scalars['ID']>
}

export type ResourceNotFoundError = {
  __typename?: 'ResourceNotFoundError'
  requestId: Scalars['ID']
}

export type RespondToLearnPollInput = {
  pollId: Scalars['ID']
  selectedOption: Scalars['String']
}

export type RespondToLearnPollResult =
  | InvalidOptionException
  | LearnPollResponse
  | RecordDoesNotExistError

export type RestoreLoginAccessInput = {
  userId: Scalars['ID']
}

export type RestoreLoginAccessResult =
  | AuthProfile
  | AuthProfileNotFoundException

/** A registration record for a prospective user */
export type Result = {
  __typename?: 'Result'
  funnel: Funnel
}

export enum RetirementPlanAccess {
  /** Married user and spouse have access to a retirement plan */
  Both = 'both',
  /** Neither married user nor spouse have access to a retirement plan */
  Neither = 'neither',
  /** Single user has no access to retirement plan */
  No = 'no',
  /** Married user has access to a retirement plan without spouse */
  OnlyMe = 'onlyMe',
  /** Married user does not have access to a retirement plan, but spouse does */
  Spouse = 'spouse',
  /** Single user has access to an employer's retirement plan */
  Yes = 'yes',
}

/** Result from attempting to retrigger RDVs */
export type RetriggerRdvsResult = FundingSourceAccount | RdvsNotTriggered

/** A returned check */
export type ReturnedCheckDeposit = {
  __typename?: 'ReturnedCheckDeposit'
  /** Amount for check. */
  amount: CurrencyAmount
  /** Returned Check Deposit Image URL for back of check. */
  backCheckImageUrl: Scalars['String']
  /** Returned Check Deposit Image URL for front of check. */
  frontCheckImageUrl: Scalars['String']
  /** Date check was returned. */
  rejectedDate: Scalars['DateTime']
}

export enum RevenueScheduleType {
  AtInvoice = 'at_invoice',
  AtRangeEnd = 'at_range_end',
  AtRangeStart = 'at_range_start',
  Evenly = 'evenly',
  Never = 'never',
}

export enum RevokeAccessReasons {
  CoreAccountReview = 'CORE_ACCOUNT_REVIEW',
  CoreBrokerDealerAssociation = 'CORE_BROKER_DEALER_ASSOCIATION',
  CoreCastleLock = 'CORE_CASTLE_LOCK',
  CoreChargeback = 'CORE_CHARGEBACK',
  CoreCollection = 'CORE_COLLECTION',
  CoreDisputedTransaction = 'CORE_DISPUTED_TRANSACTION',
  CoreLeinLevyLock = 'CORE_LEIN_LEVY_LOCK',
  CorePendingApprovalApplicationWithdrawn = 'CORE_PENDING_APPROVAL_APPLICATION_WITHDRAWN',
  CorePotentialAccountTakeover = 'CORE_POTENTIAL_ACCOUNT_TAKEOVER',
  CoreSuspiciousInvestmentActivity = 'CORE_SUSPICIOUS_INVESTMENT_ACTIVITY',
  CoreW9Required = 'CORE_W9_REQUIRED',
  Deceased = 'DECEASED',
  DelayedRiskWithdrawals = 'DELAYED_RISK_WITHDRAWALS',
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  EarlyTransferInProgress = 'EARLY_TRANSFER_IN_PROGRESS',
  Fraud = 'FRAUD',
  LaterRolloverInProgress = 'LATER_ROLLOVER_IN_PROGRESS',
  OtherNotListed = 'OTHER_NOT_LISTED',
  PlaidMismatch = 'PLAID_MISMATCH',
  ProfitStarsDispute = 'PROFIT_STARS_DISPUTE',
  ReferralPromotionFraud = 'REFERRAL_PROMOTION_FRAUD',
  SpendDisputedIncomingTransferR10 = 'SPEND_DISPUTED_INCOMING_TRANSFER_R10',
  SpendGeneralSuspension = 'SPEND_GENERAL_SUSPENSION',
  SpendReturnedTransfer = 'SPEND_RETURNED_TRANSFER',
  SpendSuspiciousTransferActivity = 'SPEND_SUSPICIOUS_TRANSFER_ACTIVITY',
  SuspiciousMrdcContactSpendRisk = 'SUSPICIOUS_MRDC_CONTACT_SPEND_RISK',
  SuspiciousMrdcPendingClosure = 'SUSPICIOUS_MRDC_PENDING_CLOSURE',
  ThreeWayCallRequired = 'THREE_WAY_CALL_REQUIRED',
  Underage = 'UNDERAGE',
  UnsupportedCustomer = 'UNSUPPORTED_CUSTOMER',
}

export type RevokeLoginAccessInput = {
  reason: RevokeAccessReasons
  userId: Scalars['ID']
}

export type RevokeLoginAccessResult =
  | AuthProfile
  | UserCredentialsNotFoundException

export type RevokePasswordResetTokenInput = {
  plaintextToken: Scalars['String']
}

export type RevokePasswordResetTokenResult =
  | InvalidPasswordResetTokenException
  | RevokePasswordResetTokenSuccess

export type RevokePasswordResetTokenSuccess = {
  __typename?: 'RevokePasswordResetTokenSuccess'
  userId: Scalars['String']
}

export enum RiskStatus {
  Confirmable = 'confirmable',
  Fixable = 'fixable',
  HardReject = 'hard_reject',
}

/** A transaction with excess change to invest into an Acorns account */
export type RoundUp = TimestampsInterface & {
  __typename?: 'RoundUp'
  amount: Scalars['Float']
  change: Scalars['Float']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  instant: Scalars['Boolean']
  investmentId: Maybe<Scalars['ID']>
  investmentNonce: Maybe<Scalars['ID']>
  linkedSubaccountId: Scalars['ID']
  manual: Scalars['Boolean']
  multiplier: Maybe<Scalars['Float']>
  name: Scalars['String']
  roundUpAccount: RoundUpAccount
  roundUpProfile: RoundUpProfile
  state: RoundUpState
  /** The target account in which this round up has been invested. */
  targetAccountId: Maybe<Scalars['ID']>
  total: Maybe<Scalars['Float']>
  transactionDate: Scalars['DateTime']
  transactionDisplayDate: Scalars['Date']
  transactionId: Scalars['ID']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a specific linked account */
export type RoundUpAccount = TimestampsInterface & {
  __typename?: 'RoundUpAccount'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  enabled: Scalars['Boolean']
  linkedSubaccountId: Scalars['ID']
  roundUpProfile: RoundUpProfile
  roundUps: RoundUp[]
  startDate: Maybe<Scalars['String']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
}

/** Round up settings for a user */
export type RoundUpProfile = TimestampsInterface & {
  __typename?: 'RoundUpProfile'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  multiplier: Scalars['Float']
  realTimeRoundUpEligible: Scalars['Boolean']
  roundUpAccounts: RoundUpAccount[]
  roundUpCount: Scalars['Int']
  roundUpTotal: Scalars['Float']
  roundUps: RoundUp[]
  roundUpsEnabled: Scalars['Boolean']
  /** True if user has auto roundups off (making all roundups manual, even from Spend accounts)or at least one enabled non-spend roundup account. */
  showRoundUpsProgress: Scalars['Boolean']
  /** The target account to which a user's round up investments will be made. */
  targetAccountId: Maybe<Scalars['ID']>
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  wholeDollarAmount: Scalars['Float']
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpCountArgs = {
  spend?: InputMaybe<Scalars['Boolean']>
  state?: InputMaybe<RoundUpState[]>
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Round up settings for a user */
export type RoundUpProfileRoundUpTotalArgs = {
  spend?: InputMaybe<Scalars['Boolean']>
  state?: InputMaybe<RoundUpState[]>
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Changeable attributes for user profiles */
export type RoundUpProfileInput = {
  /** Round up multiplier */
  multiplier?: InputMaybe<Scalars['Float']>
  /** Toggle global user setting for auto round ups */
  roundUpsEnabled?: InputMaybe<Scalars['Boolean']>
  /** Acorns account ID of roundups destination */
  targetAccountId?: InputMaybe<Scalars['ID']>
  /** Round up to custom dollar amount */
  wholeDollarAmount?: InputMaybe<Scalars['Float']>
}

export enum RoundUpState {
  /**
   * Round ups that will be invested automatically
   * @deprecated Use waiting state instead
   */
  AutoInvestable = 'autoInvestable',
  /** Round ups that were canceled, either before or after an investment was created */
  Canceled = 'canceled',
  /** Round ups associated with an investment */
  Invested = 'invested',
  /** Round ups that have yet to be invested */
  Pending = 'pending',
  /** Round ups that requested to be invested but have not been transferred */
  RoundedUp = 'roundedUp',
  /** Round ups which are ready to be invested */
  Waiting = 'waiting',
}

export enum RoundUpType {
  Auto = 'auto',
  RealTime = 'realTime',
}

/** An individual edge within the paginated list of RoundUpType */
export type RoundUpTypeEdge = {
  __typename?: 'RoundUpTypeEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The RoundUpType record in the edge */
  node: RoundUp
}

/** Relay style pagination information for RoundUpType */
export type RoundUpTypePagination = {
  __typename?: 'RoundUpTypePagination'
  edges: RoundUpTypeEdge[]
  pageInfo: PageInfo
}

export type SmsAuthChallenge = AuthChallenge & {
  __typename?: 'SMSAuthChallenge'
  alternateAuthenticators: AuthenticatorInfo[]
  challengeTrigger: ChallengeTriggers
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  maskedPhoneNumber: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/** SSN supporting document requested user alert. */
export type SsnDocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'SSNDocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export enum SsnStorageResult {
  Exists = 'EXISTS',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
}

export enum SalaryInterval {
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type SamePasswordsException = {
  __typename?: 'SamePasswordsException'
  message: Maybe<Scalars['String']>
}

export type SampleMailInDocument = {
  __typename?: 'SampleMailInDocument'
  letterUrl: Maybe<Scalars['URL']>
  mailType: MailInDocumentType
}

export type SaveInterestPaidItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SaveInterestPaidItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    /** The calendar month in which this interest was earned. */
    monthEarned: Scalars['String']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SaveTransferInItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SaveTransferInItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SaveTransferOutItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SaveTransferOutItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlInput = {
  /** the upload uuid from the upload object */
  uploadUuid: Scalars['ID']
}

/** Input for saving an upload url after direct to s3 upload */
export type SaveUploadUrlsInput = {
  /** a field where the user can add additional info for their uploads */
  additionalInfo?: InputMaybe<Scalars['String']>
  /** collection of uploads uuid from the uploads object */
  uploadsUuid: Array<Scalars['ID']>
}

/** LegacyUploadDocumentResult */
export type SaveUploadUrlsResult = DocumentUploads | UploadSaveError

export type SavingsAccountEligibility = {
  __typename?: 'SavingsAccountEligibility'
  isEligibleForOpen: Scalars['Boolean']
  notEligibleReasons: SavingsAccountEligibilityRequirement[]
}

export enum SavingsAccountEligibilityRequirement {
  NeedsCheckingAccount = 'NEEDS_CHECKING_ACCOUNT',
  NeedsDirectDeposit = 'NEEDS_DIRECT_DEPOSIT',
  NeedsOtherBankingPartner = 'NEEDS_OTHER_BANKING_PARTNER',
}

export enum SavingsAccountType {
  EmergencySavings = 'EMERGENCY_SAVINGS',
}

export type ScheduleInput = {
  type: ScheduleType
}

export type ScheduleRecurringTransferInput = {
  recurrenceRule: RecurrenceRuleInput
  transferEvent: RecurringTransferEventInput
}

export type ScheduleRecurringTransferResult =
  | MalformedRecurringTransferException
  | RecurringTransfer

export type ScheduleResult = {
  __typename?: 'ScheduleResult'
  active: Scalars['Boolean']
  name: Maybe<Scalars['String']>
}

export enum ScheduleType {
  Chat = 'chat',
  Email = 'email',
  Phone = 'phone',
}

export type Scope = {
  __typename?: 'Scope'
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['String']>
  identifier: Scalars['String']
  required: Scalars['Boolean']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/** Query attributes for Employer Search */
export type SearchEmployersInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Search Term */
  searchTerm?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
  /** Switch Type */
  switchType?: InputMaybe<SwitchType>
}

/** Search Results */
export type SearchEmployersPayload = {
  __typename?: 'SearchEmployersPayload'
  results: Maybe<Employer[]>
  /** Unique Tracking ID */
  trackingId: Scalars['ID']
}

export type SearchHistory = {
  __typename?: 'SearchHistory'
  popularSearches: Maybe<Array<Scalars['String']>>
  recentSearches: Array<Scalars['String']>
}

export type SearchSecuritiesInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SearchSecuritiesOrderBy>
  search: Scalars['String']
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>
}

export enum SearchSecuritiesOrderBy {
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by match score in descending order */
  BestMatch = 'BEST_MATCH',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that match caller input LevenshteinDistanceThreshold or better ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE',
}

export type SearchSecuritiesPageInfo = {
  __typename?: 'SearchSecuritiesPageInfo'
  count: Scalars['Int']
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  nextPageCursor: Maybe<Scalars['String']>
  prevPageCursor: Maybe<Scalars['String']>
  totalMatches: Maybe<Scalars['Int']>
}

export type SearchSecuritiesResponse = {
  __typename?: 'SearchSecuritiesResponse'
  pageInfo: Maybe<SearchSecuritiesPageInfo>
  securities: Security[]
}

export type SearchSupportArticleResult = {
  __typename?: 'SearchSupportArticleResult'
  author: SupportAuthor
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  draft: Scalars['Boolean']
  editedAt: Scalars['DateTime']
  id: Scalars['ID']
  name: Scalars['String']
  outdated: Scalars['Boolean']
  position: Maybe<Scalars['Int']>
  promoted: Scalars['Boolean']
  resultType: Scalars['String']
  section: SupportSection
  slug: Scalars['String']
  snippet: Scalars['String']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type SearchSupportResult = {
  __typename?: 'SearchSupportResult'
  relevantSearchArticles: Array<Maybe<SearchSupportArticleResult>>
  relevantSearchCategories: Array<Maybe<SupportCategory>>
}

export enum SearchTermCategory {
  BenefitsHub = 'BENEFITS_HUB',
  Default = 'DEFAULT',
  ReferralsLander = 'REFERRALS_LANDER',
}

/** Secret Squirrel Error */
export type SecretSquirrelException = {
  __typename?: 'SecretSquirrelException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type SecuritiesBySectorInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<SecuritiesBySectorOrderBy>
  sectors: TradingSector[]
  securityTypes?: InputMaybe<Array<InputMaybe<SecurityType>>>
}

export enum SecuritiesBySectorOrderBy {
  /** Securities that contain the provided trading sector(s) ordered by market cap in descending order */
  MarketCap = 'MARKET_CAP',
  /** Securities that contain the provided trading sector(s) ordered by share price (open_price) in descending order */
  SharePrice = 'SHARE_PRICE',
}

export type SecuritiesBySectorPageInfo = {
  __typename?: 'SecuritiesBySectorPageInfo'
  count: Scalars['Int']
  hasNextPage: Scalars['Boolean']
  hasPreviousPage: Scalars['Boolean']
  nextPageCursor: Maybe<Scalars['String']>
  prevPageCursor: Maybe<Scalars['String']>
  totalMatches: Maybe<Scalars['Int']>
}

export type SecuritiesBySectorResponse = {
  __typename?: 'SecuritiesBySectorResponse'
  pageInfo: Maybe<SecuritiesBySectorPageInfo>
  securities: Security[]
}

export type SecuritiesBySymbolsInput = {
  symbols: Array<Scalars['TickerSymbol']>
}

export type SecuritiesBySymbolsResponse = {
  __typename?: 'SecuritiesBySymbolsResponse'
  securities: Security[]
}

export type Security = {
  currentPrice: BigCurrencyAmount
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: SecurityHeadline[]
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use Security.headlines. */
  securityHeadlines: SecurityHeadline[]
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** Describes a target allocation percentage for the specified security */
export type SecurityAllocationTarget = {
  /** ID or Symbol of the targeted security */
  securityId: Scalars['String']
  /** Target allocation percentage, ex: 33 -> 33% */
  securityPercent: Scalars['Int']
}

export type SecurityAnswer = {
  questionId: Scalars['ID']
  response: Scalars['String']
}

export type SecurityBySymbolInput = {
  symbol: Scalars['TickerSymbol']
}

/** Individualized diversification information by security */
export type SecurityDiversificationInfo = {
  __typename?: 'SecurityDiversificationInfo'
  /** Metric representing the security's contribution to the overall diversification of the portfolio */
  diversificationFactor: Scalars['Float']
  /** Security symbol */
  symbol: Scalars['String']
}

export type SecurityGain = {
  __typename?: 'SecurityGain'
  marketValue: Maybe<BigCurrencyAmount>
  percent: Maybe<Scalars['BigDecimal']>
}

export type SecurityHeadline = {
  __typename?: 'SecurityHeadline'
  createdAt: Scalars['DateTime']
  headline: Scalars['String']
  source: Scalars['String']
  storyUrl: Scalars['URL']
  thumbnailUrl: Maybe<Scalars['URL']>
}

/** Security Not Supported */
export type SecurityNotSupportedException = {
  __typename?: 'SecurityNotSupportedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type SecurityPerformance = {
  __typename?: 'SecurityPerformance'
  gain: SecurityGain
  prices: Maybe<SecurityPrice[]>
  symbol: Scalars['TickerSymbol']
}

export type SecurityPerformanceBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime']
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']>
  maxPoints?: InputMaybe<Scalars['Int']>
  startDate: Scalars['DateTime']
  symbol: Scalars['TickerSymbol']
}

export type SecurityPerformancesBySymbolInput = {
  /** Only the Date component is used */
  endDate: Scalars['DateTime']
  /** Only the Date component is used */
  interval?: InputMaybe<Scalars['Int']>
  maxPoints?: InputMaybe<Scalars['Int']>
  startDate: Scalars['DateTime']
  symbols: Array<Scalars['TickerSymbol']>
}

export type SecurityPrice = {
  __typename?: 'SecurityPrice'
  date: Scalars['Date']
  marketValue: BigCurrencyAmount
  timestamp: Scalars['DateTime']
  unadjustedMarketValue: Maybe<BigCurrencyAmount>
}

export type SecurityProfile = {
  __typename?: 'SecurityProfile'
  defaultLogoUrl: Maybe<Scalars['URL']>
  description: Maybe<Scalars['String']>
  logoUrl: Maybe<Scalars['URL']>
  tradingSectors: TradingSector[]
}

export enum SecurityType {
  Bond = 'BOND',
  Etf = 'ETF',
  Stock = 'STOCK',
}

/** User Directed Portfolio Object */
export type SelfDirectedPortfolio = BasePortfolio & {
  __typename?: 'SelfDirectedPortfolio'
  /** Indicates the portfolio's allocation percentage */
  accountAllocation: PortfolioAllocation
  cashOwed: MonetaryAmount
  currentAllocationPercentage: Scalars['Float']
  currentBalance: MonetaryAmount
  currentBalanceWithPending: MonetaryAmount
  /** Indicates the extent to which the Portfolio has been customized by an investor. */
  customizationLevel: Maybe<PortfolioCustomizationLevel>
  /** Description of the portfolio */
  description: Scalars['String']
  /** ID of the Portfolio */
  id: Scalars['ID']
  /** Indicates the Acorns-designated portfolio name */
  name: Scalars['String']
  pendingBalance: MonetaryAmount
  /** Securities currently owned by the Portfolio's InvestmentAccount (will be null if not selected in the context of an InvestmentAccount). */
  portfolioSecurities: Maybe<PortfolioSecurity[]>
  /** Security Allocations for the given portfolio */
  portfolioSecurityAllocations: Maybe<PortfolioSecurityAllocation[]>
  /** Contains requirement statuses for removing the portfolio */
  requirements: AccountRequirements
  status: SelfDirectedPortfolioStatus
  yearToDateReturn: Maybe<MarketReturn>
}

export enum SelfDirectedPortfolioStatus {
  /** Self Directed Portfolio has been removed */
  Closed = 'CLOSED',
  /** Self Directed Portfolio is open */
  Open = 'OPEN',
  /** Self Directed Portfolio has started the closure process */
  PendingClosure = 'PENDING_CLOSURE',
}

export type SendBrazeEventInput = {
  event: BrazeEvent
  userId: Scalars['ID']
}

export type SendChatMessageResponse =
  | ChatHistoryMessage
  | ChatMessageSizeOutOfBounds
  | ChatSessionNotFound
  | ChatUnavailableError

export type SendCheckPaymentInput = {
  amount: CurrencyAmountInput
  fromAccountId: Scalars['ID']
  memo?: InputMaybe<Scalars['String']>
  nonce: Scalars['String']
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Check or errors */
export type SendCheckPaymentResult =
  | AuthorizationError
  | CheckPayment
  | DuplicateActionError
  | InvalidAddressError

export type Session = {
  __typename?: 'Session'
  redirectUrl: Maybe<Scalars['String']>
  refreshToken: Maybe<Scalars['ID']>
  token: Scalars['ID']
  uuid: Scalars['ID']
}

export enum SessionType {
  Behavioral = 'BEHAVIORAL',
  Default = 'DEFAULT',
}

export type SetAuthenticationPinInput = {
  pin: Scalars['String']
  pinConfirmation: Scalars['String']
}

export type SetAuthenticationPinResult =
  | InvalidPinException
  | SetAuthenticationPinSuccess
  | UserCredentialsNotFoundException

export type SetAuthenticationPinSuccess = {
  __typename?: 'SetAuthenticationPINSuccess'
  userId: Scalars['ID']
}

/** Response to a beneficiary ssn update */
export type SetBeneficiarySsnResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidSsnException
  | SecretSquirrelException
  | SsnAlreadyInUseException
  | SsnMatchesCustodianException
  | SsnUpdateForbiddenException

export type SetDefaultAuthenticatorInput = {
  authenticatorId: Scalars['ID']
}

export type SetDefaultAuthenticatorResult =
  | AuthenticatorAlreadyDefaultException
  | AuthenticatorNotFoundException
  | EmailAuthenticator
  | PhoneAuthenticator

/** Configuration for setting public access of investment account recaps. */
export type SetInvestmentAccountRecapPublicAccessInput = {
  /** The unique identifier of the investment account recap for which public access is being modified. */
  id: Scalars['ID']
  /** Whether or not the recap is public. */
  public: Scalars['Boolean']
}

/** Result of modifying the public access of an investment account recap. */
export type SetInvestmentAccountRecapPublicAccessResult =
  | InvestmentAccountRecap
  | InvestmentAccountRecapNotFoundException

/** Options to set an account with a linking error */
export type SetLinkingErrorInput = {
  /** Error to give the linked account */
  code: LinkedAccountLinkingErrorsEnum
}

export type SetNegotiationStatusInput = {
  negotiationMethod: NegotiationMethod
  operator: Scalars['String']
  refundAmount?: InputMaybe<Scalars['Float']>
  status: BankFeeNegotiationStatus
  submissionId: Scalars['ID']
  userId: Scalars['ID']
}

export type SetNegotiationStatusResult = {
  __typename?: 'SetNegotiationStatusResult'
  message: Scalars['String']
}

export type SetPortfolioInput = {
  id: Scalars['ID']
}

/** Input for setting a funding source as preferred withdrawal account */
export type SetPreferredWithdrawalAccountInput = {
  /** the uuid of the funding source being set */
  fundingSourceUuid: Scalars['ID']
}

/** Result of setting a funding source as preferred withdrawal account. */
export type SetPreferredWithdrawalAccountResult =
  | FundingSourceAccount
  | PreferredAccountNotEligibleError
  | PreferredAccountNotSupportedError

export type SetReferralCampaignFlagsInput = {
  autoAdd?: InputMaybe<Scalars['Boolean']>
  campaignId: Scalars['ID']
  fallback?: InputMaybe<Scalars['Boolean']>
  override?: InputMaybe<OverrideInput>
  qa?: InputMaybe<Scalars['Boolean']>
}

export type SetReferralCampaignFlagsResult = {
  __typename?: 'SetReferralCampaignFlagsResult'
  autoAdd: Scalars['Boolean']
  fallback: Scalars['Boolean']
  id: Scalars['ID']
  qa: Scalars['Boolean']
}

export type SetUpTip = {
  __typename?: 'SetUpTip'
  backgroundImage: Image
  body: Scalars['String']
  ctaDetails: ActionFeedCta
  id: Scalars['ID']
  image: Image
  type: ProductSetupTipType
}

export type Settings = {
  __typename?: 'Settings'
  /** @deprecated Highly non-performant! */
  allowDebitCard: Scalars['Boolean']
  /** @deprecated Highly non-performant! */
  automaticRoundup: Scalars['Boolean']
  depositsSuspended: Maybe<Scalars['Boolean']>
  /** @deprecated Highly non-performant! */
  dollarRoundupAmount: Scalars['Float']
  /** @deprecated Highly non-performant! */
  notifications: Notifications
  /** @deprecated Highly non-performant! */
  roundupMultiplier: Scalars['Int']
  /** @deprecated Highly non-performant! */
  threshold: Scalars['Int']
}

export type Signature = TimestampsInterface & {
  __typename?: 'Signature'
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Type of profile */
  profile: Maybe<Profile>
  /** Type of signature */
  signatureType: SignatureType
  /** SVG file */
  svgFile: Scalars['String']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** Internal ID for user */
  userId: Scalars['ID']
}

export enum SignatureType {
  /** A signature used for a user's bank fee negotiation */
  BankFeeNegotiation = 'bankFeeNegotiation',
  /** A signature for the user investment certificate */
  Certificate = 'certificate',
  /** A signature used for the user spend debit card */
  DebitCard = 'debitCard',
  /** A signature used for the user direct deposit PDF form */
  DirectDeposit = 'directDeposit',
  /** A signature used for a user's utility bill negotiation */
  UtilityBillNegotiation = 'utilityBillNegotiation',
}

export type SiteWideBannerContent = {
  __typename?: 'SiteWideBannerContent'
  bannerText: Scalars['String']
  currentVersion: Scalars['String']
  publishedVersion: Maybe<Scalars['String']>
  visible: Scalars['Boolean']
}

export type SiteWideBannerContentInput = {
  bannerText?: InputMaybe<Scalars['String']>
  publish?: InputMaybe<Scalars['Boolean']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type SmartDepositMetadataInput = {
  supportedTargetAccounts: SplitDepositTargetAccountType[]
}

export type SmartDepositMetadataResult = {
  __typename?: 'SmartDepositMetadataResult'
  recommendedAllocations: SplitDepositAllocation[]
  targetAccounts: SplitDepositTargetAccount[]
}

/** Optional filter for getting customer accounts a user can withdraw from. */
export type SourceAccountsFilterInput = {
  /** Filter accounts that are able to withdraw from at this time. */
  isWithdrawalAllowed?: InputMaybe<Scalars['Boolean']>
  /** Filter accounts that can withdraw to a specified account. */
  targetAccountId?: InputMaybe<Scalars['ID']>
}

/** Extra detailed attributes for source of user's arrival to registration. */
export type SourceAttributes = {
  __typename?: 'SourceAttributes'
  /** s2 - Affiliate for Impact Radius or campaign ID */
  affiliateCampaignID: Maybe<Scalars['String']>
  /** Unique ID for user journey exposed by Button */
  buttonSourceToken: Maybe<Scalars['String']>
  /** carrier - Mobile carrier */
  carrier: Maybe<Scalars['String']>
  /** clickid - Unique Impact Radius referral ID */
  clickID: Maybe<Scalars['String']>
  /** code - Referral code of advocate the user registered with */
  code: Maybe<Scalars['String']>
  /** s4 - Customer incentive offers */
  freeformIdentifier: Maybe<Scalars['String']>
  /** promoCode - Promotional code name */
  promoCode: Maybe<Scalars['String']>
  /** referral_code - Referral code of referrer (either user-to-user or partner) that the user registered with */
  referralCode: Maybe<Scalars['String']>
  /** s3 - Customer incentive offers */
  s3: Maybe<Scalars['String']>
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

/** Source attribute object represented as is today. Should be normalized moving forward. */
export type SourceAttributesInput = {
  /** Unnormalized source attributes for supporting backwards compatibility with existing services */
  rawJSON: Scalars['String']
  /** Identifier for the prospect's attribution channel */
  sourceID: Scalars['String']
}

export type SpendAtmReimbursementItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendATMReimbursementItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendAtmWithdrawalItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendATMWithdrawalItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendAccount = {
  __typename?: 'SpendAccount'
  accountId: Maybe<Scalars['ID']>
  bankCardOrder: Maybe<BankCardOrder>
  bankType: Maybe<BankType>
  isDirectDepositIncentiveEligible: Scalars['Boolean']
  isEligible: Scalars['Boolean']
  isEligibleForPremiumCardUpgrade: Maybe<Scalars['Boolean']>
  isReopenable: Maybe<Scalars['Boolean']>
  lockReason: Maybe<BankAccountLockReason>
  status: SpendAccountStatus
}

export enum SpendAccountStatus {
  Closed = 'CLOSED',
  Locked = 'LOCKED',
  NotOpened = 'NOT_OPENED',
  Open = 'OPEN',
  Opening = 'OPENING',
  Reopening = 'REOPENING',
}

export type SpendAlert = {
  type: Scalars['String']
  userId: Scalars['ID']
}

export type SpendAtm = {
  __typename?: 'SpendAtm'
  address: SpendAtmAddress
  atmName: Scalars['String']
  imageUrl: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
}

export type SpendAtmAddress = {
  __typename?: 'SpendAtmAddress'
  addressLine: Maybe<Scalars['String']>
  cityName: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  latitude: Scalars['String']
  longitude: Scalars['String']
  postalCode: Maybe<Scalars['String']>
  stateCode: Maybe<Scalars['String']>
}

export type SpendAtmVendorUnavailableError = {
  __typename?: 'SpendAtmVendorUnavailableError'
  requestId: Maybe<Scalars['String']>
}

export type SpendAtmsCoordinateInput = {
  latitude: Scalars['String']
  longitude: Scalars['String']
}

export type SpendAtmsInput = {
  searchCoordinate: SpendAtmsCoordinateInput
  searchRadius?: InputMaybe<Scalars['Float']>
}

export type SpendAtmsPayload = {
  __typename?: 'SpendAtmsPayload'
  atms: Maybe<Array<Maybe<SpendAtm>>>
  executedSearchRadius: Maybe<Scalars['String']>
}

export type SpendAtmsResult = SpendAtmVendorUnavailableError | SpendAtmsPayload

export type SpendBillPayItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendBillPayItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendCheckDepositItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendCheckDepositItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendCheckPaymentItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendCheckPaymentItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDigitalWalletItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendDigitalWalletItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDirectDepositItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendDirectDepositItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendDisputesResponse = {
  __typename?: 'SpendDisputesResponse'
  creationDateTime: Maybe<Scalars['DateTime']>
  description: Scalars['String']
  disputeDateTime: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['Int']>
  questions: SpendTransactionsDisputeQuestions[]
  transactions: SpendTransactionsResponse[]
}

export type SpendECheckItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendECheckItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendInterestPaidItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendInterestPaidItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    /** The calendar month in which this interest was earned. */
    monthEarned: Scalars['String']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

/** A base set of fields that each PastItem from Spend transactions must implement */
export type SpendItem = {
  accountName: Scalars['String']
  /** When funds associated with the transaction became available. */
  availableAt: Maybe<Scalars['DateTime']>
  /** Full description of transaction. See BankTransaction.description for details. */
  description: Scalars['String']
  moneyManagerTransfer: Scalars['Boolean']
  productAccountType: ProductAccountType
  /** Shorter version of description. See BankTransaction.summary for details. */
  summary: Scalars['String']
  transactionDescription: Scalars['String']
  transactionType: TransactionType
}

export type SpendPurchaseItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendPurchaseItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendRealTimeRoundUpItem = PastItem &
  PastTargetedTransferItem &
  SpendItem & {
    __typename?: 'SpendRealTimeRoundUpItem'
    accountName: Scalars['String']
    /** The investment amount after being multiplied. */
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** Past Item ID */
    id: Scalars['ID']
    /** The investment amount prior to being multiplied */
    initialAmount: Maybe<CurrencyAmount>
    moneyManagerTransfer: Scalars['Boolean']
    multiplier: Maybe<Scalars['Int']>
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendTransactionsDisputeCustomersResponse = {
  __typename?: 'SpendTransactionsDisputeCustomersResponse'
  accountNumber: Maybe<Scalars['String']>
  applicationCode: Maybe<Scalars['String']>
  customerNumber: Maybe<Scalars['String']>
  disputes: SpendDisputesResponse[]
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  productCode: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeQuestions = {
  __typename?: 'SpendTransactionsDisputeQuestions'
  answer: Maybe<Scalars['String']>
  question: Maybe<Scalars['String']>
}

export type SpendTransactionsDisputeResponse = {
  __typename?: 'SpendTransactionsDisputeResponse'
  bankType: BankType
  customers: SpendTransactionsDisputeCustomersResponse
}

export type SpendTransactionsDisputeResult = SpendTransactionsDisputeResponse

export type SpendTransactionsInput = {
  amount: Scalars['String']
  availableAt?: InputMaybe<Scalars['DateTime']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  description: Scalars['String']
  id: Scalars['ID']
  settledAt?: InputMaybe<Scalars['DateTime']>
  status: BankTransactionStatus
  tag?: InputMaybe<Scalars['String']>
  type: BankTransactionType
  typeCode: Scalars['String']
  updatedAt?: InputMaybe<Scalars['DateTime']>
  voidedAt?: InputMaybe<Scalars['DateTime']>
}

export type SpendTransactionsResponse = {
  __typename?: 'SpendTransactionsResponse'
  amount: Scalars['Float']
  coreTransactionId: Scalars['String']
  description: Scalars['String']
  disputedAmount: Scalars['Float']
  id: Maybe<Scalars['Int']>
  postingDate: Scalars['DateTime']
  status: Maybe<Scalars['String']>
  transactionCode: Scalars['String']
}

export type SpendTransferInItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SpendTransferInItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SpendTransferOutItem = PastItem &
  PastTargetedTransferItem &
  PastUserTransferItem &
  SpendItem & {
    __typename?: 'SpendTransferOutItem'
    accountName: Scalars['String']
    amount: CurrencyAmount
    /** When funds associated with the transaction became available. */
    availableAt: Maybe<Scalars['DateTime']>
    /** When this was first created */
    createdAt: Scalars['DateTime']
    /** Full description of transaction. See BankTransaction.description for details. */
    description: Scalars['String']
    /** Flags inclusion in the pending transfer drawer */
    drawerInclusion: Scalars['Boolean']
    /** An estimated completion date for when a user transfer will be completed */
    estimatedCompletionDate: Maybe<Scalars['DateTime']>
    /** Past Item ID */
    id: Scalars['ID']
    /** Indicates whether the user transfer is a recurring investment */
    isRecurring: Maybe<Scalars['Boolean']>
    moneyManagerTransfer: Scalars['Boolean']
    productAccountType: ProductAccountType
    /** The corresponding product of the item */
    productType: ProductType
    /** Whether or not the transaction is reversible */
    reversible: Scalars['Boolean']
    sourceAccountTitle: Maybe<Scalars['String']>
    /** The current state of the item */
    status: PastItemStatus
    /** Shorter version of description. See BankTransaction.summary for details. */
    summary: Scalars['String']
    targetAccountTitle: Maybe<Scalars['String']>
    /** The title of the item */
    title: Scalars['String']
    transactionDescription: Scalars['String']
    transactionType: TransactionType
    /** When this was last updated. NULL if never updated */
    updatedAt: Scalars['DateTime']
  }

export type SplitDeposit = {
  __typename?: 'SplitDeposit'
  allocations: SplitDepositAllocation[]
  createdAt: Scalars['String']
  distributedAt: Maybe<Scalars['String']>
  expectedNextDepositAmount: Maybe<Scalars['String']>
  expectedNextDepositAt: Maybe<Scalars['String']>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isCancelable: Scalars['Boolean']
  isCanceled: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  /** @deprecated deprecated, use allocations instead */
  savingsRatePercent: Scalars['String']
  settingsId: Scalars['ID']
  /** @deprecated deprecated, use allocations instead */
  splitDistribution: DistributionAmounts
  transactionAmount: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
  willDistributeAutomaticallyAt: Maybe<Scalars['String']>
}

export type SplitDepositAllocation = {
  allocationPercent: Scalars['String']
  nickname: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositAllocationInput = {
  allocationPercent: Scalars['String']
  nickname?: InputMaybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDailyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositDailyRecurrenceRule'
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositDirectDepositAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositDirectDepositAllocation'
  allocationPercent: Scalars['String']
  nickname: Maybe<Scalars['String']>
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  normalizedDailyAmount: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export type SplitDepositDirectDepositIntentSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositIntentSetting'
  allocations: SplitDepositDirectDepositAllocation[]
  createdAt: Scalars['String']
  deposits: Maybe<SplitDeposit[]>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  estimatedPaycheckAmount: CurrencyAmount
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositDirectDepositIntentSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositDirectDepositSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositDirectDepositSetting'
  allocations: SplitDepositDirectDepositAllocation[]
  awaitingConfiguration: Scalars['Boolean']
  createdAt: Scalars['String']
  deposits: Maybe<SplitDeposit[]>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  isUsingRecommendedAllocations: Scalars['Boolean']
  monthlyTotals: MonthlyTotal[]
  name: Scalars['String']
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  totalAmounts: Maybe<TotalAmounts>
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositDirectDepositSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositMonthlyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositMonthlyRecurrenceRule'
  byMonthDay: Array<Scalars['Int']>
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositMutation = {
  __typename?: 'SplitDepositMutation'
  cancel: SplitDeposit
  execute: SplitDeposit
  id: Scalars['ID']
  userId: Scalars['ID']
}

export enum SplitDepositNormalizationFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export type SplitDepositRecurrenceAllocation = SplitDepositAllocation & {
  __typename?: 'SplitDepositRecurrenceAllocation'
  allocationPercent: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  legacyRecurrenceAmount: Maybe<FormattedMonetaryAmount>
  legacyRecurrenceRule: Maybe<SplitDepositRecurrenceRule>
  nickname: Maybe<Scalars['String']>
  targetAccountId: Scalars['ID']
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositRecurrenceFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type SplitDepositRecurrenceRule = {
  frequency: SplitDepositRecurrenceFrequency
}

export type SplitDepositRecurrenceSetting = SplitDepositSettings & {
  __typename?: 'SplitDepositRecurrenceSetting'
  allocations: SplitDepositRecurrenceAllocation[]
  createdAt: Scalars['String']
  deposits: Maybe<SplitDeposit[]>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  monthlyTotals: MonthlyTotal[]
  name: Scalars['String']
  normalizedAmount: Maybe<FormattedMonetaryAmount>
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositRecurrenceSettingDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export enum SplitDepositSettingType {
  DirectDeposit = 'DIRECT_DEPOSIT',
  DirectDepositIntent = 'DIRECT_DEPOSIT_INTENT',
  Recurrence = 'RECURRENCE',
}

export type SplitDepositSettings = {
  allocations: SplitDepositAllocation[]
  createdAt: Scalars['String']
  deposits: Maybe<SplitDeposit[]>
  /** @deprecated deprecated */
  distributionType: DistributionType
  /** @deprecated use name instead */
  employer: Scalars['String']
  /** @deprecated deprecated */
  employerHidden: Scalars['Boolean']
  /** @deprecated deprecated */
  employerName: Scalars['String']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isHidden: Scalars['Boolean']
  name: Scalars['String']
  /** @deprecated deprecated */
  onboarded: Scalars['Boolean']
  /** @deprecated deprecated */
  savingsRatePercent: Scalars['String']
  updatedAt: Scalars['String']
  userId: Scalars['ID']
}

export type SplitDepositSettingsDepositsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Order>
}

export type SplitDepositSettingsFilterInput = {
  settingTypes: SplitDepositSettingType[]
  showHiddenEmployerSettings?: InputMaybe<Scalars['Boolean']>
}

export type SplitDepositSettingsMutation = {
  __typename?: 'SplitDepositSettingsMutation'
  configure: SplitDepositSettings
  employer: Scalars['String']
  employerHidden: Scalars['Boolean']
  id: Scalars['ID']
  userId: Scalars['ID']
}

export type SplitDepositSettingsMutationConfigureArgs = {
  input: ConfigureSettingsInput
}

export type SplitDepositTargetAccount = {
  __typename?: 'SplitDepositTargetAccount'
  nickname: Maybe<Scalars['String']>
  targetAccountId: Maybe<Scalars['ID']>
  targetAccountType: SplitDepositTargetAccountType
}

export enum SplitDepositTargetAccountType {
  Early = 'EARLY',
  Invest = 'INVEST',
  Later = 'LATER',
  Save = 'SAVE',
  Spend = 'SPEND',
}

export type SplitDepositWeeklyRecurrenceRule = SplitDepositRecurrenceRule & {
  __typename?: 'SplitDepositWeeklyRecurrenceRule'
  byWeekDay: DayOfWeek[]
  frequency: SplitDepositRecurrenceFrequency
}

/** This SSN already belongs to another beneficiary for this custodian */
export type SsnAlreadyInUseException = {
  __typename?: 'SsnAlreadyInUseException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** This SSN is a duplicate of the current custodian's SSN */
export type SsnMatchesCustodianException = {
  __typename?: 'SsnMatchesCustodianException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Beneficiary's ssn cannot be updated */
export type SsnUpdateForbiddenException = {
  __typename?: 'SsnUpdateForbiddenException'
  /** message */
  message: Maybe<Scalars['String']>
}

/** Attributes for starting PDF Switch */
export type StartAcornsPdfSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer Name */
  employerName?: InputMaybe<Scalars['String']>
  /** [DEPRECATED] Use employerName instead. */
  name?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

/** Starts a check deposit session. */
export type StartCheckDepositInput = {
  /** The client info to pass to Ensenta for validation purposes */
  clientInfo: ClientInfo
}

/** Starts a check deposit session with our vendor. */
export type StartCheckDepositPayload = {
  __typename?: 'StartCheckDepositPayload'
  /** Token that represents a session with our vendor. */
  sessionToken: Scalars['String']
}

/** Attributes for starting Online Switch */
export type StartOnlineSwitchInput = {
  /** Bank Account ID */
  bankAccountId: Scalars['ID']
  /** Employer ID */
  employerId: Scalars['ID']
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

export type StartOnlineSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartOnlineSwitchPayload'
  userSwitch: UserSwitch
}

/** Changeable attributes for addresses */
export type StartSubmittableSwitchAddressInput = {
  /** City */
  city: Scalars['String']
  /** Country */
  country: Scalars['String']
  /** State */
  state: Scalars['String']
  /** Street 1 */
  street1: Scalars['String']
  /** Street 2 */
  street2?: InputMaybe<Scalars['String']>
  /** Zip code */
  zipCode: Scalars['String']
}

/** Attributes for starting Submittable Switch */
export type StartSubmittableSwitchInput = {
  /** Bank Account ID */
  bankAccountId?: InputMaybe<Scalars['ID']>
  /** Employer ID */
  employerId: Scalars['ID']
  /** Employer Address */
  employerLocationAddress?: InputMaybe<StartSubmittableSwitchAddressInput>
  /** Employee ID */
  nonSsnEmployeeId?: InputMaybe<Scalars['String']>
  /** Session ID */
  sessionId?: InputMaybe<Scalars['ID']>
}

export type StartSubmittableSwitchPayload = SwitchPayloadInterface & {
  __typename?: 'StartSubmittableSwitchPayload'
  userSwitch: UserSwitch
}

export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

/** Statement */
export type Statement = {
  __typename?: 'Statement'
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableId: Maybe<Scalars['ID']>
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  archivableType: Maybe<Scalars['String']>
  /** created at date and time of Statement */
  createdAt: Scalars['DateTime']
  day: Scalars['Int']
  /** update at date and time of Statement */
  endDate: Maybe<Scalars['DateTime']>
  /**
   * Deprecated do not use
   * @deprecated Use taxFormType instead
   */
  formType: Maybe<FormType>
  id: Scalars['ID']
  /** Unique identifier of the investment account for which the statement was generated for. */
  investmentAccountId: Scalars['ID']
  investmentAccountType: Maybe<InvestmentAccountType>
  /**
   * Deprecated do not use
   * @deprecated Use statementLink instead
   */
  link: Maybe<StatementLink>
  month: Scalars['Int']
  portfolioType: StatementPortfolioType
  /**
   * Deprecated do not use
   * @deprecated Will not be supported in the future
   */
  s3Filename: Maybe<Scalars['String']>
  /** created at date and time of Statement */
  startDate: Maybe<Scalars['DateTime']>
  statementLink: Maybe<Scalars['String']>
  statementType: StatementType
  taxFormType: Maybe<TaxFormType>
  /** update at date and time of Statement */
  updatedAt: Maybe<Scalars['DateTime']>
  uploaded: Maybe<Scalars['Boolean']>
  year: Scalars['Int']
}

/** An individual edge within the paginated list of Statement */
export type StatementEdge = {
  __typename?: 'StatementEdge'
  /** The unique key used for pagination */
  cursor: Scalars['ID']
  /** The Statement record in the edge */
  node: Statement
}

/** StatementLink */
export type StatementLink = {
  __typename?: 'StatementLink'
  downloadUrl: Scalars['String']
  url: Scalars['String']
}

/** Relay style pagination information for Statement */
export type StatementPagination = {
  __typename?: 'StatementPagination'
  edges: StatementEdge[]
  pageInfo: PageInfo
}

export enum StatementPortfolioType {
  Customized = 'CUSTOMIZED',
  Managed = 'MANAGED',
  SelfDirected = 'SELF_DIRECTED',
}

export enum StatementType {
  /** user trade or chargeback confirmation */
  DailyUserTradeConfirmation = 'daily_user_trade_confirmation',
  /** tax statements */
  Tax = 'tax',
  /** monthly statements */
  User = 'user',
}

export type Stock = Security & {
  __typename?: 'Stock'
  currentPrice: BigCurrencyAmount
  displayName: Scalars['String']
  earliestPriceDate: Scalars['Date']
  headlines: SecurityHeadline[]
  id: Scalars['ID']
  lastClosePrice: BigCurrencyAmount
  lastUpdatedAt: Scalars['DateTime']
  longName: Scalars['String']
  marketCap: Scalars['BigDecimal']
  openPrice: BigCurrencyAmount
  profile: SecurityProfile
  /** @deprecated Use Security.headlines. */
  securityHeadlines: SecurityHeadline[]
  /** @deprecated Use Security.profile. */
  securityProfile: SecurityProfile
  shortName: Scalars['String']
  symbol: Scalars['TickerSymbol']
  type: SecurityType
  volume: Scalars['BigDecimal']
  week52High: BigCurrencyAmount
  week52Low: BigCurrencyAmount
}

/** There was a problem when making the deposits */
export type StoredRdvDepositsInvalid = {
  __typename?: 'StoredRdvDepositsInvalid'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** Deposits have not been initiated yet */
export type StoredRdvDepositsMissing = {
  __typename?: 'StoredRdvDepositsMissing'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type StringKeyAsset = {
  __typename?: 'StringKeyAsset'
  args: Array<Scalars['String']>
  key: Scalars['StringKey']
}

export type SubcategoryMessage = {
  __typename?: 'SubcategoryMessage'
  body: Maybe<Scalars['String']>
  ctaText: Maybe<Scalars['String']>
  id: Scalars['ID']
  title: Maybe<Scalars['String']>
  url: Maybe<Scalars['String']>
}

export type Submission = {
  __typename?: 'Submission'
  bank: BankName
  created: Scalars['DateTime']
  feeSynopsis: Maybe<Scalars['String']>
  key: Scalars['String']
  linkedAccountId: Scalars['ID']
  status: SubmissionStatus
  updated: Scalars['DateTime']
}

export type SubmissionError = {
  __typename?: 'SubmissionError'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
}

export enum SubmissionStatus {
  Collect = 'COLLECT',
  Completed = 'COMPLETED',
  ConnectionError = 'CONNECTION_ERROR',
  DelayCharge = 'DELAY_CHARGE',
  MailInError = 'MAIL_IN_ERROR',
  MailInEscalated = 'MAIL_IN_ESCALATED',
  MailInPending = 'MAIL_IN_PENDING',
  MailInSent = 'MAIL_IN_SENT',
  Pending = 'PENDING',
}

export type SubmitBankFeeNegotiationInput = {
  linkedAccountId: Scalars['ID']
}

export type SubmitBankFeeNegotiationResponse = {
  __typename?: 'SubmitBankFeeNegotiationResponse'
  message: Scalars['String']
  status: Scalars['String']
}

export type SubmitBankFeeNegotiationResult =
  | LinkedAccountNotFound
  | SubmitBankFeeNegotiationResponse

export type SubmitEarnMissingCreditRequestInput = {
  extensionMerchantName?: InputMaybe<Scalars['String']>
  merchantId: Scalars['ID']
  method: EarnPurchaseMethod
  orderNumber: Scalars['String']
  proofOfPurchaseUrl: Scalars['URL']
  purchaseDate: Scalars['Date']
  subTotal: Scalars['Float']
  total: Scalars['Float']
}

export type SubmitEarnMissingCreditRequestResult =
  | EarnMissingCreditRequest
  | EarnMissingCreditRequestPurchaseDateError

export type SubmitSpendTransactionsDisputeInput = {
  cardNumber: Scalars['String']
  disputeReason: Scalars['String']
  eSignature: Scalars['String']
  merchantInfo: Scalars['String']
  message: Scalars['String']
  selectedTransactions: SpendTransactionsInput[]
  spendCardDetails: Scalars['String']
}

export type SubmitUserReportedBankFeeRefundInput = {
  refundAmount: Scalars['Amount']
  submissionId: Scalars['ID']
  userId: Scalars['ID']
}

export type SubmitUserReportedBankFeeRefundResult = {
  __typename?: 'SubmitUserReportedBankFeeRefundResult'
  message: Scalars['String']
}

/** Submittable Switches are performed via Click Switch API. */
export type SubmittableSwitch = SwitchInterface & {
  __typename?: 'SubmittableSwitch'
  requiresEmployerMailingAddress: Maybe<Scalars['Boolean']>
  requiresNonSsnEmployeeId: Maybe<Scalars['Boolean']>
  requiresSsnLastFour: Maybe<Scalars['Boolean']>
  source: SwitchSource
  type: SwitchType
  vendorTargetId: Scalars['ID']
}

export type SubscribeToTierInput = {
  feedback?: InputMaybe<Scalars['String']>
  tierId: Scalars['ID']
  tierPriceId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type SubscribeToTierResult =
  | InvalidTier
  | InvalidTierPrice
  | TierSubscription

export type SubscribeUserToTierByProductKeyInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  /**
   * Subscription requests with an effective date earlier than the current subscription's createdAt
   * timestamp will be ignored. Defaults to current time.
   */
  effectiveAt?: InputMaybe<Scalars['DateTime']>
  productKey: ProductKey
  tierGroupId?: InputMaybe<Scalars['ID']>
}

export type SubscribeUserToTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
  tierPriceId: Scalars['ID']
}

export type SubscribeUserToTierResult =
  | InvalidTierPriceId
  | TierDowngradeActionRequired
  | TierSubscription

export type SubscriberIneligibleError = {
  __typename?: 'SubscriberIneligibleError'
  message: Scalars['String']
}

export type Subscription = {
  __typename?: 'Subscription'
  /** Subscribe to user/bot messages for a particular session */
  onChatMessage: ChatHistoryMessage
  /** Subscribe to user/bot messages for a particular session. This subscription supports both full messages and partial messages */
  onChatMessageStream: ChatMessageStreamResponse
  /** Returns new messages created */
  onMessageCreated: Message
}

export type SubscriptionOnChatMessageArgs = {
  sessionId: Scalars['ID']
}

export type SubscriptionOnChatMessageStreamArgs = {
  sessionId: Scalars['ID']
}

export type SubscriptionOnMessageCreatedArgs = {
  categoryFilters?: InputMaybe<MessageCategory[]>
  typeFilters?: InputMaybe<MessageType[]>
}

export type SubscriptionMigration = {
  __typename?: 'SubscriptionMigration'
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  effectiveAt: Scalars['DateTime']
  fromTier: Tier
  id: Scalars['ID']
  toTier: Tier
  updatedAt: Maybe<Scalars['DateTime']>
}

export type SubscriptionMigrationInvalidError = {
  __typename?: 'SubscriptionMigrationInvalidError'
  message: Scalars['String']
}

export type SubscriptionMigrationWaiver = {
  __typename?: 'SubscriptionMigrationWaiver'
  accepted: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  migration: SubscriptionMigration
  reason: SubscriptionMigrationWaiverReason
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum SubscriptionMigrationWaiverReason {
  FinancialHardship = 'FINANCIAL_HARDSHIP',
}

export enum SubscriptionPaymentMethod {
  Ach = 'ach',
  Amazon = 'amazon',
  ApplePay = 'apple_pay',
  Bachs = 'bachs',
  Check = 'check',
  CreditCard = 'credit_card',
  Eft = 'eft',
  GooglePay = 'google_pay',
  MoneyOrder = 'money_order',
  Other = 'other',
  Paypal = 'paypal',
  Roku = 'roku',
  Sepadirectdebit = 'sepadirectdebit',
  WireTransfer = 'wire_transfer',
}

/** transition actions for a subscription */
export enum SubscriptionTransitionAction {
  AddPromotion = 'ADD_PROMOTION',
  Deactivate = 'DEACTIVATE',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE',
}

export type SucceedVendorInvoiceResult = BillingVendorError | Invoice

export type SuggestedMoneyRulesResult = SuggestedMoneyRulesSuccess

export type SuggestedMoneyRulesSuccess = {
  __typename?: 'SuggestedMoneyRulesSuccess'
  adjustedForIncome: Scalars['Boolean']
  resultingCategories: MoneyManagerCategory[]
  resultingRuleset: MoneyRulesRuleset
}

export enum SuitabilityAccountSubtype {
  Individual = 'INDIVIDUAL',
  RothIra = 'ROTH_IRA',
  SepIra = 'SEP_IRA',
  TraditionalIra = 'TRADITIONAL_IRA',
}

export enum SuitabilityAccountType {
  Brokerage = 'BROKERAGE',
  Retirement = 'RETIREMENT',
}

export type SuitabilityAnswer = {
  __typename?: 'SuitabilityAnswer'
  answer: Scalars['String']
  id: Scalars['ID']
}

export type SuitabilityInput = {
  answerId: Scalars['ID']
  questionId: Scalars['ID']
}

export type SuitabilityQuestion = {
  __typename?: 'SuitabilityQuestion'
  answers: Array<Maybe<SuitabilityAnswer>>
  defaultAnswer: SuitabilityAnswer
  id: Scalars['ID']
  pickerId: Scalars['ID']
  placeholder: Scalars['String']
}

export type SummaryItem = {
  __typename?: 'SummaryItem'
  amount: CurrencyAmount
  title: Scalars['String']
}

export type SupportArticle = {
  __typename?: 'SupportArticle'
  author: SupportAuthor
  body: Scalars['String']
  draft: Maybe<Scalars['Boolean']>
  editedAt: Scalars['DateTime']
  id: Scalars['ID']
  labels: Maybe<Array<Maybe<Scalars['String']>>>
  private: Maybe<Scalars['Boolean']>
  promoted: Maybe<Scalars['Boolean']>
  section: SupportSection
  sectionId: Scalars['ID']
  slug: Maybe<Scalars['String']>
  title: Scalars['String']
}

export type SupportAuthor = {
  __typename?: 'SupportAuthor'
  id: Scalars['ID']
  name: Scalars['String']
  photo: SupportAuthorPhoto
}

export type SupportAuthorPhoto = {
  __typename?: 'SupportAuthorPhoto'
  contentUrl: Scalars['String']
}

export type SupportCategory = {
  __typename?: 'SupportCategory'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportSection = {
  __typename?: 'SupportSection'
  articles: Array<Maybe<SupportArticle>>
  category: SupportCategory
  categoryId: Scalars['ID']
  id: Scalars['ID']
  name: Scalars['String']
}

export type SupportTicket = {
  __typename?: 'SupportTicket'
  description: Scalars['String']
  id: Scalars['ID']
  reportingTag: Maybe<Scalars['String']>
  subCategory: Maybe<Scalars['String']>
  subject: Scalars['String']
  url: Scalars['String']
}

export type SupportTicketForm = {
  __typename?: 'SupportTicketForm'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  displayName: Maybe<Scalars['String']>
  id: Scalars['ID']
  isDefault: Maybe<Scalars['Boolean']>
  ticketFields: Maybe<Array<Maybe<SupportTicketFormField>>>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type SupportTicketFormField = {
  __typename?: 'SupportTicketFormField'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  customFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  name: Maybe<Scalars['String']>
  required: Maybe<Scalars['Boolean']>
  systemFieldOptions: Maybe<Array<Maybe<CustomFieldOption>>>
  title: Scalars['String']
  type: Scalars['String']
  updatedAt: Maybe<Scalars['DateTime']>
}

export type SupportTicketResponse = RecaptchaException | SupportTicket

export type SupportTicketWithCustomFieldsResponse =
  | SubmissionError
  | SupportTicket

export type SupportUser = {
  __typename?: 'SupportUser'
  email: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
}

/** Response returned if the bank is supported for Plaid Verification. */
export type SupportsPlaidVerificationResult = {
  __typename?: 'SupportsPlaidVerificationResult'
  /** Plaid Verification supports this Bank */
  supportsPlaidVerificationType: Scalars['Boolean']
}

/** Common attributes for all Switch Types */
export type SwitchInterface = {
  source: SwitchSource
  type: SwitchType
}

export enum SwitchMethod {
  /** Used clickswitch */
  Clickswitch = 'clickswitch',
  /** Used clickswitch and online */
  ClickswitchOnline = 'clickswitchOnline',
  /** Used clickswitch, online, and PDF */
  ClickswitchOnlinePdf = 'clickswitchOnlinePdf',
  /** Used clickswitch and PDF */
  ClickswitchPdf = 'clickswitchPdf',
  /** None */
  None = 'none',
  /** Used online */
  Online = 'online',
  /** Used online and PDF */
  OnlinePdf = 'onlinePdf',
  /** Used pdf */
  Pdf = 'pdf',
  /** Unknown */
  Unknown = 'unknown',
}

export type SwitchPayloadInterface = {
  userSwitch: UserSwitch
}

export enum SwitchSource {
  Acorns = 'acorns',
  ClickSwitch = 'clickSwitch',
}

export enum SwitchState {
  /** Attempted to setup direct deposit */
  Attempted = 'attempted',
  /** User has not interacted with direct deposit in Acorns */
  NoInteraction = 'noInteraction',
  /** Completed direct deposit setup */
  Switched = 'switched',
  /** Viewed PDF screen or went to Online Portal */
  Viewed = 'viewed',
}

export enum SwitchStatus {
  /** Deposit confirmed in Spend account */
  Completed = 'completed',
  /** New for processing */
  New = 'new',
  /** PDF downloaded */
  PdfDownloaded = 'pdfDownloaded',
  /** PDF generated */
  PdfGenerated = 'pdfGenerated',
  /** Ready for processing */
  Ready = 'ready',
  /** Sent to ClickSwitch */
  Submitted = 'submitted',
}

export enum SwitchType {
  /** Online */
  Online = 'online',
  /** Default PDF */
  Pdf = 'pdf',
  /** Submittable Generic */
  Submittable = 'submittable',
  /** Submittable Custom */
  SubmittableCustom = 'submittableCustom',
}

export type SyncBankFeeTransactionsInput = {
  userId: Scalars['ID']
}

export type SyncBankFeeTransactionsResult = {
  __typename?: 'SyncBankFeeTransactionsResult'
  message: Scalars['String']
}

export type SyncFundingSourceToVendorResult =
  | BillingVendorError
  | DuplicateBillingInfoError
  | VendorBillingInfo

export type SyncSupportAccountInput = {
  id: Scalars['ID']
}

export type SyncSupportAccountResponse = {
  __typename?: 'SyncSupportAccountResponse'
  eventId: Scalars['String']
}

export type SystemCardLockedSpendAlert = SpendAlert & {
  __typename?: 'SystemCardLockedSpendAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** Optional filter for getting customer accounts a user can deposit to. */
export type TargetAccountsFilterInput = {
  /** Filter accounts that are able to be deposited into at this time. */
  isDepositAllowed?: InputMaybe<Scalars['Boolean']>
  /** Filter accounts that a specified account can deposit into. */
  sourceAccountId?: InputMaybe<Scalars['ID']>
}

export enum TaxApplicationStatus {
  Cancelled = 'CANCELLED',
  NotStarted = 'NOT_STARTED',
  QuestionnaireCompleted = 'QUESTIONNAIRE_COMPLETED',
  QuestionnaireInProgress = 'QUESTIONNAIRE_IN_PROGRESS',
  ReadyToSubmit = 'READY_TO_SUBMIT',
  Submitted = 'SUBMITTED',
}

export type TaxFilingPartner = {
  __typename?: 'TaxFilingPartner'
  accountUsed: Maybe<RefundBankAccount>
  disqualificationReason: Maybe<Scalars['String']>
  federalReturn: Maybe<TaxReturn>
  isStateFiled: Maybe<Scalars['Boolean']>
  isUserDisqualified: Maybe<Scalars['Boolean']>
  netRefundAmount: Maybe<MonetaryAmount>
  refundToAcorns: Maybe<Scalars['Boolean']>
  stateReturns: Maybe<Array<Maybe<TaxReturn>>>
  taxAppStatus: TaxApplicationStatus
}

export enum TaxFormType {
  Form1099 = 'form1099',
  Form1099Bdiv = 'form1099BDIV',
  Form1099Misc = 'form1099MISC',
  Form1099R = 'form1099R',
  Form1099R1 = 'form1099R1',
  Form1099R2 = 'form1099R2',
  Form1099R4 = 'form1099R4',
  Form1099R7 = 'form1099R7',
  Form1099R8 = 'form1099R8',
  Form1099Re = 'form1099RE',
  Form1099Rj = 'form1099RJ',
  Form1099Rq = 'form1099RQ',
  Form1099Rt = 'form1099RT',
  Form5498 = 'form5498',
  Other = 'other',
}

export type TaxReturn = {
  __typename?: 'TaxReturn'
  lastSubmissionDate: Maybe<Scalars['Date']>
  refundAmount: MonetaryAmount
  rejectedReason: Maybe<Scalars['String']>
  returnStatus: TaxReturnStatus
  taxLocationCode: Scalars['String']
}

export enum TaxReturnStatus {
  Accepted = 'ACCEPTED',
  FiledPendingResponse = 'FILED_PENDING_RESPONSE',
  NotFiled = 'NOT_FILED',
  Rejected = 'REJECTED',
}

export type TaxWithholdingAmounts = {
  __typename?: 'TaxWithholdingAmounts'
  /** total amount that will be withheld from the feds */
  federalWithholdingAmount: MonetaryAmount
  /** total amount that will be withheld from the state */
  stateWithholdingAmount: MonetaryAmount
}

export enum TfaNotification {
  PushNotification = 'PUSH_NOTIFICATION',
}

export type TfaOptions = {
  __typename?: 'TfaOptions'
  email: Maybe<Array<Scalars['String']>>
  notification: Maybe<TfaNotification[]>
  phone: Maybe<Array<Scalars['String']>>
  question: Maybe<Array<Scalars['String']>>
}

export enum TfaStatus {
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Required = 'REQUIRED',
}

export enum TfaType {
  Email = 'EMAIL',
  Notification = 'NOTIFICATION',
  Pending = 'PENDING',
  Phone = 'PHONE',
  Question = 'QUESTION',
}

export type Tier = {
  __typename?: 'Tier'
  /** Indicates whether a tier is active or deprecated */
  active: Scalars['Boolean']
  /** Image asset path in CDN */
  assetPath: Maybe<Scalars['String']>
  /** Associated grouping of products */
  bundles: Maybe<Bundle[]>
  description: Scalars['String']
  /** Name of tier to display in certain positions where space is limited */
  displayName: Maybe<Scalars['String']>
  /** @deprecated Use Query.products and Tier.products instead. */
  excludedProducts: TierProduct[]
  id: Scalars['ID']
  /** @deprecated Use Query.products and Tier.products instead. */
  includedProducts: TierProduct[]
  key: TierKey
  matchProgram: Maybe<MatchProgram>
  name: Scalars['String']
  /** Associated Products available when subscribed to this Tier. */
  products: Maybe<Product[]>
  /**
   * (DONT USE) Internal only, may be removed without warning.
   * @deprecated Use Query.tierGroupForUser to determine the subscriber's Tier Group.
   */
  tierGroupId: Scalars['ID']
  /** Price of Tier */
  tierPrice: TierPrice
}

export type TierMatchProgramArgs = {
  investmentAccountType: InvestmentAccountType
}

/** Individual action in a list of required actions */
export type TierDowngradeAction = {
  __typename?: 'TierDowngradeAction'
  key: TierDowngradeActionKey
}

/** Actions that must be taken to complete a downgrade workflow */
export enum TierDowngradeActionKey {
  CloseEarlyAccount = 'CLOSE_EARLY_ACCOUNT',
  CloseEmergencyFundAccount = 'CLOSE_EMERGENCY_FUND_ACCOUNT',
  CloseInvestAccount = 'CLOSE_INVEST_ACCOUNT',
  CloseLaterAccount = 'CLOSE_LATER_ACCOUNT',
  CloseSelfDirectedInvest = 'CLOSE_SELF_DIRECTED_INVEST',
  CloseSpendAccount = 'CLOSE_SPEND_ACCOUNT',
}

/** The list of required actions */
export type TierDowngradeActionRequired = {
  __typename?: 'TierDowngradeActionRequired'
  actions: TierDowngradeAction[]
}

/** Grouping of Tiers w/default tier, etc. */
export type TierGroup = {
  __typename?: 'TierGroup'
  active: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  /** Used to key A/B test off of */
  id: Scalars['ID']
  /** Tier ID which is the "preferred" one (i.e "Acorns recommends") */
  preferredTierId: Scalars['ID']
  tierOptions: TierOption[]
  updatedAt: Scalars['DateTime']
  winbackTierOption: Maybe<TierOption>
}

export enum TierKey {
  /** Hardship $1 tier for our winback campaign */
  Assist = 'ASSIST',
  /** Legacy $2 SPEND tier */
  Bronze = 'BRONZE',
  Copper = 'COPPER',
  /** Promotional tier for Cricket Wireless subscribers. */
  Cricket = 'CRICKET',
  Gold = 'GOLD',
  /** Promotional free tier for active military and veterans */
  Military = 'MILITARY',
  Null = 'NULL',
  Platinum = 'PLATINUM',
  Silver = 'SILVER',
}

/** Combination of a Tier and available prices to choose from. */
export type TierOption = {
  __typename?: 'TierOption'
  preferredTierPrice: TierPrice
  tier: Tier
  tierPrices: TierPrice[]
}

export type TierOptionByTierPriceIdResult = InvalidTierPriceId | TierOption

/** Pricing configuration used for a tier */
export type TierPrice = {
  __typename?: 'TierPrice'
  /** @deprecated Monetary values have been migrated to new standard `MicrosMoney`. Use `amountV2`. */
  amount: CurrencyAmount
  amountV2: MicrosMoney
  billingFrequency: BillingFrequency
  id: Scalars['ID']
  /** (DONT USE) Internal only, may be removed without warning. */
  tierId: Scalars['ID']
}

/** (Deprecated) Minimal representation of an Acorns product. */
export type TierProduct = {
  __typename?: 'TierProduct'
  /** used as unique identifier for this product */
  key: ProductKey
}

/** Unique combo of Tier and TierPrice tied to a User */
export type TierSubscription = {
  __typename?: 'TierSubscription'
  /** Reference to an Promotion the subscriber is actively consuming. */
  activePromotion: Maybe<Promotion>
  createdAt: Scalars['DateTime']
  createdBy: Maybe<TierSubscriptionCreatedBy>
  id: Scalars['ID']
  migration: Maybe<SubscriptionMigration>
  migrationId: Maybe<Scalars['ID']>
  /** The Offer the subscriber subscribed to for access to their Tier. */
  offer: Maybe<Offer>
  /** Indicates when the subscribers current Offer expires. */
  offerExpiresAt: Maybe<Scalars['DateTime']>
  /** Previous tier subscription the user had before this one. */
  previous: Maybe<TierSubscription>
  /** Indicates when a promotion was applied to the subscription. */
  promotionAppliedAt: Maybe<Scalars['DateTime']>
  /** Indication of when a subscribers promotion ends. */
  promotionExpiresAt: Maybe<Scalars['DateTime']>
  status: TierSubscriptionStatus
  tier: Tier
  tierPrice: TierPrice
  transition: Maybe<TierSubscriptionTransition>
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionAlreadyDeactivated = {
  __typename?: 'TierSubscriptionAlreadyDeactivated'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export type TierSubscriptionConnection = {
  __typename?: 'TierSubscriptionConnection'
  edges: TierSubscription[]
  pageInfo: TierSubscriptionPageInfo
}

export enum TierSubscriptionCreatedBy {
  /** Subscription created by the pre-launch backfill script */
  Backfill = 'BACKFILL',
  /** Flag to indicate user ought to be billed by the "legacy" billing system */
  LegacyUser = 'LEGACY_USER',
  /** Subscription record that was created as a result of a migration */
  Migration = 'MIGRATION',
  /** User auto-subscribed based on the status of their open accounts */
  SubscribedByOpenAccounts = 'SUBSCRIBED_BY_OPEN_ACCOUNTS',
  /** Subscription created via INTERNAL client request (either an admin or an internal process) */
  System = 'SYSTEM',
  /** Subscription created via EXTERNAL client request */
  User = 'USER',
}

/** account deactivation reasons */
export enum TierSubscriptionDeactivationReason {
  AcornsCostsTooMuch = 'ACORNS_COSTS_TOO_MUCH',
  CantAffordToInvestAtThisTime = 'CANT_AFFORD_TO_INVEST_AT_THIS_TIME',
  ConcernedAboutTheMarket = 'CONCERNED_ABOUT_THE_MARKET',
  DontWantToInvest = 'DONT_WANT_TO_INVEST',
  NotEnoughControlOverMyInvestments = 'NOT_ENOUGH_CONTROL_OVER_MY_INVESTMENTS',
  NotSureHowAcornsWorks = 'NOT_SURE_HOW_ACORNS_WORKS',
  NotTheRightTimeToInvest = 'NOT_THE_RIGHT_TIME_TO_INVEST',
  Other = 'OTHER',
  PoorInvestmentPerformance = 'POOR_INVESTMENT_PERFORMANCE',
  SwitchingToAnotherService = 'SWITCHING_TO_ANOTHER_SERVICE',
  ThisIsTemporaryIllBeBack = 'THIS_IS_TEMPORARY_ILL_BE_BACK',
  TroubleConnectingMyBank = 'TROUBLE_CONNECTING_MY_BANK',
  UnexpectedChargesToMyBank = 'UNEXPECTED_CHARGES_TO_MY_BANK',
}

export type TierSubscriptionForUser =
  | TierSubscription
  | TierSubscriptionNotFound
  | TierSubscriptionUnsubscribed

/** Returned if there is no found tier subscription */
export type TierSubscriptionNotFound = {
  __typename?: 'TierSubscriptionNotFound'
  message: Scalars['String']
}

/** Metadata for pagination of Tier Subscription History */
export type TierSubscriptionPageInfo = {
  __typename?: 'TierSubscriptionPageInfo'
  cursor: Maybe<Scalars['String']>
  hasNext: Scalars['Boolean']
}

/** Status of a tier subscription */
export enum TierSubscriptionStatus {
  /** An active subscription */
  Active = 'ACTIVE',
  /** A cancelled subscription */
  Inactive = 'INACTIVE',
  /** In the process of either upgrading or downgrading a subscription */
  Transitioning = 'TRANSITIONING',
}

/** Information about a transitioning subscription */
export type TierSubscriptionTransition = {
  __typename?: 'TierSubscriptionTransition'
  desiredTier: Maybe<Tier>
  /** Once we've decoupled our Tier and TierPrice, we'll need to make sure we're subscribing the user to the proper Tier and TierPrice */
  desiredTierPrice: Maybe<TierPrice>
  initiatedAt: Scalars['DateTime']
  subscriptionDeactivationReason: Maybe<TierSubscriptionDeactivationReason>
  transitionAction: SubscriptionTransitionAction
}

/** User has unsubscribed from their tier (account closed) */
export type TierSubscriptionUnsubscribed = {
  __typename?: 'TierSubscriptionUnsubscribed'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
}

export enum TimeFrameFilter {
  Month = 'month',
  NinetyDays = 'ninetyDays',
  ThirtyDays = 'thirtyDays',
  Year = 'year',
}

export type TimestampsInterface = {
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
}

export type Toggle = {
  __typename?: 'Toggle'
  id: Scalars['String']
  invalid: Maybe<Scalars['Boolean']>
  value: Scalars['Boolean']
}

export type TokenExpiredException = {
  __typename?: 'TokenExpiredException'
  message: Maybe<Scalars['String']>
}

/** Top Employer Name and Logo */
export type TopEmployer = {
  __typename?: 'TopEmployer'
  /** Employer Name */
  employerName: Scalars['String']
  /** Employer switch type */
  employerSwitchType: SwitchType
  /** Employer Logo URL */
  logo: Scalars['String']
  /** Employer online URL */
  onlineSwitchUrl: Maybe<Scalars['String']>
}

/** Top Employer List */
export type TopEmployerPayload = {
  __typename?: 'TopEmployerPayload'
  topEmployersList: TopEmployer[]
}

export type TopHolding = {
  __typename?: 'TopHolding'
  /** The market value that this security makes up of the ETF */
  marketValue: BigCurrencyAmount
  /** The number of shares that this security makes up of the ETF */
  numberOfShares: Maybe<Scalars['BigDecimal']>
  securityName: Scalars['String']
  /** The percentage of shares that this security makes up of the ETF */
  sharePercentage: Scalars['BigDecimal']
  symbol: Maybe<Scalars['TickerSymbol']>
}

export type TotalAmounts = {
  __typename?: 'TotalAmounts'
  totalContributedAmount: CurrencyAmount
  totalDepositedAmount: CurrencyAmount
}

export enum TradingSector {
  BasicMaterials = 'BASIC_MATERIALS',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerCyclical = 'CONSUMER_CYCLICAL',
  ConsumerDefensive = 'CONSUMER_DEFENSIVE',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  RealEstate = 'REAL_ESTATE',
  Technology = 'TECHNOLOGY',
  Utilities = 'UTILITIES',
}

export type Transaction = {
  __typename?: 'Transaction'
  amount: Maybe<Scalars['Float']>
  backupPaymentMethodUsed: Maybe<Scalars['Boolean']>
  collectedAt: Maybe<Scalars['DateTime']>
  collectionMethod: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  origin: Maybe<Scalars['String']>
  originalTransactionId: Maybe<Scalars['String']>
  refunded: Maybe<Scalars['Boolean']>
  status: Maybe<Scalars['String']>
  subscriptionIds: Maybe<Array<Maybe<Scalars['String']>>>
  success: Maybe<Scalars['Boolean']>
  type: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  uuid: Maybe<Scalars['String']>
  voidedAt: Maybe<Scalars['DateTime']>
}

export enum TransactionCategory {
  Fee = 'FEE',
  Refund = 'REFUND',
}

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

/** Transfer transactions object */
export type Transfer = {
  __typename?: 'Transfer'
  amount: CurrencyAmount
  /** When this was cancelled. NULL if never cancelled */
  canceledAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  from: TransferableAccount
  id: Scalars['ID']
  state: TransferState
  to: TransferableAccount
  /** When this was last updated. NULL if never updated */
  updatedAt: Scalars['DateTime']
}

export enum TransferAction {
  /** Initiate a one time deposit to the top level account. */
  OneTimeDeposit = 'ONE_TIME_DEPOSIT',
  /** Initiate a one time withdrawal from the top level account. */
  OneTimeWithdrawal = 'ONE_TIME_WITHDRAWAL',
  /** Initiate a recurring deposit to the top level account. */
  RecurringDeposit = 'RECURRING_DEPOSIT',
}

export enum TransferState {
  Canceled = 'canceled',
  Completed = 'completed',
  Initiated = 'initiated',
  Transferring = 'transferring',
}

export type TransferableAccount = {
  __typename?: 'TransferableAccount'
  /** The last 4 digits of the account or null if unavailable */
  accountNumberMasked: Maybe<Scalars['String']>
  /** A snapshot of the accounts last balance if available to acorns. External accounts wont have this. This is the value of the AVAILABLE balance. */
  balance: Maybe<CurrencyAmount>
  /** Whether an account is linked from plaid, spend, paypal, direct_bank or manual */
  externalSource: Maybe<ExternalSource>
  id: Scalars['ID']
  /** The name of the account. e.g. Chase Checking */
  name: Scalars['String']
  /** The type of Acorns account we are tracking for the user */
  type: TransferableAccountTypeEnum
}

export enum TransferableAccountTypeEnum {
  Core = 'core',
  Early = 'early',
  External = 'external',
  Later = 'later',
  Save = 'save',
  Spend = 'spend',
}

/** Info on accounts that can be transferred from */
export type TransferableFrom = {
  __typename?: 'TransferableFrom'
  from: TransferableAccount
}

/** Info about accounts that can be transferred to */
export type TransferableTo = {
  __typename?: 'TransferableTo'
  /** This field will be null if there is no max limit */
  max: Maybe<CurrencyAmount>
  /** This field will be null if there is no max limit */
  min: Maybe<CurrencyAmount>
  to: TransferableAccount
}

export type TrendingLearnContentPreview =
  | LearnArticlePreview
  | LearnArticlePreviewLocked
  | LearnMediaPreview
  | LearnMediaPreviewLocked

/** Entity describing the TrustedContact for a user's InvestmentAccount(s) */
export type TrustedContact = {
  __typename?: 'TrustedContact'
  /** Email of trusted contact */
  email: Scalars['Email']
  /** First name of the trusted contact */
  firstName: Scalars['String']
  /** ID of the trusted contact */
  id: Scalars['ID']
  investmentAccounts: Array<Maybe<InvestmentAccount>>
  /** Last name of the trusted contact */
  lastName: Scalars['String']
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']
  /** ID of the user that the contact belongs to */
  userId: Scalars['ID']
}

/** Trusted contact email/phone not unique under user scope */
export type TrustedContactAlreadyExistsException = {
  __typename?: 'TrustedContactAlreadyExistsException'
  /** attributes that failed uniqueness check */
  attributes: Array<Scalars['String']>
  /** error message */
  message: Scalars['String']
}

/** Fields for adding/editing a trusted contact. */
export type TrustedContactInput = {
  /** Email of trusted contact */
  email: Scalars['Email']
  /** First name of the trusted contact */
  firstName: Scalars['String']
  /** All investment account ids that this TrustedContact should be assigned to */
  investmentAccountIds: Array<Scalars['ID']>
  /** Last name of the trusted contact */
  lastName: Scalars['String']
  /** Phone number of trusted contact */
  phoneNumber: Scalars['PhoneNumber']
}

/** Trusted contact email invalid */
export type TrustedContactInvalidEmail = {
  __typename?: 'TrustedContactInvalidEmail'
  /** error message */
  message: Scalars['String']
}

/** Trusted contact phone number invalid */
export type TrustedContactInvalidPhoneNumber = {
  __typename?: 'TrustedContactInvalidPhoneNumber'
  /** error message */
  message: Scalars['String']
}

/** TrustedContact does not exist */
export type TrustedContactNotFoundException = {
  __typename?: 'TrustedContactNotFoundException'
  /** message */
  message: Scalars['String']
}

export enum Type {
  Charge = 'charge',
  Credit = 'credit',
}

export enum UsStateCodes {
  /** Armed Forces America */
  Aa = 'AA',
  /** Armed Forces Europe */
  Ae = 'AE',
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Armed Forces Pacific */
  Ap = 'AP',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District Of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Federated States Of Micronesia */
  Fm = 'FM',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Marshall Islands */
  Mh = 'MH',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palau */
  Pw = 'PW',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

export type UnableToCancelCheckError = {
  __typename?: 'UnableToCancelCheckError'
  requestId: Scalars['ID']
}

/** Input for unauthenticated creation of an upload url for direct to s3 upload */
export type UnauthenticatedCreateUploadUrlInput = {
  /** the document type of the upload document */
  documentType: DocumentType
  /** the file_name upload document */
  fileName: Scalars['String']
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
}

/** Input for saving an upload url after direct to s3 upload */
export type UnauthenticatedSaveUploadUrlInput = {
  /** the suspended upload additional info */
  additionalInfo?: InputMaybe<Scalars['String']>
  /** the suspended upload token of the user uploading a document */
  token: Scalars['String']
  /** the upload uuid from the upload object */
  uploadUuids: Array<Scalars['ID']>
}

/** LegacyUploadDocumentResult */
export type UnauthenticatedSaveUploadUrlResult =
  | DocumentUploads
  | UploadSaveError

export type UnauthorizedException = {
  __typename?: 'UnauthorizedException'
  message: Maybe<Scalars['String']>
}

export type UnauthorizedModifyLockedContentError = {
  __typename?: 'UnauthorizedModifyLockedContentError'
  message: Scalars['String']
}

export type UnblockDeviceInput = {
  deviceId: Scalars['ID']
}

export type UnblockDeviceResult = Device | DeviceNotFoundException

export type UnlinkOidcCredentialsInput = {
  oidcProvider: OidcProvider
}

export type UnlinkOidcCredentialsResult =
  | OidcCredentialsNotFoundException
  | UnlinkOidcCredentialsSuccess

export type UnlinkOidcCredentialsSuccess = {
  __typename?: 'UnlinkOidcCredentialsSuccess'
  email: Maybe<Scalars['EmailAddress']>
  oidcProvider: Maybe<OidcProvider>
  status: Maybe<Scalars['Boolean']>
  userId: Scalars['ID']
}

export type UnlockBankCardPayload = {
  __typename?: 'UnlockBankCardPayload'
  bankCard: Maybe<BankCard>
}

export type UnmarkLearnContentAsHelpfulInput = {
  contentId: Scalars['ID']
}

export type UnmarkLearnContentAsHelpfulResult =
  | RecordDoesNotExistError
  | UpdateLearnContentHelpfulnessResult

/** Account is not eligible for onboarding completion due to missing required info */
export type UnmetRequirementsException = {
  __typename?: 'UnmetRequirementsException'
  requirements: OnboardingRequirement[]
}

/** Error indicating that request cannot be retried */
export type UnrecoverableError = {
  __typename?: 'UnrecoverableError'
  /** Reason why error occurred */
  reason: Scalars['String']
}

/** The LinkedAccount associated with the linked_account_id will never be valid with the external provider */
export type UnrecoverableLinkedAccountError = {
  __typename?: 'UnrecoverableLinkedAccountError'
  /** ID of the unrecoverable LinkedAccount */
  linkedAccountId: Scalars['ID']
}

export type UnsubscribeUserFromTierInput = {
  /** Deprecated */
  createdBy?: InputMaybe<TierSubscriptionCreatedBy>
}

export type UnsubscribeUserFromTierResult =
  | TierDowngradeActionRequired
  | TierSubscriptionUnsubscribed

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlert = Alert & {
  __typename?: 'UnverifiedBeneficiarySsnAlert'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /**
   * Internal ID of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  beneficiaryId: Scalars['ID']
  /**
   * First name of the beneficiary
   * @deprecated Use the beneficiary field instead
   */
  firstName: Scalars['String']
  /** @deprecated The type of the alert is defined by the gql type. */
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The associated beneficiary does not have a verified SSN */
export type UnverifiedBeneficiarySsnAlertItem = UserAlertsItem & {
  __typename?: 'UnverifiedBeneficiarySsnAlertItem'
  /** The beneficary associated with the alert. */
  beneficiary: Beneficiary
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Source attribute object containing properties that can be updated. */
export type UpdatableAttributesInput = {
  /** Name of targeted group for ad in Adjust */
  adGroup?: InputMaybe<Scalars['String']>
  /** Name of campaign in Adjust */
  campaign?: InputMaybe<Scalars['String']>
  /** Click label of install with referral ID in Adjust */
  clickLabel?: InputMaybe<Scalars['String']>
  /** Creative content name in Adjust */
  creative?: InputMaybe<Scalars['String']>
  /** Name of funnel user wants to experience */
  funnel?: InputMaybe<FunnelName>
  /** Identifier for the prospect's attribution channel */
  sourceID?: InputMaybe<Scalars['String']>
  /** Full name of tracker in Adjust */
  trackerName?: InputMaybe<Scalars['String']>
  /** Six character token ID in Adjust */
  trackerToken?: InputMaybe<Scalars['String']>
}

/** Input to update account portfolio */
export type UpdateAccountPortfolioInput = {
  /** Investment account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio Risk Type */
  riskLevel: PortfolioRiskLevel
  /** Portfolio theme */
  theme: PortfolioTheme
}

/** Update Account Portfolio Response */
export type UpdateAccountPortfolioResponse =
  | InvalidActionOnAccount
  | InvestmentAccount
  | InvestmentAccountNotFoundException
  | PortfolioNotFoundException
  | PortfolioUpdateFailedException

export type UpdateAttributionInput = {
  /** Email address for prospect used during initial sign-up */
  email?: InputMaybe<Scalars['String']>
  /** Contextual attributes representing parameters surrounding user sign-up */
  sourceAttributes: UpdatableAttributesInput
  /** Unique user identifier */
  userId?: InputMaybe<Scalars['ID']>
}

/** Union for the result of the updateAttribution mutation */
export type UpdateAttributionResult =
  | InvalidConversionIdentifierException
  | InvalidSourceAttributesException
  | NoProspectRecord
  | RegistrationFunnel

export type UpdateAuthEmailInput = {
  email: Scalars['EmailAddress']
}

export type UpdateAuthEmailResult = AuthProfile | ExistingEmailVerifiedException

export type UpdateAuthPhoneNumberInput = {
  phoneNumber: Scalars['PhoneNumber']
}

export type UpdateAuthPhoneNumberResult =
  | AuthProfile
  | InvalidPhoneNumberException

export type UpdateBankAccountGoalInput = {
  accountId: Scalars['ID']
  currentGoal: BankAccountGoalInput
}

export type UpdateBankAccountGoalPayload = {
  __typename?: 'UpdateBankAccountGoalPayload'
  requestId: Scalars['ID']
}

export type UpdateBankAccountGoalResult = UpdateBankAccountGoalPayload

export type UpdateBankCardPinInput = {
  newPin: Scalars['BankCardPin']
}

export type UpdateBankCardPinPayload = {
  __typename?: 'UpdateBankCardPinPayload'
  bankCard: Maybe<BankCard>
}

export type UpdateBannersInput = {
  helpcenter?: InputMaybe<HelpcenterContentInput>
  sitewide?: InputMaybe<SiteWideBannerContentInput>
}

/** Response to a beneficiary update */
export type UpdateBeneficiaryInfoResult =
  | Beneficiary
  | BeneficiaryNotFoundException
  | InternalErrorException
  | InvalidAddressException
  | InvalidEmailException
  | InvalidPhoneException

export type UpdateBenefitStatusInput = {
  benefitProductKey: BenefitsTrackerProducts
  claimStatus: ClaimStatus
  claimedOn?: InputMaybe<Scalars['DateTime']>
  details?: InputMaybe<Array<InputMaybe<BenefitStatusDetail>>>
  expiresOn?: InputMaybe<Scalars['DateTime']>
  updatedBy: Scalars['String']
}

export type UpdateBenefitStatusResponse = {
  __typename?: 'UpdateBenefitStatusResponse'
  message: Scalars['String']
}

export type UpdateCredentialsResult =
  | BlockedEmailDomainException
  | Credentials
  | EmailTakenException
  | UserCredentialsNotFoundException

export type UpdateDelegateResult = DelegateDefinition

export type UpdateElapsedTimeForLearnQuizInput = {
  elapsedTimeMilliseconds: MillisecondsInput
  quizId: Scalars['ID']
}

export type UpdateElapsedTimeForLearnQuizResult =
  | LearnContentElapsedMillisecondsUpdatedResult
  | RecordDoesNotExistError

export type UpdateLearnContentHelpfulnessResult = {
  __typename?: 'UpdateLearnContentHelpfulnessResult'
  contentId: Scalars['ID']
  isHelpful: Scalars['Boolean']
}

export type UpdateLearnProgressInput = {
  contentId: Scalars['ID']
  contentProgress: LearnProgressInput
}

export type UpdateLearnProgressResult =
  | LearnProgressUpdatedResult
  | RecordDoesNotExistError

/** Attributes for updating the linked account */
export type UpdateLinkedAccountInput = {
  /** Plaid link session id */
  linkSessionId: Scalars['String']
}

export type UpdateMessageFailed = {
  __typename?: 'UpdateMessageFailed'
  errorMessage: Scalars['String']
}

export type UpdateMessageIgnored = {
  __typename?: 'UpdateMessageIgnored'
  requestId: Scalars['ID']
}

export type UpdateMessageResult =
  | AlertMessage
  | LegacyAlertDismissalSuccess
  | NotificationMessage
  | UpdateMessageIgnored

export type UpdateMessagesFailure = {
  __typename?: 'UpdateMessagesFailure'
  errorMessage: Scalars['String']
}

/** Input type for updating MoneyManager allocations. */
export type UpdateMoneyManagerAllocationsInput = {
  allocations: MoneyManagerStagedRulesInput[]
  archetype?: InputMaybe<MoneyRulesArchetype>
  isCustomized: Scalars['Boolean']
}

/** Represents the result of the updateMoneyManagerAllocations mutation, which can be either a success or an error. */
export type UpdateMoneyManagerAllocationsResult =
  | AllocationAmountsSumExceedingMaxError
  | InvalidSingleRuleIdError
  | MismatchedDistributionUnitsError
  | MissingValidRulesetError
  | NonUniqueSingleRuleIdsError
  | UpdateMoneyManagerAllocationsSuccess

/**
 * Represents a successful update of MoneyManager allocations.
 * Returns the list of money rules after the change.
 */
export type UpdateMoneyManagerAllocationsSuccess = {
  __typename?: 'UpdateMoneyManagerAllocationsSuccess'
  categories: MoneyManagerCategory[]
  rules: MoneyRulesRule[]
}

export type UpdateMoneyManagerAutomationTargetInput = {
  amount: MoneyRulesCurrencyAmountInput
  customSelection: Scalars['Boolean']
  suggestedPeriod?: InputMaybe<MoneyManagerPeriodInput>
  type: MoneyManagerAutomationTargetType
}

export type UpdateMoneyManagerAutomationTargetResult =
  | MoneyManagerInputError
  | UpdateMoneyManagerAutomationTargetSuccess

/** The new state of the user's automation targets */
export type UpdateMoneyManagerAutomationTargetSuccess = {
  __typename?: 'UpdateMoneyManagerAutomationTargetSuccess'
  automationTargets: Array<Maybe<MoneyManagerAutomationTarget>>
}

export type UpdateMoneyManagerSettingsFailure = {
  __typename?: 'UpdateMoneyManagerSettingsFailure'
  reason: Scalars['String']
}

export type UpdateMoneyManagerSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMoneyManagerSettingsResult =
  | UpdateMoneyManagerSettingsFailure
  | UpdateMoneyManagerSettingsSuccess

export type UpdateMoneyManagerSettingsSuccess = {
  __typename?: 'UpdateMoneyManagerSettingsSuccess'
  settings: Maybe<MoneyManagerSettings>
}

export type UpdateMoneyRulesSourceSettingsFailure = {
  __typename?: 'UpdateMoneyRulesSourceSettingsFailure'
  reason: Scalars['String']
}

export type UpdateMoneyRulesSourceSettingsInput = {
  moneyManagerEnabled?: InputMaybe<Scalars['Boolean']>
  processRecurringDeposits?: InputMaybe<Scalars['Boolean']>
}

export type UpdateMoneyRulesSourceSettingsResult =
  | UpdateMoneyRulesSourceSettingsFailure
  | UpdateMoneyRulesSourceSettingsSuccess

export type UpdateMoneyRulesSourceSettingsSuccess = {
  __typename?: 'UpdateMoneyRulesSourceSettingsSuccess'
  settings: Maybe<MoneyRulesSettings>
}

export type UpdateOauthAppInput = {
  accessTokenAudience?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  accessTokenExpiry?: InputMaybe<Scalars['Int']>
  active?: InputMaybe<Scalars['Boolean']>
  contactEmail?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<Scalars['String']>
  externalApp?: InputMaybe<Scalars['Boolean']>
  imageUri?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  pageType?: InputMaybe<Scalars['String']>
  redirectUri?: InputMaybe<Scalars['String']>
  refreshTokenExpiry?: InputMaybe<Scalars['Int']>
  scopeIdentifiers?: InputMaybe<Array<Scalars['String']>>
  type?: InputMaybe<OauthAppType>
}

export type UpdateOauthAppResult = OauthApp | OauthAppNotFoundException

/** Changes opt_out_of_targeting field */
export type UpdateOptOutOfTargetingInput = {
  /** Has user opted out of targeting? */
  optedOutOfTargeting: Scalars['Boolean']
}

/** Input for updatePortfolioSecurities */
export type UpdatePortfolioSecuritiesInput = {
  /** Investment Account ID */
  investmentAccountId: Scalars['ID']
  /** Portfolio ID */
  portfolioId: Scalars['ID']
  /** List of Securities and their target allocation percent */
  securityAllocations: SecurityAllocationTarget[]
}

/** Result of updating a portfolio's securities */
export type UpdatePortfolioSecuritiesResult =
  | CustomerAgreementRequiredException
  | InvalidAllocationPercentError
  | InvalidSecurityError
  | InvalidSecurityForAllocationError
  | InvestmentAccount
  | LiquidationUnavailableError
  | NegativeSecurityPercentError
  | PortfolioSecurityLimitReached

export type UpdatePromoCodeInput = {
  businessLine: PromoCodeBusinessLine
  channel: Scalars['String']
  condensedTitle: Scalars['String']
  cursor: Scalars['String']
  description: Scalars['String']
  internalMemo?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart: Scalars['DateTime']
  qualificationAction: PromoCodeQualificationAction
  qualificationAmount: Scalars['Int']
  rewards?: InputMaybe<Array<Scalars['ID']>>
  status: PromoCodeStatus
  termsUrl?: InputMaybe<Scalars['URL']>
  title: Scalars['String']
}

export type UpdatePromoCodeResult =
  | DuplicatePromoCodeError
  | PromoCode
  | PromoCodeFieldLengthError

export type UpdatePromotedCampaignsInput = {
  campaignIds: Array<InputMaybe<Scalars['ID']>>
}

export type UpdatePromotedCampaignsResult = PromotedCampaigns

export type UpdateReferralCampaignInput = {
  actionFeedDesc?: InputMaybe<Scalars['String']>
  background?: InputMaybe<CampaignBackgroundType>
  condensedTitle?: InputMaybe<Scalars['String']>
  cursor: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  eligibilityEnd?: InputMaybe<Scalars['DateTime']>
  hidden?: InputMaybe<Scalars['Boolean']>
  icon?: InputMaybe<CampaignIconType>
  internalMemo?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  publishEnd?: InputMaybe<Scalars['DateTime']>
  publishStart?: InputMaybe<Scalars['DateTime']>
  qualificationAction?: InputMaybe<CampaignQualificationActionType>
  qualificationAmount?: InputMaybe<Scalars['Int']>
  rewards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  status?: InputMaybe<CampaignStatus>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateReferralCampaignResult = ReferralCampaignV2

export type UpdateReferralPayoutInput = {
  advocateOfferId?: InputMaybe<Scalars['String']>
  friendOfferId?: InputMaybe<Scalars['String']>
  payoutId: Scalars['ID']
  reason?: InputMaybe<Scalars['String']>
  status: ReferralPayoutStatus
  statusChangeBy: Scalars['String']
}

export type UpdateReferralPayoutResult = ReferralPayout

export type UpdateReferralRelationshipInput = {
  friendId: Scalars['ID']
  status: ReferralRelationshipStatus
  /** Status of the referral relationship */
  statusDetails?: InputMaybe<ReferralStatusDetails>
}

export type UpdateReferralRelationshipResult = ReferralRelationship

/** Returned if failure updating reward */
export type UpdateReferralRewardError = {
  __typename?: 'UpdateReferralRewardError'
  message: Scalars['String']
}

export type UpdateReferralRewardResponse =
  | ReferralRewardSummary
  | UpdateReferralRewardError

export type UpdateScopeException = {
  __typename?: 'UpdateScopeException'
  message: Scalars['String']
}

export type UpdateScopeInput = {
  description?: InputMaybe<Scalars['String']>
  required?: InputMaybe<Scalars['Boolean']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateScopeResult = Scope | UpdateScopeException

/** Response to a trusted contact update/insert */
export type UpdateTrustedContactResult =
  | InternalErrorException
  | TrustedContact
  | TrustedContactAlreadyExistsException
  | TrustedContactInvalidEmail
  | TrustedContactInvalidPhoneNumber
  | TrustedContactNotFoundException

/** Input type for updating user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetInput = {
  /** The annual income of the user. */
  annualIncome: Scalars['Int']
}

/** Represents the result of the updateUserProfileAndAutomationTarget mutation, which can be either a success or an error. */
export type UpdateUserProfileAndAutomationTargetResult =
  UpdateUserProfileAndAutomationTargetSuccess

/** Represents a successful update of user profile and automation target. */
export type UpdateUserProfileAndAutomationTargetSuccess = {
  __typename?: 'UpdateUserProfileAndAutomationTargetSuccess'
  /** The updated annual income of the user. */
  annualIncome: Scalars['Int']
  /** The newly updated automation targets of the user. */
  automationTargets: MoneyManagerAutomationTarget[]
  /** The newly updated objective progress data. */
  cascadeObjectives: MoneyManagerCascadeObjective[]
  /** The types of the updated automation targets. */
  updatedTargetTypes: MoneyManagerAutomationTargetType[]
}

/** Describes the update user switch state return type. */
export type UpdateUserSwitchState =
  | UpdateUserSwitchStateFailure
  | UpdateUserSwitchStatePayload

/** Update User Switch State Returns Failure */
export type UpdateUserSwitchStateFailure = {
  __typename?: 'UpdateUserSwitchStateFailure'
  failureMessage: Scalars['String']
}

/** Mutation attributes for updating a user switch state in the Direct Deposit database */
export type UpdateUserSwitchStateInput = {
  /** Switch State */
  switchState: SwitchState
}

/** Update User Switch State Return Payload */
export type UpdateUserSwitchStatePayload = {
  __typename?: 'UpdateUserSwitchStatePayload'
  /** Switch State */
  switchState: SwitchState
  /** User ID */
  userId: Scalars['ID']
}

export type UpdateVerificationProfileResult = VerificationProfile

export type UpgradeAuthenticationResult =
  | AuthSession
  | AuthenticationAlreadyUpgradedException
  | UserCredentialsNotFoundException

/** Uploads a check image to the provided session. */
export type UploadCheckInput = {
  checkImage: CheckImage
  /** The session the image will be uploaded to. */
  sessionToken: Scalars['String']
}

/** Response from uploading a check image. */
export type UploadCheckPayload = {
  __typename?: 'UploadCheckPayload'
  /** Session image was uploaded to. */
  sessionToken: Scalars['String']
}

export type UploadDocumentsInput = {
  documentRequestId: Scalars['ID']
  documentType: DocumentType
  documents: Array<Scalars['Upload']>
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExist = {
  __typename?: 'UploadDoesNotExist'
  /** message */
  message: Maybe<Scalars['String']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

/** The upload does not exist. Must call CreateUploadUrl first. */
export type UploadDoesNotExistError = {
  __typename?: 'UploadDoesNotExistError'
  /** message */
  message: Maybe<Scalars['String']>
  /** The upload uuid */
  uploadUuid: Maybe<Scalars['ID']>
  /** The authenticated user id */
  userId: Maybe<Scalars['ID']>
}

export type UploadFailedError = {
  __typename?: 'UploadFailedError'
  message: Scalars['String']
}

export type UploadOauthAppImageResult =
  | InvalidContentTypeException
  | OauthAppImageUpload

/** Errors from backend upload */
export type UploadSaveError = {
  __typename?: 'UploadSaveError'
  uploadExceptions: UploadSaveExceptions[]
}

/** Exceptions from upload error */
export type UploadSaveExceptions =
  | FileDoesNotExistError
  | UploadDoesNotExistError

export type UploadUnsolicitedDocumentsInput = {
  documentType: DocumentType
  documents: Array<Scalars['Upload']>
  /** Idempotency key for ensuring that duplicate requests are not made */
  requestKey?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentStatus>
}

/** An upload url */
export type UploadUrl = {
  __typename?: 'UploadUrl'
  key: Scalars['String']
  policy: Scalars['String']
  uploadUuid: Scalars['ID']
  url: Scalars['String']
  userId: Scalars['ID']
  xAmzAlgorithm: Scalars['String']
  xAmzCredential: Scalars['String']
  xAmzDate: Scalars['String']
  xAmzSecurityToken: Scalars['String']
  xAmzSignature: Scalars['String']
}

/** Changeable attributes for creating user matches */
export type UpsertUserMatchInput = {
  /** ID representation of the user in a external system */
  externalId: Scalars['String']
  /** The external system that the user is in */
  externalSource: ExternalUserSource
  /** Information used to identify the match */
  matchedCriteria?: InputMaybe<Array<Scalars['String']>>
  /** Current match status with external system */
  matchedStatus?: InputMaybe<UserMatchStatus>
}

/** Response to a user match creation or update attempt */
export type UpsertUserMatchResult = InternalErrorException | UserMatch

/** Entity representing the shared User object type used to resolve fields that belong to Auth Service */
export type User = {
  __typename?: 'User'
  address1: Maybe<Scalars['String']>
  address2: Maybe<Scalars['String']>
  alerts: Maybe<UserAlert[]>
  allocationProfileId: Maybe<Scalars['ID']>
  city: Maybe<Scalars['String']>
  closedAt: Maybe<Scalars['DateTime']>
  /** @deprecated Use InvestmentAccount.userAge or InvestmentAccount.withdrawalsIncurTaxPenalty instead. */
  dob: Maybe<Scalars['String']>
  email: Scalars['String']
  /** @deprecated Field no longer supported */
  employedAffiliatedWithBrokerDealer: Maybe<Scalars['Boolean']>
  employer: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  fundingSource: Maybe<FundingSource>
  fundingSourceChangeRequiresApproval: Maybe<Scalars['Boolean']>
  investmentAccounts: Maybe<InvestmentAccount[]>
  lastName: Maybe<Scalars['String']>
  occupation: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  pinCreated: Maybe<Scalars['Boolean']>
  portfolio: Maybe<Portfolio>
  registrationComplete: Maybe<Scalars['Boolean']>
  registrationCompletedAt: Maybe<Scalars['DateTime']>
  /** @deprecated Field no longer supported */
  shareholderOrDirector: Maybe<Scalars['Boolean']>
  sourceId: Maybe<Scalars['String']>
  state: Maybe<Scalars['USStateName']>
  /** @deprecated Field no longer supported */
  subjectToBackupWithholding: Maybe<Scalars['Boolean']>
  uploads: UserUpload[]
  usCitizen: Maybe<Scalars['Boolean']>
  uuid: Scalars['ID']
  verified: Maybe<Scalars['Boolean']>
  zip: Maybe<Scalars['String']>
}

/** A user alert. */
export type UserAlert = UserAlertsItem & {
  __typename?: 'UserAlert'
  description: Scalars['String']
  id: Scalars['ID']
  key: Scalars['String']
  metadata: Maybe<Scalars['String']>
  title: Scalars['String']
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

export type UserAlertsItem = {
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** Response from user alert query */
export type UserAlertsResponse =
  | AddressDocumentRequestedUserAlert
  | BankDocumentRequestedUserAlert
  | IdentityDocumentRequestedUserAlert
  | InsufficientFundsUserAlert
  | InvestmentsPausedUserAlert
  | MiscDocumentRequestedUserAlert
  | NoFundingSourceUserAlert
  | RdvRequiredUserAlert
  | SsnDocumentRequestedUserAlert
  | UserAlert
  | W9DocumentRequestedUserAlert

export type UserCardLockedSpendAlert = SpendAlert & {
  __typename?: 'UserCardLockedSpendAlert'
  type: Scalars['String']
  userId: Scalars['ID']
}

/** The provided user is closed */
export type UserClosedException = {
  __typename?: 'UserClosedException'
  /** message */
  message: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

export type UserCohorts = {
  __typename?: 'UserCohorts'
  /** Updated list of cohorts */
  cohorts: Array<Scalars['String']>
  /** User's user_id */
  userId: Scalars['String']
}

export type UserCredentials = {
  __typename?: 'UserCredentials'
  identifier: Scalars['String']
  type: CredentialsType
  userId: Scalars['ID']
}

export type UserCredentialsInput = {
  email: Scalars['EmailAddress']
}

export type UserCredentialsNotFoundException = {
  __typename?: 'UserCredentialsNotFoundException'
  message: Maybe<Scalars['String']>
}

/** User already exists */
export type UserExistsException = {
  __typename?: 'UserExistsException'
  userId: Maybe<Scalars['ID']>
}

/** A reopen check for an investment account reopen request. */
export type UserInvestmentAccountReopenCheck = TimestampsInterface & {
  __typename?: 'UserInvestmentAccountReopenCheck'
  /** The ID of the reopen request to which this check belongs. */
  accountReopenRequestId: Scalars['Int']
  /** Date time the record was created */
  createdAt: Scalars['DateTime']
  /** The UUID of the investment account for which this check was made. */
  investmentAccountId: Scalars['ID']
  /** A boolean indicating whether this check passed or failed. */
  passed: Scalars['Boolean']
  /** The check type. */
  reopenCheckType: InvestmentAccountReopenCheck
  /** Date time the record was last updated */
  updatedAt: Scalars['DateTime']
  /** UUID of the user to whom the account the reopen request was made for belongs. */
  userUuid: Scalars['ID']
}

export type UserLockedException = {
  __typename?: 'UserLockedException'
  message: Maybe<Scalars['String']>
}

/** record of a user matching in an external system */
export type UserMatch = {
  __typename?: 'UserMatch'
  /** Id of user in external system */
  externalId: Scalars['ID']
  externalMetadata: Maybe<ExternalMetadata>
  externalSource: ExternalUserSource
  /** Acorns user id */
  id: Scalars['ID']
  matchedAt: Scalars['DateTime']
  matchedCriteria: Maybe<Array<Scalars['String']>>
  matchedStatus: UserMatchStatus
}

export enum UserMatchStatus {
  UserMatchStatusEligible = 'USER_MATCH_STATUS_ELIGIBLE',
  UserMatchStatusIneligibleCancelled = 'USER_MATCH_STATUS_INELIGIBLE_CANCELLED',
  UserMatchStatusIneligibleIncorrectTier = 'USER_MATCH_STATUS_INELIGIBLE_INCORRECT_TIER',
  UserMatchStatusInvalid = 'USER_MATCH_STATUS_INVALID',
}

/** No user was found for the ID provided */
export type UserNotFound = {
  __typename?: 'UserNotFound'
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** No user was found for the ID provided */
export type UserNotFoundException = {
  __typename?: 'UserNotFoundException'
  /** message */
  message: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** User is not a US resident */
export type UserNotUsResidentException = {
  __typename?: 'UserNotUSResidentException'
  userId: Maybe<Scalars['ID']>
}

/** Custodian must be verified in order to open an Early Account */
export type UserNotVerifiedException = {
  __typename?: 'UserNotVerifiedException'
  /** message */
  message: Maybe<Scalars['String']>
}

export type UserPartnerStatusResponse = {
  __typename?: 'UserPartnerStatusResponse'
  message: Scalars['String']
}

/** The provided user is locked */
export type UserReopenLockedException = {
  __typename?: 'UserReopenLockedException'
  /** The date the user was locked */
  lockedAt: Scalars['DateTime']
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** The provided user is suspended */
export type UserReopenSuspendedException = {
  __typename?: 'UserReopenSuspendedException'
  /** The date the user was suspended */
  suspendedAt: Scalars['DateTime']
  /** The reason the user was suspended */
  suspendedReason: Maybe<Scalars['String']>
  /** The provided user id */
  userId: Maybe<Scalars['ID']>
}

/** User Status */
export type UserStatus = {
  __typename?: 'UserStatus'
  age: Scalars['Int']
  closed: Scalars['Boolean']
  closedAt: Maybe<Scalars['DateTime']>
  registrationComplete: Scalars['Boolean']
  registrationCompleteAt: Maybe<Scalars['DateTime']>
  userId: Scalars['String']
  verified: Scalars['Boolean']
  verifiedAt: Maybe<Scalars['DateTime']>
}

export type UserSuspendedException = {
  __typename?: 'UserSuspendedException'
  message: Maybe<Scalars['String']>
  suspendedToken: Maybe<Scalars['String']>
  suspensionReasonValid: Maybe<Scalars['Boolean']>
}

/** Token has incorrect length */
export type UserSuspendedUploadTokenLengthError = {
  __typename?: 'UserSuspendedUploadTokenLengthError'
  /** expected length of token */
  length: Scalars['Int']
}

/** Validation response for suspended upload token */
export type UserSuspendedUploadTokenValidation = {
  __typename?: 'UserSuspendedUploadTokenValidation'
  reason: Scalars['String']
  tokenValid: Scalars['Boolean']
}

/** Describes a user request for a direct deposit switch. */
export type UserSwitch = {
  __typename?: 'UserSwitch'
  /** Creation Date */
  createdAt: Scalars['String']
  /** Switch ID */
  id: Scalars['ID']
  /** Indicates whether the user is already depositing on the Spend account or not. */
  isComplete: Scalars['Boolean']
  /** Status of the direct deposit switch. */
  status: SwitchStatus
  /** Switch Type */
  switchType: SwitchType
  /** Last Updated Date */
  updatedAt: Scalars['String']
  /** User ID */
  userId: Scalars['ID']
  /** Switch ID provided by the vendor. */
  vendorSwitchId: Maybe<Scalars['ID']>
}

export type UserToken = {
  __typename?: 'UserToken'
  consumedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  expiresAt: Scalars['DateTime']
  oauthAppClientId: Maybe<Scalars['ID']>
  oauthAppId: Scalars['ID']
  updatedAt: Scalars['DateTime']
  userId: Scalars['ID']
  userScopes: Array<Maybe<Scalars['String']>>
  userTokenId: Scalars['ID']
}

export type UserUpload = {
  __typename?: 'UserUpload'
  createdAt: Scalars['DateTime']
  documentType: Maybe<Scalars['String']>
  id: Scalars['ID']
}

/** Object representing an acorns user */
export type User_V2 = {
  __typename?: 'User_v2'
  closedAt: Maybe<Scalars['Date']>
  email: Scalars['String']
  uuid: Scalars['ID']
}

export type ValidPolicies = {
  __typename?: 'ValidPolicies'
  policies: Maybe<Array<Maybe<Policy>>>
}

export type ValidateCredentialsInput = {
  credentialsType?: CredentialsType
  nativeLoginInput?: InputMaybe<NativeLoginInput>
  oidcLoginInput?: InputMaybe<OidcLoginInput>
  udid: Scalars['String']
}

export type ValidateCredentialsResult =
  | AuthSession
  | DeviceBlockedException
  | InvalidCredentialsException
  | LoginRateLimitedException
  | OidcCredentialsNotFoundException
  | UserSuspendedException
  | ValidateCredentialsSuccess

export type ValidateCredentialsSuccess = {
  __typename?: 'ValidateCredentialsSuccess'
  authenticators: Maybe<Authenticator[]>
  mfaToken: Scalars['String']
  userId: Scalars['ID']
}

export type ValidateDocumentsInput = {
  /** ID of document provided by Socure */
  documentId: Scalars['ID']
  /** Acorns subaccount for processing uploaded documents */
  product?: InputMaybe<IdentitySubaccount>
}

export type ValidateFaceLivenessSessionResult =
  | FaceLivenessSession
  | FaceLivenessSessionExpiredException
  | FaceLivenessSessionFailedException
  | FaceLivenessSessionIncompleteException
  | FaceLivenessSessionNotFoundException
  | MissingIdImageException

export type ValidatePasswordResetTokenResult =
  | InvalidPasswordResetTokenException
  | ValidatePasswordResetTokenSuccess

export type ValidatePasswordResetTokenSuccess = {
  __typename?: 'ValidatePasswordResetTokenSuccess'
  displaySsnField: Scalars['Boolean']
}

/** Input for validating a user suspended upload token */
export type ValidateUserSuspendedUploadTokenInput = {
  /** Upload token */
  token: Scalars['String']
}

/** Result from validating document uploader token */
export type ValidateUserSuspendedUploadTokenResult =
  | UserSuspendedUploadTokenLengthError
  | UserSuspendedUploadTokenValidation

export type ValidationError = {
  __typename?: 'ValidationError'
  errorCode: Scalars['String']
  errorMessage: Maybe<Scalars['String']>
  /** The nonce of the intent. */
  intentId: Scalars['UUID']
}

export type VendAuthSessionInput = {
  challengeAnswerInput: ChallengeAnswerInput
  rememberMe?: InputMaybe<Scalars['Boolean']>
  udid: Scalars['String']
  userId: Scalars['ID']
}

export type VendAuthSessionResult =
  | AuthChallengeAnswerAttemptsExhaustedException
  | AuthChallengeAnswerIncorrectException
  | AuthChallengeExpiredException
  | AuthSession
  | ChallengeRateExceededException
  | DeviceBlockedException
  | UserSuspendedException

export type VendorBillingInfo = {
  __typename?: 'VendorBillingInfo'
  accountType: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  lastFour: Maybe<Scalars['String']>
  primary: Maybe<Scalars['Boolean']>
  routingNumber: Maybe<Scalars['String']>
}

export type VendorCustomerAccount = {
  __typename?: 'VendorCustomerAccount'
  billTo: Maybe<Scalars['String']>
  code: Maybe<Scalars['String']>
  company: Maybe<Scalars['String']>
  dunningCampaignId: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  object: Maybe<Scalars['String']>
  parentAccountId: Maybe<Scalars['String']>
}

export type VerificationDetails = {
  __typename?: 'VerificationDetails'
  /**
   * This field indicates whether this KYC verification result is still valid and usable for the user today, regardless of its status (e.g., success, soft fail, hard fail).
   * When true, the banking KYC is either tied to an active account or part of an ongoing KYC process. When false, the user’s account may be closed or archived, making this KYC result no longer reusable.
   * Per our current approved BANK guidelines, a new KYC verification must be initiated within banking if the user goes through a reopen process.
   */
  isActive: Maybe<Scalars['Boolean']>
  response: Maybe<Scalars['String']>
  vendor: Maybe<Scalars['String']>
}

export type VerificationProfile = {
  __typename?: 'VerificationProfile'
  /** Session ID calculated by Socure */
  deviceSessionId: Maybe<Scalars['String']>
  /** Status of submitted documents after initial identity verification */
  documentVerification: Maybe<DocumentVerification>
  /** SSN verification consent */
  eCBSV: Ecbsv
  /**
   * Flag indicating whether eCBSV can be used or not for verification
   * @deprecated Use `eCBSV.consent` instead
   */
  eCBSVConsent: Scalars['Boolean']
  /** Customer's IP address used during registration */
  ipAddress: Maybe<Scalars['String']>
}

export type VerificationProfileInput = {
  /** Session ID calculated by Socure */
  deviceSessionId?: InputMaybe<Scalars['String']>
  /** Customer's acceptance or declination of consent to utilize eCBSV */
  eCBSVConsent?: InputMaybe<Scalars['Boolean']>
}

export enum VerificationStatus {
  ActionRequired = 'actionRequired',
  ActionRequiredDueToFailure = 'actionRequiredDueToFailure',
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success',
}

export type VerifyCheckPaymentRecipientAddressInputType = {
  recipient: CheckPaymentRecipientInput
  recipientAddress: CheckPaymentAddressInput
}

/** Address deliverable by mail carrier or InvalidAddressError */
export type VerifyCheckPaymentRecipientAddressResult =
  | AuthorizationError
  | CheckPaymentRecipientAddressType
  | InvalidAddressError

export type VerifyDeviceInput = {
  deviceId: Scalars['ID']
}

export type VerifyDeviceResult =
  | DeviceNotFoundException
  | EmailAuthChallenge
  | SmsAuthChallenge

export type VerifyIdentityByDocumentsResult = DocumentVerification

export type VerifyPasswordsInput = {
  newPassword: Scalars['String']
  oldPassword: Scalars['String']
}

export type VerifyPasswordsResult =
  | IncorrectOldPasswordException
  | InvalidPasswordException
  | SamePasswordsException
  | UnauthorizedException
  | VerifyPasswordsSuccess

export type VerifyPasswordsSuccess = {
  __typename?: 'VerifyPasswordsSuccess'
  isValid: Scalars['Boolean']
}

export type VerifyPromoCodeResponse = InvalidPromoCodeError | PromoCode

/** Input for verifying RDVs */
export type VerifyRdvsInput = {
  /** Deposit amounts inputted by user. Example: [0.77, 0.23] */
  deposits: Array<Scalars['Float']>
}

/** Result from attempting to verify RDVs */
export type VerifyRdvsResult =
  | AccountFrozen
  | FundingSourceAccount
  | IncorrectRdvAmounts
  | StoredRdvDepositsInvalid
  | StoredRdvDepositsMissing

export type VersionMismatchException = {
  __typename?: 'VersionMismatchException'
  latestVersion: Maybe<Scalars['ID']>
}

export type ViewedLearnContentResult = {
  __typename?: 'ViewedLearnContentResult'
  contentId: Scalars['ID']
}

/** W9 document requested. */
export type W9DocumentRequestedUserAlert = UserAlertsItem & {
  __typename?: 'W9DocumentRequestedUserAlert'
  /** The type of document requested to be uploaded */
  requestedDocumentType: DocumentType
  /** The type of the alert */
  type: Scalars['String']
  /** The user ID associated to the alert */
  userId: Scalars['ID']
}

/** result from attempting to create a provisional waiver for a user */
export type Waiver = MightyOakCardWaiver | PromotionalWaiver | ProvisionalWaiver

export type WaiverCreationException = {
  __typename?: 'WaiverCreationException'
  message: Scalars['String']
}

export type WaiverDeletionException = {
  __typename?: 'WaiverDeletionException'
  message: Scalars['String']
}

export enum WaiverPromotion {
  /** Cricket Wireless Promotion */
  Cricket = 'CRICKET',
  /** Mighty Oak Card Promotion */
  MightyOakCard = 'MIGHTY_OAK_CARD',
}

export enum WaiverPromotion_V2 {
  Cricket = 'CRICKET',
  MightyOakCard = 'MIGHTY_OAK_CARD',
}

/** URLs for linked account webhooks */
export type Webhooks = {
  __typename?: 'Webhooks'
  /** URL for plaid webhooks */
  plaid: Scalars['String']
}

/** A URL which represents the location of the account linking source the client should use. */
export type WebviewLinkSession = {
  __typename?: 'WebviewLinkSession'
  /** The URL a client should use for account linking. */
  url: Scalars['URL']
}

/** Withdrawal Investment Object */
export type Withdrawal = {
  __typename?: 'Withdrawal'
  amount: Scalars['Float']
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  presentableWithdrawalStatus: PresentableWithdrawalStatus
}

export type WithholdingDefaults = {
  __typename?: 'WithholdingDefaults'
  federalWithholdingPercentage: Scalars['Float']
  showFederalWithholdingField: Scalars['Boolean']
  showStateWithholdingField: Scalars['Boolean']
  stateWithholdingPercentage: Scalars['Float']
}

export type WithholdingEstimates = {
  __typename?: 'WithholdingEstimates'
  /** estimated amount that will be delivered to the customer */
  estimatedCustomerAmount: MonetaryAmount
  /** estimated total amount that will be withheld for federal taxes */
  estimatedFederalWithholdingAmount: MonetaryAmount
  /** estimated total amount that will be withheld for state taxes */
  estimatedStateWithholdingAmount: MonetaryAmount
  /** estimated earnings that will be taxed */
  estimatedTaxableEarnings: MonetaryAmount
  /** estimated total amount that will be withheld (state and federal) */
  estimatedTotalWithholdingAmount: MonetaryAmount
}

export type YearLaterReport = {
  __typename?: 'YearLaterReport'
  accountBalance: Scalars['Float']
  accountCreationDate: Scalars['String']
  accountPerformance: Scalars['Float']
  accountType: Scalars['String']
  firstDepositAmountForYear: Maybe<Scalars['Float']>
  firstDepositDateForYear: Maybe<Scalars['String']>
  recurringContributionAmount: Scalars['Float']
  recurringContributionFrequency: Maybe<InvestmentFrequency>
  totalDeposits: Scalars['Float']
  totalDepositsForYear: Scalars['Float']
  totalDividends: Scalars['Float']
  totalNetReturns: Scalars['Float']
  totalWithdrawals: Scalars['Float']
  userAge: Scalars['Int']
}

/** Filter schema for the allPasyscheduledItems Query */
export type AllPastScheduledItemsFilter = {
  account?: InputMaybe<PastItemsAccountFilter>
}

export type EndChatSessionResponse = ChatSession | ChatSessionNotFound

export type HelpcenterBannerResponse =
  | HelpcenterBannerContent
  | HelpcenterBannerErrors

export type Jobs_Article = {
  __typename?: 'jobs_Article'
  body: Scalars['String']
  cta: Maybe<Cta>
  eyebrow: Scalars['String']
  id: Scalars['ID']
  image: Maybe<Image>
  title: Scalars['String']
}

export type Jobs_Education = {
  __typename?: 'jobs_Education'
  articles: Jobs_Article[]
  id: Scalars['ID']
  title: Scalars['String']
}

export type Jobs_Offer = {
  __typename?: 'jobs_Offer'
  /** Company logo or generic default */
  companyLogo: Image
  /** Hiring company */
  companyName: Scalars['String']
  id: Scalars['ID']
  /** Relevant job industry */
  industryName: Maybe<Scalars['String']>
  /** Job role */
  jobName: Scalars['String']
  /** Job location */
  location: JobLocation
  /** Salary details */
  salary: Maybe<Jobs_OfferSalary>
  /** List of tags to display */
  tags: Array<Scalars['String']>
  /** Redirect URL for job posting */
  url: Scalars['URL']
}

/** Specifies a Job Offer Connection */
export type Jobs_OfferConnection = {
  __typename?: 'jobs_OfferConnection'
  edges: Jobs_OfferEdge[]
  pageInfo: PageInfo
}

/** Specifies a Job Offer Edge */
export type Jobs_OfferEdge = {
  __typename?: 'jobs_OfferEdge'
  cursor: Scalars['ID']
  node: Jobs_Offer
}

export type Jobs_OfferSalary = {
  __typename?: 'jobs_OfferSalary'
  interval: SalaryInterval
  maxValue: Scalars['Float']
  minValue: Scalars['Float']
}

export type LaterTotalLiquidationInput = {
  earlyDistributionTaxExceptionReason?: InputMaybe<Scalars['String']>
  federalTaxes: Scalars['Float']
  reason?: InputMaybe<LaterWithdrawalReason>
  stateTaxes: Scalars['Float']
  taxYear: Scalars['Int']
  withdrawalType?: InputMaybe<LaterWithdrawalType>
}

export type ManagePayoutRelationshipInput = {
  action: ManagePayoutRelationshipAction
  payoutId: Scalars['ID']
  relationshipId: Scalars['ID']
}

export type RateChatMessageResponse =
  | ChatHistoryMessage
  | ChatHistoryMessageCustomFeedbackOutOfBounds
  | ChatHistoryMessageNotFound
  | ChatHistoryMessageNotRatable
  | ChatHistoryMessageRatingFailed
  | ChatHistoryMessageRatingOutOfBounds

export enum ReferralStatusDetails {
  AcornsEmployee = 'ACORNS_EMPLOYEE',
  CampaignExpired = 'CAMPAIGN_EXPIRED',
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  InvestAccountClosed = 'INVEST_ACCOUNT_CLOSED',
  ManualPayout = 'MANUAL_PAYOUT',
  UserSuspened = 'USER_SUSPENED',
}

export type StartChatSessionResponse = ChatSession | ChatUnavailableError

/** Recommended portfolio for user based off their suitability responses */
export type Suitability_Portfolio = {
  __typename?: 'suitability_Portfolio'
  /** the portfolio description */
  description: Scalars['String']
  /** The portfolio ID */
  id: Scalars['ID']
  /** The portfolio name */
  name: Scalars['String']
}

/** Possible answer for a suitability question */
export type Suitability_SuitabilityAnswer = {
  __typename?: 'suitability_SuitabilityAnswer'
  /** Human readable text to display a description to an answer */
  description: Maybe<Scalars['String']>
  /** Internal ID for a suitability answer */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Summary of an answer used for displaying why a portfolio was recommended */
  summary: Maybe<Scalars['String']>
  /** Human readable text to display an answer to a suitability question */
  text: Scalars['String']
}

/** A user's input to update their suitabiliity */
export type Suitability_SuitabilityInput = {
  /** The answer ID */
  answerId: Scalars['ID']
  /** The question ID */
  questionId: Scalars['ID']
}

/** Suitability question asked for recommending portfolios */
export type Suitability_SuitabilityQuestion = {
  __typename?: 'suitability_SuitabilityQuestion'
  /** Default answer to the related suitability question */
  defaultAnswer: Maybe<Suitability_SuitabilityAnswer>
  /** Internal ID for a suitability question */
  id: Scalars['ID']
  /** Value for clients to use to fetch strings */
  key: Scalars['String']
  /** Possible answers to be selected for the related question */
  possibleAnswers: Suitability_SuitabilityAnswer[]
  /** Human readable text to display the suitability question */
  text: Scalars['String']
}

/** A given user's suitability response for each question and answer */
export type Suitability_SuitabilityResponse = {
  __typename?: 'suitability_SuitabilityResponse'
  /** Associated answer to the suitability question */
  answer: Maybe<Suitability_SuitabilityAnswer>
  /** Default answer to the related suitability question */
  question: Suitability_SuitabilityQuestion
}

/** Return wrapper type for the UpdateSuitability mutation */
export type Suitability_UpdateSuitabilityResult = {
  __typename?: 'suitability_UpdateSuitabilityResult'
  /** The recommended portfolio for the user's suitability responses */
  recommendedPortfolio: Maybe<Suitability_Portfolio>
  /** Internal ID for a suitability answer */
  suitabilityResponses: Suitability_SuitabilityResponse[]
}

export type UploadAudienceListInput = {
  cohortName: Scalars['String']
}

export type UserWinbackErrors = {
  __typename?: 'userWinbackErrors'
  error: Maybe<Scalars['String']>
  message: Maybe<Scalars['String']>
}

export type UserWinbackScore = {
  __typename?: 'userWinbackScore'
  churnProbability: Maybe<Scalars['Float']>
  predictedRevenue: Maybe<Scalars['Float']>
  userId: Maybe<Scalars['String']>
}

export type UserWinbackScoreRes = UserWinbackErrors | UserWinbackScore

export type ValidateCredentialsMutationVariables = Exact<{
  udid: Scalars['String']
  idToken: Scalars['String']
  nonce: Scalars['String']
  oauth: Scalars['Boolean']
}>

export type ValidateCredentialsMutation = {
  __typename?: 'Mutation'
  validateCredentials:
    | {
        __typename: 'AuthSession'
        id: string
        token?: string
        refreshToken?: string
        identityId: string
      }
    | { __typename: 'DeviceBlockedException'; message: string }
    | { __typename: 'InvalidCredentialsException'; message: string }
    | { __typename: 'LoginRateLimitedException'; message: string }
    | {
        __typename: 'OidcCredentialsNotFoundException'
        oidcProvider: OidcProvider
        oidcNotFoundUserId: string
      }
    | {
        __typename: 'UserSuspendedException'
        suspendedToken: string
        message: string
      }
    | {
        __typename: 'ValidateCredentialsSuccess'
        mfaToken: string
        userId: string
        authenticators: Array<
          | {
              __typename?: 'EmailAuthenticator'
              id: string
              lastUsedAt: any
              lastAuthenticatedAt: any
              name: string
              type: AuthType
              updatedAt: any
            }
          | {
              __typename?: 'PhoneAuthenticator'
              id: string
              lastUsedAt: any
              lastAuthenticatedAt: any
              name: string
              type: AuthType
              updatedAt: any
            }
          | {
              __typename?: 'PushAuthenticator'
              id: string
              lastUsedAt: any
              lastAuthenticatedAt: any
              name: string
              type: AuthType
              updatedAt: any
            }
        >
      }
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = {
  __typename?: 'Mutation'
  logout:
    | { __typename: 'AuthTokenNotFoundException' }
    | { __typename: 'LogoutSuccess' }
    | { __typename: 'RefreshTokenNotFoundException' }
}

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput
  oauth?: InputMaybe<Scalars['Boolean']>
}>

export type AuthenticateMutation = {
  __typename?: 'Mutation'
  authenticate:
    | { __typename: 'AuthChallengeAnswerAttemptsExhaustedException' }
    | { __typename: 'AuthChallengeAnswerIncorrectException' }
    | { __typename: 'AuthChallengeExpiredException' }
    | {
        __typename: 'AuthSession'
        id: string
        token?: string
        refreshToken?: string
        identityId: string
      }
    | { __typename: 'AuthenticatorTypeAlreadyRegisteredException' }
    | { __typename: 'AuthenticatorUnavailableException' }
    | { __typename: 'ChallengeRateExceededException' }
    | { __typename: 'DeviceBlockedException'; message: string }
    | {
        __typename: 'EmailAuthChallenge'
        id: string
        maskedEmail: string
        alternateAuthenticators: Array<{
          __typename?: 'AuthenticatorInfo'
          id: string
          type: AuthType
        }>
      }
    | { __typename: 'InvalidCredentialsException'; message: string }
    | { __typename: 'LoginRateLimitedException' }
    | { __typename: 'PhoneNumberOptedOutException' }
    | {
        __typename: 'SMSAuthChallenge'
        id: string
        maskedPhoneNumber: string
        alternateAuthenticators: Array<{
          __typename?: 'AuthenticatorInfo'
          id: string
          type: AuthType
        }>
      }
    | { __typename: 'UserLockedException'; message: string }
    | {
        __typename: 'UserSuspendedException'
        message: string
        suspensionReasonValid: boolean
        suspendedToken?: string
      }
}

export type EmailAddressValidationQueryVariables = Exact<{
  email: Scalars['EmailAddress']
}>

export type EmailAddressValidationQuery = {
  __typename?: 'Query'
  emailAddressValidation: {
    __typename?: 'EmailAddressValidation'
    credentialsExist: boolean
  }
}

export type ChallengeAuthenticateMutationVariables = Exact<{
  input: AuthenticateInput
  challengeAnswerInput?: InputMaybe<ChallengeAnswerInput>
  alternateAuthenticatorId?: InputMaybe<Scalars['ID']>
  oauth?: InputMaybe<Scalars['Boolean']>
}>

export type ChallengeAuthenticateMutation = {
  __typename?: 'Mutation'
  authenticate:
    | {
        __typename: 'AuthChallengeAnswerAttemptsExhaustedException'
        message: string
      }
    | { __typename: 'AuthChallengeAnswerIncorrectException'; message: string }
    | { __typename: 'AuthChallengeExpiredException'; message: string }
    | {
        __typename: 'AuthSession'
        id: string
        token?: string
        refreshToken?: string
        identityId: string
      }
    | { __typename: 'AuthenticatorTypeAlreadyRegisteredException' }
    | { __typename: 'AuthenticatorUnavailableException' }
    | { __typename: 'ChallengeRateExceededException' }
    | { __typename: 'DeviceBlockedException' }
    | {
        __typename: 'EmailAuthChallenge'
        id: string
        maskedEmail: string
        alternateAuthenticators: Array<{
          __typename?: 'AuthenticatorInfo'
          id: string
          type: AuthType
        }>
      }
    | { __typename: 'InvalidCredentialsException' }
    | { __typename: 'LoginRateLimitedException' }
    | { __typename: 'PhoneNumberOptedOutException' }
    | {
        __typename: 'SMSAuthChallenge'
        id: string
        maskedPhoneNumber: string
        alternateAuthenticators: Array<{
          __typename?: 'AuthenticatorInfo'
          id: string
          type: AuthType
        }>
      }
    | { __typename: 'UserLockedException'; message: string }
    | {
        __typename: 'UserSuspendedException'
        message: string
        suspensionReasonValid: boolean
        suspendedToken?: string
      }
}

export type ReinitiateChallengeMutationVariables = Exact<{
  input: ReinitiateSmsChallengeInput
}>

export type ReinitiateChallengeMutation = {
  __typename?: 'Mutation'
  reinitiateChallenge:
    | { __typename?: 'AuthChallengeExpiredException'; message: string }
    | { __typename?: 'ChallengeRateExceededException' }
    | { __typename?: 'EmailAuthChallenge'; id: string; maskedEmail: string }
    | { __typename?: 'PhoneNumberOptedOutException' }
    | { __typename?: 'SMSAuthChallenge'; id: string; maskedPhoneNumber: string }
}

export type ResetPasswordWithTokenMutationVariables = Exact<{
  password: Scalars['String']
  passwordConfirmation: Scalars['String']
  resetToken: Scalars['String']
  last4Ssn?: InputMaybe<Scalars['String']>
}>

export type ResetPasswordWithTokenMutation = {
  __typename?: 'Mutation'
  resetPasswordWithToken:
    | {
        __typename: 'InvalidPasswordResetException'
        errors: PasswordResetErrors[]
      }
    | { __typename: 'InvalidPasswordResetTokenException'; invalidToken: string }
    | { __typename: 'ResetPasswordWithTokenSuccess'; userId: string }
    | { __typename: 'UserCredentialsNotFoundException'; message: string }
}

export type ValidatePasswordResetTokenQueryVariables = Exact<{
  resetToken: Scalars['String']
}>

export type ValidatePasswordResetTokenQuery = {
  __typename?: 'Query'
  validatePasswordResetToken:
    | { __typename: 'InvalidPasswordResetTokenException'; invalidToken: string }
    | {
        __typename: 'ValidatePasswordResetTokenSuccess'
        displaySsnField: boolean
      }
}

export const ValidateCredentialsDocument = /*#__PURE__*/ gql`
  mutation ValidateCredentials(
    $udid: String!
    $idToken: String!
    $nonce: String!
    $oauth: Boolean!
  ) {
    validateCredentials(
      input: {
        udid: $udid
        credentialsType: APPLE
        oidcLoginInput: { idToken: $idToken, nonce: $nonce }
      }
    ) {
      __typename
      ... on AuthSession {
        __typename
        id
        token @skip(if: $oauth)
        refreshToken @skip(if: $oauth)
        identityId
      }
      ... on ValidateCredentialsSuccess {
        mfaToken
        userId
        authenticators {
          id
          lastUsedAt
          lastAuthenticatedAt
          lastUsedAt
          name
          type
          updatedAt
        }
      }
      ... on InvalidCredentialsException {
        message
      }
      ... on DeviceBlockedException {
        message
      }
      ... on LoginRateLimitedException {
        message
      }
      ... on UserSuspendedException {
        suspendedToken
        message
      }
      ... on OidcCredentialsNotFoundException {
        oidcNotFoundUserId: userId
        oidcProvider
      }
    }
  }
`
export type ValidateCredentialsMutationFn = ApolloReactCommon.MutationFunction<
  ValidateCredentialsMutation,
  ValidateCredentialsMutationVariables
>

/**
 * __useValidateCredentialsMutation__
 *
 * To run a mutation, you first call `useValidateCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCredentialsMutation, { data, loading, error }] = useValidateCredentialsMutation({
 *   variables: {
 *      udid: // value for 'udid'
 *      idToken: // value for 'idToken'
 *      nonce: // value for 'nonce'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
export function useValidateCredentialsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ValidateCredentialsMutation,
    ValidateCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ValidateCredentialsMutation,
    ValidateCredentialsMutationVariables
  >(ValidateCredentialsDocument, options)
}
export type ValidateCredentialsMutationHookResult = ReturnType<
  typeof useValidateCredentialsMutation
>
export type ValidateCredentialsMutationResult =
  ApolloReactCommon.MutationResult<ValidateCredentialsMutation>
export type ValidateCredentialsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ValidateCredentialsMutation,
    ValidateCredentialsMutationVariables
  >
export const LogoutDocument = /*#__PURE__*/ gql`
  mutation Logout {
    logout {
      __typename
    }
  }
`
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options,
  )
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult =
  ApolloReactCommon.MutationResult<LogoutMutation>
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>
export const AuthenticateDocument = /*#__PURE__*/ gql`
  mutation Authenticate($input: AuthenticateInput!, $oauth: Boolean = false) {
    authenticate(input: $input) {
      __typename
      ... on AuthSession {
        id
        token @skip(if: $oauth)
        refreshToken @skip(if: $oauth)
        identityId
      }
      ... on SMSAuthChallenge {
        id
        maskedPhoneNumber
        alternateAuthenticators {
          id
          type
        }
      }
      ... on EmailAuthChallenge {
        id
        maskedEmail
        alternateAuthenticators {
          id
          type
        }
      }
      ... on InvalidCredentialsException {
        message
      }
      ... on UserSuspendedException {
        message
        suspensionReasonValid
        suspendedToken @skip(if: $oauth)
      }
      ... on DeviceBlockedException {
        message
      }
      ... on UserLockedException {
        message
      }
    }
  }
`
export type AuthenticateMutationFn = ApolloReactCommon.MutationFunction<
  AuthenticateMutation,
  AuthenticateMutationVariables
>

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
export function useAuthenticateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AuthenticateMutation,
    AuthenticateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AuthenticateMutation,
    AuthenticateMutationVariables
  >(AuthenticateDocument, options)
}
export type AuthenticateMutationHookResult = ReturnType<
  typeof useAuthenticateMutation
>
export type AuthenticateMutationResult =
  ApolloReactCommon.MutationResult<AuthenticateMutation>
export type AuthenticateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AuthenticateMutation,
  AuthenticateMutationVariables
>
export const EmailAddressValidationDocument = /*#__PURE__*/ gql`
  query EmailAddressValidation($email: EmailAddress!) {
    emailAddressValidation(email: $email) {
      credentialsExist
    }
  }
`

/**
 * __useEmailAddressValidationQuery__
 *
 * To run a query within a React component, call `useEmailAddressValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressValidationQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailAddressValidationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EmailAddressValidationQuery,
    EmailAddressValidationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EmailAddressValidationQuery,
    EmailAddressValidationQueryVariables
  >(EmailAddressValidationDocument, options)
}
export function useEmailAddressValidationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmailAddressValidationQuery,
    EmailAddressValidationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EmailAddressValidationQuery,
    EmailAddressValidationQueryVariables
  >(EmailAddressValidationDocument, options)
}
export type EmailAddressValidationQueryHookResult = ReturnType<
  typeof useEmailAddressValidationQuery
>
export type EmailAddressValidationLazyQueryHookResult = ReturnType<
  typeof useEmailAddressValidationLazyQuery
>
export type EmailAddressValidationQueryResult = ApolloReactCommon.QueryResult<
  EmailAddressValidationQuery,
  EmailAddressValidationQueryVariables
>
export const ChallengeAuthenticateDocument = /*#__PURE__*/ gql`
  mutation ChallengeAuthenticate(
    $input: AuthenticateInput!
    $challengeAnswerInput: ChallengeAnswerInput
    $alternateAuthenticatorId: ID
    $oauth: Boolean = false
  ) {
    authenticate(
      input: $input
      challengeAnswerInput: $challengeAnswerInput
      alternateAuthenticatorId: $alternateAuthenticatorId
    ) {
      __typename
      ... on SMSAuthChallenge {
        id
        maskedPhoneNumber
        alternateAuthenticators {
          id
          type
        }
      }
      ... on EmailAuthChallenge {
        id
        maskedEmail
        alternateAuthenticators {
          id
          type
        }
      }
      ... on AuthSession {
        id
        token @skip(if: $oauth)
        refreshToken @skip(if: $oauth)
        identityId
      }
      ... on AuthChallengeAnswerIncorrectException {
        message
      }
      ... on AuthChallengeAnswerAttemptsExhaustedException {
        message
      }
      ... on AuthChallengeExpiredException {
        message
      }
      ... on UserLockedException {
        message
      }
      ... on UserSuspendedException {
        message
        suspensionReasonValid
        suspendedToken @skip(if: $oauth)
      }
    }
  }
`
export type ChallengeAuthenticateMutationFn =
  ApolloReactCommon.MutationFunction<
    ChallengeAuthenticateMutation,
    ChallengeAuthenticateMutationVariables
  >

/**
 * __useChallengeAuthenticateMutation__
 *
 * To run a mutation, you first call `useChallengeAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeAuthenticateMutation, { data, loading, error }] = useChallengeAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      challengeAnswerInput: // value for 'challengeAnswerInput'
 *      alternateAuthenticatorId: // value for 'alternateAuthenticatorId'
 *      oauth: // value for 'oauth'
 *   },
 * });
 */
export function useChallengeAuthenticateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ChallengeAuthenticateMutation,
    ChallengeAuthenticateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ChallengeAuthenticateMutation,
    ChallengeAuthenticateMutationVariables
  >(ChallengeAuthenticateDocument, options)
}
export type ChallengeAuthenticateMutationHookResult = ReturnType<
  typeof useChallengeAuthenticateMutation
>
export type ChallengeAuthenticateMutationResult =
  ApolloReactCommon.MutationResult<ChallengeAuthenticateMutation>
export type ChallengeAuthenticateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ChallengeAuthenticateMutation,
    ChallengeAuthenticateMutationVariables
  >
export const ReinitiateChallengeDocument = /*#__PURE__*/ gql`
  mutation ReinitiateChallenge($input: ReinitiateSMSChallengeInput!) {
    reinitiateChallenge(input: $input) {
      ... on SMSAuthChallenge {
        id
        maskedPhoneNumber
      }
      ... on EmailAuthChallenge {
        id
        maskedEmail
      }
      ... on AuthChallengeExpiredException {
        message
      }
    }
  }
`
export type ReinitiateChallengeMutationFn = ApolloReactCommon.MutationFunction<
  ReinitiateChallengeMutation,
  ReinitiateChallengeMutationVariables
>

/**
 * __useReinitiateChallengeMutation__
 *
 * To run a mutation, you first call `useReinitiateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinitiateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinitiateChallengeMutation, { data, loading, error }] = useReinitiateChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReinitiateChallengeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReinitiateChallengeMutation,
    ReinitiateChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReinitiateChallengeMutation,
    ReinitiateChallengeMutationVariables
  >(ReinitiateChallengeDocument, options)
}
export type ReinitiateChallengeMutationHookResult = ReturnType<
  typeof useReinitiateChallengeMutation
>
export type ReinitiateChallengeMutationResult =
  ApolloReactCommon.MutationResult<ReinitiateChallengeMutation>
export type ReinitiateChallengeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ReinitiateChallengeMutation,
    ReinitiateChallengeMutationVariables
  >
export const ResetPasswordWithTokenDocument = /*#__PURE__*/ gql`
  mutation ResetPasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetToken: String!
    $last4Ssn: String
  ) {
    resetPasswordWithToken(
      input: {
        password: $password
        passwordConfirmation: $passwordConfirmation
        resetToken: $resetToken
        last4Ssn: $last4Ssn
      }
    ) {
      __typename
      ... on ResetPasswordWithTokenSuccess {
        userId
      }
      __typename
      ... on InvalidPasswordResetTokenException {
        invalidToken
      }
      __typename
      ... on UserCredentialsNotFoundException {
        message
      }
      __typename
      ... on InvalidPasswordResetException {
        errors
      }
    }
  }
`
export type ResetPasswordWithTokenMutationFn =
  ApolloReactCommon.MutationFunction<
    ResetPasswordWithTokenMutation,
    ResetPasswordWithTokenMutationVariables
  >

/**
 * __useResetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithTokenMutation, { data, loading, error }] = useResetPasswordWithTokenMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      resetToken: // value for 'resetToken'
 *      last4Ssn: // value for 'last4Ssn'
 *   },
 * });
 */
export function useResetPasswordWithTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResetPasswordWithTokenMutation,
    ResetPasswordWithTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResetPasswordWithTokenMutation,
    ResetPasswordWithTokenMutationVariables
  >(ResetPasswordWithTokenDocument, options)
}
export type ResetPasswordWithTokenMutationHookResult = ReturnType<
  typeof useResetPasswordWithTokenMutation
>
export type ResetPasswordWithTokenMutationResult =
  ApolloReactCommon.MutationResult<ResetPasswordWithTokenMutation>
export type ResetPasswordWithTokenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ResetPasswordWithTokenMutation,
    ResetPasswordWithTokenMutationVariables
  >
export const ValidatePasswordResetTokenDocument = /*#__PURE__*/ gql`
  query validatePasswordResetToken($resetToken: String!) {
    validatePasswordResetToken(resetToken: $resetToken) {
      __typename
      ... on InvalidPasswordResetTokenException {
        invalidToken
      }
      ... on ValidatePasswordResetTokenSuccess {
        displaySsnField
      }
    }
  }
`

/**
 * __useValidatePasswordResetTokenQuery__
 *
 * To run a query within a React component, call `useValidatePasswordResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordResetTokenQuery({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *   },
 * });
 */
export function useValidatePasswordResetTokenQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ValidatePasswordResetTokenQuery,
    ValidatePasswordResetTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ValidatePasswordResetTokenQuery,
    ValidatePasswordResetTokenQueryVariables
  >(ValidatePasswordResetTokenDocument, options)
}
export function useValidatePasswordResetTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ValidatePasswordResetTokenQuery,
    ValidatePasswordResetTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ValidatePasswordResetTokenQuery,
    ValidatePasswordResetTokenQueryVariables
  >(ValidatePasswordResetTokenDocument, options)
}
export type ValidatePasswordResetTokenQueryHookResult = ReturnType<
  typeof useValidatePasswordResetTokenQuery
>
export type ValidatePasswordResetTokenLazyQueryHookResult = ReturnType<
  typeof useValidatePasswordResetTokenLazyQuery
>
export type ValidatePasswordResetTokenQueryResult =
  ApolloReactCommon.QueryResult<
    ValidatePasswordResetTokenQuery,
    ValidatePasswordResetTokenQueryVariables
  >
